(function () {
  'use strict';

  angular
    .module('administracionNotificaciones', [
      'angular-bind-html-compile',
      'base64', // Módulo para codificar en base64
      'formly', // Módulo para formularios dinámicos
      'formlyBootstrap', // Tema de bootstrap para formularios dinámicos
      'ngAnimate', // Módulo para crear animaciones
      'ngjsColorPicker', // Módulo para selector de color
      'ngResource', // Módulo para conectarse a un servidor REST
      'ngSanitize', // Módulo para limpiar el contenido web
      'ngStorage', // Módulo para guardar en el local storage
      'ngTable', // Módulo para tablas dinámicas
      'ui-iconpicker', // Módulo para selector de iconos
      'ui.bootstrap', // Directivas de angular para bootstrap
      'ui.router', // Módulo para manejo de estados de la aplicación
      'ui.calendar', //
      'ngFileSaver', // File Saver
      'star-rating',
      'highcharts-ng'
    ]);
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').directive('menuItem', menuItem);

  function menuItem() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/tema/sidebar/navigation-menu/menu-item.html',
      controller: 'MenuItemCtrl as menuItem',
      bindToController: true,
      scope: {
        item: '=',
        padding: '='
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('administracionNotificaciones')
    .controller('MenuItemCtrl', MenuItemCtrl);

  function MenuItemCtrl($scope, $rootScope, $state, Autenticacion, ServicioSeccion, Dialogo) {
    var vm = this;

    vm.select = select;
    vm.isVisible = isVisible;
    vm.isEnabled = isEnabled;
    vm.getName = getName;
    vm.getTooltip = getTooltip;

    $rootScope.$on('$stateChangeSuccess', function () {
      if ($state.current.name === vm.item.state) {
        $rootScope.selectedMenu = vm.item;
      }
    });

    $rootScope.$watch('selectedMenu', validate);
    $scope.$watch('menuItem.item.children', validate, true);

    function isVisible(item) {
      if (item.children) {
        return item.children.find(function (item) {
          return isVisible(item);
        });
      } else {
        return Autenticacion.hasPermissions(item.permissions);
      }
    }

    function isEnabled(item) {
      return ServicioSeccion.habilitadas(item.sections);
    }

    function validate() {
      if ($rootScope.selectedMenu === vm.item) {
        vm.item.opened = true;
        vm.item.present = true;
        return;
      } else if (vm.item.children) {
        var foundChildren;
        vm.item.children.forEach(function (hijo) {
          if (hijo.opened) {
            vm.item.opened = true;
            vm.item.present = false;
            foundChildren = true;
          }
        });
        if (foundChildren) {
          return;
        }
      }
      vm.item.present = false;
      vm.item.opened = false;
    }

    function select() {
      console.log('Navegando a estado:', vm.item);
      $rootScope.selectedMenu = vm.item;
      if (!vm.item.children) {
        if (vm.isEnabled(vm.item)) {
          $state.go(vm.item.state);
        } else {
          Dialogo.mostrarError({
            texto: 'Esta sección no se encuentra habilitada en este momento.'
          });
        }
      }
    }

    function getName() {
      return vm.item.name && vm.item.name.length > 18 ? vm.item.name.substring(0, 18) + '...' : vm.item.name;
    }

    function getTooltip() {
      return vm.item.name && vm.item.name.length > 18 ? vm.item.name : '';
    }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').directive('userInfo', userInfo);

  function userInfo() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/tema/page-header/user-info/user-info.html',
      replace: true,
      controller: 'UserInfoCtrl as vm'
    };
  }
})();

(function () {
  'use strict';

  angular
  .module('administracionNotificaciones')
  .controller('UserInfoCtrl', UserInfoCtrl);

  UserInfoCtrl.$inject = ['Autenticacion', '$state', 'Dialogo', 'AlmacenUsuario', 'Usuario', '$http', '$interval', '$rootScope', 'URL_SERVIDOR'];

  function UserInfoCtrl(Autenticacion, $state, Dialogo, AlmacenUsuario, Usuario, $http, $interval, $rootScope, URL_SERVIDOR) {
    var vm = this;
    // console.log(AlmacenUsuario.getUsuario());
    vm.usuario = Usuario.getInfo();
    // console.log(vm.usuario);
    vm.cerrarSesion = cerrarSesion;
    vm.mostrarInformacionPersonal = mostrarInformacionPersonal;
    vm.cambiarPassword = cambiarPassword;
    vm.getFullName = getFullName;
    
    vm.cantidadNotificaciones = 0;
    vm.cargarCantidadNotificaciones = cargarCantidadNotificaciones;

    vm.notificacionesPreview = [];
    vm.mostrarPreview = false;
    vm.cargarPreview = cargarPreview;
    vm.ocultarPreview = ocultarPreview;

    vm.irABandeja = irABandeja;

    function irABandeja() {
      vm.mostrarPreview = false; // opcional, para cerrar el popup
      $state.go('main.bandeja-notificaciones');
    }

    // 🔹 ACÁ VA ESTO (inicialización)
    cargarCantidadNotificaciones();

    // refresco cada 30 segundos y al leer una notificación
    var intervalo = $interval(cargarCantidadNotificaciones, 30000);
    $rootScope.$on('notificacion:leida', cargarCantidadNotificaciones);

    function cargarCantidadNotificaciones() {
      $http.get(URL_SERVIDOR + 'api/notificaciones/cantidad')
        .then(function (response) {
          vm.cantidadNotificaciones = response.data.noLeidas || 0;
        })
        .catch(function () {
          vm.cantidadNotificaciones = 0;
        });
    }

    function cargarPreview() {
      vm.mostrarPreview = true;

      $http.get(URL_SERVIDOR + 'api/notificaciones/bandeja/ultimas')
        .then(function (response) {
          vm.notificacionesPreview = response.data || [];
          vm.notificacionesPreview = vm.notificacionesPreview.filter(function(n){
            return !n.leida;
          });
        })
        .catch(function () {
          vm.notificacionesPreview = [];
        });
    }

    function ocultarPreview() {
      vm.mostrarPreview = false;
    }

    function cerrarSesion() {
      Autenticacion.cerrarSesion().then(
        function () {
          $state.go('login');
        },
        function (respuesta) {
          Dialogo.mostrarError({titulo: 'Error', texto: ' ' + respuesta.data.message});
        }
      );
    }

    function getFullName() {
      if (!vm.usuario) {
        return '';
      }
      if (vm.usuario.persona && vm.usuario.persona.nombre && vm.usuario.persona.apellido) {
        return vm.usuario.persona.apellido + ', ' + vm.usuario.persona.nombre;
      } else {
        return vm.usuario.nick;
      }
    }

    function mostrarInformacionPersonal() {
      $state.go('main.usuarios.edit');
    }

    function cambiarPassword() {
      $state.go('main.usuarios.cambiarPassword');
    }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').directive('profile', profile);

  function profile() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/tema/page-header/profile/profile.html',
      replace: true,
      controller: 'ProfileCtrl as profile',
      bindToController: true
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('administracionNotificaciones')
    .controller('ProfileCtrl', ProfileCtrl);

  function ProfileCtrl(ACTIVE_PROFILE) {
    var vm = this;

    vm.profile = ACTIVE_PROFILE;
    vm.esProduccion = esProduccion;

    function esProduccion() {
      return vm.profile == 'produccion';
    }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').directive('pageTitle', pageTitle);

  function pageTitle() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/tema/page-header/page-title/page-title.html',
      replace: true,
      controller: 'PageTitleCtrl as title',
      bindToController: true
    };
  }
})();

(function () {
  'use strict';

  angular
  .module('administracionNotificaciones')
  .controller('PageTitleCtrl', PageTitleCtrl);

  function PageTitleCtrl($rootScope, $state) {
    var vm = this;

    actualizarTitulo();

    $rootScope.$on('$stateChangeSuccess', actualizarTitulo);

    function actualizarTitulo() {
      vm.state = $state.current;
      if (vm.state.data) {
        vm.key = (vm.state.data.state.name ? vm.state.data.state.name : vm.state.data.state.type) + '.title';
      } else {
        vm.key = '';
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').service('ListState', ListState);

  function ListState(ListConf, DEFAULT_LIST_STATE_ACTIONS, DEFAULT_LIST_STATE_GENERAL_ACTIONS, DEFAULT_LIST_STATE_DATASOURCE) {
    var vm = this;

    vm.get = get;

    function get(config) {
      var newConf = angular.merge({}, config);
      newConf.list = angular.merge({}, config, config.list);
      addDefaultGeneralActions(newConf.list);
      addDefaultActions(newConf.list);
      newConf.list.datasource = angular.merge({}, DEFAULT_LIST_STATE_DATASOURCE, newConf.list.datasource);
      newConf.list = ListConf.get(newConf.list);
      newConf.list.resolve(angular.merge({}, newConf.defaultFilter, { sort: processDefaultSort(newConf.sorting) }, newConf.stateParams));
      return newConf.list;
    }

    function processDefaultSort(sorting) {
      var sort = [];
      if (!sorting) {
        return sort;
      }
      for (var key in sorting) {
        if (sorting.hasOwnProperty(key)) {
          sort.push(key + ',' + sorting[key]);
        }
      }
      if (sort.length === 0) {
        sort.push('id,asc');
      }
      return sort;
    }

    function addDefaultGeneralActions(config) {
      if (config.noDefaultGeneralActions) {
        return;
      }
      if (!config.generalActions) {
        config.generalActions = [];
      }
      DEFAULT_LIST_STATE_GENERAL_ACTIONS.forEach(function (def) {
        var present = false;
        config.generalActions = config.generalActions.map(function (action) {
          if (action.id === def.id) {
            present = true;
            return angular.merge(def, action);
          } else {
            return action;
          }
        });
        if (!present) {
          config.generalActions.push(angular.merge({}, def));
        }
      });
    }

    function addDefaultActions(config) {
      if (config.noDefaultActions) {
        return;
      }
      if (!config.cols) {
        config.cols = [];
      }
      var actionCol;
      config.cols.forEach(function (col) {
        if (col.type === 'actions') {
          actionCol = col;
        }
      });
      if (!actionCol) {
        actionCol = {
          title: 'Acciones',
          type: 'actions',
          actions: []
        };
        config.cols.push(actionCol);
      }
      DEFAULT_LIST_STATE_ACTIONS.forEach(function (def) {
        var present = false;
        actionCol.actions = actionCol.actions.map(function (action) {
          if (action.id === def.id) {
            present = true;
            return angular.merge(def, action);
          } else {
            return action;
          }
        });
        if (!present) {
          actionCol.actions.push(angular.merge({}, def));
        }
      });
    }
  }
})();

/* global angular */
(function () {
  angular.module('administracionNotificaciones')
  .controller('DefaultListCtrl', DefaultListCtrl);

  function DefaultListCtrl($scope, list) {
    var vm = this;
    vm.list = list;
    $scope.$watch('vm.list.ready', function(value) {
      if (value) {
        $scope.$emit('OCULTAR_CARGANDO');
      }
    });
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').value('DEFAULT_LIST_STATE_GENERAL_ACTIONS', [
    {
      id: 'nuevo',
      style: 'btn-success',
      icon: 'fa fa-plus',
      text: 'Nuevo',
      action: 'scope.actions.newElement()'
    }
  ]);
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').value('DEFAULT_LIST_STATE_DATASOURCE', {
    type: 'rest',
    method: 'query',
    eager: true,
    isArray: true
  });
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').value('DEFAULT_LIST_STATE_ACTIONS', [
    {
      id: 'editar',
      style: 'btn-primary',
      icon: 'fa fa-edit',
      text: 'Editar',
      action: 'scope.actions.editElement(item)'
    },
    {
      id: 'eliminar',
      style: 'btn-danger',
      icon: 'fa fa-trash',
      text: 'Eliminar',
      action: 'scope.actions.deleteElement(item)'
    }
  ]);
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config(ngTableFilterConfigProvider) {

    var filterAliasUrls = {
      'checkbox-list': 'app/components/abm/list/filter/checkbox-list.html'
    };
    ngTableFilterConfigProvider.setConfig({
      aliasUrls: filterAliasUrls
    });

  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').service('GeneralFilter', GeneralFilter);

  function GeneralFilter() {
    var vm = this;
    vm.get = get;
    vm.getFilter = getFilter;

    function get(config) {
      if (!config.filter) return [];
      return config.filter.map(getFilter).reduce(reduce, []);
    }

    function getFilter(filter) {
      return filter;
    }

    function reduce(filters, filter) {
      if (angular.isArray(filter)) {
        Array.push.apply(filters, filter);
      } else {
        filters.push(filter);
      }
      return filters;
    }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').directive('checkboxListFilter', checkboxListFilter);

  function checkboxListFilter() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/abm/list/filter/checkbox-list-filter.html',
      controller: function($scope) {
        $scope.$watch('$column.data', function(newValue) {
          $scope.$column.checkboxFields = newValue.map(function(value, index) {
            return {
              key: 'option'+index,
              type: 'checkbox',
              templateOptions: {
                label: value.label
              }
            };
          });
          $scope.$column.checkboxModel = {};
          newValue.forEach(function(value, index) {
            $scope.$column.checkboxModel['option'+index] = value.selected;
            $scope.$column.checkboxReady = true;
          });
        });
        $scope.$watch('$column.checkboxModel', function(newValue) {
          if (!$scope.$column.checkboxReady) return;
          var options = [];
          $scope.$column.data.forEach(function(value, index) {
            if ($scope.$column.checkboxModel['option'+index]) {
              options.push(value.value);
            }
          });
          console.log(options.join(','));
          $scope.params.filter()[$scope.name] = options.join(',');
        }, true);
      }
    };
  }

})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config(formlyConfigProvider) {

    formlyConfigProvider.setType({
      name: 'subirArchivo',
      templateUrl: 'app/components/abm/form/types/upload-file.html',
      wrapper: ['bootstrapLabel', 'bootstrapHasError']
    });

  }
})();

(function () {
  'use strict';

  angular
    .module('administracionNotificaciones')
    .directive('subirArchivo', subirArchivo);

  function subirArchivo() {
    return {
      scope: {
        subirArchivo: '='
      },
      link: function (scope, element) {
        element.bind('change', function (changeEvent) {
          scope.subirArchivo ={};
          var reader = new FileReader();
          reader.onload = function (loadEvent) {
            scope.$apply(function () {
              scope.subirArchivo.contenido = loadEvent.target.result;
            });
          };
          scope.subirArchivo.nombre = changeEvent.target.files[0].name;
          reader.readAsDataURL(changeEvent.target.files[0]);
        });
      }
    };

  }
})();
(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config(formlyConfigProvider) {
    formlyConfigProvider.setType({
      name: 'typeahead',
      templateUrl: 'app/components/abm/form/types/typeahead.html',
      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
      defaultOptions: {
        templateOptions: {
          ngOptions: 'item as item[to.propiedad] for item in to.funcion($viewValue) | limitTo:to.limite ? to.limite : 8'
        },
        ngModelAttrs:{
          ngOptions:{
            attribute: 'uib-typeahead'
          }
        }
      }
    });
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').directive('tableArrows', tableArrows);

  function tableArrows($rootScope) {
    return {
      link: function (scope, element, attr) {
        var x = parseInt(scope.formOptions.data.colIndex);
        var y = parseInt(scope.formOptions.data.rowIndex);

        function sendEvent(event, x, y) {
          event.preventDefault();
          event.stopPropagation();
          $rootScope.$broadcast('ENTER-' + attr.tableArrows + '-' + x + '-' + y, { y: y, x: x });
        }

        function isText(element) {
          if (element.type === 'select-one') return false;
          return true;
        }

        scope.$on('ENTER-' + attr.tableArrows + '-' + x + '-' + y, function (evt, data) {
          if (x == data.x && y == data.y) {
            element.focus();
          }
        });

        element.on('keydown', function (event) {
          if (event.key === 'Enter' || event.key === 'ArrowDown') {
            sendEvent(event, x, y + 1);
          } else if (event.key === 'ArrowUp') {
            sendEvent(event, x, y - 1);
          } else if (event.key === 'ArrowLeft' && (!isText(this) || this.selectionStart === 0)) {
            sendEvent(event, x - 1, y);
          } else if (event.key === 'ArrowRight' && (!isText(this) || !this.value || this.selectionEnd === this.value.length)) {
            sendEvent(event, x + 1, y);
          }
        });
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config(formlyConfigProvider) {
    formlyConfigProvider.setType({
      name: 'static',
      template: '<p class="form-control-static" bind-html-compile="getValue()"></p>',
      controller: controller,
      wrapper: ['bootstrapLabel', 'bootstrapHasError']
    });

    controller.$inject = ['$scope'];
    function controller($scope) {
      $scope.getValue = function() {
        if ($scope.options.templateOptions.expression) {
          return $scope.options.templateOptions.expression;
        } else {
          return '{{model.'+$scope.options.key +'}}';
        }
      };
    }
  }

})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').directive('selectOnFocus', selectOnFocus);

  function selectOnFocus() {
    return {
      link: function (scope, element) {
        element.on('focus', function () {
          this.setSelectionRange(0, this.value.length);
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config(formlyConfigProvider) {

    formlyConfigProvider.setType({
      name: 'optionalDate',
      extends: 'input',
      template: '<div class="input-group"><input class="form-control" date-string ng-model="model[options.key]" ng-disabled="!enabled"><span class="input-group-addon"><input type="checkbox" ng-model="enabled" ng-change="change()"></span></div>',
      controller: controller,
      defaultOptions: {
        templateOptions: {
          type: 'date'
        }
      },
      wrapper: ['bootstrapLabel', 'bootstrapHasError']
    });

    controller.$inject = ['$scope', '$parse'];
    function controller($scope, $parse) {
      $scope.change = change;
      var exp;

      $scope.$watch('options.key', function (value) {
        exp = $parse('model[\'' + value + '\']');
      });

      function change() {
        if (!exp) return;
        if ($scope.enabled) {
          exp.assign($scope, moment().format('DD/MM/YYYY'));
        } else {
          exp.assign($scope, null);
        }
      }
    }
  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config(formlyConfigProvider) {
    formlyConfigProvider.setType({
      name: 'list',
      template: '<abm-list list="to.list" class-name="\'campo-tabla\'"></abm-list>',
      controller: controller,
      wrapper: ['bootstrapLabel', 'bootstrapHasError']
    });

    controller.$inject = ['$scope'];
    function controller($scope) {
      $scope.$watch('model[options.key]', function(newValue) {
        if ($scope.to.list.datasource.set) {
          $scope.to.list.datasource.set(newValue);
        }
      });
      $scope.$watch('to.list.data', function(newValue) {
        $scope.model[$scope.options.key] = newValue;
      });
    }
  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config(formlyConfigProvider) {
    formlyConfigProvider.setType({
      name: 'icon',
      template: '<div><ui-iconpicker ng-model="model[options.key]" groups="{{to.groups || \'bootstrap ionicons\'}}"></ui-iconpicker></div>',
      wrapper: ['bootstrapLabel', 'bootstrapHasError']
    });
  }

})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config(formlyConfigProvider) {

    formlyConfigProvider.setWrapper({
      name: 'horizontalBootstrapLabel',
      template: [
        '<label for="{{::id}}" class="{{to.anchoLabel ? to.anchoLabel : \'col-sm-2\'}} control-label">',
        '{{to.label}} {{to.required ? "*" : ""}}',
        '</label>',
        '<div class="{{to.ancho ? to.ancho : \'col-sm-10\'}}"> ',
        '<formly-transclude></formly-transclude>',
        '</div>'
      ].join(' ')
    });

    formlyConfigProvider.setType({
      name: 'horizontalInput',
      extends: 'input',
      wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
    });
  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config(formlyConfigProvider) {
    formlyConfigProvider.setType({
      name: 'datetime',
      template: '<formly-form model="fecha" fields="fields"></formly-form>',
      controller: controller,
      defaultOptions: {
        noFormControl: true
      },
      wrapper: ['bootstrapLabel', 'bootstrapHasError']
    });

    controller.$inject = ['$scope', '$parse'];
    function controller($scope, $parse) {
      var dateFormat='DD-MM-YYYY';
      var timeFormat='HH:mm';
      var separator='\'T\'';
      $scope.fecha = {

      };
      $scope.fields = [
        {
          className: 'display-flex',
          fieldGroup: [
            {
              key: 'fecha',
              className: 'flex-1',
              type: 'input',
              templateOptions: {
                type: 'date',
                required: true
              }
            },
            {
              key: 'hora',
              className: 'flex-1',
              type: 'input',
              templateOptions: {
                type: 'time',
                required: true
              }
            }
          ]
        }
      ];
      $scope.$watch('model.'+$scope.options.key, function(newValue) {
        if (!newValue) {
          $scope.fecha.fecha = newValue;
          $scope.fecha.hora = newValue;
        } else {
          newValue = moment(newValue);
          $scope.fecha.fecha = moment(newValue.format(dateFormat),dateFormat).toDate();
          $scope.fecha.hora = moment(newValue.format(timeFormat),timeFormat).toDate();
        }
      });
      $scope.$watch('fecha', function(newValue) {
        $parse('model.'+$scope.options.key).assign($scope,moment(moment(newValue.fecha).format(dateFormat)+separator+moment(newValue.hora).format(timeFormat),dateFormat+separator+timeFormat).toDate());
      }, true);
    }
  }

})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').directive('dateString', dateString);

  function dateString() {
    return {
      require: 'ngModel',
      link: function (scope, element, attr, ngModel) {
        ngModel.$parsers.push(function (value) {
          if (!value) {
            return null;
          }
          return moment(value).format('DD/MM/YYYY');
        });
        ngModel.$formatters.push(function (value) {
          if (!value) {
            return null;
          }
          return moment(value, 'DD/MM/YYYY').toDate();
        });
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config(formlyConfigProvider) {
    formlyConfigProvider.setType({
      name: 'color',
      template: '<input type="hidden" ng-model="model[options.key]"><ngjs-color-picker selected-color="model[options.key]"  options="to.pickerOptions" style="cursor: pointer"></ngjs-color-picker>',
      wrapper: ['bootstrapLabel', 'bootstrapHasError']
    });
  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config(formlyConfigProvider) {
    formlyConfigProvider.setWrapper({
      name: 'collapsable',
      template: '<div class="panel panel-default"><div class="panel-heading"  ng-click="to.collapsed = !to.collapsed" >{{to.collapsableLabel}}<span class="fa fa-chevron-down pull-right" ng-if="to.collapsed"></span><span class="fa fa-chevron-up pull-right" ng-if="!to.collapsed"></span></div><div class="panel-body" uib-collapse="to.collapsed"><formly-transclude></formly-transclude></div></div>'
    });
  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config(formlyConfigProvider) {
    formlyConfigProvider.setType({
      name: 'cellphone',
      template: '<div class="input-group"><span class="input-group-addon">0</span><input type="hidden" ng-model="model[options.key]"><input type="text" id="{{fc[0].$name+\'_prefix\'}}" cellphone-prefix name="{{fc[0].$name+\'_prefix\'}}" ng-model="model[options.key]" class="form-control" formly-skip-ng-model-attrs-manipulator><span class="input-group-addon">15</span><input id="{{fc[0].$name+\'_suffix\'}}" cellphone-suffix name="{{fc[0].$name+\'_suffix\'}}" type="text" ng-model="model[options.key]" class="form-control" formly-skip-ng-model-attrs-manipulator></div>',
      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
      defaultOptions: {
        validators: {
          phonelength: validate
        }
      }
    });

    function validate(value) {
      if (!value) {
        return true;
      }
      if (value.indexOf('0') === 0) {
        value = value.slice(1);
      } else {
        return false;
      }
      var parts = value.split('-15');
      if (parts.length != 2) {
        return false;
      }
      return (parts[0].length + parts[1].length) === 10;
    }
  }

})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').directive('cellphoneSuffix', cellphoneSuffix);

  function cellphoneSuffix() {
    return {
      require: 'ngModel',
      link: function (scope, element, attr, ngModel) {

                // convert utc date to local for display
        ngModel.$formatters.push(function (value) {
          if (!value) return '';
          if (value.indexOf('0') === 0) {
            value = value.slice(1);
          }
          var parts = value.split('-15');
          if (parts.length < 2) {
            return parts[0];
          } else {
            return parts[1];
          }
        });

                // convert local date to utc for storage
        ngModel.$parsers.push(function (value) {
          var previous = ngModel.$modelValue;
          if (!previous) {
            if (value) {
              return '0-15' + value;
            } else {
              return null;
            }
          } else {
            if (previous.indexOf('0') === 0) {
              previous = previous.slice(1);
            }
            var parts = previous.split('-15');
            var prefix;
            if (parts.length >= 2) {
              prefix = parts[0];
            } else {
              prefix = '';
            }
            if (value || prefix) {
              return '0' + prefix + '-15' + value;
            } else {
              return null;
            }
          }
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('administracionNotificaciones').directive('cellphonePrefix', cellphonePrefix);

  function cellphonePrefix() {
    return {
      require: 'ngModel',
      link: function (scope, element, attr, ngModel) {

                // convert utc date to local for display
        ngModel.$formatters.push(function (value) {
          if (!value) return '';
          if (value.indexOf('0') === 0) {
            value = value.slice(1);
          }
          var parts = value.split('-15');
          if (parts.length < 2) {
            return '';
          } else {
            return parts[0];
          }
        });

                // convert local date to utc for storage
        ngModel.$parsers.push(function (value) {
          var previous = ngModel.$modelValue;
          if (!previous) {
            if (value) {
              return '0' + value + '-15';
            } else {
              return null;
            }
          } else {
            if (previous.indexOf('0') === 0) {
              previous = previous.slice(1);
            }
            var parts = previous.split('-15');
            var suffix;
            if (parts.length >= 2) {
              suffix = parts[1];
            } else {
              suffix = parts[0];
            }
            if (value || suffix) {
              return '0' + value + '-15' + suffix;
            } else {
              return null;
            }
          }
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('administracionNotificaciones').service('EditNewState', EditNewState);

  function EditNewState(FormConf, DEFAULT_EDIT_NEW_STATE_DATASOURCE) {
    var vm = this;

    vm.get = get;

    function get(config) {
      var newConf = angular.merge({}, defaultConfig, config);
      newConf.form = angular.merge({}, newConf, config.form);
      // console.log(newConf.form);
      newConf.form.datasource = angular.merge({}, DEFAULT_EDIT_NEW_STATE_DATASOURCE, newConf.form.datasource);
      newConf.form = FormConf.get(newConf.form);
      newConf.form.resolve(newConf.stateParams);
      return newConf.form;
    }

    var defaultConfig = {
      eager: true
    };

  }
})();

/* global angular */
(function () {
  angular.module('administracionNotificaciones')
  .controller('DefaultEditCtrl', DefaultEditCtrl);

  function DefaultEditCtrl(form) {
    var vm = this;
    vm.form = form;
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').value('DEFAULT_EDIT_NEW_STATE_DATASOURCE', {
    type: 'editNew',
    isNew: '!id || id === \'nuevo\'',
    eager: true,
    editDatasource: {
      method: 'get',
      type: 'rest'
    }
  });
})();

/* global angular */
(function () {
  angular.module('administracionNotificaciones').run(run);

  function run($state, DataState, $uibModal) {
    DataState.generateModelStates('ControlDiarioReloj', [{
      defaultConfig: 'app/app/main/reloj/control-diario/list.state.json',
      defaultFilter: {
        fecha: new Date()
      },
      datasource: {
        preprocess: function (modelo) {
          modelo.forEach(function (persona) {
            if (persona.diferenciaIngreso !== null && persona.diferenciaIngreso !== undefined) {
              if (persona.diferenciaIngreso === 0) {
                persona.diferenciaIngreso = 'a tiempo';
              } else {
                persona.diferenciaIngreso = moment.duration(Math.abs(persona.diferenciaIngreso), 'minutes').humanize() + (persona.diferenciaIngreso > 0 ? ' después' : ' antes');
              }
            }
            if (persona.diferenciaSalida !== null && persona.diferenciaSalida !== undefined) {
              if (persona.diferenciaSalida === 0) {
                persona.diferenciaSalida = 'a tiempo';
              } else {
                persona.diferenciaSalida = moment.duration(Math.abs(persona.diferenciaSalida), 'minutes').humanize() + (persona.diferenciaSalida > 0 ? ' después' : ' antes');
              }
            }
          });
          return modelo;
        },
        processParams: function (params) {
          params.fecha = moment(params.fecha).format('DD-MM-YYYY');
          return params;
        }
      },
      actions: {
        verEventos: function (item, fecha) {
          $uibModal.open({
            templateUrl: 'app/app/main/reloj/control-diario/lista-eventos-control-diario.html',
            size: 'lg',
            keyboard: false,
            controllerAs: 'vm',
            controller: function (eventos) {
              var vm = this;
              vm.eventos = eventos;
              vm.fecha = fecha;
            },
            resolve: {
              eventos: function () {
                return item.eventos;
              }
            }
          });
        },
        verLicencias: function (item, fecha) {
          $uibModal.open({
            templateUrl: 'app/app/main/reloj/control-diario/lista-licencias-control-diario.html',
            size: 'lg',
            keyboard: false,
            controllerAs: 'vm',
            controller: function (licencias) {
              var vm = this;
              vm.licencias = licencias;
              vm.fecha = fecha;
            },
            resolve: {
              licencias: function () {
                return item.solicitudes;
              }
            }
          });
        }
      }
    },
    {
      defaultConfig: 'app/app/main/reloj/control-diario/list-persona.state.json',
      defaultFilter: {
        fechaDesde: new Date(),
        fechaHasta: new Date()
      },
      datasource: {
        preprocess: function (modelo) {
          modelo.forEach(function (persona) {
            if (persona.diferenciaIngreso !== null && persona.diferenciaIngreso !== undefined) {
              if (persona.diferenciaIngreso === 0) {
                persona.diferenciaIngreso = 'a tiempo';
              } else {
                persona.diferenciaIngreso = moment.duration(Math.abs(persona.diferenciaIngreso), 'minutes').humanize() + (persona.diferenciaIngreso > 0 ? ' después' : ' antes');
              }
            }
            if (persona.diferenciaSalida !== null && persona.diferenciaSalida !== undefined) {
              if (persona.diferenciaSalida === 0) {
                persona.diferenciaSalida = 'a tiempo';
              } else {
                persona.diferenciaSalida = moment.duration(Math.abs(persona.diferenciaSalida), 'minutes').humanize() + (persona.diferenciaSalida > 0 ? ' después' : ' antes');
              }
            }
          });
          return modelo;
        },
        processParams: function (params) {
          params.fechaDesde = moment(params.fechaDesde).format('DD-MM-YYYY');
          params.fechaHasta = moment(params.fechaHasta).format('DD-MM-YYYY');
          params.idPersonal = 12;
          return params;
        }
      },
      actions: {
        verEventos: function (item, fecha) {
          $uibModal.open({
            templateUrl: 'app/app/main/reloj/control-diario/lista-eventos-control-diario.html',
            size: 'lg',
            keyboard: false,
            controllerAs: 'vm',
            controller: function (eventos) {
              var vm = this;
              vm.eventos = eventos;
              vm.fecha = fecha;
            },
            resolve: {
              eventos: function () {
                return item.eventos;
              }
            }
          });
        },
        verLicencias: function (item, fecha) {
          $uibModal.open({
            templateUrl: 'app/app/main/reloj/control-diario/lista-licencias-control-diario.html',
            size: 'lg',
            keyboard: false,
            controllerAs: 'vm',
            controller: function (licencias) {
              var vm = this;
              vm.licencias = licencias;
              vm.fecha = fecha;
            },
            resolve: {
              licencias: function () {
                return item.solicitudes;
              }
            }
          });
        }
      }
    }
    ]);
  }
})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider
      .state('main.cursos.inscribirse', {
        url: '/inscribirse',
        templateUrl: 'app/app/main/pago-tic/inscripcion/inscribirse.html',
        controller: 'InscribirseCtrl as vm',
        params: {
          alumno: null
        }
      });
  }
})();

(function () {
  angular.module('administracionNotificaciones')
    .controller('InscribirseCtrl', InscribirseCtrl);

  function InscribirseCtrl($scope, $state, $stateParams, Dialogo, Curso, AlumnoOficio) {
    var vm = this;
    vm.volver = volver;
    vm.model = {};
    vm.model.alumno = $stateParams.alumno;
    vm.conceptos = [];
    vm.conceptosAgrupados = [];
    vm.fields = [
      {
        key: 'curso',
        type: 'select',
        className: 'col-lg-6',
        templateOptions: {
          label: 'Curso:',
          options: [],
          required: true,
          ngOptions : 'options as options.nombre for options in to.options track by options.id',
          onChange: function (value) {
            if (value) {
              Curso.listarConceptos({ id: value.id }).$promise.then(function (response) {
                vm.conceptos = response;
                vm.planes = obtenerPlanes(vm.conceptos); // Obtener los planes disponibles
                vm.fields[1].templateOptions.options = vm.planes; // Actualizar las opciones del campo de planes
                vm.conceptosAgrupados = agruparYOrdenarConceptos(vm.conceptos);
              });
            }
          }
        }
      },
      {
        key: 'plan',
        type: 'select',
        className: 'col-lg-6',
        templateOptions: {
          label: 'Plan:',
          options: [],
          required: true,
          ngOptions: 'option as option for option in to.options'
        }
      }
    ];

    // Buscar los cursos quiero paguna de 100 y ordenados por nombre
    Curso.listar({sort: 'nombre,asc', page: 0, size: 100}).$promise.then(function (response) {
      vm.fields[0].templateOptions.options = response.content;
    });

    function agruparYOrdenarConceptos(conceptos) {
      return conceptos.reduce(function (acc, concepto) {
        if (!acc[concepto.plan]) {
          acc[concepto.plan] = [];
        }
        acc[concepto.plan].push(concepto);
        acc[concepto.plan].sort(function (a, b) {
          return a.orden - b.orden;
        });
        return acc;
      }, {});
    }

    function obtenerPlanes(conceptos) {
      if (!Array.isArray(conceptos)) {
        return [];
      }
      var planes = conceptos.map(function (concepto) {
        return concepto.plan;
      });
      return Array.from(new Set(planes)); // Eliminar duplicados
    }

    function volver() {
      $state.go('main.alumnos.alumnos', {}, { location: 'replace' });
    }

    vm.submit = function() {
      Dialogo.mostrarCargando();
      AlumnoOficio.inscribirse({
        id: vm.model.alumno.id,
        id_curso: vm.model.curso.id,
        plan: vm.model.plan
      }).$promise.then(function() {
        Dialogo.mostrarExito({
          icono: 'fa-check',
          titulo: 'Inscripción realizada exitosamente',
          texto: 'Alumno: ' + vm.model.alumno.nombreCompleto + ', Curso: ' + vm.model.curso.nombre,
          backdrop: 'static',
          keyboard: false,
          accionSi: volver
        }, $scope);
        Dialogo.ocultarCargando();
      }).catch(function(error) {
        Dialogo.mostrarError({
          titulo: 'Error',
          texto: error.data.message
        });
        Dialogo.ocultarCargando();
      });
    };
  }
})();
(function () {
  angular.module('administracionNotificaciones').run(run);
  function run($timeout, $state, Localidad, DataState) {
    DataState.generateModelStates('AlumnoOficio', [
      {
        defaultConfig: 'app/app/main/pago-tic/alumnos/list.state.json',
        actions: {
          nuevoHijo: function() {
            $state.go('^.edit', {id: 'nuevo'});
          },
          inscribirse: function (item) {
            $state.go('main.cursos.inscribirse', {alumno: item});
          }
          
        }
      },
      {
        defaultConfig: 'app/app/main/pago-tic/alumnos/edit.state.json',
        controller: 'AlumnoOficioEditCtrl as vm',
        datasource: {
          preprocess: function (modelo) {
            if (!modelo.localidad) {
              Localidad.getVillaMaria().$promise.then(function (response) {
                modelo.localidad = angular.copy(response);
              });
            }
            return modelo;
          }
        }
      }
    ]);
  }
})();
/* global angular */
(function () {
  angular.module('administracionNotificaciones')
  .controller('AlumnoOficioEditCtrl', AlumnoOficioEditCtrl);

  function AlumnoOficioEditCtrl(Localidad, form) {
    var vm = this;
    vm.form = form;

    vm.form.fields.push({
      key: 'localidad',
      type: 'typeahead',
      templateOptions: {
        label: 'Localidad:',
        placeholder: 'Buscar por nombre o código postal',
        propiedad: 'id',
        propiedadFiltro: 'nombre',
        ngOptions: 'item as (item.nombreCompletoMostrar) for item in to.funcion($viewValue) | limitTo:30',
        espera: 500,
        asincrono: true,
        required: true,
        funcion: function ($viewValue) {
          return Localidad.get({ filtro: $viewValue }).$promise
              .then(function (response) {
                return response.content; // Devuelve solo la lista de localidades
              });
        }
      },
      ngModelAttrs: {
        ngOptions: {
          attribute: 'uib-typeahead'
        }
      }
    });
  }
})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider.state('main.materias-cursando.materias',{
      url: '',
      templateUrl: 'app/app/main/materia-cursando/materias-cursando/materias-cursando.html',
      controller: 'MateriaCursandoCtrl as vm'
    });

  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').controller('MateriaCursandoCtrl', MateriaCursandoCtrl);

  function MateriaCursandoCtrl(materiaCursando, $state) {
    var vm = this;
    vm.materiaCursando = materiaCursando;
    vm.verMateria = verMateria;

    function verMateria(materia) {
      $state.go('main.materias-cursando.detalle',{materia:materia});
    }
  }

})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider.state('main.materias-cursando.detalle', {
      url: '/detalle',
      templateUrl: 'app/app/main/materia-cursando/materia/materia.html',
      controller: 'MateriaCtrl as vm',
      params: {
        materia: null
      },
      resolve: {
        materia: function ($stateParams) {
          return $stateParams.materia;
        }
      }
    });
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').controller('MateriaCtrl', MateriaCtrl);

  function MateriaCtrl(materia, $state) {
    var vm = this;
    vm.materia = materia;
    vm.volver = volver;
    vm.getEstado = getEstado;
    vm.getNombreEstado = getNombreEstado;

    function volver() {
      $state.go('main.materias-cursando.materias');
    }

    function getNombreEstado(detalle) {
      if (detalle.estado === 'APROBADO') {
        return 'Aprobado';
      } else if (detalle.estado === 'NO_APROBADO') {
        return 'No Aprobado';
      }
    }

    function getEstado(detalle) {
      if (detalle.estado === 'APROBADO') {
        return 'label-success';
      } else if (detalle.estado === 'NO_APROBADO') {
        return 'label-warning';
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider.state('main.libro-de-temas.detalle', {
      url: '/detalle',
      templateUrl: 'app/app/main/libro-de-temas/libro-de-temas/libro-de-temas.html',
      controller: 'LibroDeTemasCtrl as vm',
      params: {
        materia: null,
        especialidad: null
      },
      resolve: {
        clases: function(LibroDeTemas, $stateParams) {
          var materia = $stateParams.materia.codigoMateria;
          var especialidad = $stateParams.especialidad.codigoAcademico;
          var plan =  $stateParams.materia.plan;
          var clave = especialidad + '-' + plan + '-' + materia;
          var parametros = {
            clave: clave
          };
          return LibroDeTemas.buscarFechas(parametros).$promise;
        }
      }
    });

  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').controller('LibroDeTemasCtrl', LibroDeTemasCtrl);

  function LibroDeTemasCtrl(clases, $state) {
    var vm = this;
    vm.clases = clases;
    vm.getEstado = getEstado;
    vm.getTitulo = getTitulo;
    vm.getFuenteTexto = getFuenteTexto;
    vm.volver = volver;

    formatearArrayObservaciones();

    function formatearArrayObservaciones() {
      vm.clases.forEach(function(clase) {
        if (clase.claseDictada) {
          clase.claseDictada.arrayObservaciones = crearArrayObservaciones(clase);
        }
      });
    }

    function getEstado(clase) {
      var estilo = '';

      if (clase.claseDictada && !clase.claseDictada.titulo) {
        estilo = estilo + 'item-disabled-text ';
      }

      if (!clase.claseDictada) {
        estilo = estilo + 'item-disabled-text ';
      }

      if (moment(clase.fecha).isAfter(moment())) {
        estilo = '';
        estilo = estilo + 'fecha-posterior';
      } else {
        estilo = estilo + 'aprobada';
      }

      return estilo;
    }

    function crearArrayObservaciones(clase) {
      if (clase.claseDictada && clase.claseDictada.observaciones) {
        var observ = clase.claseDictada.observaciones;
        var arrayObservaciones = observ.split('\n');
        return arrayObservaciones;
      }
    }

    function getTitulo(clase) {
      if (clase.claseDictada) {
        if (clase.claseDictada.titulo) {
          return clase.claseDictada.titulo;
        } else if (clase.claseDictada.descripcion) {
          return clase.claseDictada.descripcion;
        }
      } else {
        return 'No hay datos de esta clase.';
      }
    }

    function getFuenteTexto(clase) {
      if (!clase.claseDictada) {
        return 'texto-cursiva';
      }
    }

    function volver(){
      $state.go('main.libro-de-temas.materias');
    }

  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider.state('main.libro-de-temas.materias',{
      url: '',
      templateUrl: 'app/app/main/libro-de-temas/materias-libro-de-temas/materias-libro-de-temas.html',
      controller: 'MateriasLibroDeTemasCtrl as vm'
    });

  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').controller('MateriasLibroDeTemasCtrl', MateriasLibroDeTemasCtrl);

  function MateriasLibroDeTemasCtrl(materias, $state, $filter) {
    var vm = this;
    vm.getEstado = getEstado;
    vm.verLibroDeTemas = verLibroDeTemas;
    vm.materias = quitarMateriasAprobadasYNoCursadas(materias.detalles);

    function quitarMateriasAprobadasYNoCursadas(materias) {
      materias = $filter('filter')(materias, function(value) {
        return value.estadoMateria === 'CURSANDO' || value.estadoMateria ==='REGULARIZADA';
      });
      return materias;
    }

    function getEstado(materia) {
      if (materia.estadoMateria === 'REGULARIZADA') {
        return 'Regularizada';
      } else if (materia.estadoMateria === 'CURSANDO') {
        return 'Cursando';
      }
    }

    function verLibroDeTemas(materia) {
      var especialidad = materias.persona.alumno.especialidad;
      $state.go('main.libro-de-temas.detalle',{materia:materia, especialidad:especialidad});
    }


  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider.state('main.comisiones-para-cursado',{
      url: 'comisiones-para-cursado',
      templateUrl: 'app/app/main/inscripcion-cursado/comisiones-para-cursado/comisiones-para-cursado.html',
      controller: 'ComisionesParaCursadoCtrl as vm',
      resolve: {
        comisionesCursado: function(ComisionesCursado) {
          return ComisionesCursado.getComisiones();
        },
        materia: function(ComisionesCursado) {
          return ComisionesCursado.getMateria();
        }
      }
    });

  }

})();
(function() {
  'use strict';

  angular.module('administracionNotificaciones').service('ComisionesCursado', ComisionesCursado);

  function ComisionesCursado() {
    var vm = this;

    vm.getMateria = getMateria;
    vm.setMateria = setMateria;
    vm.getComisiones = getComisiones;
    vm.setComisiones = setComisiones;

    var materia;
    var comisiones;

    function getComisiones() {
      return comisiones;
    }

    function setComisiones(c) {
      comisiones = c;
    }

    function getMateria() {
      return materia;
    }

    function setMateria(m) {
      materia = m;
    }

  }

})();
(function () {
  'use strict';
  angular
    .module('administracionNotificaciones')
    .controller('ComisionesParaCursadoCtrl', ComisionesParaCursadoCtrl);

  function ComisionesParaCursadoCtrl($scope, $state, Dialogo, InscripcionCursado, comisionesCursado, materia) {
    var vm = this;

    vm.comisionesCursado = comisionesCursado;
    vm.getHorarios = getHorarios;
    vm.confirmarInscripcion = confirmarInscripcion;
    vm.volver = volver;

    var comisionSeleccionada = {};

    function confirmarInscripcion(comision) {
      var config = {};
      config.texto = '¿Está seguro que desea inscribirse a esta comisión?';
      config.accionSi = inscribir;
      comisionSeleccionada = comision;
      Dialogo.mostrarConfirmacion(config, $scope);
    }

    function inscribir() {
      Dialogo.mostrarCargando();
      // var config = {};
      var objetoInscripcionCursado = armarObjetoInscripcionCursado();
      InscripcionCursado.inscribir(
        objetoInscripcionCursado,
        function (respuesta) {
          Dialogo.ocultarCargando();
          Dialogo.mostrarExito({
            icono: 'fa-check',
            plantilla: '/app/app/main/inscripcion-cursado/comisiones-para-cursado/dialogo-confirmacion-visualizacion-comisiones.html',
            titulo: 'Inscripción Exitosa',
            parrafos: ['Comisión: " + respuesta.comision, "Edificio: ' + respuesta.cursado.edificio, 'Horario: ' + respuesta.cursado.horario, 'Checksum: ' + respuesta.cursado.checksum],
            accionSi: volver
          }, $scope);
        },
        errorInscripcion);
    }

    function armarObjetoInscripcionCursado() {
      return {
        especialidad: comisionSeleccionada.especialidad,
        plan: comisionSeleccionada.plan,
        materia: comisionSeleccionada.materia,
        comision: comisionSeleccionada.comision,
        detalleMateria: materia
      };
    }

    function errorInscripcion(respuesta) {
      Dialogo.mostrarError(
        {
          titulo: 'Error',
          texto: respuesta.data.message
        },
        $scope
      );
      Dialogo.ocultarCargando();
    }

    function getHorarios(materia) {
      if (!materia.horarioCursado) return [];
      var horarios = [];
      materia.horarioCursado.split(/,\s?/).forEach(function (horario) {
        if (horario.indexOf('C') === 0) {
          horario = horario.substring(3);
        }
        horarios.push(horario);
      });
      return horarios;
    }

    function volver() {
      $state.go('main.inscripcion-cursado');
    }
  }
})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').directive('estadisticaExamen', estadisticaExamen);

  function estadisticaExamen() {
    return {
      restrict: 'E',
      templateUrl: 'app/app/main/examen/estadistica-examen/estadistica-examen.html',
      replace : true,
      controller: 'EstadisticaExamenCtrl as vm',
      bindToController: true,
      scope: {
        examenes: '='
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').controller('EstadisticaExamenCtrl', EstadisticaExamenCtrl);

  function EstadisticaExamenCtrl($scope) {
    var vm = this;

    vm.estadistica = {};

    $scope.$watch('vm.examenes', estadisticas);


    function estadisticas(){
      if (!vm.examenes) return;
      var cantidadAusente = 0;
      var notaSinAplazo = 0;
      var notaConAplazo = 0;
      var cantidadExamenesAnotados = 0;
      var cantidadExamenSinAplazo = 0;
      var cantidadExamenConAplazo = 0;
      var soloAplazos = 0;
      var aproboPractica = 0;

      vm.examenes.detalles.forEach(function(detalle){
        cantidadExamenesAnotados = cantidadExamenesAnotados + 1;
        if(detalle.estadoExamen){
          if (detalle.estadoExamen === 'AUSENTE') {
            cantidadAusente = cantidadAusente + 1;
          } else if (detalle.estadoExamen === 'UNO' || detalle.estadoExamen === 'DOS' || detalle.estadoExamen === 'TRES') {
            cantidadExamenConAplazo = cantidadExamenConAplazo + 1;
            notaConAplazo = notaConAplazo + getNumeroNota(detalle);
            soloAplazos = soloAplazos + 1;
          } else if(detalle.estadoExamen !=='APROBADO'){
            cantidadExamenSinAplazo = cantidadExamenSinAplazo + 1;
            cantidadExamenConAplazo = cantidadExamenConAplazo + 1;
            notaSinAplazo = notaSinAplazo + getNumeroNota(detalle);
            notaConAplazo = notaConAplazo + getNumeroNota(detalle);
          } else if(detalle.estadoExamen ==='APROBADO'){
            aproboPractica = aproboPractica + 1;
          }
        }
      });

      vm.estadistica.promedioSinAplazo = notaSinAplazo/cantidadExamenSinAplazo;
      vm.estadistica.promedioConAplazo = notaConAplazo/cantidadExamenConAplazo;
      vm.estadistica.cantidadExamenesAnotados = cantidadExamenesAnotados;
      vm.estadistica.cantidadMateriasDesaprobadas = soloAplazos;
      vm.estadistica.cantidadMateriasAprobadas = cantidadExamenSinAplazo + aproboPractica;
      vm.estadistica.cantidadAusencias = cantidadAusente;
    }

    function getNumeroNota(detalle){
      if (detalle.estadoExamen === 'DIEZ') {
        return 10;
      } else if (detalle.estadoExamen === 'NUEVE') {
        return 9;
      } else if (detalle.estadoExamen === 'OCHO') {
        return 8;
      } else if (detalle.estadoExamen === 'SIETE') {
        return 7;
      } else if (detalle.estadoExamen === 'SEIS') {
        return 6;
      } else if (detalle.estadoExamen === 'CINCO') {
        return 5;
      } else if (detalle.estadoExamen === 'CUATRO') {
        return 4;
      } else if (detalle.estadoExamen === 'TRES') {
        return 3;
      } else if (detalle.estadoExamen === 'DOS') {
        return 2;
      } else if (detalle.estadoExamen === 'UNO') {
        return 1;
      }
    }

    estadisticas();
  }
})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider.state('main.realizarEncuesta',{
      url: 'encuestas/:encuesta',
      templateUrl: 'app/app/main/encuestas/realizar-encuesta/realizar-encuesta.html',
      controller: 'RealizarEncuestaCtrl as vm',
      resolve: {
        encuesta: function($stateParams, Encuesta) {
          return Encuesta.listarPreguntas($stateParams.encuesta).$promise;
        }
      }
    });

  }

})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').controller('RealizarEncuestaCtrl', RealizarEncuestaCtrl);

  function RealizarEncuestaCtrl($scope, $state, orderByFilter, Dialogo, Encuesta, encuesta) {
    var vm = this;
    vm.encuesta = encuesta;
    vm.encuesta.detalles = orderByFilter(vm.encuesta.detalles, 'pregunta.ordenPregunta');
    vm.finalizar = finalizar;
    vm.cambiarRating = cambiarRating;
    vm.volver = volver;
    vm.toogleCheckbox = toogleCheckbox;
    vm.check = false;
    vm.getRating = getRating;
    initRespuestas();

    function initRespuestas() {
      vm.encuesta.detalles.forEach(function (detalle) {
        detalle.respuesta = null;
      });
    }

    function cambiarRating(pregunta, rating) {
      if (rating !== null) {
        if (pregunta.deshabilitado && rating !== -1) {
          pregunta.respuesta = rating - 1;
          pregunta.deshabilitado = false;
        } else if (pregunta.deshabilitado && rating === -1) {
          pregunta.respuesta = 2;
        } else {
          pregunta.respuesta = rating - 1;
        }
      } else {
        pregunta.respuesta = rating;
      }
    }

    function getRating(pregunta) {
      if (pregunta.respuesta !== null && !pregunta.deshabilitado) {
        return pregunta.respuesta + 1;
      } else {
        return 0;
      }
    }

    function finalizar() {
      if (encuestaCompleta()) {
        Dialogo.mostrarConfirmacion({
          texto: '¿Está seguro que desea confirmar y enviar la encuesta? Luego de hacer esto no podrá modificar sus respuestas.',
          titulo: 'Enviar encuesta',
          icon: 'fa-check',
          accionSi: function () {
            Dialogo.mostrarCargando();
            Encuesta.guardar(vm.encuesta).$promise.then(function () {
              Dialogo.mostrarExito({
                icono: 'fa-check',
                titulo: 'Encuesta realizada exitosamente',
                texto: 'Asignatura: ' + vm.encuesta.asignatura.nombre + ', Docente: ' + vm.encuesta.persona.apellido + ', ' + vm.encuesta.persona.nombre,
                backdrop: 'static',
                keyboard: false,
                accionSi: volver
              }, $scope);
            }, function (error) {
              Dialogo.ocultarCargando();
              Dialogo.mostrarError({
                titulo: 'Error',
                texto: error.data.message,
                accionSi: volver
              }, $scope);
            });
          }
        }, $scope);
      } else {
        Dialogo.mostrarError({
          titulo: 'Error',
          texto: 'Debe completar la encuesta antes de enviarla'
        }, $scope);
      }
    }

    function encuestaCompleta() {
      var flag = true;
      vm.encuesta.detalles.forEach(function (detalle) {
        if (detalle.pregunta.tipoPregunta.nombre === 'radius' && detalle.respuesta === null) {
          flag = false;
        }
        if (detalle.pregunta.tipoPregunta.nombre === 'text' && detalle.opinion === null) {
          flag = false;
        }
      });
      return flag;
    }

    function volver() {
      $state.go('main.encuestas', {}, { location: 'replace' });
    }

    function toogleCheckbox(pregunta, value) {
      if (value) {
        cambiarRating(pregunta, -1);
      } else {
        cambiarRating(pregunta, null);
      }

    }
  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider
    .state('main.analitica-encuesta-home',{
      url: 'analitica-encuesta/home',
      templateUrl: 'app/app/main/encuestas/analitica/analitica-encuesta-home.html',
      controller: 'AnaliticaEncuestaHomeCtrl as vm',
      resolve: {
        informes: function(AnaliticaEncuesta) {
          return AnaliticaEncuesta.obtenerInformesDisponibles();
        }
      }})
      .state('main.analitica-docente-comparativa', {
        url: 'analitica-docente/comparativa/:dashboard',
        params: {
          especialidad: null,
          plan: null,
          materia: null,
          comision: null
        },
        templateUrl: 'app/app/main/encuestas/analitica/analitica-encuesta-detail.html',
        controller: 'AnaliticaEncuestaDetailCtrl as vm',
        resolve: {
          link: function($stateParams, AnaliticaEncuesta) {
            return AnaliticaEncuesta.obtenerLinkComparativa({
              id: $stateParams.dashboard,
              especialidad: parseInt($stateParams.especialidad,10),
              comision: $stateParams.comision,
              plan: parseInt($stateParams.plan,10),
              materia: $stateParams.materia
            }).$promise;
          }
        }
      })
      .state('main.analitica-encuesta-detail', {
      url: 'analitica-encuesta/details/:dashboard',
      templateUrl: 'app/app/main/encuestas/analitica/analitica-encuesta-detail.html',
      controller: 'AnaliticaEncuestaDetailCtrl as vm',
      resolve: {
        link: function($stateParams, AnaliticaEncuesta) {
          console.log($stateParams);
          return AnaliticaEncuesta.obtenerLink({id : $stateParams.dashboard}).$promise;
        }
      }
    });
  }

})();


(function() {
  'use strict';

  angular.module('administracionNotificaciones').controller('AnaliticaEncuestaHomeCtrl', AnaliticaEncuestaHomeCtrl);

  function AnaliticaEncuestaHomeCtrl($sce, $state, informes) {
    var vm = this;    
    vm.informes = informes;

    vm.verInformes = verInformes;

    function verInformes(informe) {

      $state.go('main.analitica-encuesta-detail', {dashboard: informe.id});

    }
  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').controller('AnaliticaEncuestaDetailCtrl', AnaliticaEncuestaDetailCtrl);

  function AnaliticaEncuestaDetailCtrl($sce, link) {
    var vm = this;    
    vm.link1 = $sce.trustAsResourceUrl(link.mensaje);
    
    var pageContentWidth = document.getElementById('sidebar-wrapper').offsetHeight;
    var altoMetabase = pageContentWidth * 0.87;

    vm.innerComponentStyle = {
      height: altoMetabase + 'px',
      border: 'none'
  
    };
   
  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider.state('main.turno-examen',{
      url: 'turnos',
      templateUrl: 'app/app/main/inscripcion-examen/turno-examen/turno-examen.html',
      controller: 'TurnoExamenCtrl as vm',
      
      resolve: {
        examen: function(Examen) {
          return Examen.get().$promise;
        }
      }

    });

  }
  
})();
(function() {
  'use strict';
  
  angular.module('administracionNotificaciones').service('TurnosExamen', TurnosExamen);
  
  function TurnosExamen() {
    var vm = this;
    var turnos = [];
  
    vm.setTurnos= setTurnos;
    vm.getTurnos= getTurnos;
  
    function setTurnos(t){
      turnos = t;
    }

    function getTurnos(){
      return turnos;
    }
  }
  
})();
(function() {
  'use strict';

  angular.module('administracionNotificaciones').controller('TurnoExamenCtrl', TurnoExamenCtrl);

  function TurnoExamenCtrl(TurnosExamen, Dialogo, $scope, $state, InscripcionExamen, $filter) {
    var vm = this;
    vm.turnosInscripcion = TurnosExamen.getTurnos();
    vm.turnosInscripcion.detalles = quitarTurnosInscriptos(vm.turnosInscripcion.detalles);
    vm.confirmarInscripcion = confirmarInscripcion;
    vm.volver = volver;
    var turnoSeleccionado = {};

    function confirmarInscripcion(turno){
      var config = {};
      config.texto = '¿Esta seguro que desea inscribirse a esta materia?';
      config.accionSi = inscribir;
      turnoSeleccionado = turno;
      Dialogo.mostrarConfirmacion(config, $scope);
    }

    function inscribir(){
      Dialogo.mostrarCargando();
      var objetoInscripcionExamen = armarObjetoInscripcionExamen();
      InscripcionExamen.inscribir(objetoInscripcionExamen, function(detalleInscripcion) {
        Dialogo.ocultarCargando();
        Dialogo.mostrarExito({
          icono: 'fa-check',
          plantilla: 'app/app/main/inscripcion-examen/turno-examen/dialogo-inscripcion-exitosa.html',
          titulo: 'Inscripción Exitosa',
          accionSi: volver,
          parrafos: ['Materia: '+detalleInscripcion.materia.nombreMateria, 'Día: '+detalleInscripcion.dato.inscripto,
           'Horario Teórico: '+detalleInscripcion.dato.horarioTeorico, 'Horario Práctico: '+detalleInscripcion.dato.horarioPractico,
            'Aula: '+detalleInscripcion.dato.aula, 'Checksum: '+detalleInscripcion.dato.checksum]
        }, $scope);
      }, errorInscripcion);
    }

    function armarObjetoInscripcionExamen(){
      var objetoDetalleMateriaParaExamen = vm.turnosInscripcion.materia;

      var fechaExamen = turnoSeleccionado;
      fechaExamen.horarioSeleccionado = fechaExamen.horariosDisponibles[0];

      var objetoInscripcionExamen = {
        materia: objetoDetalleMateriaParaExamen,
        fecha: fechaExamen,
        dato: null //es para la respuesta
      };

      return objetoInscripcionExamen;
    }

    function errorInscripcion(respuesta){
      Dialogo.mostrarError($scope, {
        titulo: 'Error',
        texto: respuesta.data.message
      });
      Dialogo.ocultarCargando();
    }

    function volver(){
      $state.go('main.inscripcion-examen');
    }

    function quitarTurnosInscriptos(turnos) {
      return $filter('filter')(turnos, function(value) {
        return value.fechaExamen !== vm.turnosInscripcion.materia.fechaExamen;
      });
    }
  }

})();
(function () {
  'use strict';

  angular.module('administracionNotificaciones').directive('sidebar', sidebar);

  function sidebar() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/tema/sidebar/sidebar.html',
      replace: true,
      controller: 'SidebarCtrl as sidebar',
      bindToController: true
    };
  }
})();

(function () {
  'use strict';

  angular
  .module('administracionNotificaciones')
  .controller('SidebarCtrl', SidebarCtrl);

  function SidebarCtrl($rootScope, Menu) {
    var vm = this;

    vm.toggle = toggle;
    vm.menu = Menu;

    $rootScope.sidebarOpen = true;

    $rootScope.$watch('info', function (newValue) {
      vm.info = newValue;
    });

    function toggle() {
      $rootScope.sidebarOpen = !$rootScope.sidebarOpen;
    }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').directive('pageHeader', pageHeader);

  function pageHeader() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/tema/page-header/page-header.html',
      replace: true
    };
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').service('StateConfig', StateConfig);

  function StateConfig() {
    var vm = this;

    vm.getStateName = getStateName;
    vm.getStateUrl = getStateUrl;
    vm.getStateData = getStateData;

    function getStateName(state) {
      if (state.state) {
        return state.state;
      } else {
        var name = 'main.' + state.model.pluralName.toLowerCase() + '.';
        if (state.name) {
          name += state.name;
        } else {
          name += state.type;
        }
        return name;
      }
    }

    function getStateParams(state) {
      if (state.params) {
        return state.params;
      } else if (state.type === 'edit') {
        return ['id'];
      } else {
        return [];
      }
    }
    
    function getStateData(state) {
      if (state.type === 'list') {
        return angular.merge({mantenerCargando: true}, state.data);
      } else {
        return angular.merge({}, state.data);
      }
    }

    function getStateUrl(state) {
      if (state.url) {
        return state.url;
      } else {
        var url;
        if (state.name) {
          url = state.name;
        } else {
          url = state.type;
        }
        var params = getStateParams(state).map(function(s) {
          return ':'+s;
        }).join('/');
        if (params.length > 0) {
          url += '/' + params;
        }
        return url;
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').provider('RuntimeStates', function runtimeStates($stateProvider) {
    // runtime dependencies for the service can be injected here, at the provider.$get() function.
    this.$get = function() { // for example
      return {
        addState: function(name, state) {
          $stateProvider.state(name, state);
        }
      };
    };
  });
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').service('DataState', DataState);

  function DataState($http, $q, $injector, $timeout, $location, $parse, $state, $sessionStorage, $rootScope, RuntimeStates, ListState, EditNewState, ModelConfig, Menu, StateConfig) {
    var vm = this;

    var statePromises = [];

    var initialUrl;

    restoreState();

    vm.generateModelStates = generateModelStates;
    vm.setInitialUrl = setInitialUrl;

    function generateModelStates(model, states) {
      var deferState = $q.defer();
      statePromises.push(deferState.promise);
      if (angular.isString(model)) {
        var resource = $injector.get(model);
        var modelObject = resource.config;
        if (!modelObject.name) {
          modelObject.name = model;
        }
        model = modelObject;
      }
      ModelConfig.generate(model);
      var promises = [];
      states.forEach(function (state) {
        if (angular.isString(state)) {
          promises.push($http.get(state).then(function(response) {
            return response.data;
          }));
        } else if (state.defaultConfig && angular.isString(state.defaultConfig)) {
          promises.push($http.get(state.defaultConfig).then(function(response) {
            state = angular.merge({}, response.data, state);
            return state;
          }));
        } else {
          promises.push($timeout(function () {
            return state;
          }));
        }
      });
      $q.all(promises).then(function(states) {
        generateParentState(model);
        states.forEach(function(state) {
          state.model = angular.merge({}, model, state.model);
          if (state.type === 'list') {
            generateList(state);
          } else if (state.type === 'edit') {
            generateEdit(state);
          } else {
            generateCustom(state);
          }
        });
        Menu.addMenuItems(model, states);
        deferState.resolve(true);
      }, function(error) {
        deferState.reject(error);
      });
    }

    function generateParentState(model) {
      RuntimeStates.addState('main.' + model.pluralName.toLowerCase(), {
        url: model.pluralName.toLowerCase()+'/',
        template: '<ui-view></ui-view>'
      });
    }

    function generateList(state) {
      var data = StateConfig.getStateData(state);
      var listResolve = function($stateParams) {
        state.stateParams = $stateParams;
        return ListState.get(state).promise.then(function(value) {
          // console.log('Resolved');
          data.state = value;
          return value;
        });
      };
      listResolve.$inject = ['$stateParams'];
      RuntimeStates.addState(StateConfig.getStateName(state), {
        url: StateConfig.getStateUrl(state),
        templateUrl: state.templateUrl ? state.templateUrl : 'app/components/abm/list/state/default-list.html',
        controller: state.controller ? state.controller : 'DefaultListCtrl as vm',
        data: data,
        resolve: {
          list: listResolve
        }
      });
    }

    function generateEdit(state) {
      var formResolve = function($stateParams) {
        state.stateParams = $stateParams;
        return EditNewState.get(state).promise.then(function(value) {
          data.state = value;
          return value;
        });
      };
      formResolve.$inject = ['$stateParams'];
      var data = {};
      RuntimeStates.addState(StateConfig.getStateName(state), {
        url: StateConfig.getStateUrl(state),
        templateUrl: state.templateUrl ? state.templateUrl : 'app/components/abm/form/state/default-edit.html',
        controller: state.controller ? state.controller : 'DefaultEditCtrl as vm',
        data: data,
        resolve: {
          form: formResolve
        }
      });
    }

    function generateCustom(state) {
      var data = {};
      var customResolve = function($stateParams) {
        return state.resolve($stateParams).then(function(value) {
          data.state = value;
          return value;
        });
      };
      customResolve.$inject = ['$stateParams'];
      RuntimeStates.addState(StateConfig.getStateName(state), {
        url: StateConfig.getStateUrl(state),
        templateUrl: state.templateUrl,
        controller: state.controller,
        data: data,
        resolve: customResolve
      });
    }

    function setInitialUrl(url) {
      initialUrl = url;
    }

    function restoreState() {
      $timeout(function() {
        $q.all(statePromises).then(function() {
          $location.path(initialUrl);
        }, function() {
          $location.path(initialUrl);
        });
      });
    }

  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').service('Resource', Resource);

  function Resource($parse, $injector, DEFAULT_RESOURCE) {
    var vm = this;

    vm.getMethod = getMethod;

    function getMethod(key, customConfig) {
      var resourceName = customConfig.resource.name || customConfig.model.name;
      var resource = $injector.get(resourceName);
      var configData = angular.merge({}, DEFAULT_RESOURCE.methods, (resource && resource.config && resource.config.resource ? resource.config.resource.methods : {}), customConfig.resource.methods);
      var methodConfig = $parse(key)(configData);
      var method = function(data, success, error) {
        var params;
        if (!methodConfig.params) {
          params = null;
        } else if (angular.isObject(methodConfig.params)) {
          params = {};
          angular.forEach(methodConfig.params, function (value, key) {
            params[key] = data[value];
          });
        } else {
          params = data;
        }
        return resource[methodConfig.name](params, success, error);
      };
      return method;
    }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').value('DEFAULT_RESOURCE', {
    methods: {
      save: {
        name: 'save',
        params: true
      },
      update: {
        name: 'update',
        params: true
      },
      delete: {
        name: 'delete',
        params: {
          id: 'id'
        }
      },
      query: {
        name: 'query',
        params: true
      },
      queryChildren: {
        name: 'queryChildren',
        params: true
      },
      get: {
        name: 'get',
        params: true
      }
    }
  });
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').service('Messages', Messages);

  function Messages($parse, DEFAULT_MESSAGES) {
    var vm = this;

    vm.get = get;

    function get(key, customConfig) {
      return $parse(key)(angular.merge({}, DEFAULT_MESSAGES, customConfig ? customConfig.messages : {}));
    }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').value('DEFAULT_MESSAGES', {
    list: {
      title: '{{scope.model.pluralName | capitalizeFirstLetter}}'
    },
    edit: {
      title: '{{scope.model.isNewExpr(scope.formData) ? (scope.model.female ? \'Nueva \' : \'Nuevo \') + (model.displayName ? model.displayName : model.name) : (\'Editar \' +(model.displayName ? model.displayName : model.name))}}'
    },
    save: {
      success: {
        title: 'Éxito',
        message: '{{model.article | capitalizeFirstLetter}} {{model.displayName ? model.displayName : model.name}} se ha guardado correctamente.'
      },
      error: {
        title: 'Error'
      }
    },
    delete: {
      confirm: {
        title: 'Confirmación',
        message: '¿Está seguro que desea eliminar {{model.article}} {{model.displayName ? model.displayName : model.name}}?'
      },
      success: {
        title: 'Éxito',
        message: '{{model.article | capitalizeFirstLetter}} {{model.displayName ? model.displayName : model.name}} se ha borrado correctamente.'
      },
      error: {
        title: 'Error'
      }
    }
  });
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').filter('capitalizeFirstLetter', capitalizeFirstLetter);

  function capitalizeFirstLetter() {
    return function capitalizeFirstLetter(string) {
      if (!string || !angular.isString(string)) return string;
      return string.charAt(0).toUpperCase() + string.slice(1);
    };
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').directive('abmTitle', abmTitle);

  function abmTitle() {
    return {
      restrict: 'E',
      template: '<span bind-html-compile="getTitle()"></span>',
      controller: controller,
      replace: false,
      scope: {
        scope: '=',
        key: '='
      }
    };
  }

  function controller($scope, Messages) {
    $scope.getTitle = getTitle;
    function getTitle() {
      return Messages.get($scope.key, $scope.scope);
    }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').service('ModelConfig', ModelConfig);

  function ModelConfig($parse) {
    var vm = this;
    vm.generate = generate;

    function generate(config) {
      if (!config.resource) {
        config.resource = {};
      }
      if (!config.resource.name) {
        config.resource.name = config.name;
      }
      if (!config.pluralName) {
        config.pluralName = config.name + 's';
      }
      if (!config.article) {
        config.article = config.female ? 'la' : 'el';
      }
      if (!config.isNew) {
        config.isNewExpr = function(data) {
          return !data || !data.id || data.id === 'nuevo';
        };
      } else if (angular.isFunction(config.isNew)) {
        config.isNewExpr = config.isNew;
      } else {
        var innerFunction = $parse(config.isNew);
        config.isNewExpr = function(conf) {
          return innerFunction(conf);
        };
      }
      return config;
    }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').filter('summary', summary);

  function summary(filterFilter, $parse) {
    return function(data,type,mapper,filter) {
      if (!data) {
        return;
      }
      if (filter) {
        if (angular.isFunction(filter)) {
          data = filterFilter(data,function(item) {
            return filter(item);
          });
        } else {
          var accesor = $parse(filter);
          data = filterFilter(data,function(item) {
            return accesor({item:item});
          });
        }
      }
      if (mapper) {
        if (angular.isFunction(mapper)) {
          data = data.map(function(item) {
            return mapper(item);
          });
        } else {
          accesor = angular.isFunction(mapper) ? mapper : $parse(mapper);
          data = data.map(function(item) {
            return accesor({item:item});
          });
        }
      }
      if (type == 'count') {
        return data.reduce(function(prev) {
          return prev+=1;
        },0);
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').directive('searchRow', searchRow);

  function searchRow() {
    return {
      restrict: 'A',
      template: '<td colspan="{{length}}" bind-html-compile="get()">',
      controller: function($scope) {
        $scope.get = get;

        function get() {
          var texto = '<div class="input-group" style="width: 100%"><input type="text" class="form-control" ng-model="conf.text" placeholder="Filtrar"><span class="input-group-addon"><i class="fa fa-search"></i></span></div>';
          return texto;
        }

      },
      replace: false,
      scope: {
        conf: '=',
        length: '='
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').directive('abmList', abmList);

  function abmList() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/abm/list/list.html',
      controller: function($scope, $q, NgTableParams, Dialogo, $stateParams) {

        $scope.list.ready = false;
        
        $scope.$watch('listForm', function(value) {
          if ($scope.list) {
            // console.log('List form');
            $scope.list.form = value;
          }
        });

        $scope.onFinishRender = onFinishRender;

        var requested = false;

        function onFinishRender() {
          $scope.list.ready = true;
        }

        function update() {
          var page;

          function getData(p) {
            Dialogo.mostrarCargando();
            $scope.list.ready = false;
            // console.log('Updated params');
            var params = angular.merge({}, $stateParams);
            if (p.page) {
              params.page = p.page();
            }
            params.filter = angular.merge({}, params.filter, p.parameters().filter, $scope.list.filterValues);
            var sorting = undefined;
            if ($scope.list &&  $scope.list.sorting) {
              sorting = p.parameters().sorting;
              var sort = [];
              for (var key in sorting) {
                if (sorting.hasOwnProperty(key)) {
                  sort.push(key+','+sorting[key]);
                }
              }
              if (sort.length === 0) {
                sort.push('id,asc');
              }
              params.sort = sort;
            }
            // console.log(requested);
            // console.log($scope.list);
            var promise;
            if (requested) {
              params.cache = true;
            }
            if ($scope.list.eager && !requested) {
              requested = true;
              promise = $q.when($scope.list.data);
            } else {
              promise = $scope.list.datasource.get(params);
            }
            return promise.then(function(data) {
              if ($scope.list.datasource.pagination && data.data && data.data.totalElements) {
                $scope.list.params.total(data.data.totalElements);
              }
              if ($scope.list.params && sorting) {
                $scope.list.params.sorting(sorting);
              }
              $scope.list.data = data;
              onFinishRender();
              Dialogo.ocultarCargando();
              return data;
            });
          }
          
          if (!$scope.list.params) {
            page = 1;
          } else if (angular.isFunction($scope.list.params.page)) {
            page = $scope.list.params.page();
          } else if ($scope.list.params.page) {
            page = $scope.list.params.page;
          } else {
            page = 1;
          }
          $scope.list.params = new NgTableParams({
            page: page, 
            count: $scope.list.count, 
            sorting: $scope.list.sorting
          }, {
            counts: [], 
            total: 1, 
            getData: getData, 
            filterOptions: {
              filterLayout: 'horizontal'
            }
          });
        }

        $scope.$watch('list.filterValues', update, true);
        update();
      },
      replace: false,
      scope: {
        list: '=',
        className: '='
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').service('ListConf', ListConf);

  function ListConf($q, $timeout, Datasource, CrudActions, Columns, GeneralFilter) {
    var vm = this;
    vm.get = get;

    function get(config) {
      config = angular.merge({}, {count: 10}, config);
      var resolutions = [];
      config.actions = CrudActions.getActions(config);
      config.cols = Columns.get(config);
      if (config.summaryRows) {
        config.summaryRows = config.summaryRows.map(function(r) {
          return r.map(function(c) {
            return Columns.getCol(c);
          });
        });
      }
      config.filterFields = GeneralFilter.get(config);
      config.filterValues = angular.merge({}, config.defaultFilter);
      if (config.addItemRow && config.addItemRow.datasource) {
        config.addItemRow.datasource.resource = angular.merge({}, config.model.resource, config.addItemRow.datasource.resource);
        config.addItemRow.datasource = Datasource.get(config.addItemRow.datasource);
        if (config.addItemRow.datasource.needsResolution) {
          resolutions.push(config.addItemRow.datasource);
        }
      }
      config.datasource.resource = angular.merge({}, config.model.resource, config.datasource.resource);
      config.datasource = Datasource.get(config.datasource);
      if (config.eager) {
        var dd = $q.defer();
        config.datasource.promise.then(function(data) {
          config.data = data;
          // console.log('Promise resolved');
          dd.resolve(data);
          return data;
        });
        resolutions.push({promise: dd.promise, resolve: config.datasource.resolve});
      }
      if (!config.extraData) {
        config.extraData = {};
      }
      if (config.extraResolves) {
        config.extraResolves.forEach(function (r) {
          var d = $q.defer();
          resolutions.push({
            promise: d.promise,
            resolve: function(params) {
              return r.resolve(params).then(function(data) {
                config.extraData[r.name] = data;
                d.resolve(data);
                return data;
              });
            }
          });
        });
      }
      if (resolutions.length > 0) {
        config.promise = $q.all(resolutions.map(function(r) {return r.promise;})).then(function() {
          return config;
        });
        config.resolve = function (params) {
          resolutions.forEach(function (r) {
            r.resolve(params);
          });
          return config;
        };
      } else {
        var defer = $q.defer();
        config.promise = defer.promise;
        config.resolve = function() {
          // console.log('Resolving');
          defer.resolve(config);
          return config;
        };
      }
      if (config.postResolve) {
        config.promise = config.promise.then(config.postResolve);
      }
      return config;
    }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').directive('formCol', formCol);

  function formCol() {
    return {
      restrict: 'E',
      template: '<formly-form model="row" fields="formColFields" options="{data:{rowIndex: rowIndex, colIndex: colIndex}}"></formly-form>',
      scope: true,
      link: function (scope) {
        if (scope.col.isolated) {
          scope.formColFields = angular.copy(scope.col.fields);
        } else {
          scope.formColFields = scope.col.fields;
        }
      }
    };
  }

})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').service('Columns', Columns);

  function Columns() {
    var vm = this;
    vm.get = get;
    vm.getCol = getCol;

    function get(config) {
      return config.cols.map(getCol).reduce(reduce, []);
    }

    function getCol(col) {
      var resultCol = getColImp(col);
      if (col.colspan) {
        resultCol.colspan = col.colspan;
      }
      return resultCol;
    }

    function getColImp(col) {
      if (col.expression) {
        return col;
      } else if (!col.type || col.type === 'simple') {
        return getSimpleCol(col);
      } else if (col.type === 'icon') {
        return getIconCol(col);
      } else if (col.type === 'labels') {
        return getLabelsCol(col);
      } else if (col.type === 'nested') {
        return getNestedCol(col);
      } else if (col.type === 'actions') {
        return getActionsCol(col);
      } else if (col.type === 'boolean') {
        return getBooleanCol(col);
      } else if (col.type === 'editable') {
        return getEditableCol(col);
      } else if (col.type === 'form') {
        return getFormCol(col);
      } else if (col.type === 'link') {
        return getLinkCol(col);
      } else if (col.type === 'comment') {
        return getComentarioCol(col);
      } else {
        return col;
      }
    }

    function reduce(cols, col) {
      if (angular.isArray(col)) {
        Array.push.apply(cols, col);
      } else {
        cols.push(col);
      }
      return cols;
    }

    function getSimpleCol(col) {
      col.expression = '{{row.' + col.field;
      if (col.valueFormatter) col.expression += ' | ' + col.valueFormatter;
      col.expression += '}}';
      return col;
    }

    function getIconCol(col) {
      col.expression = '<span';
      if (col.colorField) col.expression += ' ng-style="{\'color\':row.' + col.colorField + '}"';
      col.expression += '><i class="{{row.'+ col.field + '}}"';
      col.expression += '></i> {{row.'+col.textField+'}}</span>';
      return col;
    }

    function getLabelsCol(col) {
      col.expression = '';
      col.labels.forEach(function(label) {
        col.expression += '<span class="label '+label.style+'" ng-if="'+label.displayExpression+'">'+label.name+'</span>';
      });
      return col;
    }

    function getNestedCol(col) {
      col.expression = '<span style="white-space: nowrap;"><span ng-repeat="n in row.__nested_data_array" class="fa fa-square" style="visibility: hidden"></span><span class="fa fa-minus-square" ng-if="row.__nested_showing_children" ng-click="list.datasource.hideChildren(row)"></span><span class="fa fa-plus-square" ng-if="!row.__nested_showing_children" ng-click="list.datasource.showChildren(row)"></span></span>';
      return col;
    }

    function getActionsCol(col) {
      col.expression = '<action-bar actions="col.actions" scope="list" item="row"></action-bar>';
      return col;
    }

    function getBooleanCol(col) {
      col.expression = '';
      if (col.yesCondition !== false) {
        col.expression += '<i class="'+(col.yesIcon?col.yesIcon:'fa fa-check')+'" ng-if="'+col.yesCondition+'"></i>';
      }
      if (col.noCondition !== false) {
        col.expression += '<i class="'+(col.noIcon?col.noIcon:'fa fa-close')+'" ng-if="'+col.noCondition+'"></i>';
      }
      return col;
    }

    function getLinkCol(col) {
      col.expression = '<a ng-href="{{row.' + col.field;
      col.expression += '}}" target="_blank"><i class="fa '+ col.icon +'"></i></a>';
      return col;
    }

    function getComentarioCol(col) {
      col.expression = '<span ng-if="row.' + col.field + '" class="fa fa-lg fa-comment" uib-popover="{{row.' + col.field + '}}" popover-trigger="\'mouseenter\'" popover-append-to-body="true"></span>';
      return col;
    }

    function getEditableCol(col) {
      if (col.inputType && col.inputType == 'select') {
        col.expression = '<select class="'+(col.inputClass?col.inputClass:'')+'" ng-model="'+col.fieldExpression+'" ng-options="'+col.ngOptions+'" ng-if="'+(col.enabled?col.enabled:true)+'"></select><div ng-if="!('+(col.enabled?col.enabled:true)+')">row[col.field]</div>';
      } else {
        col.expression = '<input class="'+(col.inputClass?col.inputClass:'')+'" type="'+col.inputType+'"ng-model="'+col.fieldExpression+'" ng-if="'+(col.enabled?col.enabled:true)+'"><div ng-if="!('+(col.enabled?col.enabled:true)+')">row[col.field]</div>';
      }
      return col;
    }

    function getFormCol(col) {
      col.expression = '<form-col></form-col>';
      return col;
    }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').directive('addItemRow', addItemRow);

  function addItemRow() {
    return {
      restrict: 'A',
      template: '<td colspan="{{length}}" bind-html-compile="get()">',
      controller: function($scope) {
        $scope.get = get;
        $scope.search = search;
        $scope.addElement = addElement;

        function get() {
          var texto = '<div class="input-group" style="width: 100%"><input type="text" class="form-control" ng-model="conf.searchData.text" placeholder="'+$scope.conf.placeholder+'" uib-typeahead="';
          var options = 'item as ';
          if ($scope.conf.displayFunction) {
            options += 'conf.displayFunction(item)';
          } else if ($scope.conf.displayExpression) {
            options += $scope.conf.displayExpression;
          } else if ($scope.conf.displayField) {
            options += 'item.' + $scope.conf.displayField;
          } else {
            options += 'item';
          }
          options += ' for item in search($viewValue)';
          texto += options + '" typeahead-on-select="addElement($item); conf.searchData.text = \'\';" typeahead-loading="conf.searchData.loading" typeahead-wait-ms="300" typeahead-min-length="3" typeahead-no-results="conf.searchData.noResults"><span class="input-group-addon"><i ng-class="{\'fa fa-pencil\':!conf.searchData.text, \'fa fa-refresh fa-spin\': conf.searchData.loading, \'fa fa-check\':!conf.searchData.loading && !conf.searchData.noResults && conf.searchData.text,\'fa fa-close\':conf.searchData.noResults}"></i></span></div>';
          return texto;
        }

        function search(value) {
          var param = {};
          param[$scope.conf.searchParam] = value;
          return $scope.conf.datasource.get(param);
        }

        function addElement(item) {
          $scope.add(item);
        }
      },
      replace: false,
      scope: {
        conf: '=',
        length: '=',
        add: '=',
        actions: '='
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').service('RestDatasource', RestDatasource);

  function RestDatasource($timeout, $q, $parse, $injector, filterFilter, orderByFilter, Resource, DEFAULT_DATASOURCES) {
    var vm = this;

    var cache;
    // var cacheParams;
    // var a;

    vm.get = get;

    function get(config) {
      var defer = $q.defer();
      config = angular.merge({}, DEFAULT_DATASOURCES[config.type], config);
      var datasource = createDatasource(config);
      datasource.get = function (params) {
        // if (cache && angular.equals(params,cacheParams)) {
        //   return $q.when(cache);
        // }
        var method = Resource.getMethod(config.method, config);
        params = angular.merge({}, params, datasource.params);
        addServerFilter(datasource, params, config);
        addServerSort(datasource, params, config);
        addServerPagination(datasource, params, config);
        if (datasource.processParams) {
          params = datasource.processParams(params, datasource);
        }
        var promise;
        if (datasource.filter != 'server' && datasource.pagination != 'server' && datasource.sort != 'server' && cache && params.cache == true) {
          promise = $q.when(cache);
        } else {
          var serverParams = angular.copy(params);
          delete serverParams.cache;
          promise = method(serverParams).$promise;
        }
        return promise.then(function (response) {
          // cacheParams = params;
          cache = response;
          var unfiltered = processData(response, config);
          var unsorted = filter(unfiltered, datasource, params, config);
          var unpaged = sort(unsorted, datasource, params, config);
          return paginate(unpaged, datasource, params, config);
        });
      };
      datasource.delete = function (params, success, error) {
        cache = undefined;
        // cacheParams = undefined;
        return Resource.getMethod('delete', config)(params, success, error);
      };
      datasource.save = function (item, success, error) {
        if (config.postprocess) {
          item = config.postprocess(item);
        }
        var method = Resource.getMethod(config.saveMethod ? config.saveMethod : 'save', config);
        return method(item, success, error).$promise;
      };
      datasource.update = function (item, success, error) {
        if (config.postprocess) {
          item = config.postprocess(item);
        }
        var method = Resource.getMethod(config.updateMethod ? config.updateMethod : 'update', config);
        return method(item, success, error).$promise;
      };
      datasource.resolve = function (params) {
        return datasource.get(params).then(function (result) {
          // console.log('Result');
          // console.log(result.length);
          defer.resolve(result);
        });
      };
      datasource.promise = defer.promise;
      return datasource;
    }

    function createDatasource(config) {
      return {
        isArray: config.isArray,
        async: true,
        pagination: config.pagination ? config.pagination : config.sort ? config.sort : config.filter,
        filter: config.filter ? config.filter : config.pagination ? config.pagination : config.sort,
        sort: config.sort ? config.sort : config.pagination ? config.pagination : config.filter,
        fixedFilter: config.fixedFilter,
        processParams: config.processParams,
        params: config.params
      };
    }

    function addServerFilter(datasource, params) {
      if (datasource.filter != 'server') return;
      var filter = params.filter;
      if (!filter) {
        filter = {};
      }
      delete params.filter;
      angular.merge(params, filter);
      if (datasource.fixedFilter) {
        angular.merge(params, datasource.fixedFilter);
      }
    }

    function addServerSort(datasource, params) {
      // console.log(params.sort);
      if (datasource.sort != 'server') return;
      // var sort = "";
      if (!params.sort) {
        // console.log(params.sort);
      }
    }

    function addServerPagination(datasource, params) {
      if (datasource.pagination != 'server') return;
      if (!params.sort) {
        // params.sort = 'id';
      }
      if (!params.pagination) {
        params.pagination = true;
      }
      if (!params.size) {
        params.size = 10;
      }
      if (!params.page) {
        params.page = 0;
      } else {
        params.page = params.page - 1;
      }
    }

    function processData(response, config) {
      var unprocessed;
      if (config.dataProperty) {
        unprocessed = angular.copy(response[config.dataProperty]);
        unprocessed.data = angular.copy(response);
        delete unprocessed.data[config.dataProperty];
      } else {
        unprocessed = response;
      }
      if (config.preprocess) {
        return config.preprocess(unprocessed, response);
      } else {
        return unprocessed;
      }
    }

    function filter(data, datasource, params) {
      // console.log(datasource.filter);
      if (datasource.filter != 'client') return data;
      if (!datasource.isArray) return data;
      if (!params.filter && !datasource.fixedFilter) return data;
      var filter = angular.merge({}, params.filter, datasource.fixedFilter);
      // console.log(filter);
      var filtered = filterFilter(data, filter);
      if (data.data) {
        filtered.data = data.data;
      }
      return filtered;
    }

    function paginate(data, datasource, params) {
      if (datasource.pagination != 'client') return data;
      if (!datasource.isArray) return data;
      if (!params.pagination) {
        params.pagination = true;
      }
      if (!params.size) {
        params.size = 10;
      }
      if (!params.page) {
        params.page = 1;
      }
      var total = data.length;
      var paged = data.slice((params.page - 1) * params.size, params.page * params.size);
      paged.data = angular.merge({}, data.data, { totalElements: total });
      return paged;
    }

    function sort(data, datasource, params) {
      // console.log('Sort');
      // console.log(params);
      if (datasource.sort != 'client') return data;
      if (!params.sort) {
        params.sort = [];
      }
      var sortParams = params.sort.map(function (p) {
        if (p.indexOf(',') != -1) {
          var parts = p.split(',');
          var param = parts[0];
          if (parts[1] == 'desc') {
            param = '-' + param;
          }
          return param;
        } else {
          return p;
        }
      });
      // console.log(sortParams);
      // console.log(orderByFilter(data,sortParams));
      var sorted = orderByFilter(data, sortParams);
      if (data.data) {
        sorted.data = data.data;
      }
      return sorted;
    }

    // function getParameter(object, key) {
    //   return $parse(key)(object);
    // }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').service('RestDatasource2', RestDatasource);

  function RestDatasource(ENABLE_API_CHECK) {
    var vm = this;
    var shape = configShape();
    var DEFAULT_RESOURCE_ARRAY = {
      method: 'query'
    };
    var DEFAULT_RESOURCE_SINGLE = {
      method: 'get'
    };

    vm.get = get;

    function get(params) {
      var newParams = setDefault(params);
      check(newParams);
    }

    function check(params) {
      if (!ENABLE_API_CHECK) return;
      shape(params);
    }

    function configShape() {
      var check = apiCheck();
      return check.shape({
        isArray: check.boolean,
        resource: check.shape({
          name: check.string,
          method: check.string,
          params: check.shape({})
        })
      });
    }

    function setDefault(params) {
      var newParams = angular.merge({}, params);
      if (newParams.isArray) {
        newParams.resource = angular.merge(DEFAULT_RESOURCE_ARRAY, newParams.resource);
      } else {
        newParams.resource = angular.merge(DEFAULT_RESOURCE_SINGLE, newParams.resource);
      }
      return newParams;
    }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').service('NestedDatasource', NestedDatasource);

  function NestedDatasource($timeout, $q, $parse, $injector, Resource, DEFAULT_DATASOURCES) {
    var vm = this;

    var data;

    vm.get = get;

    function get(config) {
      config = angular.merge({}, DEFAULT_DATASOURCES[config.type], config);
      data = [];
      var datasource = {
        topLevelDatasource: $injector.get('Datasource').get(angular.merge({}, config, config.topLevel)),
        nestedLevelDatasource: $injector.get('Datasource').get(angular.merge({}, config, config.nestedLevel)),
        isArray: true,
        async: false
      };
      datasource.resolve = datasource.topLevelDatasource.resolve;
      datasource.promise = datasource.topLevelDatasource.promise.then(function (d) {
        angular.copy(d.map(mapTopLevelItem), data);
        return data;
      });
      datasource.getSync = function () {
        return datasource.data;
      };
      datasource.get = function () {
        return $q.when(data);
      };
      datasource.showChildren = function (parent) {
        if (datasource.nestedLevelDatasource.async) {
          datasource.nestedLevelDatasource.get(parent).then(function (data) {
            addChildren(data, parent, datasource);
          });
        } else {
          addChildren(datasource.nestedLevelDatasource.getSync(parent), parent, datasource);
        }
        return data;
      };
      datasource.hideChildren = function (parent) {
        var newArray = data.filter(function (item) {
          return item.__nested_data_id === parent.__nested_data_id || item.__nested_data_id.indexOf(parent.__nested_data_id) !== 0;
        });
        parent.__nested_showing_children = false;
        data.length = 0;
        data.push.apply(data, newArray);
        return data;
      };
      return datasource;
    }

    function addChildren(d, parent) {
      var newElements = d.map(mapChildItem(parent));
      newElements.unshift(0);
      newElements.unshift(data.indexOf(parent) + 1);
      data.splice.apply(data, newElements);
      parent.__nested_showing_children = true;
    }

    function mapTopLevelItem(item) {
      item.__nested_data_id = '' + item.id;
      item.__nested_showing_children = false;
      item.__nested_data_level = 0;
      item.__nested_data_array = Array.apply(null, { length: item.__nested_data_level }).map(Number.call, Number);
      return item;
    }

    function mapChildItem(parent) {
      return function (item) {
        item.__nested_data_id = parent.__nested_data_id + '.' + item.id;
        item.__nested_showing_children = false;
        item.__nested_data_level = parent.__nested_data_level + 1;
        item.__nested_data_array = Array.apply(null, { length: item.__nested_data_level }).map(Number.call, Number);
        return item;
      };
    }
  }
})();
(function () {
  'use strict';

  angular.module('administracionNotificaciones').service('MultipleDatasource', MultipleDatasource);

  function MultipleDatasource($timeout, $q, $parse, $injector, Resource, DEFAULT_DATASOURCES) {
    var vm = this;

    var cache;
    var cacheParams;

    vm.get = get;

    function get(config) {
      config = angular.merge({}, DEFAULT_DATASOURCES[config.type], config);
      var datasource = createDatasource(config);
      var defer = $q.defer();
      if (config.children) {
        config.children.forEach(function (childrenConfig) {
          var children = $injector.get('Datasource').get(childrenConfig);
          datasource.children.push(children);
        });
        datasource.get = function (params) {
          if (cache && angular.equals(params, cacheParams)) {
            return $q.when(cache);
          }
          return $q.all(datasource.children.map(function (child) {
            return child.get(params);
          })).then(function (results) {
            return combinar(results, datasource.isArray);
          }).then(function (combined) {
            cacheParams = params;
            cache = combined;
            defer.resolve(combined);
            return cache;
          });
        };
        if (datasource.needsResolution) {
          datasource.promise = defer.promise;
        }
      }
      return datasource;
    }

    function combinar(results, isArray) {
      if (isArray) {
        return Array.prototype.concat.apply([], results);
      } else {
        return results.find(function (r) {
          return r;
        });
      }
    }

    function createDatasource(config) {
      return {
        children: [],
        async: false,
        isArray: config.isArray,
        pagination: config.pagination
      };
    }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').service('MemoryDatasource', MemoryDatasource);

  function MemoryDatasource($timeout, $q, $parse, $injector, Resource, DEFAULT_DATASOURCES) {
    var vm = this;

    vm.get = get;

    function get(config) {
      var defer = $q.defer();
      config = angular.merge({}, DEFAULT_DATASOURCES[config.type], config);
      var datasource = createDatasource(config);
      var data = createData(config);
      datasource.getSync = function () {
        return data;
      };
      datasource.get = function () {
        return $q.when(data);
      };
      datasource.set = function (newData) {
        return data = newData;
      };
      datasource.resolve = function (params) {
        return datasource.get(params).then(function (result) {
          defer.resolve(result);
        });
      };
      datasource.addElement = function (item, key) {
        if (key) {
          data[key] = item;
        } else if (datasource.isArray) {
          data.push(item);
        }
      };
      datasource.remove = function (item) {
        if (datasource.isArray) {
          data.splice(data.indexOf(item), 1);
        }
      };
      datasource.promise = defer.promise;
      return datasource;
    }

    function createDatasource(config) {
      return {
        isArray: config.isArray,
        async: false,
        pagination: config.pagination
      };
    }

    function createData(config) {
      if (config.defaultData) {
        return config.defaultData;
      } else if (config.isArray) {
        return [];
      } else {
        return {};
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').service('EditNewDatasource', EditNewDatasource);

  function EditNewDatasource($timeout, $q, $parse, $injector, Resource, DEFAULT_DATASOURCES) {
    var vm = this;

    vm.get = get;
    var cache;
    // var cacheParams;

    function get(config) {
      config = angular.merge({}, DEFAULT_DATASOURCES[config.type], config);
      var defer = $q.defer();
      var newDatasource = getChild(config, config.newDatasource);
      var editDatasource = getChild(config, config.editDatasource);
      var datasource = createDatasource(config, newDatasource, editDatasource);
      datasource.isNewFunction = getIsNewFunction(config);
      datasource.get = function (params) {
        // if (cache && angular.equals(params,cacheParams)) {
        //   return $q.when(cache);
        // }
        // cacheParams = params;
        var unprocessed;
        if (datasource.isNewFunction(params)) {
          unprocessed = datasource.newDatasource.get(params);
        } else {
          unprocessed = datasource.editDatasource.get(params);
        }
        return unprocessed.then(function (data) {
          cache = processData(data, config);
          return cache;
        });
      };
      datasource.resolve = function (params) {
        return datasource.get(params).then(function (result) {
          defer.resolve(result);
        });
      };
      datasource.promise = defer.promise;
      datasource.save = function (item, success, error) {
        if (config.postprocess) {
          item = config.postprocess(item);
        }
        var method = Resource.getMethod(config.saveMethod ? config.saveMethod : 'save', config);
        return method(item, success, error).$promise;
      };
      datasource.update = function (item, success, error) {
        if (config.postprocess) {
          item = config.postprocess(item);
        }
        var method = Resource.getMethod(config.updateMethod ? config.updateMethod : 'update', config);
        return method(item, success, error).$promise;
      };
      return datasource;
    }

    function getChild(config, child) {
      var copyConfig = angular.merge({}, config);
      delete copyConfig.preprocess;
      delete copyConfig.postprocess;
      return $injector.get('Datasource').get(angular.merge({}, copyConfig, child));
    }

    function processData(data, config) {
      if (config.preprocess) {
        return config.preprocess(data, config);
      } else {
        return data;
      }
    }

    function createDatasource(config, newDatasource, editDatasource) {
      return {
        isArray: config.editDatasource.isArray && config.newDatasource.isArray,
        async: config.editDatasource.async || config.newDatasource.async,
        pagination: config.editDatasource.pagination || config.newDatasource.pagination,
        newDatasource: newDatasource,
        editDatasource: editDatasource
      };
    }

    function getIsNewFunction(config) {
      if (angular.isFunction(config.isNew)) {
        return config.isNew;
      } else {
        return $parse(config.isNew);
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').value('DEFAULT_DATASOURCES', {
    editNew: {
      isNew: '!id || id === \'nuevo\'',
      editDatasource: {
        method: 'get',
        type: 'rest'
      },
      newDatasource: {
        type: 'memory'
      }
    },
    rest: {
      method: 'query'
    },
    memory: {},
    multiple: {},
    nested: {
      topLevel: {
        type: 'rest',
        method: 'query'
      },
      nestedLevel: {
        type: 'rest',
        method: 'queryChildren'
      }
    },
    custom: {}
  });
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').service('Datasource', Datasource);

  function Datasource($injector, DEFAULT_DATASOURCES) {
    var vm = this;

    vm.get = get;

    function get(config) {
      config = angular.merge({}, DEFAULT_DATASOURCES[config.type], config);
      if (!config) {
        return null;
      } else {
        return $injector.get(map[config.type]).get(config);
      }
    }

    var map = {
      custom: 'CustomDatasource',
      editNew: 'EditNewDatasource',
      memory: 'MemoryDatasource',
      multiple: 'MultipleDatasource',
      nested: 'NestedDatasource',
      rest: 'RestDatasource'

    };
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').service('CustomDatasource', CustomDatasource);

  function CustomDatasource($timeout, $q, $parse, $injector, Resource, DEFAULT_DATASOURCES) {
    var vm = this;

    var cache;
    var cacheParams;

    vm.get = get;

    function get(config) {
      config = angular.merge({}, DEFAULT_DATASOURCES[config.type], config);
      var defer = $q.defer();
      var datasource = createDatasource(config);
      datasource.get = function (params) {
        if (cache && angular.equals(params, cacheParams)) {
          return $q.when(cache);
        }
        return datasource.customGet(params).then(function (response) {
          cacheParams = params;
          cache = response;
          return cache;
        });
      };
      datasource.resolve = function (params) {
        return datasource.get(params).then(function (result) {
          defer.resolve(result);
        });
      };
      datasource.promise = defer.promise;
      return datasource;
    }

    function createDatasource(config) {
      return {
        isArray: config.isArray,
        async: true,
        pagination: config.pagination,
        customGet: config.customGet
      };
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('administracionNotificaciones')
    .service('Menu', Menu);

  function Menu(orderByFilter, StateConfig) {
    var vm = this;

    vm.items = [];

    vm.addMenuItems = addMenuItems;

    function addItem(item) {
      var same = vm.items.find(function (i) {
        return (i.name == item.name);
      });
      if (same) {
        same.children.push.apply(same.children, item.children);
      } else {
        vm.items.push(item);
        angular.copy(orderByFilter(vm.items, 'order'), vm.items);
      }
    }

    function addChildrenItem(item) {
      var parentMenu = vm.items.find(function (i) {
        return i.name === item.parentMenu.name;
      });
      // console.log(item.parentMenu.name);
      // console.log(JSON.stringify(parentMenu));
      if (!parentMenu) {
        parentMenu = angular.copy(item.parentMenu);
        vm.items.push(parentMenu);
      }
      if (!parentMenu.children) parentMenu.children = [];
      // console.log(parentMenu.children.length);
      parentMenu.children.push(item);
      angular.copy(orderByFilter(vm.items, 'order'), vm.items);
      // console.log(item);
      // console.log(parentMenu.children.length);
      // console.log(vm.items);
    }

    function addMenuItems(model, states) {
      states.forEach(function (state) {
        if (state.showInMenu !== false) {
          addChildrenItem({
            name: getMenuName(model, state),
            icon: getMenuIcon(model, state),
            permissions: state.permissions,
            sections: state.sections,
            state: StateConfig.getStateName(state),
            parentMenu: getParentMenu(model, state)
          });
        }
      });
    }

    function getMenuName(model, state) {
      if (state.menuName) {
        return state.menuName;
      } else if (state.type === 'list') {
        return 'Listado';
      } else if (state.type === 'edit') {
        return model.female ? 'Nueva' : 'Nuevo';
      }
    }

    function getMenuIcon(model, state) {
      if (state.icon) {
        return state.icon;
      } else if (state.type === 'list') {
        return 'fa fa-bars';
      } else if (state.type === 'edit') {
        return 'fa fa-plus';
      }
    }

    function getParentMenu(model, state) {
      return angular.merge({}, {
        name: model.pluralName,
        icon: model.icon,
        order: model.order
      }, state.parentMenu);
    }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').directive('abmForm', abmForm);

  function abmForm() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/abm/form/form.html',
      replace: false,
      scope: {
        form: '=',
        className: '='
      },
      controller: function($scope, $q, $stateParams) {
        
        var requested = false;

        $scope.$watch('form', function() {
          
          if ($scope.form && $scope.form.datasource) {
            var promise;
            if ($scope.form.eager && !requested) {
              requested = true;
              promise = $q.when($scope.form.data);
            } else {
              promise = $scope.form.datasource.get($stateParams);
            }
            return promise.then(function (data) {
              $scope.formData = data;
              $scope.form.formData = data;
            });
          }
        });
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').service('FormConf', FormConf);

  function FormConf($q, $timeout, Datasource, CrudActions, Fields) {
    var vm = this;
    vm.get = get;

    function get(config) {
      // console.log(config);
      var resolutions = [];
      config.needsResolution = true;
      config.actions = CrudActions.getActions(config);
      config.fields = Fields.get(config);
      config.datasource.resource = angular.merge({}, config.model.resource, config.datasource.resource);
      config.datasource = Datasource.get(config.datasource);
      if (config.fields.needsResolution) {
        resolutions.push(config.fields);
      }
      if (config.eager) {
        var dd = $q.defer();
        config.datasource.promise.then(function(data) {
          config.data = data;
          dd.resolve(data);
          return data;
        });
        resolutions.push({promise: dd.promise, resolve: config.datasource.resolve});
      }
      if (!config.extraData) {
        config.extraData = {};
      }
      if (config.extraResolves) {
        config.extraResolves.forEach(function (r) {
          var d = $q.defer();
          resolutions.push({
            promise: d.promise,
            resolve: function(params) {
              return r.resolve(params).then(function(data) {
                d.resolve(data);
                config.extraData[r.name] = data;
                return data;
              });
            }
          });
        });
      }
      if (resolutions.length > 0) {
        config.promise = $q.all(resolutions.map(function(r) {return r.promise;})).then(function() {
          return config;
        });
        config.resolve = function (params) {
          resolutions.forEach(function (r) {
            r.resolve(params);
          });
          return config;
        };
      } else {
        var defer = $q.defer();
        config.promise = defer.promise;
        config.resolve = function(params) {
          defer.resolve(params);
          return config;
        };
      }
      if (config.postResolve) {
        config.promise = config.promise.then(config.postResolve);
      }
      return config;
    }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').service('Fields', Fields);

  function Fields($q, ListConf, ModelConfig) {
    var vm = this;
    vm.get = get;

    var defaultListFieldDatasource = {
      type: 'memory',
      isArray: true
    };

    var defaultAddItemRow = {
      placeholder: 'Buscar...',
      searchParam: 'busqueda',
      displayExpression: 'item.nombre',
      datasource: {
        type: 'rest',
        method: 'query',
        isArray: true
      }
    };

    var defaultListActions = [{
      id: 'eliminar',
      style: 'btn-danger',
      icon: 'fa fa-trash',
      text: 'Eliminar',
      action: 'scope.datasource.remove(item)'
    }];

    function get(config) {
      var fields = config.fields.map(function (field) {
        return getField(field, config);
      });
      var promises = [];
      fields.forEach(function (field) {
        if (field.needsResolution) {
          fields.needsResolution = true;
          promises.push(field.promise);
        }
      });
      if (promises.length) {
        fields.promise = $q.all(promises);
      }
      return fields;
    }

    function getField(field, config) {
      if (field && field.type === 'list') {
        return getListField(field, config);
      } else {
        field.templateOptions.needsResolution = false;
        return field;
      }
    }

    function getListField(field, config) {
      if (!field.templateOptions.list.model) {
        field.templateOptions.list.model = {};
      }
      ModelConfig.generate(field.templateOptions.list.model);
      field.templateOptions.list.datasource = angular.merge({}, defaultListFieldDatasource, field.templateOptions.list.datasource);
      if (field.templateOptions.list.addItemRow !== false) {
        field.templateOptions.list.addItemRow = angular.merge({}, defaultAddItemRow, field.templateOptions.list.addItemRow);
      }
      addDefaultActions(field.templateOptions.list);
      field.templateOptions.list.actions = angular.merge({}, field.templateOptions.list.actions, config.actions);
      field.templateOptions.list = ListConf.get(field.templateOptions.list);
      field.templateOptions.needsResolution = field.templateOptions.list.needsResolution;
      field.templateOptions.promise = field.templateOptions.list.promise;
      return field;
    }

    function addDefaultActions(config) {
      if (config.noDefaultActions) {
        return;
      }
      if (!config.cols) {
        config.cols = [];
      }
      var actionCol;
      config.cols.forEach(function (col) {
        if (col.type === 'actions') {
          actionCol = col;
        }
      });
      if (!actionCol) {
        actionCol = {
          title: 'Acciones',
          type: 'actions',
          actions: []
        };
        config.cols.push(actionCol);
      }
      defaultListActions.forEach(function (def) {
        var present = false;
        actionCol.actions = actionCol.actions.map(function (action) {
          if (action.id === def.id) {
            present = true;
            return angular.merge(def, action);
          } else {
            return action;
          }
        });
        if (!present) {
          actionCol.actions.push(angular.merge({}, def));
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').service('DefaultCrudActions', DefaultCrudActions);

  function DefaultCrudActions($state, $window, $interpolate, Dialogo, Messages) {
    var vm = this;

    vm.getActions = getActions;

    function getActions(config) {
      return {
        deleteElement: deleteElement(config),
        editElement: editElement(config),
        newElement: newElement(config),
        saveElement: saveElement(config),
        cancelElement: cancelElement(config)
      };
    }

    function deleteElement(config) {
      return function (item) {
        Dialogo.mostrarConfirmacion({
          titulo: interpolateMessages('delete.confirm.title', config),
          texto: interpolateMessages('delete.confirm.message', config)
        }).then(function (dialogo) {
          dialogo.result.then(function () {
            confirmedDelete(config)(item.id);
          });
        });
      };
    }

    function editElement() {
      return function (item) {
        $state.go('^.edit', {
          id: item.id
        });
      };
    }

    function newElement() {
      return function () {
        $state.go('^.edit', {
          id: 'nuevo'
        });
      };
    }

    function confirmedDelete(config) {
      return function (id) {
        Dialogo.mostrarCargando();
        return config.datasource.delete({
          id: id
        }, successDelete(config), errorDelete(config));
      };
    }

    function isNew(config, data) {
      return config.model.isNewExpr(data);
    }

    function saveElement(config) {
      return function (item) {
        Dialogo.mostrarCargando();
        if (isNew(config, config.formData)) {
          config.datasource.save(item, successSave(config), errorSave(config));
        } else {
          config.datasource.update(item, successSave(config), errorSave(config));
        }
      };
    }
 
    function cancelElement(config) {
      return function () {
        backToList(config)();
      };
    }

    function successSave(config) {
      return function (response) {
        config.response = response;
        Dialogo.ocultarCargando();
        Dialogo.mostrarExito({
          titulo: interpolateMessages('save.success.title', config),
          texto: interpolateMessages('save.success.message', config)
        }).then(function (dialogo) {
          dialogo.result.then(function () {
            backToList(config)();
          });
        });
      };
    }

    function errorSave(config) {
      return function (error) {
        Dialogo.ocultarCargando();
        Dialogo.mostrarError({
          titulo: interpolateMessages('save.error.title', config),
          texto: error.data.message
        });
      };
    }

    function backToList(config) {
      if (config.actions && config.actions.backToList) {
        return config.actions.backToList;
      } else {
        return function () {
          $window.history.back();
        };
      }
    }

    function successDelete(config) {
      return function () {
        Dialogo.ocultarCargando();
        Dialogo.mostrarExito({
          titulo: interpolateMessages('delete.success.title', config),
          texto: interpolateMessages('delete.success.message', config)
        }).then(function (dialogo) {
          dialogo.result.then(function () {
            reloadState();
          });
        });
      };
    }

    function errorDelete(config) {
      return function (error) {
        Dialogo.ocultarCargando();
        Dialogo.mostrarError({
          titulo: interpolateMessages('delete.error.title', config),
          texto: error.data.message
        });
      };
    }

    function interpolateMessages(key, config) {
      return $interpolate(Messages.get(key, config))(config);
    }

    function reloadState() {
      $state.reload();
    }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').service('CrudActions', CrudActions);

  function CrudActions(DefaultCrudActions) {
    var vm = this;

    vm.getActions = getActions;

    function getActions(config) {
      var defaultActions = DefaultCrudActions.getActions(config);
      return angular.merge({}, defaultActions, config ? config.actions: null);
    }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').directive('actionBar', actionBar);

  function actionBar() {
    return {
      restrict: 'E',
      template: '<span class="btn-group" bind-html-compile="getActions()"></span>',
      controller: function($scope, Autenticacion) {
        $scope.getActions = getActions;
        $scope.hasPermissions = hasPermissions;

        function hasPermissions(permissions) {
          return Autenticacion.hasPermissions(permissions);
        }

        function getActions() {
          var expression = '';
          if (!$scope.actions || !$scope.actions.forEach) return expression;
          $scope.actions.forEach(function(action) {
            expression += '<button ng-click="'+(action.disabledCondition ? '!('+action.disabledCondition+') && ' : '')+action.action+'"';
            if (action.disabledCondition) {
              expression += ' ng-class="{\'disabled\':'+action.disabledCondition+'}"';
            }
            if (action.needsPermissions || action.displayExpression) {
              expression += ' ng-if="';
            }
            if (action.needsPermissions) {
              expression += 'hasPermissions([\'';
              if (angular.isArray(action.needsPermissions)) {
                expression += action.needsPermissions.join('\',\'');
              } else {
                expression += action.needsPermissions;
              }
              expression += '\'])';
            }
            if (action.needsPermissions && action.displayExpression) {
              expression += ' && ';
            }
            if (action.displayExpression) {
              expression += action.displayExpression;
            }
            if (action.needsPermissions || action.displayExpression) {
              expression += '" ';
            }
            expression += ' class="btn '+action.style+' disabled-tooltip"';
            if (action.text || action.disabledText) {
              expression += ' uib-tooltip="{{'+(action.disabledCondition ? action.disabledCondition : false) +' ? \''+action.disabledText+'\' : \''+(action.text?action.text:'')+'\'}}" tooltip-trigger="\'mouseenter\'" tooltip-append-to-body="true"';
            }
            expression += '><i class="'+action.icon+'"></i></button>';
          });
          return expression;
        }
      },
      replace: false,
      scope: {
        actions: '=',
        scope: '=',
        item: '='
      }
    };
  }
})();

(function () {
  angular.module('administracionNotificaciones').run(run);
  function run($state, DataState) {
    DataState.generateModelStates('Usuario', [
      {
        defaultConfig: 'app/app/main/usuario/edit.state.json',
        actions: {
          backToList: function() {
            $state.go('^');
          }
        }
      },
      {
        defaultConfig: 'app/app/main/usuario/list.state.json',
        actions: {
          nuevoUsuarioDocente: function() {
            $state.go('^.nuevoUsuarioDocente');
          }
        }
      },
      {
        defaultConfig: 'app/app/main/usuario/nuevo-usuario-docente.state.json',
        actions: {
          backToList: function() {
            $state.go('^');
          }
        }
      },
      {
        defaultConfig: 'app/app/main/usuario/cambiar-password.state.json',
        actions: {
          backToList: function() {
            $state.go('^');
          }
        }
      }
    ]);
  }
})();

/* global angular */
(function () {
  angular.module('administracionNotificaciones').run(run);
  function run($state, DataState) {
    DataState.generateModelStates('SolicitudLicencia', [
      'app/app/main/solicitud-licencia/list.state.json'
    ]);
  }
})();
  
/* global angular */
(function () {
  angular.module('administracionNotificaciones').run(run);
  function run($state, DataState, Dialogo) {
    
    function successSave() {
      return function () {
        Dialogo.ocultarCargando();
        Dialogo.mostrarExito({titulo: 'Éxito', texto: 'Se guardaron las secciónes correctamente'});
      };
    }

    function errorSave(error) {
      Dialogo.ocultarCargando();
      Dialogo.mostrarError({ titulo: 'Error', texto: error.data.message });
    }

    DataState.generateModelStates('Seccion', [
      {
        defaultConfig: 'app/app/main/seccion/edit.state.json',
        actions: {
          saveElement: function (data, scope) {
            Dialogo.mostrarCargando();
            return scope.datasource.save(data, successSave(data), errorSave);
          }
        }
      }
    ]);
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider.state('main.rr-hh', {
      url: 'rr-hh',
      templateUrl: 'app/app/main/rr-hh/rr-hh.html',
      controller: 'RRHHCtrl as vm',
      resolve: {
        
      }
    });

  }

})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').controller('RRHHCtrl', RRHHCtrl);

  function RRHHCtrl(RRHH, Dialogo) {
    var vm = this;
    vm.list = {
      actions: {
        imprimir: generarReporteAsistenciaDocentes
      },
      messages: {
        name: {
          title: 'Reporte Mensual de Asistencias Docentes'
        }
      },
      generalActions: [{
        'id': 'imprimirSolicitudesAcumuladas',
        'style': 'btn-danger',
        'icon': 'fa fa-file-pdf-o',
        'text': 'Imprimir',
        'action': 'scope.actions.imprimir(scope.filterValues.anio, scope.filterValues.mes)'
      }],
      filterValues: {
        anio: moment().year(),
        mes: moment().month() + 1
      },
      filterFields: [{
        'type': 'horizontalInput',
        'key': 'anio',
        'className': 'col-sm-6',
        'templateOptions': {
          'type': 'number',
          'label': 'Año:'
        },
        'modelOptions': {
          'debounce': 1000
        }
      },
      {
        'type': 'horizontalInput',
        'key': 'mes',
        'className': 'col-sm-6',
        'templateOptions': {
          'type': 'number',
          'label': 'Mes:'
        },
        'modelOptions': {
          'debounce': 1000
        }
      }

      ]
    };
    vm.key = 'name.title';

    vm.generarReporteAsistenciaDocentes = generarReporteAsistenciaDocentes;

    function generarReporteAsistenciaDocentes(anio, mes) {
      Dialogo.mostrarCargando();
      RRHH.exportarPDF({
        mes: mes,
        anio: anio
      }).then(function () {
        Dialogo.mostrarExito({
          titulo: 'Éxito',
          texto: 'Se ha exportado correctamente la planilla.',
          accionSi: function (dialogo) {
            dialogo.close();
          }
        });
        Dialogo.ocultarCargando();
      });
    }
  }
})();

/* global angular */
(function () {
  angular.module('administracionNotificaciones').run(run);

  function run($state, $http, DataState, Personal) {
    DataState.generateModelStates('Persona', [{
      defaultConfig: 'app/app/main/persona/docentes.state.json',
      actions: {
        edit: function (item) {
          $state.go('^.edit', item);
        },
        editContactData: function (item) {
          $state.go('^.editarContacto', item);
        }
      }
    },
    {
      defaultConfig: 'app/app/main/persona/personal.state.json',
      actions: {
        verSolicitudesPeriodo: function (item) {
          $state.go('^.solicitudesPeriodo', {
            idPersonal: item.id
          });
        }
      }
    },
    {
      defaultConfig: 'app/app/main/persona/solicitudes-periodo.state.json',
      defaultFilter: {
        mes: moment().month() + 1,
        anio: moment().year()
      },
      actions: {
        imprimir: function (item, anio, mes) {
          Personal.imprimirLicenciasAcumuladas(item, anio, mes);
        }
      },
      extraResolves: [{
        name: 'personal',
        resolve: function (params) {
          return Personal.get({
            id: params.idPersonal
          }).$promise;
        }
      }]
    },
    {
      defaultConfig: 'app/app/main/persona/editar-contacto.state.json',
      actions: {
        backToList: function () {
          $state.go('^.docentes');
        }
      }
    },
    {
      defaultConfig: 'app/app/main/persona/edit.state.json',
      actions: {
        backToList: function () {
          $state.go('^.docentes');
        }
      }
    }
    ]);
  }
})();

(function () {
  angular.module('administracionNotificaciones').run(run);
  function run(DataState) {
    DataState.generateModelStates('Permiso', [
      {
        defaultConfig: 'app/app/main/permiso/list.state.json'
      },
      {
        defaultConfig: 'app/app/main/permiso/edit.state.json'
      }
    ]);
  }
})();

(function () {
  angular.module('administracionNotificaciones').run(run);
  function run($state, PagoTIC, Dialogo, DataState) {
    DataState.generateModelStates('PagoTIC', [
      {
        defaultConfig: 'app/app/main/pago-tic/list.state.json',
        actions: {
          nuevoFormularioPagoTIC: function() {
            $state.go('^.nuevoFormularioPagoTIC');
          },
          renovarLink: function (item) {
            Dialogo.mostrarCargando();
            PagoTIC.renovarLink(item).$promise.then(function () {
              Dialogo.ocultarCargando();
              $state.reload();
            }, function (error) {
              Dialogo.mostrarError({
                titulo: 'Error',
                texto: error.data.message
              });
              Dialogo.ocultarCargando();
            });
          },
          aprobarManual: function (item) {

            Dialogo.mostrarConfirmacion({
              texto: '¿Está seguro que desea aprobar Manualmente el pago?',
              titulo: 'Pago manual',
              icon: 'fa-check',
              accionSi: function (dialogo) {
                Dialogo.mostrarCargando();
                dialogo.close();
                PagoTIC.aprobarManual(item).$promise.then(function () {
                  Dialogo.ocultarCargando();
                  $state.reload();
                }, function (error) {
                  Dialogo.mostrarError({
                    titulo: 'Error',
                    texto: error.data.message
                  });
                  Dialogo.ocultarCargando();
                });
              }
            });

          },
          refrescar: function() {
            $state.reload();
          }
        },
        extraResolves: [],
        postResolve: function (config) {
          
          //quiero recorrer todos los config.cols
          for (var i = 0; i < config.cols.length; i++) {
            //Filtro de Estados
            if (config.cols[i].field == 'estado') {
              var estados = [];
              estados.push({
                id: 'pending',
                title: 'Pendiente'
              });
              estados.push({
                id: 'approved',
                title: 'Aprobado'
              });
              estados.push({
                id: 'approved_manual',
                title: 'Aprobado Manual'
              });
              estados.push({
                id: 'overdue',
                title: 'Vencido'
              });
              estados.push({
                id: 'issued',
                title: 'Emitido'
              });
              estados.push({
                id: 'in_process',
                title: 'En proceso'
              });
              estados.push({
                id: 'refunded',
                title: 'Devuelto'
              });
              estados.push({
                id: 'regenerated',
                title: 'Regenerado'
              });
              estados.push({
                id: 'rejected',
                title: 'Rechazado'
              });
              config.cols[i].filterData = estados.map(function (e) {
                return {
                  id: e.id,
                  title: e.title
                };
              }); 
            }
          }
          return config;
        }
      },
      {
        defaultConfig: 'app/app/main/pago-tic/nuevo-formulario-pago.state.json',
        datasource: {
          defaultData: {
            
          },
          preprocess: function (data, config) {
            return data;
          },
          postprocess: function (data, config) {
            var dto = {};
            dto.payer = {};
            dto.payer.name = data.name;
            dto.payer.email = data.email;
            dto.payer.external_reference = data.documento;
            dto.payer.identification = {};
            dto.payer.identification.number = data.documento;
            dto.payer.phone = data.telefono;
            dto.concepto = data.concepto;
            dto.curso = data.curso;
            //Detalles Pago
            dto.details = [];

            dto.details.push({
              external_reference: data.concepto.id,
              concept_id: data.concepto.codigo,
              concept_description: data.curso.nombre + ' - ' + data.concepto.descripcion,
              amount: data.monto
            });
            var expectedFormat = 'YYYY-MM-DD';
            dto.due_date = moment(data.dueDate).format(expectedFormat);
            dto.last_due_date = moment(data.lastDueDate).format(expectedFormat);
            
            return dto;
          }
        },
        extraResolves: [
          {
            name: 'cursos',
            resolve: function (params) {
              return PagoTIC.getCursos().$promise;
            }
          }
        ],
        postResolve: function (config) {

          config.fields[4].templateOptions.options = config.extraData.cursos;
          var controladorConcepto = function ($scope) {
            $scope.$watch('model.curso', function (newValue, oldValue) {
              if (newValue !== oldValue) {
                // Reload options
                $scope.to.options = newValue.conceptosOrdenados;
              }
            });
          };
          controladorConcepto.$inject = ['$scope'];
          config.fields[5].controller = controladorConcepto;

          //Controlador Monto
          var controladorMonto = function ($scope) {
            $scope.$watch('model.concepto', function (newValue, oldValue) {
              if (newValue !== oldValue) {
                // Reload options
                $scope.model.monto = newValue ? newValue.precio : undefined;
                $scope.model.dueDate =  moment(newValue.fechaVto).toDate();
              }
            });
          };
          controladorMonto.$inject = ['$scope'];
          config.fields[6].controller = controladorMonto;

          return config;
        }
  
      }
    ]);
  }
})();

(function () {
  angular.module('administracionNotificaciones').run(run);
  function run($state, $stateParams, DataState, Curso) {
    DataState.generateModelStates('Curso', [
      {
        defaultConfig: 'app/app/main/pago-tic/cursos.list.state.json',
        actions: {
          verConceptos: function(curso) {
            $state.go('^.listarConceptos', {id: curso.id});
          }
        }
      },
      {
        defaultConfig: 'app/app/main/pago-tic/edit.state.json'
      },
      {
        defaultConfig: 'app/app/main/pago-tic/listado-conceptos.state.json',
        actions: {
          editarConcepto: function(concepto) {
            // $state.go('^.editarConcepto',concepto);
            $state.go('main.cursos.editarConcepto',{id: concepto.id, id_curso: $stateParams.id});
          },
          volver: function() {
            $state.go('^.cursos');
          }
        },
        extraResolves: [{
          name: 'cursoSeleccionado',
          resolve: function (params) {
            return Curso.get({id: params.id}).$promise;
          }
        }]
      },
      {
        defaultConfig: 'app/app/main/pago-tic/concepto-edit.state.json',
        datasource: {
          preprocess: function (modelo) {
            if (modelo.fechaVto) {
              modelo.fechaVto = moment(modelo.fechaVto).toDate();
            }
            return modelo;
          },
          postprocess: function(modelo) {
            modelo.fechaVto = moment(modelo.fechaVto).format('YYYY-MM-DD');
            modelo.id_curso = $stateParams.id_curso;
            return modelo;
          }
        }
      }
      
      
    ]);
  }
})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider.state('main.pedir-certificados',{
      url: 'pedir-certificados',
      templateUrl: 'app/app/main/pedir-certificados/pedir-certificados.html',
      controller: 'PedirCertificadosCtrl as vm',
      resolve: {
        certificados: function(Certificado) {
          return Certificado.query().$promise;
        }
      }
    });
  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').controller('PedirCertificadosCtrl', PedirCertificadosCtrl);

  function PedirCertificadosCtrl($scope, Dialogo, Certificado, certificados) {
    var vm = this;

    vm.certificados = certificados;

    vm.pedirCertificado = pedirCertificado;

    function pedirCertificado(certificado) {
      Dialogo.mostrarConfirmacion({
        texto: '¿Está seguro que desea pedir este certificado?',
        accionSi: function() {
          Dialogo.mostrarCargando();
          confirmarPedido(certificado);
        }
      },$scope);
    }

    function confirmarPedido(certificado) {
      Certificado.solicitar(certificado,exito,error);
    }

    function exito(respuesta) {
      Dialogo.mostrarExito({texto: respuesta.mensaje, accionSi: salir},$scope);
      Dialogo.ocultarCargando();
    }

    function salir() {
      Dialogo.salir();
    }

    function error(respuesta) {
      Dialogo.mostrarError({texto: respuesta.data.message},$scope);
      Dialogo.ocultarCargando();
    }

  }

})();

/* global angular */
(function () {
  angular.module('administracionNotificaciones').run(run);
  function run($state, DataState) {
    DataState.generateModelStates('NotificacionAlumnosInscriptos', [
      'app/app/main/notificacion-alumnos-inscriptos/list.state.json'
    ]);
  }
})();

(function () {
  'use strict';

  angular
    .module('administracionNotificaciones')
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('main.notificaciones-enviadas', {
      url: '/notificaciones/enviadas',
      templateUrl: 'app/app/main/notificacion/notificaciones-enviadas.html',
      controller: 'NotificacionesEnviadasCtrl as vm',
      data: {
        permissions: 'crearNotificaciones'
      }
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('administracionNotificaciones')
    .controller('NotificacionesEnviadasCtrl', NotificacionesEnviadasCtrl);

  NotificacionesEnviadasCtrl.$inject = ['$http', 'URL_SERVIDOR', 'Dialogo'];

  function NotificacionesEnviadasCtrl($http, URL_SERVIDOR, Dialogo) {
    var vm = this;

    vm.notificaciones = [];
    vm.cargando = false;
    vm.anioActual = new Date().getFullYear();
    vm.aniosDisponibles = (function() {
      var anios = [];
      for (var a = vm.anioActual; a >= vm.anioActual - 5; a--) anios.push(a);
      return anios;
    })();
    vm.filtro = { texto: '', desde: null, hasta: null, estado: '', anio: vm.anioActual };
    vm.paginaActual = 1;
    vm.tamanioPagina = 10;

    vm.cargar = cargar;
    vm.limpiarFiltros = limpiarFiltros;
    vm.notificacionesFiltradas = notificacionesFiltradas;
    vm.cambiarPagina = cambiarPagina;
    vm.totalPaginas = totalPaginas;

    init();

    function init() {
      cargar();
    }

    function cargar() {
      vm.cargando = true;
      $http.get(URL_SERVIDOR + 'notificaciones/enviadas')
        .then(function (response) {
          vm.notificaciones = response.data || [];
          vm.paginaActual = 1;
        })
        .catch(function () {
          Dialogo.mostrarError({ titulo: 'Error', texto: 'No se pudieron cargar las notificaciones enviadas.' });
          vm.notificaciones = [];
        })
        .finally(function () {
          vm.cargando = false;
        });
    }

    function limpiarFiltros() {
      vm.filtro = { texto: '', desde: null, hasta: null, estado: '', anio: vm.anioActual };
      vm.paginaActual = 1;
    }

    function notificacionesFiltradas() {
      return vm.notificaciones.filter(function (n) {
        // filtro año
       if (vm.filtro.anio) {
          var fechaN = new Date(n.fechaRecepcion || n.fechaEnvio);
          if (fechaN.getFullYear() !== parseInt(vm.filtro.anio)) return false;
        }
        // filtro texto (título o destinatario)
        if (vm.filtro.texto) {
          var texto = vm.filtro.texto.toLowerCase();
          var enTitulo = n.titulo && n.titulo.toLowerCase().indexOf(texto) >= 0;
          var enDestinatario = n.destinatario && n.destinatario.toLowerCase().indexOf(texto) >= 0;
          if (!enTitulo && !enDestinatario) return false;
        }
        // filtro estado
        if (vm.filtro.estado && n.estadoCodigo !== vm.filtro.estado) return false;
        // filtro fecha
      if (vm.filtro.desde || vm.filtro.hasta) {
          var fecha = new Date(n.fechaRecepcion || n.fechaEnvio);
          if (vm.filtro.desde && fecha < new Date(vm.filtro.desde)) return false;
          if (vm.filtro.hasta && fecha > new Date(vm.filtro.hasta)) return false;
        }
        return true;
      });
    }

    function cambiarPagina(pagina) {
      vm.paginaActual = pagina;
    }

    function totalPaginas() {
      return Math.ceil(notificacionesFiltradas().length / vm.tamanioPagina) || 1;
    }
  }
})();

(function () {
  angular.module('administracionNotificaciones')
  .config(config)
  .run(run);

  function config($stateProvider) {

    $stateProvider.state('main.notificacionEnviar', {
      url: 'notificaciones/enviar',
      templateUrl: 'app/app/main/notificacion/enviar-notificacion.html',
      controller: 'EnviarNotificacionController',
      controllerAs: 'vm',
      data: {
        permissions: 'crearNotificaciones'
      }
    });

  }

  function run(DataState, $http, URL_SERVIDOR, Dialogo) {
    DataState.generateModelStates('Notificacion', [
      {
        defaultConfig: 'app/app/main/notificacion/list.state.json',
        defaultFilter: { anio: new Date().getFullYear() },
        actions: {
          publicar: function(item) {
            $http.post(URL_SERVIDOR + 'notificaciones/' + item.id + '/publicar')
              .then(function() {
                item.estado = { codigo: 'generada', nombre: 'Generada' };
                Dialogo.mostrarExito({ titulo: 'Publicada', texto: 'La notificación fue publicada y será enviada en la fecha programada.' });
              })
              .catch(function(error) {
                var msg = error && error.data && error.data.message ? error.data.message : 'No se pudo publicar la notificación.';
                Dialogo.mostrarError({ titulo: 'Error', texto: msg });
              });
          }
        }
      },
      {
        defaultConfig: 'app/app/main/notificacion/edit.state.json',
        datasource: {
          preprocess: function (modelo) {
            if (modelo.fechaVencimiento) {
              modelo.fechas = {
                fechaVencimiento: modelo.fechaVencimiento,
                tieneVencimiento: true
              };
            } else {
              modelo.fechas = {
                fechaVencimiento: moment(modelo.fechaEnvio).add(1, 'M').toDate(),
                tieneVencimiento: false
              };
            }
            modelo.destinatarios = [];
            modelo.grupos.forEach(function (grupo) {
              modelo.destinatarios.push(grupo);
            });
            modelo.personasEspecificas.forEach(function (persona) {
              modelo.destinatarios.push(persona);
            });
            return modelo;
          },
          postprocess: function (modelo) {
            modelo = angular.copy(modelo);
            if (modelo.fechas.tieneVencimiento) {
              modelo.fechaVencimiento = modelo.fechas.fechaVencimiento;
            } else {
              modelo.fechaVencimiento = null;
            }
            delete modelo.fechas;
            modelo.grupos = [];
            modelo.personasEspecificas = [];
            if (modelo.esGlobal) return;
            modelo.destinatarios.forEach(function (d) {
              if (d) {
                if (d.apellido) {
                  modelo.personasEspecificas.push(d);
                } else {
                  modelo.grupos.push(d);
                }
              }
            });
            delete modelo.destinatarios;
            return modelo;
          }
        },
        actions: {
          getNombreMiembro: function getNombre(elemento) {
            if (!elemento) return '';
            if (!elemento.apellido) {
              return elemento.nombreCompleto;
            } else {
              var nombre = elemento.nombre + ' ' + elemento.apellido;
              if (elemento.alumno && elemento.alumno.legajo) {
                nombre += ' (Alumno:' + elemento.alumno.legajo + ')';
              }
              if (elemento.docente && elemento.docente.legajo) {
                nombre += ' (Docente:' + elemento.docente.legajo + ')';
              }
              return nombre;
            }
          }
        }
      }
    ]);
  }
})();

(function () {
  'use strict';

  angular
    .module('administracionNotificaciones')
    .controller('EnviarNotificacionController', EnviarNotificacionController);

  EnviarNotificacionController.$inject = ['$http', 'URL_SERVIDOR', 'Dialogo'];

  function EnviarNotificacionController($http, URL_SERVIDOR, Dialogo) {
    var vm = this;

    vm.categorias = [];
    vm.notificaciones = [];
    vm.grupos = [];
    vm.personas = [];

    vm.categoriaSeleccionada = null;
    vm.notificacionSeleccionada = null;
    vm.tipoDestinatario = 'grupo';
    vm.destinatarios = [];   // lista de destinatarios seleccionados
    vm.enviando = false;
    vm.textoBusqueda = '';
    vm.resultadosBusqueda = [];
    vm.buscando = false;

    vm.agregarDestinatario = function(item) {
      if (!item) return;
      var yaExiste = vm.destinatarios.some(function(d) {
        return d.id === item.id && d.apellido === item.apellido;
      });
      if (!yaExiste) vm.destinatarios.push(item);
      vm.textoBusqueda = '';
      vm.resultadosBusqueda = [];
    };

    vm.quitarDestinatario = function(index) {
      vm.destinatarios.splice(index, 1);
    };

    vm.anioActual = new Date().getFullYear();
    vm.aniosDisponibles = (function() {
      var anios = [];
      for (var a = vm.anioActual; a >= vm.anioActual - 5; a--) anios.push(a);
      return anios;
    })();
    vm.filtroAnio = vm.anioActual;

    vm.notificacionesFiltradas = function() {
      if (!vm.filtroAnio) return vm.notificaciones;
      return vm.notificaciones.filter(function(n) {
        var fecha = new Date(n.fechaEnvio);
        return fecha.getFullYear() === parseInt(vm.filtroAnio);
      });
    };

    vm.onCategoriaChange = onCategoriaChange;
    vm.onTipoDestinatarioChange = onTipoDestinatarioChange;

    // Buscador de destinatarios (grupos + personas)
    vm.buscarDestinatarios = function() {
      if (!vm.textoBusqueda || vm.textoBusqueda.length < 2) {
        vm.resultadosBusqueda = [];
        return;
      }
      vm.buscando = true;
      var texto = vm.textoBusqueda;

      var promGrupos = $http.get(URL_SERVIDOR + 'grupo-persona', {
        params: { busqueda: texto, size: 10 }
      }).then(function(r) {
        var data = r.data;
        return data.content || data || [];
      }).catch(function() { return []; });

      var promPersonas = $http.get(URL_SERVIDOR + 'persona', {
        params: { busqueda: texto, size: 10 }
      }).then(function(r) {
        var data = r.data;
        return data.content || data || [];
      }).catch(function() { return []; });

      Promise.all([promGrupos, promPersonas]).then(function(resultados) {
        vm.resultadosBusqueda = resultados[0].concat(resultados[1]);
        vm.buscando = false;
        var scope = angular.element(document.body).scope();
        if (scope && !scope.$$phase) scope.$apply();
      });
    };

    vm.getNombreDestinatario = function(item) {
      if (!item) return '';
      if (item.apellido) {
        var nombre = item.apellido + ', ' + item.nombre;
        if (item.docente && item.docente.legajo) nombre += ' (Docente: ' + item.docente.legajo + ')';
        if (item.alumno && item.alumno.legajo) nombre += ' (Alumno: ' + item.alumno.legajo + ')';
        return nombre;
      }
      return item.nombreCompleto || item.nombre || '';
    };

    vm.onNotificacionChange = function() {
      if (vm.notificacionSeleccionada) {
        vm.tituloEditable = vm.notificacionSeleccionada.titulo;
        vm.mensajeEditable = vm.notificacionSeleccionada.mensaje;
      } else {
        vm.tituloEditable = '';
        vm.mensajeEditable = '';
      }
    };
    vm.tituloEditable = '';
    vm.mensajeEditable = '';
    vm.adjunto = null;

    vm.onArchivoSeleccionado = function(input) {
      var file = input.files[0];
      if (!file) return;
      var reader = new FileReader();
      reader.onload = function(e) {
        var base64 = e.target.result.split(',')[1];
        vm.adjunto = { nombre: file.name, base64: base64 };
        var scope = angular.element(input).scope();
        if (scope && !scope.$$phase) scope.$apply();
      };
      reader.readAsDataURL(file);
    };

    vm.quitarAdjunto = function() {
      vm.adjunto = null;
    };
    vm.enviar = enviar;

    activar();

    function activar() {
      $http.get(URL_SERVIDOR + 'categorias-notificacion')
        .then(function (response) {
          vm.categorias = response.data;
        })
        .catch(function () {
          Dialogo.mostrarError({
            titulo: 'Error',
            texto: 'No se pudieron cargar las categorías.'
          });
        });

      cargarGrupos();
    }


    function onCategoriaChange() {
      vm.notificacionSeleccionada = null;
      vm.notificaciones = [];

      if (!vm.categoriaSeleccionada) return;

      $http.get(URL_SERVIDOR + 'notificaciones/todos')
        .then(function (response) {
          var todas = response.data || [];
          vm.notificaciones = todas.filter(function (n) {
            if (!n.categorias || n.categorias.length === 0) return false;
            return n.categorias.some(function (c) {
              return c.id === vm.categoriaSeleccionada.id;
            });
          });

          if (vm.notificaciones.length === 0) {
            Dialogo.mostrarError({
              titulo: 'Sin resultados',
              texto: 'No hay notificaciones para la categoría seleccionada.'
            });
          }
        })
        .catch(function () {
          Dialogo.mostrarError({
            titulo: 'Error',
            texto: 'No se pudieron cargar las notificaciones.'
          });
        });
    }

    function onTipoDestinatarioChange() {
      vm.destinatario = null;
      if (vm.tipoDestinatario === 'grupo') {
        cargarGrupos();
      } else {
        cargarPersonas();
      }
    }

    function cargarGrupos() {
      $http.get(URL_SERVIDOR + 'grupo-persona/primer-nivel')
        .then(function (response) {
          vm.grupos = response.data || [];
        })
        .catch(function () {
          Dialogo.mostrarError({
            titulo: 'Error',
            texto: 'No se pudieron cargar los grupos.'
          });
        });
    }

    function cargarPersonas() {
      vm.personas = [];
      vm.textoBusquedaPersona = '';
    }

    vm.buscarPersonas = function() {
      if (!vm.textoBusquedaPersona || vm.textoBusquedaPersona.length < 2) {
        vm.personas = [];
        return;
      }
      $http.get(URL_SERVIDOR + 'persona', { params: { busqueda: vm.textoBusquedaPersona, size: 20 } })
        .then(function (response) {
          var data = response.data;
          vm.personas = data.content || data || [];
        })
        .catch(function () {
          Dialogo.mostrarError({
            titulo: 'Error',
            texto: 'No se pudieron cargar las personas.'
          });
        });
    };

    function enviar() {
      if (!vm.notificacionSeleccionada || vm.destinatarios.length === 0) {
        Dialogo.mostrarError({
          titulo: 'Campos requeridos',
          texto: 'Debe seleccionar una notificación y al menos un destinatario.'
        });
        return;
      }

      vm.enviando = true;

      var idGrupos = [];
      var promesasUsuarios = [];

      vm.destinatarios.forEach(function(dest) {
        var esPersona = dest.apellido !== undefined;
        if (!esPersona) {
          idGrupos.push(dest.id);
        } else {
          // Resolver usuario de la persona
          promesasUsuarios.push(
            $http.get(URL_SERVIDOR + 'usuarios/lista', {
              params: { 'persona.apellido': dest.apellido, 'persona.nombre': dest.nombre, size: 5 }
            }).then(function(response) {
              var usuarios = response.data.content || response.data || [];
              var usuario = usuarios.find(function(u) {
                return u.persona && u.persona.id === dest.id;
              });
              return usuario ? usuario.id : null;
            }).catch(function() { return null; })
          );
        }
      });

      Promise.all(promesasUsuarios).then(function(idUsuariosResueltos) {
        var idUsuarios = idUsuariosResueltos.filter(function(id) { return id !== null; });

        var data = {
          idNotificacion: vm.notificacionSeleccionada.id,
          idGrupos: idGrupos,
          idUsuarios: idUsuarios
        };

        if (vm.adjunto) {
          data.adjuntoBase64 = vm.adjunto.base64;
          data.nombreAdjunto = vm.adjunto.nombre;
        }
        if (vm.tituloEditable !== vm.notificacionSeleccionada.titulo) {
          data.tituloPersonalizado = vm.tituloEditable;
        }
        if (vm.mensajeEditable !== vm.notificacionSeleccionada.mensaje) {
          data.mensajePersonalizado = vm.mensajeEditable;
        }

        return $http.post(URL_SERVIDOR + 'notificaciones/asignar', data);
      }).then(function() {
        Dialogo.mostrarExito({
          titulo: 'Enviada',
          texto: 'La notificación fue enviada correctamente.'
        });
        vm.notificacionSeleccionada = null;
        vm.destinatarios = [];
        vm.adjunto = null;
        vm.tituloEditable = '';
        vm.mensajeEditable = '';
        vm.textoBusqueda = '';
        vm.resultadosBusqueda = [];
      }).catch(function() {
        Dialogo.mostrarError({ titulo: 'Error', texto: 'No se pudo enviar la notificación.' });
      }).finally(function() {
        vm.enviando = false;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('administracionNotificaciones')
    .config(config);

  function config($stateProvider) {

    $stateProvider
      .state('main.bandeja-notificaciones', {
        url: '/notificacion/bandeja',
        templateUrl: 'app/app/main/notificacion/bandeja-notificacion.html',
        controller: 'BandejaNotificacionCtrl as vm'
      });

  }

})();
(function () {
    'use strict';

    angular
        .module('administracionNotificaciones')
        .controller('BandejaNotificacionCtrl', BandejaNotificacionCtrl);

    BandejaNotificacionCtrl.$inject = ['$http', 'URL_SERVIDOR', 'Dialogo', '$scope', '$uibModal', '$rootScope', 'FileSaver', 'Blob'];

    function BandejaNotificacionCtrl($http, URL_SERVIDOR, Dialogo, $scope, $uibModal, $rootScope, FileSaver, Blob) {
        var vm = this;

        vm.notificaciones = [];
        vm.cantidad = {};
        vm.cargando = false;
        vm.notificacionSeleccionada = null;

        vm.cargarBandeja = cargarBandeja;
        vm.seleccionarNotificacion = seleccionarNotificacion;
        vm.verNotificacion = verNotificacion;
        vm.estaLeida = estaLeida;
        vm.calcularFechaLectura = calcularFechaLectura;
        vm.notificacionesFiltradas = notificacionesFiltradas;
        vm.filtroTexto = filtroTexto;
        vm.filtroEstado = filtroEstado;
        vm.filtroFecha = filtroFecha;
        vm.limpiarFiltros = limpiarFiltros;
        vm.cambiarPagina = cambiarPagina;
        vm.totalPaginas = totalPaginas;

        vm.urlAdjunto = function(n) {
            return URL_SERVIDOR + 'notificaciones/' + n.idNotificacion + '/adjunto';
        };

        vm.descargarAdjunto = function(n) {
            $http.get(URL_SERVIDOR + 'notificaciones/' + n.idNotificacion + '/adjunto', {
                responseType: 'arraybuffer'
            }).then(function(response) {
                var blob = new Blob([response.data], { type: 'application/pdf' });
                FileSaver.saveAs(blob, n.nombreAdjunto || 'adjunto.pdf');
            }).catch(function() {
                Dialogo.mostrarError({ titulo: 'Error', texto: 'No se pudo descargar el adjunto.' });
            });
        };

        vm.paginaActual = 1;
        vm.tamanioPagina = 5;

        vm.anioActual = new Date().getFullYear();
        vm.aniosDisponibles = (function() {
            var anios = [];
            for (var a = vm.anioActual; a >= vm.anioActual - 5; a--) anios.push(a);
            return anios;
        })();

        vm.filtro = { texto: '', desde: null, hasta: null, estado: '', anio: vm.anioActual };

        $scope.$watch('vm.filtro', function () {
            vm.paginaActual = 1;
        }, true);

        init();

        function init() {
            cargarBandeja();
        }

        // El back devuelve estado.codigo = 'enviada' (no leída) o 'leida'
        function estaLeida(n) {
            return n.estado && n.estado.codigo === 'leida';
        }

        function calcularFechaLectura(n) {
            if (n.fechaLectura) return n.fechaLectura;
            if (estaLeida(n)) return n.fechaRecepcion || n.fechaEnvio;
            return null;
        }


        function cargarBandeja() {
            vm.cargando = true;
            $http.get(URL_SERVIDOR + 'api/notificaciones/bandeja')
                .then(function (response) {
                    var data = response.data;
                    vm.notificaciones = (data.items || data) || [];
                    vm.paginaActual = 1;
                    vm.cantidad = data.cantidad || {};
                })
                .catch(function () {
                    Dialogo.mostrarError({ titulo: 'Error', texto: 'No se pudo cargar la bandeja.' });
                    vm.notificaciones = [];
                    vm.cantidad = {};
                })
                .finally(function () {
                    vm.cargando = false;
                });
        }

        // marcar como leída 

        function marcarComoLeida(n) {
            if (estaLeida(n)) return;

            $http.post(URL_SERVIDOR + 'notificaciones/usuario/' + n.idNotificacionPorUsuario + '/leer')
                .then(function () {
                    if (n.estado) {
                        n.estado.codigo = 'leida';
                        n.estado.nombre = 'Leída';
                    } else {
                        n.estado = { codigo: 'leida', nombre: 'Leída' };
                    }
                    n.fechaLectura = new Date();
                    n.tipoLectura = 'MANUAL';
                    $rootScope.$broadcast('notificacion:leida');
                });
        }

        function seleccionarNotificacion(n) {
            vm.notificacionSeleccionada = n;
            marcarComoLeida(n);
        }

        // por el momento lo abro en un modal, pero podría ser una página aparte si el contenido es muy grande o tiene adjuntos - ANALIZAR

        function verNotificacion(n) {
            marcarComoLeida(n);
            $uibModal.open({
                templateUrl: 'ver-notificacion-modal.html',
                size: 'lg',
                appendTo: angular.element(document.body),
                controller: function ($scope, $uibModalInstance) {
                    $scope.n = n;
                    $scope.cerrar = function () { $uibModalInstance.close(); };
                    $scope.descargar = function () {
                        $http.get(URL_SERVIDOR + 'notificaciones/' + n.idNotificacion + '/adjunto', {
                            responseType: 'arraybuffer'
                        }).then(function(response) {
                            var blob = new Blob([response.data], { type: 'application/pdf' });
                            FileSaver.saveAs(blob, n.nombreAdjunto || 'adjunto.pdf');
                        }).catch(function() {
                            Dialogo.mostrarError({ titulo: 'Error', texto: 'No se pudo descargar el adjunto.' });
                        });
                    };
                }
            });
        }

        //filtros

        function limpiarFiltros() {
            vm.filtro = { texto: '', desde: null, hasta: null, estado: '', anio: vm.anioActual };
        }

        function notificacionesFiltradas() {
            return vm.notificaciones.filter(function (n) {
                return filtroAnio(n) && filtroTexto(n) && filtroEstado(n) && filtroFecha(n);
            });
        }

        function filtroAnio(item) {
            if (!vm.filtro.anio) return true;
            var fecha = new Date(item.fechaRecepcion || item.fechaEnvio);
            return fecha.getFullYear() === parseInt(vm.filtro.anio);
        }

        function filtroTexto(item) {
            if (!vm.filtro.texto) return true;
            var texto = vm.filtro.texto.toLowerCase();
            return (item.titulo && item.titulo.toLowerCase().includes(texto)) ||
                   (item.mensaje && item.mensaje.toLowerCase().includes(texto));
        }

        function filtroEstado(item) {
            if (!vm.filtro.estado) return true;
            if (vm.filtro.estado === 'leidas') return estaLeida(item);
            if (vm.filtro.estado === 'noLeidas') return !estaLeida(item);
            return true;
        }

        function filtroFecha(item) {
            if (!vm.filtro.desde && !vm.filtro.hasta) return true;
            var fecha = new Date(item.fechaRecepcion || item.fechaEnvio);
            if (vm.filtro.desde && fecha < new Date(vm.filtro.desde)) return false;
            if (vm.filtro.hasta && fecha > new Date(vm.filtro.hasta)) return false;
            return true;
        }


        function cambiarPagina(pagina) {
            vm.paginaActual = pagina;
        }

        function totalPaginas() {
            return Math.ceil(notificacionesFiltradas().length / vm.tamanioPagina) || 1;
        }
    }
})();

/* global angular */
(function () {
  angular.module('administracionNotificaciones').run(run);
  function run($state, DataState, TipoDocumentacion, Dialogo, DocumentacionDocentes, Descargas) {
    DataState.generateModelStates('MisDocumentos', [
      {
        defaultConfig: 'app/app/main/mis-documentos/list.state.json',
        // templateUrl: 'app/app/main/mis-documentos/list-documentos.html',
        controller: 'DocumentacionDocenteListCtrl as vm',
        actions: {
          nuevaDocumentacion: function (especialid, plan, materia, anoacademi, comision) {
            var dto = {
              anoacademi: anoacademi,
              plan: plan,
              materia: materia,
              comision: comision,
              especialid: especialid
            };
            dto.id = 'nuevo';
            $state.go('^.edit', dto);
          },
          imprimir: function (documentacion) {
            Dialogo.mostrarCargando();
            DocumentacionDocentes.descargarArchivo(documentacion.id).then(function () {
              Dialogo.mostrarExito({
                titulo: 'Éxito',
                texto: 'Se ha descargado el archivo.',
                accionSi: function (dialogo) {
                  dialogo.close();
                }
              });
              Dialogo.ocultarCargando();
            }, function (error) {
              Dialogo.mostrarError({
                titulo: 'Error',
                texto: error.data.message
              });
              Dialogo.ocultarCargando();
            });
          },
          eliminar: function (documentacion) {
            Dialogo.mostrarConfirmacion({
              texto: '¿Está seguro que desea eliminar el archivo?',
              titulo: 'Eliminar archivo',
              icon: 'fa-check',
              accionSi: function (dialogo) {
                Dialogo.mostrarCargando();
                dialogo.close();
                DocumentacionDocentes.remove({ id: documentacion.id }).$promise.then(function () {
                  Dialogo.ocultarCargando();
                  $state.reload();
                }, function (error) {
                  Dialogo.mostrarError({
                    titulo: 'Error',
                    texto: error.data.message
                  });
                  Dialogo.ocultarCargando();
                });
              }
            });

          }
        }

      },
      {
        defaultConfig: 'app/app/main/mis-documentos/edit.state.json',
        controller: 'DocumentacionDocenteEditCtrl as vm',
        extraResolves: [{
          name: 'tiposDocumentacion',
          resolve: function () {
            var rta = TipoDocumentacion.query({
            }).$promise;
            return rta;
          }
        }
        ],
        postResolve: function (config) {
          config.fields[1].templateOptions.options = config.extraData.tiposDocumentacion;
          return config;
        },
        datasource: {
          preprocess: function (modelo) {
            if (modelo.fechaInicioCarga) {
              modelo.fechaInicioCarga = moment(modelo.fechaInicioCarga).toDate();
            }
            if (modelo.fechaFinCarga) {
              modelo.fechaFinCarga = moment(modelo.fechaFinCarga).toDate();
            }
            return modelo;
          },
          postprocess: function (modelo) {

            var archivo = {};
            archivo = angular.copy(modelo.archivo);
            archivo.archivo = angular.copy(modelo.archivo.contenido);
            archivo.nombreArchivo = angular.copy(modelo.archivo.nombre);
            archivo.archivo = archivo.archivo.split(',')[1];
            delete modelo.archivo;

            var dto = {
              id: modelo.id,
              archivo: archivo,
              documentacion: modelo
            };
            return dto;
          }
        }
      },
      {
        defaultConfig: 'app/app/main/mis-documentos/descargas-list.state.json',
        actions: {
          imprimir: function (item) {
            Dialogo.mostrarCargando();
            Descargas.descargarArchivo(item).then(function () {
              // Dialogo.mostrarExito({
              //   titulo: 'Éxito',
              //   texto: 'Se ha descargado el archivo.',
              //   accionSi: function (dialogo) {
              //     dialogo.close();
              //   }
              // });
              Dialogo.ocultarCargando();
            }, function (error) {
              Dialogo.mostrarError({
                titulo: 'Error',
                texto: error.data.message
              });
              Dialogo.ocultarCargando();
            });
          }
        }
      }
    ]);
  }
})();

/* global angular */
(function () {
  angular.module('administracionNotificaciones')
        .controller('DocumentacionDocenteListCtrl', DocumentacionDocenteListCtrl);

  function DocumentacionDocenteListCtrl($scope, list) {
    var vm = this;
    delete list.generalActions;
    vm.list = list;
    $scope.$watch('vm.list.ready', function (value) {
      if (value) {
        $scope.$emit('OCULTAR_CARGANDO');
      }
    });
  }
})();

/* global angular */
(function () {
  angular.module('administracionNotificaciones').run(run);

  function run($q, DataState, $state, Columns, Messages, Dialogo, MateriaDocente, AnaliticaEncuesta) {

    function saveElement(data, scope) {
      Dialogo.mostrarCargando();
      return scope.datasource.save(data, successSave(data), errorSave);
    }

    function successSave(comision) {
      return function (response) {
        Dialogo.ocultarCargando();
        Dialogo.mostrarConfirmacion({
          data: {
            comision: comision
          },
          fields: [{
            type: 'input',
            key: 'checksum',
            templateOptions: {
              type: 'text',
              label: 'Ingrese el código que recibió por Whatsapp:',
              required: true,
              minlength: 9,
              maxlength: 9
            }
          }],
          titulo: 'Confirmar notas comisión',
          texto: response.mensaje,
          plantilla: 'app/app/main/materia-docente/dialogo-confirmar-notas-inmediato.html',
          accionSi: function (dialogo, data) {
            Dialogo.mostrarCargando();
            dialogo.close();
            // console.log(comision);
            var params = {
              anioAcademico: comision.comision.id.anoacademi,
              especialidad: comision.comision.id.especialid,
              plan: comision.comision.id.plan,
              materia: comision.comision.id.materia,
              comision: comision.comision.id.comision
            };
            MateriaDocente.confirmarNotas({
              comision: params,
              checksum: data.checksum
            }, function () {
              Dialogo.mostrarExito({
                titulo: 'Éxito',
                texto: 'Las notas se han confirmado correctamente y ya puede ver los cambios realizados.',
                accionSi: function (dialogo) {
                  dialogo.close();
                  $state.go('^.list');
                }
              });
              Dialogo.ocultarCargando();
            }, function (error) {
              Dialogo.mostrarError({
                titulo: 'Error',
                texto: error.data.message
              });
              Dialogo.ocultarCargando();
            });
          },
          textoSi: 'Confirmar',
          textoNo: 'Confirmar luego',
          accionNo: function (dialogo) {
            dialogo.close();
            $state.go('^.list');
          }
        });
      };
    }

    function errorSave(error) {
      Dialogo.ocultarCargando();
      Dialogo.mostrarError({
        titulo: 'Error',
        texto: error.data.message
      });
    }

    DataState.generateModelStates('MateriaDocente', [
      {
        defaultConfig: 'app/app/main/materia-docente/materias-cerradas.state.json',
        postResolve: function (config) {
          config.filter[0].templateOptions.options = config.extraData.aniosDisponibles.map(function (e) {
            return {
              value: e,
              name: e
            };
          });
          if (config.filter[0].templateOptions.options.length > 0) {
            if (!config.filterValues) {
              config.filterValues = {};
            }
            config.filterValues.anioAcademico = config.extraData.aniosDisponibles[0];
          }
          return config;
        },
        extraResolves: [{
          name: 'aniosDisponibles',
          resolve: function () {
            return $q.when([
              '2021',
              '2020',
              '2019',
              '2018',
              '2017',
              '2016',
              '2015',
              '2014',
              '2013'
            ]);
          }
        }]
      },
      {
        defaultConfig: 'app/app/main/materia-docente/list.state.json',
        postResolve: function (config) {
          config.filter[0].templateOptions.options = config.extraData.aniosDisponibles.map(function (e) {
            return {
              value: e,
              name: e
            };
          });
          if (config.filter[0].templateOptions.options.length > 0) {
            if (!config.filterValues) {
              config.filterValues = {};
            }
            config.filterValues.anioAcademico = config.extraData.aniosDisponibles[0];
          }
          return config;
        },
        extraResolves: [{
          name: 'aniosDisponibles',
          resolve: function () {
            return MateriaDocente.aniosDisponibles().$promise;
          }
        }],
        actions: {
          verNotas: function (comision) {
            if (comision.pendienteVerificacion != 'NO_TIENE') {
              var texto = null;
              if (comision.pendienteVerificacion == 'PENDIENTES_PROPIA') {
                texto = 'Usted tiene notas pendientes de verificación para esta comisión, estas notas no serán visibles hasta que no las confirme. ¿Desea continuar?';
              } else if (comision.pendienteVerificacion == 'PENDIENTES_OTRO') {
                if (comision.nombreDocentePendienteVerificacion.length > 1) {
                  texto = 'Los docentes ' + comision.nombreDocentePendienteVerificacion.join(', ') + ' tienen notas pendientes de verificación para esta comisión, estas notas no serán visibles hasta que no las confirme. ¿Desea continuar?';
                } else {
                  texto = 'El docente ' + comision.nombreDocentePendienteVerificacion[0] + ' tiene notas pendientes de verificación para esta comisión, estas notas no serán visibles hasta que no las confirme. ¿Desea continuar?';
                }
              } else if (comision.pendienteVerificacion == 'PENDIENTES_PROPIA_Y_OTRO') {
                if (comision.nombreDocentePendienteVerificacion.length > 1) {
                  texto = 'Usted y los docentes ' + comision.nombreDocentePendienteVerificacion.join(', ') + ' tienen notas pendientes de verificación para esta comisión, estas notas no serán visibles hasta que no las confirme. ¿Desea continuar?';
                } else {
                  texto = 'Usted y el docente ' + comision.nombreDocentePendienteVerificacion[0] + ' tiene notas pendientes de verificación para esta comisión, estas notas no serán visibles hasta que no las confirme. ¿Desea continuar?';
                }
              }
              Dialogo.mostrarConfirmacion({
                data: {
                  comision: comision
                },
                titulo: 'Advertencia',
                texto: texto,
                accionSi: function (dialogo) {
                  dialogo.close();
                  $state.go('^.consultarNotas', comision);
                }
              });
            } else {
              $state.go('^.consultarNotas', comision);
            }
          },
          editarNotas: function (comision) {
            if (comision.pendienteVerificacion != 'NO_TIENE') {
              var texto = null;
              if (comision.pendienteVerificacion == 'PENDIENTES_PROPIA') {
                texto = 'Usted tiene notas pendientes de verificación para esta comisión, si carga notas nuevas, las notas que cargó y no verificó se perderán. ¿Desea continuar?';
              } else if (comision.pendienteVerificacion == 'PENDIENTES_OTRO') {
                if (comision.nombreDocentePendienteVerificacion.length > 1) {
                  texto = 'Los docentes ' + comision.nombreDocentePendienteVerificacion.join(', ') + ' tienen notas pendientes de verificación para esta comisión, si carga notas nuevas, las notas cargadas por el resto de los docentes se perderán. ¿Desea continuar?';
                } else {
                  texto = 'El docente ' + comision.nombreDocentePendienteVerificacion[0] + ' tiene notas pendientes de verificación para esta comisión, si carga notas nuevas, las notas cargadas por el otro docente se perderán. ¿Desea continuar?';
                }
              } else if (comision.pendienteVerificacion == 'PENDIENTES_PROPIA_Y_OTRO') {
                if (comision.nombreDocentePendienteVerificacion.length > 1) {
                  texto = 'Usted y los docentes ' + comision.nombreDocentePendienteVerificacion.join(', ') + ' tienen notas pendientes de verificación para esta comisión, si carga notas nuevas, las notas cargadas por usted y por los otros docentes se perderán. ¿Desea continuar?';
                } else {
                  texto = 'Usted y el docente ' + comision.nombreDocentePendienteVerificacion[0] + ' tiene notas pendientes de verificación para esta comisión, si carga notas nuevas, las notas cargadas por usted y el otro docente se perderán. ¿Desea continuar?';
                }
              }
              Dialogo.mostrarConfirmacion({
                data: {
                  comision: comision
                },
                titulo: 'Confirmar carga de notas',
                texto: texto,
                accionSi: function (dialogo) {
                  dialogo.close();
                  $state.go('^.editarNotas', comision);
                }
              });
            } else {
              $state.go('^.editarNotas', comision);
            }
          },
          exportarPlanilla: function (comision) {
            Dialogo.mostrarCargando();
            // console.log(comision);
            var params = {
              anioAcademico: comision.anioAcademico,
              especialidad: comision.especialidad,
              plan: comision.plan,
              materia: comision.materia,
              comision: comision.comision,
              nombreMateria: comision.nombreMateria
            };
            MateriaDocente.exportarPlanilla(params).then(function () {
              Dialogo.mostrarExito({
                titulo: 'Éxito',
                texto: 'Se ha exportado correctamente la planilla.',
                accionSi: function (dialogo) {
                  dialogo.close();
                }
              });
              Dialogo.ocultarCargando();
            }, function (error) {
              Dialogo.mostrarError({
                titulo: 'Error',
                texto: error.data.message
              });
              Dialogo.ocultarCargando();
            });
          },
          confirmarNotas: function (comision) {
            Dialogo.mostrarConfirmacion({
              data: {
                comision: comision
              },
              fields: [{
                type: 'input',
                key: 'checksum',
                templateOptions: {
                  type: 'text',
                  label: 'Ingrese el código que recibió por Whatsapp:',
                  required: true,
                  minlength: 9,
                  maxlength: 9
                }
              }],
              titulo: 'Confirmar notas comisión',
              plantilla: 'app/app/main/materia-docente/dialogo-confirmar-notas.html',
              accionSi: function (dialogo, data) {
                Dialogo.mostrarCargando();
                dialogo.close();
                MateriaDocente.confirmarNotas({
                  comision: comision,
                  checksum: data.checksum
                }, function () {
                  Dialogo.mostrarExito({
                    titulo: 'Éxito',
                    texto: 'Las notas se han confirmado correctamente y ya puede ver los cambios realizados.'
                  });
                  Dialogo.ocultarCargando();
                  $state.go($state.current, {}, {
                    reload: true
                  });
                }, function (error) {
                  Dialogo.mostrarError({
                    titulo: 'Error',
                    texto: error.data.message
                  });
                  Dialogo.ocultarCargando();
                });
              }
            });
          },
          reenviarSMS: function (comision) {
            Dialogo.mostrarConfirmacion({
              data: {
                comision: comision
              },
              titulo: 'Confirmar reenvío de Whatsapp',
              texto: '¿Está seguro que desea reenviar el Whatsapp con el código de verificación?',
              accionSi: function (dialogo) {
                Dialogo.mostrarCargando();
                dialogo.close();
                MateriaDocente.reenviarSMS(comision, function (data) {
                  Dialogo.mostrarExito({
                    titulo: 'Éxito',
                    texto: data.mensaje
                  });
                  Dialogo.ocultarCargando();
                }, function (error) {
                  Dialogo.mostrarError({
                    titulo: 'Error',
                    texto: error.data.message
                  });
                  Dialogo.ocultarCargando();
                });
              }
            });
          },
          cerrar: function (comision) {
            if (comision.pendienteVerificacion != 'NO_TIENE') {
              Dialogo.mostrarError({
                titulo: 'Error',
                texto: 'No se puede pedir cerrar la comisión porque existen notas pendientes de verificación.'
              });
            } else {
              Dialogo.mostrarConfirmacion({
                titulo: 'Confirmar cierre de comisión',
                texto: '¿Está seguro que quiere cerrar la comisión? Una vez realizado esto no podrá cargar más notas para esa comisión.',
                accionSi: function (dialogo) {
                  Dialogo.mostrarCargando();
                  dialogo.close();
                  MateriaDocente.solicitarCierre(comision, function (data) {
                    // console.log(data);
                    Dialogo.mostrarConfirmacion({
                      data: {
                        comision: comision,
                        id: data.id
                      },
                      fields: [{
                        type: 'input',
                        key: 'hash',
                        templateOptions: {
                          type: 'text',
                          label: 'Ingrese el código que recibió para confirmar el cierre:',
                          required: true,
                          minlength: 8,
                          maxlength: 8
                        }
                      }],
                      texto: 'Se ha enviado un Whatsapp con un código de verificación a su teléfono.',
                      titulo: 'Confirmar cierre comisión',
                      plantilla: 'app/app/main/materia-docente/dialogo-confirmar-cierre-comision.html',
                      accionSi: function (dialogo, data) {
                        Dialogo.mostrarCargando();
                        dialogo.close();
                        comision.hash = data.hash;
                        comision.id = data.id;
                        MateriaDocente.cerrar(comision, function (data) {
                          Dialogo.mostrarExito({
                            titulo: 'Éxito',
                            texto: data.mensaje
                          });
                          Dialogo.ocultarCargando();
                          $state.go($state.current, {}, {
                            reload: true
                          });
                        }, function (error) {
                          Dialogo.mostrarError({
                            titulo: 'Error',
                            texto: error.data.message
                          });
                          Dialogo.ocultarCargando();
                        });
                      }
                    });
                    Dialogo.ocultarCargando();
                  });
                }
              });
              Dialogo.ocultarCargando();
            }
          },
          verLibroDeTemas: function (comision) {
            $state.go('main.libro de temas.list', comision);
          },
          verDocumentacion: function (comision) {
            $state.go('main.documentación.list', comision);
          },
          verComparativoEncuesta: function (comision) {
            $state.go('main.analitica-docente-comparativa', {
              dashboard: '48',
              especialidad: comision.especialidad,
              plan: comision.plan,
              materia: comision.materia,
              comision: comision.comision
            });
          }
          /* verComparativoEncuesta: function (comision) {
          //  Dialogo.mostrarCargando();
            console.log(comision);
            var params = {
              anioAcademico: comision.anioAcademico,
              especialidad: comision.especialidad,
              plan: comision.plan,
              materia: comision.materia,
              comision: comision.comision,
              nombreMateria: comision.nombreMateria.split('(')[0].trim()
            //  nombreMateria: comision.nombreMateria
            };
            AnaliticaEncuesta.obtenerLinkComparativa({
          id: '48',
          especialidad: comision.especialidad,
          plan: comision.plan,
          materia: comision.nombreMateria.split('(')[0].trim(),//comision.nombreMateria,
          comision: comision.comision
        }).$promise
          .then(function(response) {
            console.log('Respuesta del backend:', response);
            if (response && response.mensaje) {
              window.open(response.mensaje, '_blank');
            } else {
              console.error('La respuesta no contiene un enlace válido:', response);
              alert('No se encontró un enlace válido en la respuesta de Metabase.');
            }
          })
          .catch(function(error) {
            console.error('Error al obtener el enlace de Metabase:', error);
            alert('No se pudo cargar el gráfico de Metabase. Por favor, intenta de nuevo.');
          });
          } */
        }

      },
      {
        defaultConfig: 'app/app/main/materia-docente/consultar-notas.state.json',
        postResolve: function (config) {
          return config.datasource.get(config.stateParams).then(function (data) {
            var cols = data.data.configuracion.abreviaturaNotas.map(function (n, i) {
              return Columns.getCol({
                title: n,
                type: 'labels',
                clase: 'text-center',
                indiceNota: i,
                labels: [{
                  name: '{{row.notas[' + i + ']}}',
                  style: 'label-success',
                  displayExpression: 'row.notas[' + i + ']>=6'
                },
                  {
                    name: '{{row.notas[' + i + ']}}',
                    style: 'label-danger',
                    displayExpression: 'row.notas[' + i + ']<6 && row.notas[' + i + '] > 0'
                  },
                  {
                    name: '{{row.notas[' + i + ']}}',
                    style: 'label-none',
                    displayExpression: 'row.notas[' + i + ']==0'
                  }
                ]
              });
            }).filter(function (n) {
              return n.title;
            });
            var evaluados = [1, 0];
            var aprobados = [1, 0];
            var desaprobados = [1, 0];
            config.summaryRows[3][0].colspan += cols.length;
            config.summaryRows[4][0].colspan += cols.length;
            config.summaryRows[5][0].colspan += cols.length;
            config.summaryRows[6][0].colspan += cols.length;
            config.summaryRows[7][0].colspan += cols.length;
            cols.forEach(function (col) {
              evaluados.push({
                expression: '{{$data | summary:\'count\':\'item\':\'item.notas[' + col.indiceNota + '] && item.notas[' + col.indiceNota + '] != 0\'}}',
                clase: 'text-center'
              });
              aprobados.push({
                expression: '{{$data | summary:\'count\':\'item\':\'item.notas[' + col.indiceNota + '] >= 6\'}}',
                clase: 'text-center'
              });
              desaprobados.push({
                expression: '{{$data | summary:\'count\':\'item\':\'item.notas[' + col.indiceNota + '] > 0 && item.notas[' + col.indiceNota + '] < 6\'}}',
                clase: 'text-center'
              });
            });
            cols.unshift(4, 0);
            config.summaryRows[0].splice.apply(config.summaryRows[0], evaluados);
            config.summaryRows[1].splice.apply(config.summaryRows[1], aprobados);
            config.summaryRows[2].splice.apply(config.summaryRows[2], desaprobados);
            config.cols.splice.apply(config.cols, cols);
            return config;
          });
        },
        actions: {
          editarNotas: function (comision) {
            $state.go('^.editarNotas', comision);
          },
          exportarPlanilla: function (comision) {
            Dialogo.mostrarCargando();
            // console.log(comision);
            var params = {
              anioAcademico: comision.id.anoacademi,
              especialidad: comision.id.especialid,
              plan: comision.id.plan,
              materia: comision.id.materia,
              comision: comision.id.comision,
              nombreMateria: comision.materia.nombre
            };
            MateriaDocente.exportarPlanilla(params).then(function () {
              Dialogo.mostrarExito({
                titulo: 'Éxito',
                texto: 'Se ha exportado correctamente la planilla.',
                accionSi: function (dialogo) {
                  dialogo.close();
                }
              });
              Dialogo.ocultarCargando();
            }, function (error) {
              Dialogo.mostrarError({
                titulo: 'Error',
                texto: error.data.message
              });
              Dialogo.ocultarCargando();
            });
          }
        }
      },
      {
        defaultConfig: 'app/app/main/materia-docente/editar-notas.state.json',
        datasource: {
          preprocess: function (data) {
            var inscripto = {
              name: 'Inscripto',
              value: 'Inscripto'
            };
            var libre = {
              name: 'Libre',
              value: 'Libre'
            };
            var regular = {
              name: 'Regular',
              value: 'Regular'
            };
            var promocion = {
              name: 'Promoción TP',
              value: 'Promoción TP'
            };
            var aprobacion = {
              name: 'Aprobación Directa',
              value: 'Ap. Directa'
            };
            data.forEach(function (e) {
            //   if (e.estadoacademico == 'Abandonó' || (+e.legajo) > 900000) {
              if (e.estadoacademico == 'Abandonó') {
                e.estadoacademico = 'Inscripto';
              }
              e.estadoacademicooriginal = e.estadoacademico;
              if (e.estadoacademico == 'Inscripto') {
                e.opciones = [inscripto, libre, regular, promocion, aprobacion];
              } else if (e.estadoacademico == 'Libre') {
                e.opciones = [libre];
              } else if (e.estadoacademico == 'Regular') {
                e.opciones = [regular];
              } else if (e.estadoacademico == 'Promocion TP') {
                e.opciones = [promocion];
                e.estadoacademico = 'Promoción TP';
              } else if (e.estadoacademico == 'Ap. Directa') {
                e.opciones = [aprobacion];
              }
            });
            return data;
          }
        },
        cols: [{}, {}, {}, {}, {
          fields: [{
            validators: {
              integer: function (value) {
                var i = Number(value);
                if (i < 0 || i > 10 || !Number.isInteger(i)) {
                  return false;
                }
                return true;
              },
              aprobado: function (viewValue, modelValue, scope) {
                if (scope.model.estadoacademico == 'Ap. Directa') {
                  return Number(viewValue) >= 6;
                }
                return true;
              }
            },
            expressionProperties: {
              'templateOptions.disabled': function (viewValue, modelValue, scope) {
                return scope.model.estadoacademicooriginal != 'Inscripto';
              }
            },
            extras: {
              validateOnModelChange: true
            }
          }]
        }, {
          fields: [{
            validators: {
              noAbandono: function (value) {
                return value !== 'Abandonó';
              },
              alumnoSinLegajo: function (viewValue, modelValue, scope) {
                if (!scope.model) return true;
                // return (+scope.model.legajo) < 900000 || viewValue == 'Inscripto';
                return true || viewValue == 'Inscripto';
              }
            },
            expressionProperties: {
              'templateOptions.disabled': function (viewValue, modelValue, scope) {
                // return scope.model.legajo > 900000 || scope.model.estadoasistencia != 'Regular' || scope.model.estadoacademicooriginal != 'Inscripto';
                return scope.model.estadoasistencia != 'Regular' || scope.model.estadoacademicooriginal != 'Inscripto';
              }
            }
          }]
        }],
        postResolve: function (config) {
          return config.datasource.get(config.stateParams).then(function (data) {
            var cols = data.data.configuracion.abreviaturaNotas.map(function (n, i) {
              return Columns.getCol({
                title: n,
                type: 'form',
                isolated: true,
                clase: 'text-center no-padding',
                indiceNota: i,
                fields: [{
                  key: 'notas[' + i + ']',
                  className: 'table-input',
                  type: 'input',
                  templateOptions: {
                    type: 'text',
                    min: 1,
                    max: 10,
                    required: true,
                    selectOnFocus: true,
                    tableArrows: 'materias-docente'
                  },
                  validators: {
                    'number': function (value) {
                      var i = Number(value);
                      if (isNaN(i) || i < 0 || i > 10 || !Number.isInteger(i)) {
                        return false;
                      }
                      return true;
                    }
                  },
                  expressionProperties: {
                    'templateOptions.disabled': function (viewValue, modelValue, scope) {
                      return scope.model.estadoacademicooriginal != 'Inscripto';
                    }
                  },
                  ngModelAttrs: {
                    selectOnFocus: {
                      attribute: 'select-on-focus'
                    },
                    tableArrows: {
                      attribute: 'table-arrows'
                    }
                  }
                }]
              });
            }).filter(function (n) {
              return n.title;
            });
            var evaluados = [1, 0];
            var aprobados = [1, 0];
            var desaprobados = [1, 0];
            config.summaryRows[3][0].colspan += cols.length;
            config.summaryRows[4][0].colspan += cols.length;
            config.summaryRows[5][0].colspan += cols.length;
            config.summaryRows[6][0].colspan += cols.length;
            config.summaryRows[7][0].colspan += cols.length;
            cols.forEach(function (col) {
              evaluados.push({
                expression: '{{$data | summary:\'count\':\'item\':\'item.notas[' + col.indiceNota + '] && item.notas[' + col.indiceNota + '] != 0\'}}',
                clase: 'text-center'
              });
              aprobados.push({
                expression: '{{$data | summary:\'count\':\'item\':\'item.notas[' + col.indiceNota + '] >= 6\'}}',
                clase: 'text-center'
              });
              desaprobados.push({
                expression: '{{$data | summary:\'count\':\'item\':\'item.notas[' + col.indiceNota + '] > 0 && item.notas[' + col.indiceNota + '] < 6\'}}',
                clase: 'text-center'
              });
            });
            cols.unshift(4, 0);
            config.summaryRows[0].splice.apply(config.summaryRows[0], evaluados);
            config.summaryRows[1].splice.apply(config.summaryRows[1], aprobados);
            config.summaryRows[2].splice.apply(config.summaryRows[2], desaprobados);
            config.cols.splice.apply(config.cols, cols);
            return config;
          });
        },
        actions: {
          saveElementAndRequestCode: function (data, scope) {
            // console.log(data);
            var r = angular.copy(data.data);
            r.notas = angular.copy(data);
            delete r.notas.data;
            saveElement(r, scope).then(function () {
              // console.log('Finish');
            });
          }
        }
      }
    ]);
  }
})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider.state('main.materias-electivas',{
      url: 'materias-electivas',
      templateUrl: 'app/app/main/materia-electiva/materia-electiva.html',
      controller: 'MateriasElectivasCtrl as vm',
      resolve: {
        materiasElectivas: function(MateriaElectiva) {
          return MateriaElectiva.query({incluirRegulares: true, incluirCursando: true}).$promise;
        }
      }
    });

  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').controller('MateriasElectivasCtrl', MateriasElectivasCtrl);

  function MateriasElectivasCtrl(materiasElectivas) {
    var vm = this;

    vm.materiasElectivas = materiasElectivas.sort(sortMaterias);
    vm.getNombreEstado = getNombreEstado;
    vm.getEstado = getEstado;
    calcularTotalesHoras();

    function calcularTotalesHoras() {
      vm.totales = {
        aprobadas: 0,
        regulares: 0,
        cursando: 0
      };
      vm.materiasElectivas.forEach(function(electiva){
        if (electiva.estadoAprobacion === 'APROBADA') {
          vm.totales.aprobadas+=electiva.horas;
        } else if (electiva.estadoAprobacion === 'REGULARIZADA') {
          vm.totales.regulares+=electiva.horas;
        } else if (electiva.estadoAprobacion === 'CURSANDO') {
          vm.totales.cursando+=electiva.horas;
        }
      });
    }

    function getNombreEstado(detalle) {
      if (detalle.estadoAprobacion === 'APROBADA') {
        if(detalle.estadoAcademicoCursado === 'APROBACION_DIRECTA'){
          return 'Aprobación Directa';
        }else{
          return 'Aprobada';
        }
      } else if (detalle.estadoAprobacion === 'REGULARIZADA') {
        return 'Regularizada';
      } else if (detalle.estadoAprobacion === 'CURSANDO') {
        return 'Cursando';
      } else if (detalle.estadoAprobacion === 'NO_CURSADA') {
        return 'No Cursada';
      }
    }

    function getEstado(detalle) {
      if (detalle.estadoAprobacion === 'APROBADA') {
        return 'label-success';
      } else if (detalle.estadoAprobacion === 'REGULARIZADA') {
        return 'label-primary';
      } else if (detalle.estadoAprobacion === 'CURSANDO') {
        return 'label-warning';
      } else if (detalle.estadoAprobacion === 'NO_CURSADA') {
        return 'label-default';
      }
    }


    function sortMaterias(m1, m2) {
      var valor = getOrden(m1) - getOrden(m2);
      if (valor != 0) {
        return valor;
      } else {
        if (m1.materia < m2.materia)
          return -1
        if ( m1.materia > m2.materia)
          return 1
        return 0
      }
    }

    function getOrden(detalle) {
      if (detalle.estadoAprobacion === 'APROBADA') {
        return 0;
      } else if (detalle.estadoAprobacion === 'REGULARIZADA') {
        return 1;
      } else if (detalle.estadoAprobacion === 'CURSANDO') {
        return 2;
      } else if (detalle.estadoAprobacion === 'NO_CURSADA') {
        return 3;
      }
    }


  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider.state('main.materias-cursando',{
      url: 'materias-cursando',
      templateUrl: 'app/app/main/materia-cursando/materia-cursando.html',
      abstract: true,
      resolve: {
        materiaCursando: function(MateriaCursando) {
          return MateriaCursando.get().$promise;
        }
      }
    });

  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider.state('main.libro-de-temas',{
      url: 'libro-de-temas',
      templateUrl: 'app/app/main/libro-de-temas/libro-de-temas.html',
      abstract: true,
      resolve: {
        materias: function(EstadoAcademico) {
          return EstadoAcademico.get().$promise;
        }
      }
    });
  }
})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider.state('main.inscripcion-cursado',{
      url: 'inscripcion-cursado',
      templateUrl: '/app/app/main/inscripcion-cursado/inscripcion-cursado.html',
      controller: 'InscripcionCursadoCtrl as vm',
      resolve: {
        materiasDisponibles: function(InscripcionCursado) {
          return InscripcionCursado.materiasDisponibles().$promise;
        },
        estadoAcademico: function(EstadoAcademico) {
          return EstadoAcademico.get().$promise;
        }
      }
    });

  }

})();
(function() {
  'use strict';

  angular.module('administracionNotificaciones').controller('InscripcionCursadoCtrl', InscripcionCursadoCtrl);

  function InscripcionCursadoCtrl($scope, InscripcionCursado, ComisionesCursado, Dialogo, materiasDisponibles, estadoAcademico, $filter, TurnosExamen, $state) {
    var vm = this;
    var materiaSeleccionada;
    asignarEstadoMaterias();
    vm.verificarCursado = verificarCursado;
    vm.getEstado = getEstado;
    vm.getNombreEstado = getNombreEstado;
    vm.confirmarAnulacion = confirmarAnulacion

    function asignarEstadoMaterias() {
      materiasDisponibles.materias.forEach(function (materia) {
        estadoAcademico.detalles.forEach(function (m) {
          if (materia.codigoMateria === m.codigoMateria) {
            if(m.estadoMateria === 'NO_CURSADA' && m.faltaReg === null){
              materia.estado = 'cursable';
            }else{
              if(m.estadoMateria === 'CURSANDO' && m.faltaReg === null){
                materia.estado = 'cursando';
              }else{
                materia.estado = "no_cursable";
              }
            }
          }
        });
      });
      vm.materias = materiasDisponibles.materias;
    }
    
    function mostrarComisiones(materia) {
      Dialogo.mostrarCargando();
      InscripcionCursado.listarComisiones(materia, function(comisiones) {
        ComisionesCursado.setMateria(materia);
        ComisionesCursado.setComisiones(comisiones);
        $state.go('main.comisiones-para-cursado');
      }, errorComisiones);
    }
 
    function getNombreEstado(materia) {
      if (materia.estado === 'cursable') {
        return 'Puede Cursar';
      } else
        if(materia.estado === 'cursando'){
          return 'Cursando';
        } else{
          return 'No Puede Cursar';
      }
    }

    function getEstado(materia) {
      if (materia.estado === 'cursable') {
        return 'label-success';
      } else
        if(materia.estado === 'cursando'){
          return 'label-primary';
        } else{
          return 'label-danger';
      }
    }

    function verificarInscripcionCursado(materia) {
      return materia.checksum;
    }

    function verificarCursado(materia) {
      if (verificarInscripcionCursado(materia)) {
        mostrarMensajeConfirmacionComisiones(materia);
      } else {
        mostrarComisiones(materia);
      }
    }

    function mostrarMensajeConfirmacionComisiones(materia) {
      var horarios = getHorarios(materia);
      var horarioTexto = "";
      for(var i = 0; i<horarios.length; i++){
        if(i!=horarios.length-1){
          horarioTexto += horarios[i]+" , ";
        }else{
          horarioTexto += horarios[i];
        }
      }

      Dialogo.mostrarError({
        icono: 'fa-info',
        plantilla: 'app/app/main/inscripcion-cursado/dialogo-confirmacion-visualizacion-comisiones.html',
        titulo: 'Detalle Inscripción',
        parrafos: ["Comisión: "+materia.comisionActual, "Edificio: "+materia.edificio, "Horario: "+horarioTexto, "Checksum: "+materia.checksum]
      }, $scope);
    }

    function errorComisiones(respuesta) {
      var errores = respuesta.data.message.split('No');
      errores.shift();
      for (var i = 0; i < errores.length; i++) {
        errores[i] = 'No' + errores[i];
      }
      Dialogo.mostrarError({
        plantilla: 'app/app/main/inscripcion-cursado/dialogo-error-inscripcion-cursado.html',
        parrafos: errores
      },$scope);
      Dialogo.ocultarCargando();
    }

    function getHorarios(materia) {
      if (!materia.horarioCursado) return [];
      var horarios = [];
      materia.horarioCursado.split(/,\s?/).forEach(function (horario) {
        if (horario.indexOf('C') === 0) {
          horario = horario.substring(3);
        }
        horarios.push(horario);
      });
      return horarios;
    }

    function confirmarAnulacion(materia){
      var config = {};
      config.texto = '¿Está seguro que desea anular la inscripción a esta materia?';
      config.accionSi = anularInscripcion;
      materiaSeleccionada = materia;
      Dialogo.mostrarConfirmacion(config, $scope);
    }

    function anularInscripcion(){
      Dialogo.mostrarCargando();
      var config = {};
      var objetoAnulacion = armarObjetoAnulacion();
      InscripcionCursado.anular(objetoAnulacion, function(respuesta) {
        Dialogo.ocultarCargando();
        config.texto = 'Se ha anulado la inscripción con éxito. Ya no se encuentra inscripto a cursar esta materia.';
        config.accionSi = function(){
          Dialogo.mostrarCargando();
          $state.go($state.current, {}, {reload: true});
        };
        config.icon = 'fa-check';
        config.titulo = 'Desinscripción Exitosa';
        var scopeHijo = $scope.$new();
        Dialogo.mostrarExito(config, scopeHijo);
      }, errorAnulacion);

    }

    function errorAnulacion(respuesta){
      Dialogo.mostrarError({
        titulo: 'Error',
        texto: respuesta.data.message
      }, $scope);
      Dialogo.ocultarCargando();
    }

    function armarObjetoAnulacion() {
      return {
        especialidad: materiaSeleccionada.especialidadHomogenea,
        plan: materiaSeleccionada.planHomogenea,
        materia: materiaSeleccionada.materiaHomogenea,
        comision: materiaSeleccionada.comisionActual,
        detalleMateria: materiaSeleccionada
      };
    }
  }
})();
(function () {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider.state('main.horario-cursado-especialidad', {
      url: 'horario-cursado-especialidad',
      templateUrl: 'app/app/main/horario-cursado-especialidad/horario-cursado-especialidad.html',
      controller: 'EspecialidadHorarioCursadoCtrl as vm',
      resolve: {
          especialidades: function(EspecialidadHorarioCursado){
            return EspecialidadHorarioCursado.especialidades().$promise;
          }    
      }
    });
  }

})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').controller('EspecialidadHorarioCursadoCtrl', EspecialidadHorarioCursadoCtrl);

  function EspecialidadHorarioCursadoCtrl(Dialogo, ServicioColoresHorarioCursado, especialidades, EspecialidadHorarioCursado, uiCalendarConfig) {
    var vm = this;
    ServicioColoresHorarioCursado.resetear();
    vm.eventos = [];
    vm.modo = 'day';
    vm.cargarClases = cargarClases;
    vm.especialidades = especialidades;
    vm.eventsSources = [events];

    vm.model = {};

    function cargarClases() {
      Dialogo.mostrarCargando();
      EspecialidadHorarioCursado.horariosDictadoEspecialidadNivel({
        especialidad: vm.model.especialidad.especialid,
        nivel: vm.model.nivel
      }, (function (resp) {
        vm.eventos = crearEventos(resp);
        if (uiCalendarConfig.calendars && uiCalendarConfig.calendars.myCalendar) {
          uiCalendarConfig.calendars.myCalendar.fullCalendar('refetchEvents');
        }
        Dialogo.ocultarCargando();
      }));
    }

    function events(start, end, timezone, callback) {
      callback(vm.eventos);
    }

    function crearEventos(clases) {
      var eventos = [];
      ServicioColoresHorarioCursado.resetear();
      clases.forEach(function (clase) {
        var fechaI = clase.fechaInicio;
        var fechaF = clase.fechaFin;
        clase.color = ServicioColoresHorarioCursado.obtenerColor(clase);
        clase.className = 'text-center';
        eventos.push({
          title: clase.nombremateria + ' (' + clase.especialidad + ')',
          start: fechaI,
          end: fechaF,
          aula: 'Aula: ' + (clase.aulaNombre && clase.aulaNombre != null ? clase.aulaNombre : '-'),
          docente: clase.docente,
          especialidad: clase.especialidad,
          allDay: false,
          color: clase.color
        });
      });
      return eventos;
    }

    vm.eventRender = function (event, element) {
      if (event.aula && event.aula !== -1) element.find('.fc-title').append('<br>' + event.aula);
      if (event.docente) element.find('.fc-title').append('<br>' + event.docente);
    };

    vm.uiConfig = {
      calendar: {
        header: {
          left: 'prev',
          center: 'title',
          right: 'agendaWeek, next'
        },
        lang: 'es',
        // height: 500,
        defaultView: 'agendaWeek',
        hiddenDays: [0, 6],
        minTime: '08:00:00',
        maxTime: '23:00:00',
        monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
        dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mier', 'Jue', 'Vier', 'Sáb'],
        allDaySlot: false,
        eventRender: vm.eventRender,
        titleFormat: 'ddd D MMM',
        timezone: 'local',
        slotDuration: '00:15:00',
        slotLabelInterval: '01:00:00',
        axisFormat: 'H', //para q muestre formato de 24 hs
        timeFormat: 'H:mm',
        columnFormat: 'ddd D/M'
      }
    };


  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').controller('DocenteHorarioCursadoFiltrarCtrl', DocenteHorarioCursadoFiltrarCtrl);

  function DocenteHorarioCursadoFiltrarCtrl(Dialogo, ServicioColoresHorarioCursado, DocenteHorarioCursado, uiCalendarConfig) {
    var vm = this;
    ServicioColoresHorarioCursado.resetear();
    vm.eventos = [];
    vm.modo = 'day';
    vm.cargarClases = cargarClases;
    vm.eventsSources = [events];
    vm.flag = false;

    vm.model = {};
    vm.options = {};

    vm.fields = [
      {
        key: 'docente',
        type: 'typeahead',
        templateOptions: {
          label: 'Docente:',
          placeholder: 'Buscar por nombre, apellido o legajo',
          propiedad: 'apellido',
          propiedadFiltro: 'apellido',
          ngOptions: 'item as (item.docente.legajo+\', \'+item.nombre+\' \'+item.apellido) for item in to.funcion($viewValue) | limitTo:8',
          espera: 300,
          asincrono: true,
          required: false,
          buscar: vm.cargarClases,
          funcion: function ($viewValue) {
            return DocenteHorarioCursado.docentes({ filtro: $viewValue }).$promise;
          }
        },
        ngModelAttrs: {
          ngOptions: {
            attribute: 'uib-typeahead'
          }
        }
      }
    ];

    function cargarClases() {
      if (vm.model.docente.docente.legajo) {
        Dialogo.mostrarCargando();
        DocenteHorarioCursado.horariosDictadoLegajo({
          legajo: vm.model.docente.docente.legajo
        }, (function (resp) {
          vm.eventos = crearEventos(resp);
          if (uiCalendarConfig.calendars && uiCalendarConfig.calendars.myCalendar) {
            uiCalendarConfig.calendars.myCalendar.fullCalendar('refetchEvents');
          }
          Dialogo.ocultarCargando();
          vm.flag = true;
        }));
      }
    }

    function events(start, end, timezone, callback) {
      callback(vm.eventos);
    }

    function crearEventos(clases) {
      var eventos = [];
      ServicioColoresHorarioCursado.resetear();
      clases.forEach(function (clase) {
        var fechaI = clase.fechaInicio;
        var fechaF = clase.fechaFin;
        clase.color = ServicioColoresHorarioCursado.obtenerColor(clase);
        clase.className = 'text-center';
        eventos.push({
          title: clase.nombremateria + ' (' + clase.especialidad + ')',
          start: fechaI,
          end: fechaF,
          aula: 'Aula: ' + (clase.aulaNombre && clase.aulaNombre != null ? clase.aulaNombre : '-'),
          docente: clase.docente,
          especialidad: clase.especialidad,
          allDay: false,
          color: clase.color
        });
      });
      return eventos;
    }

    vm.eventRender = function (event, element) {
      if (event.aula && event.aula !== -1) element.find('.fc-title').append('<br>' + event.aula);
      if (event.docente) element.find('.fc-title').append('<br>' + event.docente);
    };

    vm.uiConfig = {
      calendar: {
        header: {
          left: 'prev',
          center: 'title',
          right: 'agendaWeek, next'
        },
        lang: 'es',
        // height: 500,
        defaultView: 'agendaWeek',
        hiddenDays: [0, 6],
        minTime: '08:00:00',
        maxTime: '23:00:00',
        monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
        dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mier', 'Jue', 'Vier', 'Sáb'],
        allDaySlot: false,
        eventRender: vm.eventRender,
        titleFormat: 'ddd D MMM',
        timezone: 'local',
        slotDuration: '00:15:00',
        slotLabelInterval: '01:00:00',
        axisFormat: 'H', //para q muestre formato de 24 hs
        timeFormat: 'H:mm',
        columnFormat: 'ddd D/M'
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider.state('main.horario-cursado-docente-filtrar', {
      url: 'horario-cursado-docente-filtrar',
      templateUrl: 'app/app/main/horario-cursado-docente-filtrar/horario-cursado-docente.html',
      controller: 'DocenteHorarioCursadoFiltrarCtrl as vm'
    });
  }

})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider.state('main.horario-cursado-docente', {
      url: 'horario-cursado-docente',
      templateUrl: 'app/app/main/horario-cursado-docente/horario-cursado-docente.html',
      controller: 'DocenteHorarioCursadoCtrl as vm',
      resolve: {
        clases: function (DocenteHorarioCursado) {
          return DocenteHorarioCursado.horariosDictado().$promise;
        }
      }
    });

  }

})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').controller('DocenteHorarioCursadoCtrl', DocenteHorarioCursadoCtrl);

  function DocenteHorarioCursadoCtrl(ServicioColoresHorarioCursado, clases) {
    var vm = this;
    ServicioColoresHorarioCursado.resetear();
    var eventos = crearEventos(clases);
    vm.modo = 'day';
    vm.a = false;

    function crearEventos(clases) {
      var eventos = [];

      clases.forEach(function (clase) {
        var fechaI = clase.fechaInicio;
        var fechaF = clase.fechaFin;
        clase.color = ServicioColoresHorarioCursado.obtenerColor(clase);
        clase.className = 'text-center';
        eventos.push({
          title: clase.nombremateria + ' (' + clase.especialidad + ')',
          start: fechaI,
          end: fechaF,
          aula: 'Aula: ' + (clase.aulaNombre && clase.aulaNombre != null ? clase.aulaNombre : '-'),
          docente: clase.docente,
          especialidad: clase.especialidad,
          allDay: false,
          color: clase.color
        });
      });
      return eventos;
    }

    vm.uiConfig = {
      calendar: {
        header: {
          left: 'prev',
          center: 'title',
          right: 'agendaWeek, next'
        },
        // height: 500,
        defaultView: 'agendaWeek',
        hiddenDays: [0, 6],
        minTime: '08:00:00',
        maxTime: '23:00:00',
        monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
        dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mier', 'Jue', 'Vier', 'Sáb'],
        allDaySlot: false,
        eventRender: function (event, element) {
          if (event.aula) element.find('.fc-title').append('<br>' + event.aula);
          if (event.docente) element.find('.fc-title').append('<br>' + event.docente);
        },
        eventSources: [eventos],
        titleFormat: 'ddd D MMM',
        timezone: 'local',
        slotDuration: '00:15:00',
        slotLabelInterval: '01:00:00',
        axisFormat: 'H', //para q muestre formato de 24 hs
        timeFormat: 'H:mm',
        columnFormat: 'ddd D/M'
      }
    };

  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider.state('main.horario-cursado-aula', {
      url: 'horario-cursado-aula',
      templateUrl: 'app/app/main/horario-cursado-aula/horario-cursado-aula.html',
      controller: 'AulaHorarioCursadoCtrl as vm',
      resolve: {
        edificios: function (AulaHorarioCursado) {
          return AulaHorarioCursado.edificios().$promise;
        }
      }
    });
  }

})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').controller('AulaHorarioCursadoCtrl', AulaHorarioCursadoCtrl);

  function AulaHorarioCursadoCtrl(Dialogo, ServicioColoresHorarioCursado, edificios, AulaHorarioCursado, uiCalendarConfig) {
    var vm = this;
    ServicioColoresHorarioCursado.resetear();
    vm.eventos = [];
    vm.modo = 'day';
    vm.cargarClases = cargarClases;
    vm.edificios = edificios;
    vm.eventsSources = [events];

    vm.model = {};

    var controladorComboAula = function ($scope, AulaHorarioCursado) {
      $scope.$watch('model.edificio', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          // logic to reload this select's options asynchronusly based on state's value (newValue)
          if ($scope.model[$scope.options.key] && oldValue && newValue.edificio) {
            // reset this select
            $scope.model[$scope.options.key] = '';
          }
          // Reload options
          $scope.to.loading = AulaHorarioCursado.aulas({
            id: newValue.edificio
          }, (function (res) {
            $scope.to.options = res;
          }));
        }
      });
    };

    controladorComboAula.$inject = ['$scope', 'AulaHorarioCursado'];

    vm.formFields = [{
      key: 'edificio',
      type: 'select',
      className: 'col-md-5',
      templateOptions: {
        label: 'Edificio',
        options: vm.edificios,
        valueProp: 'id',
        labelProp: 'nombre'
      }
    },
    {
      key: 'aula',
      type: 'select',
      className: 'col-md-5',
      templateOptions: {
        label: 'Aulas',
        options: [],
        ngOptions: 'aula.id as aula.id.aula for aula in to.options'
      },
      controller: controladorComboAula
    }
    ];

    function cargarClases() {
      Dialogo.mostrarCargando();
      AulaHorarioCursado.horariosDictado({
        edificio: vm.model.edificio.edificio,
        aula: vm.model.aula.aula
      }, (function (resp) {
        vm.eventos = crearEventos(resp);
        if (uiCalendarConfig.calendars && uiCalendarConfig.calendars.myCalendar) {
          uiCalendarConfig.calendars.myCalendar.fullCalendar('refetchEvents');
        }
        Dialogo.ocultarCargando();
      }));
    }

    function events(start, end, timezone, callback) {
      callback(vm.eventos);
    }

    function crearEventos(clases) {
      var eventos = [];
      ServicioColoresHorarioCursado.resetear();
      clases.forEach(function (clase) {
        var fechaI = clase.fechaInicio;
        var fechaF = clase.fechaFin;
        clase.color = ServicioColoresHorarioCursado.obtenerColor(clase);
        clase.className = 'text-center';
        eventos.push({
          title: clase.nombremateria + ' (' + clase.especialidad + ')',
          start: fechaI,
          end: fechaF,
          docente: clase.docente,
          especialidad: clase.especialidad,
          allDay: false,
          color: clase.color
        });
      });
      return eventos;
    }

    vm.eventRender = function (event, element) {
      if (event.aula && event.aula !== -1) element.find('.fc-title').append('<br>' + event.aula);
      if (event.docente) element.find('.fc-title').append('<br>' + event.docente);
    };

    vm.uiConfig = {
      calendar: {
        header: {
          left: 'prev',
          center: 'title',
          right: 'agendaWeek, next'
        },
        lang: 'es',
        // height: 500,
        defaultView: 'agendaWeek',
        hiddenDays: [0, 6],
        minTime: '08:00:00',
        maxTime: '23:00:00',
        monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
        dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mier', 'Jue', 'Vier', 'Sáb'],
        allDaySlot: false,
        eventRender: vm.eventRender,
        titleFormat: 'ddd D MMM',
        timezone: 'local',
        slotDuration: '00:15:00',
        slotLabelInterval: '01:00:00',
        axisFormat: 'H', //para q muestre formato de 24 hs
        timeFormat: 'H:mm',
        columnFormat: 'ddd D/M'
      }
    };

  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider.state('main.horario-cursado', {
      url: 'horario-cursado',
      templateUrl: 'app/app/main/horario-cursado/horario-cursado.html',
      controller: 'HorarioCursadoCtrl as vm',
      resolve: {
        clases: function (HorarioCursado) {
          return HorarioCursado.query().$promise;
        }
      }
    });

  }

})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').controller('HorarioCursadoCtrl', HorarioCursadoCtrl);

  function HorarioCursadoCtrl(ServicioColoresHorarioCursado, clases) {
    var vm = this;
    ServicioColoresHorarioCursado.resetear();
    var eventos = crearEventos(clases);
    vm.modo = 'day';
    vm.a = false;

    function crearEventos(clases) {
      var eventos = [];

      clases.forEach(function (clase) {
        var fechaI = clase.fechaInicio;
        var fechaF = clase.fechaFin;
        clase.color = ServicioColoresHorarioCursado.obtenerColor(clase);
        clase.className = 'text-center';
        eventos.push({
          title: clase.nombremateria + ' (' + clase.especialidad + ')',
          start: fechaI,
          end: fechaF,
          aula: 'Aula: ' + (clase.aulaNombre && clase.aulaNombre != null ? clase.aulaNombre : '-'),
          docente: clase.docente,
          allDay: false,
          color: clase.color
        });
      });
      return eventos;
    }

    vm.uiConfig = {
      calendar: {
        header: {
          left: 'prev',
          center: 'title',
          right: 'agendaWeek, next'
        },
        height: 500,
        defaultView: 'agendaWeek',
        hiddenDays: [0, 6],
        minTime: '08:00:00',
        maxTime: '24:00:00',
        monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
        dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mier', 'Jue', 'Vier', 'Sáb'],
        allDaySlot: false,
        eventRender: function (event, element) {
          if (event.aula) element.find('.fc-title').append('<br>' + event.aula);
          if (event.docente) element.find('.fc-title').append('<br>' + event.docente);
        },
        eventSources: [eventos],
        titleFormat: 'ddd D MMM',
        timezone: 'local',
        slotDuration: '00:15:00',
        slotLabelInterval: '01:00:00',
        axisFormat: 'H', //para q muestre formato de 24 hs
        timeFormat: 'H:mm',
        columnFormat: 'ddd D/M'
      }
    };

  }
})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').service('ServicioColoresHorarioCursado', ServicioColoresHorarioCursado);

  function ServicioColoresHorarioCursado() {
    var vm = this;
    var colores = ['DarkRed', 'Green', 'DarkSlateBlue', 'Grey', 'LightSeaGreen', 'Gold', 'BlueViolet', 'Brown', 'Chartreuse'];
    var asignados = [];

    vm.obtenerColor = obtenerColor;
    vm.resetear = resetear;

    function obtenerColor(materia) {
      var materiaYaAsignada = false;
      var colorAsignado = '';
      asignados.forEach(function(asignado) {
        if (asignado.id === materia.id) {
          materiaYaAsignada = true;
          colorAsignado = colores[asignado.color];
        }
      });

      if (!materiaYaAsignada) {
        asignados.push({
          id: materia.id,
          color: asignados.length
        });
        return colores[asignados[asignados.length - 1].color];
      } else {
        return colorAsignado;
      }
    }

    function resetear() {
      asignados = [];
    }



  }

})();

/* global angular */
(function () {
  angular.module('administracionNotificaciones').run(run);
  function run($uibModal, DataState, Haberes, Dialogo) {
    DataState.generateModelStates('Haberes', [{
      defaultConfig: 'app/app/main/haberes/list.state.json',
      actions: {
        imprimir: function (periodoLiquidacion) {
          Dialogo.mostrarCargando();
          Haberes.descargarArchivo(periodoLiquidacion.id).then(function () {
            Dialogo.ocultarCargando();
          }, function (error) {
            Dialogo.mostrarError({
              titulo: 'Error',
              texto: error.data.message
            });
            Dialogo.ocultarCargando();
          });
        }
      }
    },
    {
      defaultConfig: 'app/app/main/haberes/list-cargos.state.json',
      actions: {
        ver: function (cargo) {
          var dialogo = $uibModal.open({
            templateUrl: 'app/app/main/cargos-docentes/detalle-cargo-docente.html',
            keyboard: false,
            backdrop: 'static',
            controllerAs: 'vm',
            controller: function (cargo) {
              var vm = this;
              vm.cargoSeleccionado = cargo;
              vm.cerrar = function () {
                dialogo.close();
              };
            },
            resolve: {
              cargo: function () {
                return cargo;
              }
            }
          });
        }
      }

    }
    ]);
  }
})();


(function () {
  angular.module('administracionNotificaciones').run(run);
  function run(DataState) {
    DataState.generateModelStates('GrupoPermiso', [
      {
        defaultConfig: 'app/app/main/grupo-permiso/list.state.json'
      },
      {
        defaultConfig: 'app/app/main/grupo-permiso/edit.state.json'
      }
    ]);
  }
})();
  
(function () {
  angular.module('administracionNotificaciones').run(run);
  function run($timeout, $state, Grupo, DataState) {
    DataState.generateModelStates('Grupo', [
      {
        defaultConfig: 'app/app/main/grupo/list.state.json',
        actions: {
          nuevoHijo: function(padre) {
            $state.go('^.edit', {id: 'nuevo', idPadre: padre.id});
          },
          verMiembros: function(grupo) {
            $state.go('^.miembros', {id: grupo.id});
          }
        }
      },
      {
        defaultConfig: 'app/app/main/grupo/edit.state.json'
      },
      {
        defaultConfig: 'app/app/main/grupo/miembros.state.json',
        extraResolves: [
          {
            name: 'grupo',
            resolve: function (params) {
              return Grupo.get({id: params.id}).$promise;
            }
          }
        ]
      }
    ]);
  }
})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider
    .state('main.pre-inscripciones-examen-home', {
      url: 'examen-docente/home',
      templateUrl: 'app/app/main/examen-docente/pre-inscripciones-examen-home.html',
      controller: 'PreInscipcionExamenHomeCtrl as vm',
      resolve: {
        inscripciones: function(InscripcionExamenDocente) {
          return InscripcionExamenDocente.obtenerInscriptos().$promise;
        }
      }
    });

    

  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').controller('PreInscipcionExamenHomeCtrl', PreInscipcionExamenHomeCtrl);

  function PreInscipcionExamenHomeCtrl($uibModal, Dialogo, $q, $timeout, inscripciones, AlumnoHistorial) {
    var vm = this;
    vm.inscripciones = inscripciones;

    vm.mostrarInscriptos = mostrarInscriptos;
    // vm.mostrarDatosInscripto = mostrarDatosInscripto;
    vm.abrirModalDesempenio = abrirModalDesempenio;

    vm.selectedInscripcion = null;
    vm.inscripto = null;
    vm.historialMateria = null;
    vm.historialExamen = null;

    function mostrarInscriptos(inscripcion) {
      limpiarHistorial();
      vm.selectedInscripcion = inscripcion;
    }

    function abrirModalDesempenio(inscripto) {
      if (!(inscripto.legajo && vm.selectedInscripcion.materiaDocente)) {
        Dialogo.mostrarError({
          titulo: 'Error',
          texto: 'No se puede mostrar el desempeño del alumno'
        });
        return;
      }

      var dialogo = $uibModal.open({
        templateUrl: 'app/app/main/alumno/desempenio-alumno-modal.html',
        size: 'lg',
        keyboard: false,
        controllerAs: '$ctrl',
        controller: function (info) {
          var vm = this;
          vm.inscripto = inscripto;
          vm.titulo = inscripto.legajo + ' - ' + inscripto.nombre;
          vm.titulo2 = info.nombreMateria;
          vm.historialMateria = info.cursados;
          vm.historialExamen = info.examenes;
          vm.textoNo = 'Cerrar',
          vm.accionNo = function () {
            dialogo.dismiss();
          };
          vm.tipoNo= 'btn-danger';
        },
        resolve: {
          info: function() {
            return AlumnoHistorial.historialesAlumno({
              legajo: inscripto.legajo,
              materiaId: vm.selectedInscripcion.materiaDocente.materia,
              materiaS: vm.selectedInscripcion.materiaDocente.nombreMateria,
              carrera: ""
            }).$promise;
          }
        }
      });

      // vm.mostrarDatosInscripto(inscripto);
      // $timeout(function() {
      //   $('#modalDesempenio').modal('show');
      // }, 100);
    }

    // function mostrarDatosInscripto(inscripto) {
      

    //   vm.inscripto = inscripto;
    //   limpiarHistorial();

    //   var materiaId = vm.selectedInscripcion.materiaDocente.materia;

      
    //   return AlumnoHistorial.historialesAlumno({
    //     legajo: inscripto.legajo,
    //     materiaId: vm.selectedInscripcion.materiaDocente.materia,
    //     materiaS: vm.selectedInscripcion.materiaDocente.nombreMateria
    //   }).$promise
    //   .then(function(registro) {
    //     if (registro) {
    //       vm.historialMateria = registro.cursados;
    //       vm.historialExamen = registro.examenes;
    //     }
    //   })
    //   .catch(function(err) {
    //     console.error("Error al obtener el registro académico de la materia", materia.materiaId, err);
    //   });
      
    // }

    function limpiarHistorial() {
      vm.historialMateria = null;
      vm.historialExamen = null;
    }
  }

})();

/* global angular */
(function () {
  angular.module('administracionNotificaciones').run(run);
  function run(DataState, $state) {
    // DataState.generateModelStates('ExamenDocente', [
    //   {
    //     defaultConfig: 'app/app/main/examen-docente/list.state.json',
    //     actions: {
    //       listarAlumnosInscriptos: function(examen) {
    //         $state.go('^.alumnosInscriptos',examen);
    //       }
    //     }
    //   },
    //   {
    //     defaultConfig: 'app/app/main/examen-docente/listado-alumnos.state.json'
    //   }
    // ]);
  }
})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').filter('gruposExamen', gruposExamen);

  function gruposExamen(orderByFilter) {

    return function(array) {
      var objeto = {};
      array.forEach(function(examen) {
        var anio = moment(examen.fecha).get('year');
        if (!objeto[anio]) {
          objeto[anio] = {
            anio: anio,
            examenes: []
          };
        }
        objeto[anio].examenes.push(examen);
      });
      return orderByFilter(_.values(objeto),'anio');
    };

  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider.state('main.examen',{
      url: 'examenes',
      templateUrl: 'app/app/main/examen/examen.html',
      controller: 'ExamenCtrl as vm',
      resolve: {
        examen: function(Examen) {
          return Examen.get().$promise;
        }
      }
    });
  }
})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').controller('ExamenCtrl', ExamenCtrl);

  function ExamenCtrl(examen) {
    var vm = this;

    var fechaLimite = moment('2017-04-01');

    vm.examen = examen;
    vm.getEstado = getEstado;
    vm.getNombreNota = getNombreNota;

    function getEstado(detalle) {
      if (detalle.estadoExamen === 'AUSENTE') {
        return 'label-default'; //color gris
      } else if (detalle.estadoExamen === 'UNO' || detalle.estadoExamen === 'DOS' || detalle.estadoExamen === 'TRES') {
        return 'label-danger'; //color rojo
      } else if ((moment(detalle.fecha).isAfter(fechaLimite)) && (detalle.estadoExamen === 'CUATRO' || detalle.estadoExamen === 'CINCO')) {
        return 'label-danger'; //color rojo
      } else if (!detalle.estadoExamen) {
        return 'label-primary'; //color azul
      } else{
        return 'label-success'; //color verde
      }
    }

    function getNombreNota(detalle){
      if (detalle.estadoExamen === 'AUSENTE') {
        return 'Ausente';
      } else if (detalle.estadoExamen === 'APROBADO') {
        return 'Aprobado';
      }else if (detalle.estadoExamen === 'DIEZ') {
        return '10 (diez)';
      } else if (detalle.estadoExamen === 'NUEVE') {
        return '9 (nueve)';
      } else if (detalle.estadoExamen === 'OCHO') {
        return '8 (ocho)';
      } else if (detalle.estadoExamen === 'SIETE') {
        return '7 (siete)';
      } else if (detalle.estadoExamen === 'SEIS') {
        return '6 (seis)';
      } else if (detalle.estadoExamen === 'CINCO') {
        return '5 (cinco)';
      } else if (detalle.estadoExamen === 'CUATRO') {
        return '4 (cuatro)';
      } else if (detalle.estadoExamen === 'TRES') {
        return '3 (tres)';
      } else if (detalle.estadoExamen === 'DOS') {
        return '2 (dos)';
      } else if (detalle.estadoExamen === 'UNO') {
        return '1 (uno)';
      } else if (detalle.nota === 'Insc.') {
        return 'Usted aun no ha rendido esta materia.';
      }
    }
  }
})();

(function () {

  angular.module('administracionNotificaciones').run(run);

  function run(Menu) {
    Menu.addMenuItems({
      pluralName: 'Eventos Reloj',
      icon: 'ion ion-university',
      order: 9
    },
      [
        {
          menuName: 'Consultar',
          icon: 'ion ion-search',
          permissions: ['administrarNotificaciones'],
          state: 'main.eventoreloj.list'
        },
        {
          menuName: 'Materias Electivas',
          icon: 'ion ion-checkmark-round',
          permissions: ['administrarNotificaciones'],
          state: 'main.materias-electivas'
        }
      ]);

  }
})();

/* global angular */
(function () {
  angular.module('administracionNotificaciones').run(run);

  function run($state, DataState) {
    DataState.generateModelStates('EventoReloj', [{
      defaultConfig: 'app/app/main/evento-reloj/list.state.json'
    }]);
  }
})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').filter('gruposEstadoAcademico', gruposEstadoAcademico);

  function gruposEstadoAcademico() {

    return function(array) {
      var nuevoArray = [];
      array.forEach(function(materia) {
        var nivel = parseInt(materia.nivel);
        if (!nuevoArray[nivel-1]) {
          nuevoArray[nivel-1] = {
            nombre: nivel,
            materias: []
          };
        }
        nuevoArray[nivel-1].materias.push(materia);
      });
      return nuevoArray;
    };

  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider.state('main.estado-academico',{
      url: 'estado-academico',
      templateUrl: 'app/app/main/estado-academico/estado-academico.html',
      controller: 'EstadoAcademicoCtrl as vm',
      resolve: {
        estadoAcademico: function(EstadoAcademico) {
          return EstadoAcademico.get().$promise;
        }
      }
    });

  }

})();


(function() {
  'use strict';

  angular.module('administracionNotificaciones').controller('EstadoAcademicoCtrl', EstadoAcademicoCtrl);

  function EstadoAcademicoCtrl(estadoAcademico) {
    var vm = this;

    vm.estadoAcademico = estadoAcademico;
    vm.getNombreEstado = getNombreEstado;
    vm.getFaltaParaCursar = getFaltaParaCursar;
    vm.getFaltaParaAprobar = getFaltaParaAprobar;
    vm.getEstado = getEstado;
    vm.toggleDetalle = toggleDetalle;

    function getNombreEstado(detalle) {
      if (detalle.estadoMateria === 'APROBADA') {
        return 'Aprobada';
      } else if (detalle.estadoMateria === 'REGULARIZADA') {
        return 'Regularizada';
      } else if (detalle.estadoMateria === 'CURSANDO') {
        return 'Cursando';
      } else if (detalle.estadoMateria === 'NO_CURSADA') {
        return 'No Cursada';
      }
    }

    function getEstado(detalle) {
      if (detalle.estadoMateria === 'APROBADA') {
        return 'label-success';
      } else if (detalle.estadoMateria === 'REGULARIZADA') {
        return 'label-primary';
      } else if (detalle.estadoMateria === 'CURSANDO') {
        return 'label-warning';
      } else if (detalle.estadoMateria === 'NO_CURSADA') {
        return 'label-default';
      }
    }

    function getFaltaParaCursar(detalle) {
      if(detalle.faltaReg!==null){
        return detalle.faltaReg.split('\n');
      }      
    }

    function getFaltaParaAprobar(detalle) {
      if(detalle.faltaAprobar!==null){
        return detalle.faltaAprobar.split('\n');
      }
    }

    function toggleDetalle(detalle) {
      detalle.abierto = !detalle.abierto;
    }
  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider
    .state('main.encuestas-docentes-home',{
      url: 'encuestas-docentes/home',
      templateUrl: 'app/app/main/encuestas-docentes/encuestas-docentes-home.html',
      controller: 'EncuestasDocentesHomeCtrl as vm',
      resolve: {
        informes: function(EncuestasDocentes) {
          return EncuestasDocentes.obtenerInformesDisponibles('docentes');
        }
      }})
      .state('main.encuestas-docentes-autoridades-home',{
      url: 'encuestas-docentes-autoridades/home',
      templateUrl: 'app/app/main/encuestas-docentes/encuestas-docentes-home.html',
      controller: 'EncuestasDocentesHomeCtrl as vm',
      resolve: {
        informes: function(EncuestasDocentes) {
          return EncuestasDocentes.obtenerInformesDisponibles('autoridades');
        }
      }})
      .state('main.encuestas-docentes-basicas-home',{
      url: 'encuestas-docentes-basicas/home',
      templateUrl: 'app/app/main/encuestas-docentes/encuestas-docentes-home.html',
      controller: 'EncuestasDocentesHomeCtrl as vm',
      resolve: {
        informes: function(EncuestasDocentes) {
          return EncuestasDocentes.obtenerInformesDisponibles('basicas');
        }
      }})
      .state('main.encuestas-docentes-detail', {
      url: 'encuestas-docentes/details/:dashboard',
      templateUrl: 'app/app/main/encuestas-docentes/encuestas-docentes-detail.html',
      controller: 'EncuestasDocentesDetailCtrl as vm',
      resolve: {
        link: function($stateParams, EncuestasDocentes) {
          console.log($stateParams);
          if ($stateParams.dashboard == 53) {
            return EncuestasDocentes.obtenerLinkAutoridades().$promise;
          }
          if ($stateParams.dashboard == 54) {
            return EncuestasDocentes.obtenerLinkBasicas().$promise;
          }
          return EncuestasDocentes.obtenerLink({id : $stateParams.dashboard}).$promise;
        }
      }
    });
  }

})();


(function() {
  'use strict';

  angular.module('administracionNotificaciones').controller('EncuestasDocentesHomeCtrl', EncuestasDocentesHomeCtrl);

  function EncuestasDocentesHomeCtrl($sce, $state, informes) {
    var vm = this;    
    vm.informes = informes;

    vm.verInformes = verInformes;

    function verInformes(informe) {

      $state.go('main.encuestas-docentes-detail', {dashboard: informe.id});

    }
  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').controller('EncuestasDocentesDetailCtrl', EncuestasDocentesDetailCtrl);

  function EncuestasDocentesDetailCtrl($sce, link) {
    var vm = this;    
    vm.link1 = $sce.trustAsResourceUrl(link.mensaje);
    
    var pageContentWidth = document.getElementById('sidebar-wrapper').offsetHeight;
    var altoMetabase = pageContentWidth * 0.87;

    vm.innerComponentStyle = {
      height: altoMetabase + 'px',
      border: 'none'
  
    };
   
  }

})();

/* global angular */
(function () {
  angular.module('administracionNotificaciones').run(run);

  function run($uibModal, DataState, Dialogo, $state) {

    DataState.generateModelStates('Encuestas2025', [
      // Estado para Preguntas
      {
        defaultConfig: 'app/app/main/encuestas/pregunta/list.state.json',
        actions: {
          newElement: function() {
            $state.go('^.edit-pregunta');
          }
        }
      },
      {
        defaultConfig: 'app/app/main/encuestas/pregunta/edit.state.json',
        name: 'edit-pregunta'
      },
      // Estado para Tipos de Pregunta
      {
        defaultConfig: 'app/app/main/encuestas/tipo-pregunta/list.state.json',
        actions: {
          newElement: function() {
            $state.go('^.edit-tipo');
          }
        }
      },
      {
        defaultConfig: 'app/app/main/encuestas/tipo-pregunta/edit.state.json',
        name: 'edit-tipo'
      },
      // Estado para Opciones
      {
        defaultConfig: 'app/app/main/encuestas/opcion/list.state.json',
        actions: {
          newElement: function() {
            $state.go('^.edit-opcion');
          }
        }
      },
      {
        defaultConfig: 'app/app/main/encuestas/opcion/edit.state.json',
        name: 'edit-opcion'
      },//Encuestas Realizadas View
      {
        defaultConfig: 'app/app/main/encuestas/realizadas/list.state.json',
        
      },
      
      //Encuestas Pendientes
      {
        defaultConfig: 'app/app/main/encuestas/pendiente/list.state.json',
        
      },
      // Estado para Respuestas Posibles
      {
        defaultConfig: 'app/app/main/encuestas/respuesta-posible/list.state.json',
        actions: {
          newElement: function() {
            $state.go('^.edit-respuesta');
          }
        }
      },
      {
        defaultConfig: 'app/app/main/encuestas/respuesta-posible/edit.state.json',
        name: 'edit-respuesta'
      },
      // Estado para Graficos Encuesta
      {
        defaultConfig: 'app/app/main/encuestas/analitica/home.state.json',
        name: 'analitica-encuestas-home'
      },
    ]);
  }
})(); 
(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider.state('main.encuestas',{
      url: 'encuestas',
      templateUrl: 'app/app/main/encuestas/encuestas.html',
      controller: 'EncuestasCtrl as vm',
      resolve: {
        encuestas: function(Encuesta) {
          return Encuesta.listarDisponibles().$promise;
        }
      }
    });
  }
})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').controller('EncuestasCtrl', EncuestasCtrl);

  function EncuestasCtrl($scope, $state, Dialogo, encuestas) {
    var vm = this;
    vm.realizarEncuesta = realizarEncuesta;
    vm.encuestas = encuestas;
    vm.getNombreEstado = getNombreEstado;
    vm.getColorEstado = getColorEstado;

    function getNombreEstado(encuesta) {
      if (encuesta.encuestaRealizada) {
        return 'Realizada';
      } else{
        return 'No Realizada';
      }
    }

    function getColorEstado(encuesta) {
      if (encuesta.encuestaRealizada) {
        return 'label-success';
      } else{
        return 'label-primary';
      }
    }

    function realizarEncuesta(encuesta) {
      if (encuesta.encuestaRealizada) {
        Dialogo.mostrarError({
          texto: 'Ya ha realizado esta encuesta'
        }, $scope);
      } else {
        encuesta.persona = {id:encuesta.persona.id, nombre:encuesta.persona.nombre, apellido:encuesta.persona.apellido};
        $state.go('main.realizarEncuesta', {encuesta: JSON.stringify(angular.copy(encuesta))});
      }

    }

  }
})();

/* eslint-disable no-debugger */
/* global angular */
(function () {
  angular.module('administracionNotificaciones').run(run);
  function run($state, $q, DataState, Dialogo, DocumentacionDocentes, CargaLibroDeTemas, TipoDocumentacion) {
    
    DataState.generateModelStates('DocumentacionDocentes', [
      {
        defaultConfig: 'app/app/main/documentacion-docentes/edit.state.json',
        controller: 'DocumentacionDocenteEditCtrl as vm',
        extraResolves: [{
          name: 'materiaSeleccionada',
          resolve: function (params) {
            return CargaLibroDeTemas.getMateria({
              anoacademi: params.anoacademi,
              plan: params.plan,
              materia: params.materia,
              comision: params.comision,
              especialid: params.especialid
            }).$promise;
          }
        },
        {
          name: 'tiposDocumentacion',
          resolve: function () {
            return TipoDocumentacion.query({
            }).$promise;
          }
        }
        ], postResolve: function (config) {
          config.data.anoacademi = config.stateParams.anoacademi;
          config.data.plan = config.stateParams.plan;
          config.data.materia = config.stateParams.materia;
          config.data.comision = config.stateParams.comision;
          config.data.especialid = config.stateParams.especialid;
          config.fields[0].templateOptions.options = config.extraData.tiposDocumentacion;
          return config;
        },
        datasource: {
          preprocess: function (modelo) {
            if (modelo.fechaInicioCarga) {
              modelo.fechaInicioCarga = moment(modelo.fechaInicioCarga).toDate();
            }
            if (modelo.fechaFinCarga) {
              modelo.fechaFinCarga = moment(modelo.fechaFinCarga).toDate();
            }
            return modelo;
          },
          postprocess: function (modelo) {

            var archivo = {};
            archivo = angular.copy(modelo.archivo);
            archivo.archivo = angular.copy(modelo.archivo.contenido);
            archivo.nombreArchivo = angular.copy(modelo.archivo.nombre);
            archivo.archivo = archivo.archivo.split(',')[1];
            delete modelo.archivo;

            var dto = {
              archivo: archivo,
              documentacion: modelo
            };
            return dto;
          }
        }

      },
      {
        defaultConfig: 'app/app/main/documentacion-docentes/list.state.json',
        postResolve: function (config) {
          return config;
        },
        extraResolves: [{
          name: 'materiaSeleccionada',
          resolve: function (params) {
            return CargaLibroDeTemas.getMateria({
              anoacademi: params.anioAcademico,
              plan: params.plan,
              materia: params.materia,
              comision: params.comision,
              especialid: params.especialidad
            }).$promise;
          }
        }
        ],
        actions: {
          nuevaDocumentacion: function (especialid, plan, materia, anoacademi, comision) {
            var dto = {
              anoacademi: anoacademi,
              plan: plan,
              materia: materia,
              comision: comision,
              especialid: especialid
            };
            dto.id = 'nuevo';
            $state.go('^.edit', dto);
          },
          imprimir: function (documentacion) {
            Dialogo.mostrarCargando();
            DocumentacionDocentes.descargarArchivo(documentacion.id).then(function () {
              Dialogo.mostrarExito({
                titulo: 'Éxito',
                texto: 'Se ha descargado el archivo.',
                accionSi: function (dialogo) {
                  dialogo.close();
                }
              });
              Dialogo.ocultarCargando();
            }, function (error) {
              Dialogo.mostrarError({
                titulo: 'Error',
                texto: error.data.message
              });
              Dialogo.ocultarCargando();
            });
          },
          eliminar: function (documentacion) {
            Dialogo.mostrarConfirmacion({
              texto: '¿Está seguro que desea eliminar el archivo?',
              titulo: 'Eliminar archivo',
              icon: 'fa-check',
              accionSi: function (dialogo) {
                Dialogo.mostrarCargando();
                dialogo.close();
                DocumentacionDocentes.remove({ id: documentacion.id }).$promise.then(function () {
                  Dialogo.ocultarCargando();
                  $state.reload();
                }, function (error) {
                  Dialogo.mostrarError({
                    titulo: 'Error',
                    texto: error.data.message
                  });
                  Dialogo.ocultarCargando();
                });
              }
            });

          }
        }

      },
      {
        defaultConfig: 'app/app/main/documentacion-docentes/documentacion-especialidad.state.json',
        postResolve: function (config) {
          //Años academicos
          config.filter[0].templateOptions.options = config.extraData.aniosDisponibles.map(function (e) {
            return {
              value: e,
              name: e
            };
          });
          if (config.filter[0].templateOptions.options.length > 0) {
            if (!config.filterValues) {
              config.filterValues = {};
            }
            config.filterValues.anio = 2024;
          }
          
          //quiero recorrer todos los config.cols
          for (var i = 0; i < config.cols.length; i++) {
            //Filtro de Estados
            if (config.cols[i].field == 'estado') {
              config.cols[i].filterData = config.extraData.estados.map(function (e) {
                return {
                  id: e.id,
                  title: e.nombreEstado
                };
              }); 
            }
            //Filtro de Tipos Documentacion
            if (config.cols[i].field == 'tipoDocumento.nombre') {
              config.cols[i].filterData = config.extraData.tiposDocumentacion.map(function (e) {
                return {
                  id: e.id,
                  title: e.nombre
                };
              }); 
            }
          }
          return config;
        },
        defaultFilter: {
          anio: '2018'
        },
        extraResolves: [{
          name: 'aniosDisponibles',
          resolve: function () {
            var currentYear = new Date().getFullYear();
            var yearsArray = [];
            for (var i = 2022; i <= currentYear + 1; i++) {
              yearsArray.push(i);
            }
            yearsArray.sort(function (a, b) {
              return b - a;
            });
            return $q.when(yearsArray);
          }
        },
        {
          name: 'tiposDocumentacion',
          resolve: function () {
            return TipoDocumentacion.query({
            }).$promise;
          }
        },
        {
          name: 'estados',
          resolve: function () {
            return TipoDocumentacion.getEstados().$promise;
          }
        }],
        actions: {
          imprimir: function (documentacion) {
            Dialogo.mostrarCargando();
            DocumentacionDocentes.descargarArchivo(documentacion.id).then(function () {
              Dialogo.mostrarExito({
                titulo: 'Éxito',
                texto: 'Se ha descargado el archivo.',
                accionSi: function (dialogo) {
                  dialogo.close();
                }
              });
              Dialogo.ocultarCargando();
            }, function (error) {
              Dialogo.mostrarError({
                titulo: 'Error',
                texto: error.data.message
              });
              Dialogo.ocultarCargando();
            });
          },
          cambiarEstado: function (documentacion, tipos, estado) {
            tipos = TipoDocumentacion.getEstados().$promise.then(function (rta) {
              tipos = rta.map(function (e) {
                return e;
              });
              estado = documentacion.estadoDocumentacion;

              Dialogo.mostrarConfirmacion({
                data: {
                  documentacion: documentacion,
                  tipos: tipos,
                  estado: estado
                },
                fields: [{
                  type: 'select',
                  key: 'estado',
                  templateOptions: {
                    label: 'Próximo estado:',
                    options: tipos,
                    ngOptions: 'options as options.nombreEstado for options in to.options track by options.id',
                    required: true
                  }
                }],
                titulo: 'Cambiar estado documentación',
                texto: 'Seleccione el estado de la documentación:',
                plantilla: 'app/app/main/documentacion-docentes/dialogo-cambiar-estado-documentacion.html',
                accionSi: function (dialogo, data) {
                  Dialogo.mostrarCargando();
                  dialogo.close();
                  data.estado.idDocumentacion = documentacion.id
                  DocumentacionDocentes.cambiarEstado(data.estado, function () {
                    Dialogo.mostrarExito({
                      titulo: 'Éxito',
                      texto: 'Se ha actualizado el estado correctamente.',
                      accionSi: function (dialogo) {
                        dialogo.close();
                        $state.reload();
                      }
                    });
                    Dialogo.ocultarCargando();
                  }, function (error) {
                    Dialogo.mostrarError({
                      titulo: 'Error',
                      texto: error.data.message
                    });
                    Dialogo.ocultarCargando();
                  });
                },
                textoSi: 'Aceptar',
                textoNo: 'Cancelar',
                accionNo: function (dialogo) {
                  dialogo.close();
                  Dialogo.ocultarCargando();
                  $state.reload();

                }
              });
            });
          },
          descargar: function (scope) {
            console.log(scope);
            console.log(scope.params.parameters().filter);
            var filtros = scope.filterValues;
            filtros = angular.merge({}, scope.params.parameters().filter, scope.filterValues);
            console.log(filtros);
            Dialogo.mostrarCargando();
            DocumentacionDocentes.descargarTodosArchivo(filtros).then(function () {
              Dialogo.mostrarExito({
                titulo: 'Éxito',
                texto: 'Se ha descargado el archivo.',
                accionSi: function (dialogo) {
                  dialogo.close();
                }
              });
              Dialogo.ocultarCargando();
            }, function (error) {
              Dialogo.mostrarError({
                titulo: 'Error',
                texto: error.data.message
              });
              Dialogo.ocultarCargando();
            });
          }
        },
        generalActions: [{
          'id': 'imprimirSolicitudesAcumuladas',
          'style': 'btn-primary',
          'icon': 'fa fa-download',
          'text': 'Descargar todos los archivos',
          'action': 'scope.actions.descargar(scope)'
        }]
      }
    ]);
  }
})();

/* global angular */
(function () {
  angular.module('administracionNotificaciones')
  .controller('DocumentacionDocenteEditCtrl', DocumentacionDocenteEditCtrl);

  function DocumentacionDocenteEditCtrl(form) {
    var vm = this;
    vm.form = form;
  }
})();

/* global angular */
(function () {
  angular.module('administracionNotificaciones').run(run);
  function run($state, DataState) {

    DataState.generateModelStates('ConfiguracionCierreComision', [
      {
        defaultConfig: 'app/app/main/configuracion-cierre-comision/edit.state.json',
        datasource : {
          preprocess: function(modelo) {
            if (modelo.fechaInicioCarga) {
              modelo.fechaInicioCarga = moment(modelo.fechaInicioCarga).toDate();
            }
            if (modelo.fechaFinCarga) {
              modelo.fechaFinCarga = moment(modelo.fechaFinCarga).toDate();
            } 
            return modelo;
          },
          postprocess: function(modelo) {
            modelo.fechaInicioCarga = moment(modelo.fechaInicioCarga).format('YYYY-MM-DD');
            modelo.fechaFinCarga = moment(modelo.fechaFinCarga).format('YYYY-MM-DD');
            return modelo;
          }
        }
      },
      {
        defaultConfig: 'app/app/main/configuracion-cierre-comision/list.state.json'
      }
    ]);
  }
})();

/* global angular */
(function () {
  angular.module('administracionNotificaciones').run(run);
  function run(DataState) {
    DataState.generateModelStates('Categoria', [
      'app/app/main/categoria/list.state.json',
      'app/app/main/categoria/edit.state.json'
    ]);
  }
})();

(function() {
  'use strict';
  
  angular.module('administracionNotificaciones').config(config);
  
  function config($stateProvider) {
  
    $stateProvider
      .state('main.cargos-docentes', {
        url: 'cargos-docentes',
        templateUrl: 'app/app/main/cargos-docentes/cargos-docentes.html',
        controller: 'CargosDocentesCtrl as vm',
        resolve: {
          cargos: function(CargoDocente) {
            return CargoDocente.obtenerCargos().$promise;
          }
        }
      });
  
      
  
  }
  
})();
  
(function() {
  'use strict';
  
  angular.module('administracionNotificaciones').controller('CargosDocentesCtrl', CargosDocentesCtrl);
  
  function CargosDocentesCtrl($uibModal, Dialogo, $q, $timeout, cargos) {
    var vm = this;
    vm.cargos = cargos;
  
    vm.cargoSeleccionado = {};

    vm.mostrarCargo = function (cargo) {
      vm.cargoSeleccionado = cargo;
      $('#modalCargo').modal('show'); 
    };
  
     
  
  }
  
})();
  
(function() {
    'use strict';
  
    angular.module('administracionNotificaciones').config(config);
  
    function config($stateProvider) {
  
      $stateProvider
      .state('main.detalle-calendario', {
        url: 'detalle-calendario',
        templateUrl: 'app/app/main/calendario/detalle-calendario.html',
        controller: 'DetalleCalendarioCtrl as vm',
        resolve: {
          detalles: function(DetalleCalendario) {
            return DetalleCalendario.obtenerCalendario().$promise;
          }
        }
      });
  
      
  
    }
  
  })();
  
(function() {
    'use strict';
  
    angular.module('administracionNotificaciones').controller('DetalleCalendarioCtrl', DetalleCalendarioCtrl);
  
    function DetalleCalendarioCtrl($uibModal, Dialogo, $q, $timeout, detalles) {
      var vm = this;
      vm.detalles = detalles;
  
    }
  
  })();
  
/* global angular */
(function () {
  angular.module('administracionNotificaciones').run(run);

  function run(DataState, CargaLibroDeTemas, LibroDeTemas, Dialogo, $state, $q) {
    DataState.generateModelStates('CargaLibroDeTemas', [{
      defaultConfig: 'app/app/main/carga-libro-de-temas/materias-especialidad.state.json',
      postResolve: function (config) {
        config.filter[0].templateOptions.options = config.extraData.aniosDisponibles.map(function (e) {
          return {
            value: e,
            name: e
          };
        });
        if (config.filter[0].templateOptions.options.length > 0) {
          if (!config.filterValues) {
            config.filterValues = {};
          }
          config.filterValues.anio = config.extraData.aniosDisponibles[0];
        }
        return config;
      },
      defaultFilter: {
        anio: '2018'
      },
      extraResolves: [{
        name: 'aniosDisponibles',
        resolve: function () {var currentYear = new Date().getFullYear();
          var yearsArray = [];
          for (var i = 2013; i <= currentYear; i++) {
            yearsArray.push(i);
          }
          yearsArray.sort(function (a, b) {
            return b - a;
          });
          return $q.when(yearsArray);
        }
      }],
      actions: {
        consultarClases: function (item) {
          $state.go('^.list', {
            anioAcademico: item.materia.id.anoacademi,
            plan: item.materia.id.plan,
            especialidad: item.materia.id.especialid,
            comision: item.materia.id.comision,
            materia: item.materia.id.materia,
            editable: 'false'
          });
        }
      }
    },
    {
      defaultConfig: 'app/app/main/carga-libro-de-temas/list.state.json',
      actions: {
        editarClase: function (item) {
          if (item.fechaDictado) {
            var id = angular.copy(item.fechaDictado.id);
          } else if (item.clase) {
            var id = angular.copy(item.clase);
          }
          id.fecha = moment(id.fecha).format('DD-MM-YYYY');
          $state.go('^.edit', id);
        },
        verClase: function (item) {
          if (item.fechaDictado) {
            var id = angular.copy(item.fechaDictado.id);
          } else if (item.clase) {
            var id = angular.copy(item.clase);
          }
          id.editable = 'false';
          id.fecha = moment(id.fecha).format('DD-MM-YYYY');
          $state.go('^.edit', id);
        },
        claseTranscurrida: function (item) {
          if ((item.fechaDictado && moment().isAfter(new moment(item.fechaDictado.id.fecha))) ||
              (item.clase && moment().isAfter(new moment(item.clase.fecha)))) {
            return true;
          }
          return false;
        },
        imprimir: function (especialid, plan, materia, anoacademi, comision) {
          Dialogo.mostrarCargando();
          LibroDeTemas.imprimirLibroDeTemas(especialid, plan, materia, anoacademi, comision).then(function () {
            Dialogo.mostrarExito({
              titulo: 'Éxito',
              texto: 'Se ha exportado correctamente la planilla.',
              accionSi: function (dialogo) {
                dialogo.close();
              }
            });
            Dialogo.ocultarCargando();
          }, function (error) {
            Dialogo.mostrarError({
              titulo: 'Error',
              texto: error.data.message
            });
            Dialogo.ocultarCargando();
          });
        }
      },
      extraResolves: [{
        name: 'materiaSeleccionada',
        resolve: function (params) {
          return CargaLibroDeTemas.getMateria({
            anoacademi: params.anioAcademico,
            plan: params.plan,
            materia: params.materia,
            comision: params.comision,
            especialid: params.especialidad
          }).$promise;
        }
      },
      {
        name: 'materiaSeleccionada',
        resolve: function (params) {
          return CargaLibroDeTemas.getMateria({
            anoacademi: params.anioAcademico,
            plan: params.plan,
            materia: params.materia,
            comision: params.comision,
            especialid: params.especialidad
          }).$promise;
        }
      }
      ],
      postResolve: function(config) {
        var tipos = {};
        var caracteres = {};
        var docentes = {};
        var serieTipos = [];
        var serieCaracteres = [];
        var serieDocentes = [];
        config.data.forEach(function(clase) {
          if (clase.clase) {
            var tipo = clase.clase.tipoClase.nombre;
            if (tipos[tipo] != undefined) {
              tipos[tipo]+=1;
            } else {
              tipos[tipo]=1;
            }
            var caracter = clase.clase.caracterClase.nombre;
            if (caracteres[caracter] != undefined) {
              caracteres[caracter]+=1;
            } else {
              caracteres[caracter]=1;
            }
            var docente = clase.clase.docente.nombre+' '+clase.clase.docente.apellido;
            if (docentes[docente] != undefined) {
              docentes[docente]+=1;
            } else {
              docentes[docente]=1;
            }
          }
        });
        for (var tipo in tipos) {
          if (!tipos.hasOwnProperty(tipo)) continue;
          serieTipos.push({name: tipo, y: tipos[tipo]});
        }
        for (var caracter in caracteres) {
          if (!caracteres.hasOwnProperty(caracter)) continue;
          serieCaracteres.push({name: caracter, y: caracteres[caracter]});
        }
        for (var docente in docentes) {
          if (!docentes.hasOwnProperty(docente)) continue;
          serieDocentes.push({name: docente, y: docentes[docente]});
        }
        config.extraData.charts = {
          tipos: {
            chartType: 'Chart',
            chart: {
              plotBackgroundColor: null,
              plotBorderWidth: null,
              plotShadow: false,
              type: 'pie',
              width: 200
            },
            title: {
              text: 'Tipos de clases'
            },
            credits: {
              enabled: false
            },
            tooltip: {
              pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                  enabled: true,
                  format: '<b>{point.name}</b>: {point.percentage:.1f} %',
                  style: {
                    color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                  }
                }
              }
            },
            series: [{
              name: 'Tipos',
              colorByPoint: true,
              data: serieTipos
            }]
          },
          caracteres: {
            chartType: 'Chart',
            chart: {
              plotBackgroundColor: null,
              plotBorderWidth: null,
              plotShadow: false,
              type: 'pie',
              width: 200
            },
            title: {
              text: 'Carácter de clase'
            },
            credits: {
              enabled: false
            },
            tooltip: {
              pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                  enabled: true,
                  format: '<b>{point.name}</b>: {point.percentage:.1f} %',
                  style: {
                    color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                  }
                }
              }
            },
            series: [{
              name: 'Carácteres',
              colorByPoint: true,
              data: serieCaracteres
            }]
          },
          docentes: {
            chartType: 'Chart',
            chart: {
              plotBackgroundColor: null,
              plotBorderWidth: null,
              plotShadow: false,
              type: 'pie',
              width: 200
            },
            title: {
              text: 'Carga por docente'
            },
            credits: {
              enabled: false
            },
            tooltip: {
              pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                  enabled: true,
                  format: '<b>{point.name}</b>: {point.percentage:.1f} %',
                  style: {
                    color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                  }
                }
              }
            },
            series: [{
              name: 'Docentes',
              colorByPoint: true,
              data: serieDocentes
            }]
          }
        };
        return config;
      }
    },
    {
      defaultConfig: 'app/app/main/carga-libro-de-temas/edit.state.json',
      datasource: {
        defaultData: {
          herramientas: [],
          actividades: [],
          fecha: new Date('2018-9-26')
        },
        preprocess: function (data, config) {
          if (data.clase) {
            data.clase.fechaMostrar = moment(data.clase.fecha).format('DD-MM-YYYY');
            return data.clase;
          }
          var claseFalsaParaFer = {};
          claseFalsaParaFer.facultad = data.fechaDictado.id.facultad;
          claseFalsaParaFer.anoacademi = data.fechaDictado.id.anoacademi;
          claseFalsaParaFer.plan = data.fechaDictado.id.plan;
          claseFalsaParaFer.especialid = data.fechaDictado.id.especialid;
          claseFalsaParaFer.materia = data.fechaDictado.id.materia;
          claseFalsaParaFer.comision = data.fechaDictado.id.comision;
          claseFalsaParaFer.fecha = data.fechaDictado.id.fecha;
          claseFalsaParaFer.fechaMostrar = moment(data.fechaDictado.id.fecha).format('DD-MM-YYYY');
          claseFalsaParaFer.hora = data.fechaDictado.id.hora;

          claseFalsaParaFer.herramientas = [];
          claseFalsaParaFer.actividadesClase = [];
          return claseFalsaParaFer;
        },
        postprocess: function (data, config) {
          data.herramientas = data.herramientas.filter(function (h) {
            return h.aplica;
          }).map(function (h) {
            return h.herramienta;
          });
          data.actividadesClase = data.actividadesClase.filter(function (a) {
            return a.aplica;
          }).map(function (a) {
            return a.actividad;
          });
          return data;
        }
      },
      extraResolves: [{
        name: 'materiaSeleccionada',
        resolve: function (params) {
          return CargaLibroDeTemas.getMateria(params).$promise;
        }
      },
      {
        name: 'herramientas',
        resolve: function (params) {
          return CargaLibroDeTemas.getHerramientas().$promise;
        }
      },
      {
        name: 'tipoClase',
        resolve: function (params) {
          return CargaLibroDeTemas.getTipoClase().$promise;
        }
      },
      {
        name: 'actividadesClase',
        resolve: function (params) {
          return CargaLibroDeTemas.getActividades().$promise;
        }
      },
      {
        name: 'caracterClase',
        resolve: function (params) {
          return CargaLibroDeTemas.getCaracterClase().$promise;
        }
      },
      {
        name: 'competencia',
        resolve: function (params) {
          return CargaLibroDeTemas.getCompetencia().$promise;
        }
      },
      {
        name: 'modoUsoAulaVirtual',
        resolve: function (params) {
          return CargaLibroDeTemas.getModoImplementacionAulaVirtual().$promise;
        }
      }
        ],
      postResolve: function (config) {
        config.data.editable = config.stateParams.editable;
        config.fields[3].templateOptions.options = config.extraData.tipoClase;
        config.fields[4].templateOptions.options = config.extraData.caracterClase;
        config.fields[6].templateOptions.options = config.extraData.competencia;
        var herramientasSeleccionadas = angular.copy(config.data.herramientas);
        config.data.herramientas.length = 0;
        var todas = config.extraData.herramientas.map(function (h) {
          return {
            herramienta: h,
            aplica: false
          };
        });
        todas.splice(0, 0, 0, 0);
        config.data.herramientas.splice.apply(config.data.herramientas, todas);
        config.data.herramientas.forEach(function (h) {
          herramientasSeleccionadas.forEach(function (h2) {
            if (h2.idHerramienta === h.herramienta.idHerramienta) {
              h.aplica = true;
            }
          });
        });
        config.fields[7].templateOptions.list.datasource.herramientas = config.extraData.herramientas;
        var actividadesSeleccionadas = angular.copy(config.data.actividadesClase);
        config.data.actividadesClase.length = 0;
        var todas = config.extraData.actividadesClase.map(function (a) {
          return {
            actividad: a,
            aplica: false
          };
        });
        todas.splice(0, 0, 0, 0);
        config.data.actividadesClase.splice.apply(config.data.actividadesClase, todas);
        config.data.actividadesClase.forEach(function (a) {
          actividadesSeleccionadas.forEach(function (a2) {
            if (a2.idActividadClase === a.actividad.idActividadClase) {
              a.aplica = true;
            }
          });
        });
        config.fields[8].templateOptions.list.datasource.actividadesClase = config.extraData.actividadesClase;
        config.fields[10].templateOptions.options = config.extraData.modoUsoAulaVirtual;
        return config;
      }

    }

    ]);
  }
})();

angular.module('administracionNotificaciones').component('desempenioAlumno', {
  bindings: {
    carrera: '<',
    materia: '<',
    nombre: '<',
    historialMateria: '<',
    historialExamen: '<'
  },
  templateUrl: 'app/app/main/alumno/desempenio-alumno-modal.html'
});

(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider
    .state('main.busqueda-alumnos-home', {
      url: 'alumno/home',
      templateUrl: 'app/app/main/alumno/busqueda-alumnos-home.html',
      controller: 'BusquedaAlumnosHomeCtrl as vm'
    })
    ;

  }

})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').controller('BusquedaAlumnosHomeCtrl', BusquedaAlumnosHomeCtrl);

  function BusquedaAlumnosHomeCtrl($scope, $timeout, $q, Dialogo, AlumnoHistorial) {
    var vm = this;
    vm.historialMateria = [];
    vm.nombreAlumno = '';
    vm.legajo = null;
    vm.mostrarDatosAlumno = mostrarDatosAlumno;
    vm.cargarHistorialMaterias = cargarHistorialMaterias;
    vm.model = {};

    vm.fields = [
      {
        key: 'alumno',
        type: 'typeahead',
        templateOptions: {
          label: 'Alumno:',
          placeholder: 'Buscar por nombre, apellido o legajo',
          propiedad: 'apellido',
          propiedadFiltro: 'apellido',
          ngOptions: 'item as (item.alumno.legajo+", "+(item.nombre || "").trim()) for item in to.funcion($viewValue) | limitTo:8',
          espera: 300,
          asincrono: true,
          required: false,
          buscar: vm.mostrarDatosAlumno,
          funcion: function ($viewValue) {
            return AlumnoHistorial.alumnos({ filtro: $viewValue }).$promise;
          }
        },
        ngModelAttrs: {
          ngOptions: { attribute: 'uib-typeahead' }
        }
      }
    ];

    $scope.$watch('vm.model.alumno', function (nuevo, anterior) {
      if (nuevo && nuevo !== anterior) {
        vm.mostrarDatosAlumno();
      }
    });

    function cargarHistorialMaterias() {
      vm.historialMateria = [];
      Dialogo.mostrarCargando();
      AlumnoHistorial.materiasAsociadas({ legajo: vm.legajo }).$promise
        .then(function (materias) {
          if (!Array.isArray(materias)) {
            console.error('Error: materias no es un array', materias);
            return;
          }

          var promesas = materias.map(function (materia) {
            return AlumnoHistorial.historialesAlumno({
              legajo: vm.legajo,
              materiaId: materia.materiaId,
              materiaS: materia.nombreMateria,
              carrera: materia.carrera
            }).$promise
              .then(function (registro) {
                if (registro) {
                  vm.historialMateria.push(registro);
                }
              })
              .catch(function (err) {
                console.error('Error al obtener el registro académico de la materia', materia.materiaId, err);
              });
          });
          return $q.all(promesas);
        })
        .then(function () {
          $timeout(function () {
            Dialogo.ocultarCargando();
          });
        })
        .catch(function (error) {
          console.error('Error al obtener el historial académico del alumno', vm.legajo, error);
          Dialogo.ocultarCargando();
        });
    }

    function mostrarDatosAlumno() {
      if (!vm.model.alumno || !vm.model.alumno.alumno || !vm.model.alumno.alumno.legajo) return;

      vm.historialAlumno = [];
      vm.historialMateria = [];
      vm.historialExamen = [];

      if (!vm.model.alumno.alumno) {
        vm.legajo = vm.model.alumno.split(",")[0];
        vm.nombreAlumno = vm.model.alumno;
      } else {
        vm.legajo = vm.model.alumno.alumno.legajo;
        vm.nombreAlumno = vm.model.alumno.alumno.legajo + "- " + vm.model.alumno.nombre;
      }

      cargarHistorialMaterias();
    }
  }
})();
/* global angular */
(function () {
  angular.module('administracionNotificaciones').run(run);
  function run($uibModal, DataState, Alumnos, Dialogo) {
    DataState.generateModelStates('Alumnos', [
      /* {
        defaultConfig: 'app/app/main/alumno/list-busqueda.state.json'
      }, */
      {
        defaultConfig: 'app/app/main/alumno/list.state.json'
      }
    ]);
  }
})();
  
  
(function() {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider
    .state('main.analitica-docente-home',{
      url: 'analitica-docente/home',
      templateUrl: 'app/app/main/analitica-docente/analitica-docente-home.html',
      controller: 'AnaliticaDocenteHomeCtrl as vm',
      resolve: {
        informes: function(AnaliticaDocente) {
          return AnaliticaDocente.obtenerInformesDisponibles();
        }
      }})
    .state('main.analitica-docente-detalle', {
      url: 'analitica-docente/details/:dashboard',
      templateUrl: 'app/app/main/analitica-docente/analitica-docente-detail.html',
      controller: 'AnaliticaDocenteDetailCtrl as vm',
      resolve: {
        link: function($stateParams, AnaliticaDocente) {
          console.log($stateParams);
          return AnaliticaDocente.obtenerLink({id : $stateParams.dashboard}).$promise;
        }
      }
    });
  }

})();


(function() {
  'use strict';

  angular.module('administracionNotificaciones').controller('AnaliticaDocenteHomeCtrl', AnaliticaDocenteHomeCtrl);

  function AnaliticaDocenteHomeCtrl($sce, $state, informes) {
    var vm = this;    
    vm.informes = informes;

    vm.verInformes = verInformes;

    function verInformes(informe) {

      $state.go('main.analitica-docente-detalle', {dashboard: informe.id});

    }
  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').controller('AnaliticaDocenteDetailCtrl', AnaliticaDocenteDetailCtrl);

  function AnaliticaDocenteDetailCtrl($sce, link) {
    var vm = this;    
    vm.link1 = $sce.trustAsResourceUrl(link.mensaje);
    
    var pageContentWidth = document.getElementById('sidebar-wrapper').offsetHeight;
    var altoMetabase = pageContentWidth * 0.87;

    vm.innerComponentStyle = {
      height: altoMetabase + 'px',
      border: 'none'
  
    };
   
  }

})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {

    $stateProvider.state('main.inscripcion-examen', {
      url: 'inscripcion-examen',
      templateUrl: 'app/app/main/inscripcion-examen/inscripcion-examen.html',
      controller: 'InscripcionExamenCtrl as vm',

      resolve: {
        materiasDisponibles: function (InscripcionExamen) {
          return InscripcionExamen.materiasDisponibles().$promise;
        },
        estadoAcademico: function (EstadoAcademico) {
          return EstadoAcademico.get().$promise;
        },
        examenesDelAlumno: function (Examen) {
          return Examen.get().$promise;
        }
      }
    });
  }

})();



(function () {
  'use strict';

  angular.module('administracionNotificaciones')
    .controller('InscripcionExamenCtrl', InscripcionExamenCtrl);

  function InscripcionExamenCtrl($scope, examenesDelAlumno, InscripcionExamen, Dialogo, materiasDisponibles, $filter, TurnosExamen, $state, estadoAcademico) {
    var vm = this;
    vm.materiasDisponiblesParaRendir = filtrarMateriasDisponiblesParaRendir(estadoAcademico.detalles); //las pintadas de verde
    asignarEstadoMaterias();
    vm.examenesInscriptos = filtrarExamenesInscripto(examenesDelAlumno.detalles);
    vm.verificarTurnos = verificarTurnos;
    vm.getEstado = getEstado;
    vm.getNombreEstado = getNombreEstado;
    vm.verificarInscripcionTurno = verificarInscripcionTurno;
    vm.anularInscripcion = anularInscripcion;
    vm.getInformacionExamen = getInformacionExamen;

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    function asignarEstadoMaterias(materias) {
      materiasDisponibles.materias.forEach(function (materia) {
        materia.estado = null;
        vm.materiasDisponiblesParaRendir.forEach(function (materiaDisponibleParaRendir) {
          if (materia.nombreMateria === materiaDisponibleParaRendir.nombreMateria) {
            materia.estado = 'rendible';
          }
        });
        if (materia.estado === null) {
          materia.estado = 'no-rendible';
        }
      });
      vm.materiasDisponibles = materiasDisponibles.materias;
    }

    function filtrarMateriasDisponiblesParaRendir(materias) {
      //Solamente dejo las materias del estado academico con estado "Regularizada" y que no tengan ninguna condicion q le impida rendirla
      return $filter('filter')(materias, function (value) {
        return value.estadoMateria === 'REGULARIZADA' && value.faltaAprobar === null;
      });
    }

    function filtrarExamenesInscripto(examenes) {
      //Solamente dejo los examenes inscriptos representadas con estadoExamen === null
      return $filter('filter')(examenes, function (value) {
        if (value.estadoExamen === null) {
          value.info = buscarMateriaParaExamenInscripto(value);
        }
        return value.estadoExamen === null;
      });
    }

    function buscarMateriaParaExamenInscripto(examenInscripto) {
      var seleccionada;
      vm.materiasDisponibles.forEach(function (materia) {
        if (examenInscripto.plan === materia.plan && examenInscripto.especialidad === materia.especialidad && examenInscripto.codigoMateria === materia.codigoMateria) {
          seleccionada = materia;
        }
      });
      return seleccionada;
    }

    function getNombreEstado(materia) {
      if (materia.estado === 'rendible') {
        return 'Lista para Rendir';
      } else {
        if (materia.estado === 'regular') {
          return 'Regular';
        } else {
          if (materia.estado === 'no-rendible') {
            return 'No se Puede Rendir';
          } else {
            if (materia.estado === 'inscripto') {
              return 'Inscripto';
            }
          }
        }
      }
    }

    function getEstado(materia) {
      if (materia.estado === 'rendible') {
        return 'label-info';
      } else {
        if (materia.estado === 'regular') {
          return 'label-primary';
        } else {
          if (materia.estado === 'no-rendible') {
            return 'label-danger';
          } else {
            if (materia.estado === 'inscripto') {
              return 'label-success';
            }
          }
        }
      }
    }

    function verificarInscripcionTurno(materia) {
      //devuelve true si ya se ha inscripto antes
      if (materia.checksum === null && materia.edificio === null &&
        materia.fechaExamen === null && materia.horarioPractico === null &&
        materia.horarioTeorico === null && materia.inscripto === null) {
        return false;
      } else {
        return true;
      }
    }

    function verificarTurnos(materia) {
      if (verificarInscripcionTurno(materia)) {
        mostrarMensajeConfirmacionTurnos(materia);
      } else {
        mostrarTurnos(materia);
      }
    }

    function mostrarMensajeConfirmacionTurnos(materia) {
      Dialogo.mostrarConfirmacion({
        titulo: 'Atencíon',
        texto: 'Usted ya esta inscripto en un turno. ¿Desea inscribirse a otro turno?',
        icon: 'fa-warning',
        plantilla: 'app/app/main/inscripcion-examen/dialogo-confirmacion-visualizacion-turnos.html',
        accionSi: function () {
          Dialogo.mostrarCargando();
          mostrarTurnos(materia);
        }
      }, $scope);
    }

    function mostrarTurnos(materia) {
      Dialogo.mostrarCargando();
      InscripcionExamen.listarTurnos(materia, function (respuesta) {
        respuesta.materia = materia;
        TurnosExamen.setTurnos(respuesta);
        $state.go('main.turno-examen');
      }, errorTurnos);
    }

    function errorTurnos(respuesta) {
      var errores = respuesta.data.message.split('No');
      errores.shift();
      for (var i = 0; i < errores.length; i++) {
        errores[i] = 'No' + errores[i];
      }

      Dialogo.mostrarError({
        plantilla: 'app/app/main/inscripcion-examen/dialogo-error-turnos.html',
        parrafos: errores,
        titulo: 'Error'
      }, $scope);

      Dialogo.ocultarCargando();
    }

    function anularInscripcion(detalle) {
      Dialogo.mostrarConfirmacion({
        texto: '¿Está seguro que desea anular la inscripción?',
        accionSi: function () {
          Dialogo.mostrarCargando();
          anular(detalle);
        }
      }, $scope.$new());
    }

    function anular(detalle) {
      InscripcionExamen.anular(detalle, function (respuesta) {
        Dialogo.ocultarCargando();
        if (respuesta.resultado) { // Anulado exitosamente
          Dialogo.mostrarExito({
            texto: respuesta.mensaje,
            icon: 'fa-check',
            titulo: 'Desinscripción Exitosa',
            accionSi: function () {
              Dialogo.mostrarCargando();
              $state.go($state.current, {}, { reload: true });
            }
          }, $scope.$new());
        } else {
          Dialogo.mostrarError({
            texto: respuesta.mensaje
          }, $scope.$new());
        }

      }, function (error) {
        Dialogo.ocultarCargando();
      });
    }

    function getInformacionExamen(examen) {
      Dialogo.mostrarError({
        icono: 'fa-info',
        plantilla: 'app/app/main/inscripcion-examen/dialogo-error-turnos.html',
        titulo: 'Detalle Inscripción',
        parrafos: ['Materia: ' + examen.nombreMateriaLargo, 'Día: ' + examen.inscripto,
        'Horario Teórico: ' + examen.horarioTeorico, 'Horario Práctico: ' + examen.horarioPractico,
        'Edificio: ' + examen.edificio, 'Checksum: ' + examen.checksum]
      }, $scope);
    }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones')
        .directive('onFinishRender', onFinishRender);

  function onFinishRender($timeout) {
    return {
      restrict: 'A',
      link: function (scope, element, attr) {
        if (scope.$last === true) {
          $timeout(function () {
            scope.$eval(attr.onFinishRender);
          });
        }
      }
    };
  }
})();
(function () {
  'use strict';

  angular.module('administracionNotificaciones')
      .factory('buscarSeleccionado', buscarSeleccionado);

  function buscarSeleccionado() {
    return {
      seleccionar: function (Objeto) {
        var os = [];
        for (var i = 0; i < Objeto.length; i++) {
          if (Objeto[i].seleccionado) {
            delete Objeto[i].seleccionado;
            os.push(Objeto[i]);
          }
        }
        return os;
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').directive('contentWrapper', contentWrapper);

  function contentWrapper() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/tema/content-wrapper.html',
      replace: true
    };
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').factory('TipoDocumentacion', TipoDocumentacion);

  function TipoDocumentacion($resource, URL_SERVIDOR) {
    var TipoDocumentacion = $resource(URL_SERVIDOR + 'tipos-documentacion/', {
      clave: '@clave'
    }, {
      getEstados: {
        url: URL_SERVIDOR + 'documentacion-docente/estados',
        method: 'GET',
        isArray: true
      }
    });

    return TipoDocumentacion;
  }

})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones')
    .factory('TipoPregunta', TipoPregunta);

  function TipoPregunta($resource, URL_SERVIDOR) {
    var TipoPregunta = $resource(URL_SERVIDOR + 'encuestas2025/tipos-pregunta/:id', {
      id: '@id'
    }, {
      query: {
        url: URL_SERVIDOR + 'encuestas2025/tipos-pregunta',
        method: 'GET',
        params: {
          id: '@id'
        },
        isArray: true
      },
      update: {
        url: URL_SERVIDOR + 'encuestas2025/tipos-pregunta',
        method: 'POST'
      }
    });

    TipoPregunta.config = {
      name: 'Tipo de Pregunta',
      pluralName: 'Tipos de Pregunta',
      icon: 'fa fa-list-alt',
      order: 1,
      resource: {
        name: 'TipoPregunta',
        methods: {
          delete: {
            params: true
          },
          remove: {
            params: true
          }
        }
      }
    };

    return TipoPregunta;
  }
})(); 
(function () {
  'use strict';

  angular.module('administracionNotificaciones')
    .factory('SolicitudLicencia', SolicitudLicencia);

  function SolicitudLicencia($resource, URL_LICENCIAS) {
    var SolicitudLicencia = $resource(URL_LICENCIAS + 'solicitudes/:id', {
      id: '@id'
    }, {
      query: {
        url: URL_LICENCIAS + 'solicitudes/:id',
        method: 'GET',
        isArray: false
      },
      acumuladasPeriodo: {
        url: URL_LICENCIAS + 'solicitudes/buscar/:idPersonal/:anio/:mes',
        method: 'GET',
        params: {
          idPersonal: '@idPersonal',
          anio: '@anio',
          mes: '@mes'
        },
        isArray: true
      }
    });
    SolicitudLicencia.config = {
      female: true,
      icon: 'fa fa-medkit',
      name: 'Solicitud de Licencia',
      pluralName: 'Solicitudes',
      order: 6,
      resource: {
        name: 'SolicitudLicencia',
        methods: {
          acumuladasPeriodo: {
            name: 'acumuladasPeriodo',
            params: true
          }
        }
      }
    };
    return SolicitudLicencia;
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones')
    .factory('Seccion', Seccion);

  function Seccion($resource, URL_SERVIDOR) {
    var Seccion = $resource(URL_SERVIDOR + 'secciones/:id', { id: '@id' }, {
      update: {
        url: URL_SERVIDOR + 'secciones',
        method: 'PUT',
        isArray: true
      }
    });
    Seccion.config = {
      female: true,
      icon: 'fa fa-folder',
      name: 'Sección',
      pluralName: 'Secciones',
      order: 7,
      resource: {
        name: 'Seccion',
        methods: {
        }
      }
    };
    return Seccion;
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones')
    .factory('RRHH', RRHH);

  function RRHH($resource, $http, URL_SERVIDOR) {
    var RRHH = $resource(URL_SERVIDOR + 'rr-hh/:id', {
      id: '@id'
    }, {});
    RRHH.exportarPDF = function (periodo) {
      return $http.get(URL_SERVIDOR + 'academica/fechas-dictado/imprimir-mensual?mes=' + periodo.mes + '&anio=' + periodo.anio, {
        responseType: 'arraybuffer'
      }).then(function (response) {
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);

      });
    };
    return RRHH;
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones')
    .factory('RespuestaPosible', RespuestaPosible);

  function RespuestaPosible($resource, URL_SERVIDOR) {
    var RespuestaPosible = $resource(URL_SERVIDOR + 'encuestas2025/respuestas-posibles/:id', {
      id: '@id'
    }, {
      query: {
        url: URL_SERVIDOR + 'encuestas2025/respuestas-posibles',
        method: 'GET',
        params: {
          id: '@id'
        },
        isArray: true
      },
      update: {
        url: URL_SERVIDOR + 'encuestas2025/respuestas-posibles',
        method: 'POST'
      }
    });

    RespuestaPosible.config = {
      resource: {
        name: 'RespuestaPosible',
        methods: {
          delete: {
            params: true
          },
          remove: {
            params: true
          }
        }
      }
    };

    return RespuestaPosible;
  }
})(); 
(function () {
  'use strict';

  angular.module('administracionNotificaciones')
    .factory('Pregunta', Pregunta);

  function Pregunta($resource, URL_SERVIDOR) {
    var Pregunta = $resource(URL_SERVIDOR + 'encuestas2025/preguntas/:id', {
      id: '@id'
    }, {
      query: {
        url: URL_SERVIDOR + 'encuestas2025/preguntas',
        method: 'GET',
        params: {
          id: '@id'
        },
        isArray: true
      },
      update: {
        url: URL_SERVIDOR + 'encuestas2025/preguntas',
        method: 'POST'
      }
    });

    Pregunta.config = {
      resource: {
        name: 'Pregunta',
        methods: {
          delete: {
            params: true
          },
          remove: {
            params: true
          }
        }
      }
    };

    return Pregunta;
  }
})(); 
(function () {
  'use strict';

  angular.module('administracionNotificaciones')
    .factory('Personal', Personal);

  function Personal($resource, URL_LICENCIAS, $http) {
    var Personal = $resource(URL_LICENCIAS + 'personal/:id', {
      id: '@id'
    }, {
      query: {
        url: URL_LICENCIAS + 'personal/:id',
        method: 'GET',
        isArray: false
      }
    });
    Personal.config = {
      icon: 'fa fa-briefcase',
      pluralName: 'Personal',
      order: 7
    };
    Personal.imprimirLicenciasAcumuladas = function (idPersonal, anio, mes) {
      return $http.get(URL_LICENCIAS + 'solicitudes/imprimir/' + idPersonal + '/' + anio + '/' + mes, {
        responseType: 'arraybuffer'
      }).then(function (response) {
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        // saveAs(file, 'Solicitudes ' + idPersonal + '.pdf');
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        return file;
      });
    };
    return Personal;
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones')
      .factory('Persona', Persona);

  function Persona($resource, URL_SERVIDOR) {
    var Persona = $resource(URL_SERVIDOR + 'persona/:id', {id: '@id'}, {
      queryDocentes: {
        url: URL_SERVIDOR + 'persona/docentes',
        method: 'GET',
        params: {id: '@id'},
        isArray: true
      },
      editContactData: {
        url: URL_SERVIDOR + 'persona/:id/contacto',
        method: 'PUT',
        params: {id: '@id'}
      }
    });
    Persona.config = {
      female: true,
      icon: 'fa fa-user',
      order: 3,
      resource: {
        methods: {
          queryDocentes: {
            name: 'queryDocentes'
          },
          editContactData: {
            name: 'editContactData',
            params: true
          }
        }
      }
    };
    return Persona;
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones')
    .factory('Permiso', Permiso);

  function Permiso($resource, URL_SERVIDOR) {
    var Permiso = $resource(URL_SERVIDOR + 'Permisos/:id', {
      id: '@id'
    }, {
      query: {
        url: URL_SERVIDOR + 'Permisos/todos',
        method: 'GET',
        params: {
          id: '@id'
        },
        isArray: true
      },
      update: {
        url: URL_SERVIDOR + 'Permisos',
        method: 'POST'
      }
    });
    Permiso.config = {
      icon: 'fa fa-key',
      order: 3,
      resource: {
        methods: {
          delete: {
            params: true
          },
          remove: {
            params: true
          }
        }
      }
    };
    return Permiso;
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').factory('PagoTIC', PagoTIC);

  function PagoTIC($resource, $http, AlmacenUsuario, URL_SERVIDOR) {
    var PagoTIC = $resource(URL_SERVIDOR + 'pago-tic/:codigo/', {
      codigo: '@id'
    }, 
      {
        listar: {
          url: URL_SERVIDOR + '/pago-tic/lista',
          method: 'GET'
        },
        nuevoFormularioPagoTIC: {
          url: URL_SERVIDOR + '/pago-tic/new',
          method: 'POST'
        },
        renovarLink: {
          url: URL_SERVIDOR + '/pago-tic/:codigo/renew',
          method: 'POST'
        },
        aprobarManual: {
          url: URL_SERVIDOR + '/pago-tic/:codigo/set-pagado-manual',
          method: 'PUT'
        },
        getCursos: {
          url: URL_SERVIDOR + 'pago-tic/cursos',
          method: 'GET',
          isArray: true
        }

      });

    PagoTIC.config = {
      icon: 'fa fa-credit-card',
      order: 6,
      resource: {
        methods: {
          listar: {
            name: 'listar',
            params: true
          },
          nuevoFormularioPagoTIC: {
            name: 'nuevoFormularioPagoTIC',
            params: true
          }
        }
      }
    };
    return PagoTIC;
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones')
    .factory('Opcion', Opcion);

  function Opcion($resource, URL_SERVIDOR) {
    var Opcion = $resource(URL_SERVIDOR + 'encuestas2025/opciones/:id', {
      id: '@id'
    }, {
      query: {
        url: URL_SERVIDOR + 'encuestas2025/opciones',
        method: 'GET',
        params: {
          id: '@id'
        },
        isArray: true
      },
      update: {
        url: URL_SERVIDOR + 'encuestas2025/opciones',
        method: 'POST'
      }
    });

    Opcion.config = {
      resource: {
        name: 'Opcion',
        methods: {
          delete: {
            params: true
          },
          remove: {
            params: true
          }
        }
      }
    };

    return Opcion;
  }
})(); 
(function () {
  'use strict';

  angular.module('administracionNotificaciones')
      .factory('Notificacion', Notificacion);

  function Notificacion($resource, URL_SERVIDOR) {
    var Notificacion = $resource(URL_SERVIDOR + 'notificaciones/:id', {
      id: '@id'
    }, {
      get: {
        url: URL_SERVIDOR + 'notificaciones/admin/:id',
        method: 'GET',
        params: {id: '@id'}
      }
    });
    Notificacion.config = {
      female: true,
      name: 'Notificación',
      pluralName: 'Notificaciones',
      icon: 'fa fa-bell',
      order: 20,
      sections: [],
      resource: {
        name: 'Notificacion'
      }
    };
    return Notificacion;
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones')
    .factory('NotificacionAlumnosInscriptos', NotificacionAlumnosInscriptos);

  function NotificacionAlumnosInscriptos($resource, URL_SERVIDOR) {
    var NotificacionAlumnosInscriptos = $resource(URL_SERVIDOR + 'notificaciones-alumnos-inscriptos/:id', { id: '@id' }, {
      query: {
        url: URL_SERVIDOR + 'notificaciones-alumnos-inscriptos/:id',
        method: 'GET',
        isArray: false
      }
    });
    NotificacionAlumnosInscriptos.config = {
      female: false,
      icon: 'fa fa-medkit',
      name: 'Alumnos Inscriptos',
      pluralName: 'Alumnos Inscriptos',
      order: 6,
      resource: {
        name: 'NotificacionAlumnosInscriptos'
      }
    };
    return NotificacionAlumnosInscriptos;
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones')
    .factory('MisDocumentos', MisDocumentos);

  function MisDocumentos($resource, URL_SERVIDOR) {
    var MisDocumentos = $resource(URL_SERVIDOR + 'documentacion-docente/:id', {
      id: '@id'
    }, {
      obtenterMisDocumentos: {
        url: URL_SERVIDOR + 'documentacion-docente/:id',
        method: 'GET',
        params: {
          id: '@id'
        }
      },
      getDocumentos: {
        url: URL_SERVIDOR + 'descarga/documentos',
        method: 'GET',
        isArray: true
      },
      update: {
        url: URL_SERVIDOR + 'documentacion-docente/:id',
        method: 'PUT'
      }
    });
    MisDocumentos.config = {
      female: true,
      name: 'Mis Documento',
      displayName: 'carga de documentación',
      pluralName: 'Mis Documentos',
      icon: 'fa fa-tag',
      resource: {
        name: 'MisDocumentos',
        methods: {
          getDocumentos: {
            name: 'getDocumentos',
            params: true
          }
        }
      },
      order: 20
    };
    return MisDocumentos;
  }
})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').factory('MateriaElectiva', MateriaElectiva);

  function MateriaElectiva($resource, URL_SERVIDOR) {
    return $resource(URL_SERVIDOR + 'materias-electivas',{},{
     
    });
  }

})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones')
    .factory('MateriaDocente', MateriaDocente);

  function MateriaDocente($resource, $http, URL_SERVIDOR) {
    var MateriaDocente = $resource(URL_SERVIDOR + 'docente/materias/:id', {
      id: '@id'
    }, {
      consultarNotas: {
        url: URL_SERVIDOR + 'docente/notas/:anioAcademico-:especialidad-:plan-:materia-:comision',
        method: 'GET',
        params: {
          anioAcademico: '@anioAcademico',
          especialidad: '@especialidad',
          plan: '@plan',
          materia: '@materia',
          comision: '@comision'
        }
      },
      query: {
        url: URL_SERVIDOR + 'docente/materias/:anioAcademico',
        method: 'GET',
        isArray: true,
        params: {
          anioAcademico: '@anioAcademico'
        }
      },
      aniosDisponibles: {
        url: URL_SERVIDOR + 'docente/materias/anios-disponibles',
        method: 'GET',
        isArray: true
      },
      listado: {
        url: URL_SERVIDOR + 'docente/materias/listado',
        method: 'GET'
      },
      getUnica: {
        url: URL_SERVIDOR + 'docente/materias/:anoacademi/:especialid/:plan/:materia/:comision',
        method: 'GET',
        params: {
          anoacademi: '@anoacademi',
          especialid: '@especialid',
          plan: '@plan',
          materia: '@materia',
          comision: '@comision'
        }
      },
      editarNotas: {
        url: URL_SERVIDOR + 'docente/notas/:id',
        method: 'POST',
        params: {
          id: function (data) {
            return [data.comision.id.anoacademi, data.comision.id.especialid, data.comision.id.plan, data.comision.id.materia, data.comision.id.comision].join('-');
          }
        }
      },
      confirmarNotas: {
        url: URL_SERVIDOR + 'docente/notas/:id/confirmar',
        method: 'POST',
        params: {
          id: function (data) {
            return [data.comision.anioAcademico, data.comision.especialidad, data.comision.plan, data.comision.materia, data.comision.comision].join('-');
          }
        }
      },
      reenviarSMS: {
        url: URL_SERVIDOR + 'docente/notas/:anioAcademico-:especialidad-:plan-:materia-:comision/reenviar',
        method: 'GET',
        params: {
          anioAcademico: '@anioAcademico',
          especialidad: '@especialidad',
          plan: '@plan',
          materia: '@materia',
          comision: '@comision'
        }
      },
      solicitarCierre: {
        url: URL_SERVIDOR + 'docente/notas/:anioAcademico-:especialidad-:plan-:materia-:comision/solicitud-cierre',
        method: 'POST',
        params: {
          anioAcademico: '@anioAcademico',
          especialidad: '@especialidad',
          plan: '@plan',
          materia: '@materia',
          comision: '@comision'
        }
      },
      cerrar: {
        url: URL_SERVIDOR + 'docente/notas/:anioAcademico-:especialidad-:plan-:materia-:comision/cerrar',
        method: 'POST',
        params: {
          anioAcademico: '@anioAcademico',
          especialidad: '@especialidad',
          plan: '@plan',
          materia: '@materia',
          comision: '@comision',
          id: '@id',
          hash: '@hash'
        }
      }
    });
    MateriaDocente.exportarPlanilla = function (comision) {
      return $http.get(URL_SERVIDOR + 'docente/notas/' + comision.anioAcademico + '-' + comision.especialidad + '-' + comision.plan + '-' + comision.materia + '-' + comision.comision + '/excel', {
        responseType: 'arraybuffer'
      }).then(function (response) {
        var file = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        saveAs(file, 'Planilla notas ' + comision.nombreMateria + '-' + comision.anioAcademico + '-' + comision.especialidad + '-' + comision.plan + '-' + comision.materia + '-' + comision.comision + '.xls');
        return file;
      });
    };
    MateriaDocente.exportarPDF = function (comision) {
      return $http.get(URL_SERVIDOR + 'docente/notas/' + comision.anioAcademico + '-' + comision.especialidad + '-' + comision.plan + '-' + comision.materia + '-' + comision.comision + '/pdf', {
        responseType: 'arraybuffer'
      }).then(function (response) {
        // var file = new Blob([response.data], {
        //   type: 'application/pdf'
        // });
        // saveAs(file, 'Planilla notas ' + comision.nombreMateria + '-' + comision.anioAcademico + '-' + comision.especialidad + '-' + comision.plan + '-' + comision.materia + '-' + comision.comision + '.pdf');
        // return file;
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);

      });
    };
    MateriaDocente.config = {
      female: true,
      name: 'Cátedra',
      icon: 'fa fa-book',
      order: 4,
      resource: {
        name: 'MateriaDocente',
        methods: {
          consultarNotas: {
            name: 'consultarNotas',
            params: true
          },
          editarNotas: {
            name: 'editarNotas',
            params: true
          },
          listado: {
            name: 'listado',
            params: true
          }
        }
      }
    };
    return MateriaDocente;
  }
})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').factory('MateriaCursando', MateriaCursando);

  function MateriaCursando($resource, URL_SERVIDOR) {
    return $resource(URL_SERVIDOR + 'MateriasCursando');
  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').factory('Localidad', Localidad);

  function Localidad($resource, URL_SERVIDOR) {
    return $resource(URL_SERVIDOR + 'localidades', {
      id: '@id'
    }, {
      getVillaMaria: {
        url: URL_SERVIDOR + 'localidades/villa-maria',
        method: 'GET'
      },
      query: {
        url: URL_SERVIDOR + 'localidades',
        method: 'GET',
        isArray: true
      }
    }
    );
  }

})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').factory('LibroDeTemas', LibroDeTemas);

  function LibroDeTemas($resource, URL_SERVIDOR, $http) {
    var LibroDeTemas = $resource(URL_SERVIDOR + 'clases/', {
      clave: '@clave'
    }, {
      buscarFechas: {
        url: URL_SERVIDOR + 'clases/:clave',
        method: 'GET',
        isArray: true
      }
    });

    LibroDeTemas.imprimirLibroDeTemas = function (especialid, plan, materia, anoacademi, comision) {
      return $http.get(URL_SERVIDOR + '/libro-de-temas/imprimir/' + especialid + '-' + plan + '-' + materia + '-' + anoacademi + '-' + comision  , {
        responseType: 'arraybuffer'
      }).then(function (response) {
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        // saveAs(file, 'Solicitudes ' + idPersonal + '.pdf');
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        return file;
      });
    };
    return LibroDeTemas;
  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').factory('InscripcionExamen', InscripcionExamen);

  function InscripcionExamen($resource, URL_SERVIDOR) {
    return $resource(URL_SERVIDOR + 'inscripcion-examenes',{},{
      materiasDisponibles: {
        url: URL_SERVIDOR + 'inscripcion-examenes',
        method: 'GET'
      },
      listarTurnos: {
        url: URL_SERVIDOR + 'inscripcion-examenes/listar-turnos',
        method: 'POST'
      },
      inscribir: {
        url: URL_SERVIDOR + 'inscripcion-examenes/inscribir',
        method: 'POST'
      },
      anular: {
        url: URL_SERVIDOR + 'inscripcion-examenes/anular',
        method: 'POST'
      }
    });
  }
  
})();
(function() {
  'use strict';

  angular.module('administracionNotificaciones').factory('InscripcionExamenDocente', InscripcionExamenDocente);

  function InscripcionExamenDocente($resource, URL_SERVIDOR) {
    return $resource(URL_SERVIDOR + 'docente/Examenes/alumnos-inscriptos', {}, {
      obtenerInscriptos: {
        url: URL_SERVIDOR + 'docente/Examenes/alumnos-inscriptos',
        method: 'GET',
        isArray: true 
      }
    });
  }

})();
(function() {
  'use strict';

  angular.module('administracionNotificaciones').factory('InscripcionCursado', InscripcionCursado);

  function InscripcionCursado($resource, URL_SERVIDOR) {
    return $resource(URL_SERVIDOR + 'inscripcion-cursado',{},{
      materiasDisponibles: {
        url: URL_SERVIDOR + 'inscripcion-cursado',
        method: 'GET'
      },
      listarComisiones: {
        url: URL_SERVIDOR + 'inscripcion-cursado/comisiones',
        method: 'POST'
      },
      inscribir: {
        url: URL_SERVIDOR + 'inscripcion-cursado/inscribir',
        method: 'POST'
      },
      anular: {
        url: URL_SERVIDOR + 'inscripcion-cursado/anular',
        method: 'POST'
      }
    });
  }

})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').factory('HorarioCursado', HorarioCursado);

  function HorarioCursado($resource, URL_SERVIDOR) {
    return $resource(URL_SERVIDOR + 'fechas-cursado');
  }

})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones')
    .factory('Haberes', Haberes);

  function Haberes($resource, URL_SERVIDOR, $http) {
    var Haberes = $resource(URL_SERVIDOR + '/agentes/liquidaciones/periodos', {

    }, {
      getPeriodos: {
        url: URL_SERVIDOR + '/agentes/liquidaciones/periodos',
        method: 'GET'
      }
    });
    Haberes.descargarArchivo = function (id) {

      return $http.get(URL_SERVIDOR + '/agentes/liquidaciones/recibo/' + id + '/imprimir', {
        responseType: 'arraybuffer'
      }).then(function (response) {
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      });
    };
    Haberes.config = {
      female: true,
      name: 'Recurso Humano',
      pluralName: 'Recursos Humanos',
      icon: 'fa fa-money',
      resource: {
        name: 'Haberes',
        methods: {
          getPeriodos: {
            name: 'getPeriodos',
            params: true
          }
        }
      },
      order: 20
    };
    return Haberes;
  }
})();
(function () {
  'use strict';

  angular.module('administracionNotificaciones')
    .factory('Grupo', Grupo);

  function Grupo($resource, $timeout, URL_SERVIDOR) {
    var Grupo = $resource(URL_SERVIDOR + 'grupo-persona/:id', {
      id: '@id'
    }, {
      listarPrimerNivel: {
        url: URL_SERVIDOR + 'grupo-persona/primer-nivel',
        method: 'GET',
        isArray: true
      },
      queryChildren: {
        url: URL_SERVIDOR + 'grupo-persona/:id/subgrupos',
        method: 'GET',
        params: {id: '@id'},
        isArray: true
      },
      consultarMiembros: {
        url: URL_SERVIDOR + 'grupo-persona/:id/miembros',
        method: 'GET',
        params: {id: '@id'},
        isArray: true
      },
      actualizarMiembros: {
        url: URL_SERVIDOR + 'grupo-persona/:id/miembros',
        method: 'PUT',
        params: {id: '@id'}
      }
    });
    Grupo.config = {
      icon: 'fa fa-users',
      order: 1,
      resource: {
        methods: {
          query: {
            name: 'listarPrimerNivel'
          },
          consultarMiembros: {
            name: 'consultarMiembros',
            params: {
              id: 'id'
            },
            isArray: true
          }
        }
      }
    };
    Grupo.getNuevo = function(params) {
      if (params.id && params.id !== 'nuevo') {
        return Grupo.get({id: params.id}).$promise;
      } else if (params.idPadre) {
        return Grupo.get({id: params.idPadre}).$promise.then(function (padre) {
          return {
            miembros: [],
            padre: padre
          };
        });
      } else {
        return $timeout(function() {
          return {
            miembros: []
          };
        });
      }
    };
    return Grupo;
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones')
      .factory('GrupoPermiso', GrupoPermiso);

  function GrupoPermiso($resource, URL_SERVIDOR) {
    var GrupoPermiso = $resource(URL_SERVIDOR + 'grupo/:id', {id: '@id'}, {
      update: {
        url: URL_SERVIDOR + 'grupo',
        method: 'POST'
      }
    });
    GrupoPermiso.config = {
      pluralName: 'Grupos de permisos',
      icon: 'fa fa-key',
      order: 4,
      resource: {
        methods: {
          delete: {
            params: true
          },
          remove: {
            params: true
          }
        }
      }
    };
    return GrupoPermiso;
  }
})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').factory('Examen', Examen);

  function Examen($resource, URL_SERVIDOR) {
    return $resource(URL_SERVIDOR + 'examenes');
  }

})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones')
    .factory('ExamenDocente', ExamenDocente);

  function ExamenDocente($resource, URL_SERVIDOR) {
    var ExamenDocente = $resource(URL_SERVIDOR + 'docente/Examenes/:id', {
      id: '@id'
    }, {
      get: {
        url: URL_SERVIDOR + 'docente/Examenes/actualizado',
        method: 'GET',
        isArray: true
      },
      listarAlumnosInscriptos: {
        url: URL_SERVIDOR + 'docente/Examenes/actualizado/listar-alumnos',
        method: 'POST'
      }
    });
    ExamenDocente.config = {
      name: 'Examen',
      pluralName: 'Exámenes',
      icon: 'fa fa-pencil-square',
      order: 5,
      resource: {
        name: 'ExamenDocente',
        methods: {
          listarAlumnosInscriptos: {
            name: 'listarAlumnosInscriptos',
            params: true
          }
        }
      }
    };
    return ExamenDocente;
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones')
    .factory('EventoReloj', EventoReloj);

  function EventoReloj($resource, URL_LICENCIAS) {
    var EventoReloj = $resource(URL_LICENCIAS + 'reloj/eventos/:id', { id: '@id' }, {
      query: {
        url: URL_LICENCIAS + 'reloj/eventos/:id',
        method: 'GET',
        isArray: false
      }
    });
    EventoReloj.config = {
      female: true,
      icon: 'fa fa-medkit',
      name: 'Evento Reloj',
      pluralName: 'Eventos Reloj',
      order: 7,
      resource: {
        name: 'EventoReloj'
      }
    };
    return EventoReloj;
  }
})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').factory('EstadoAcademico', EstadoAcademico);

  function EstadoAcademico($resource, URL_SERVIDOR) {
    return $resource(URL_SERVIDOR + 'estado-academico');
  }

})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').factory('EspecialidadHorarioCursado', EspecialidadHorarioCursado);

  function EspecialidadHorarioCursado($resource, URL_SERVIDOR) {
    return $resource(URL_SERVIDOR + '/academica/especialidades', {}, {
      especialidades: {
        url: URL_SERVIDOR + 'academica/especialidades/especialidades-habilitadas',
        method: 'GET',
        isArray: true
      },
      horariosDictadoEspecialidad: {
        url: URL_SERVIDOR + 'academica/especialidades/horarios-dictado/:especialidad',
        method: 'GET',
        isArray: true,
        params: {
          especialidad: '@especialidad'
        }
      },
      horariosDictadoEspecialidadNivel: {
        url: URL_SERVIDOR + 'academica/especialidades/horarios-dictado/:especialidad/:nivel',
        method: 'GET',
        isArray: true,
        params: {
          especialidad: '@especialidad',
          nivel: '@nivel'
        }
      }
    });
  }

})();

(function () {
    'use strict';

    angular.module('administracionNotificaciones')
        .factory('Encuestas2025', Encuestas2025);

    function Encuestas2025($resource, URL_SERVIDOR) {

        var Encuestas2025 = $resource(URL_SERVIDOR + 'encuestas2025/encuestas/:id');
        Encuestas2025.config = {
            female: true,
            name: 'Encuestas Docentes',
            pluralName: 'Encuestas Docentes',
            icon: 'fa fa-comments-o',
            resource: {
              name: 'Encuestas2025',
              methods: {

              }
            },
            order: 1

          };
        return Encuestas2025;
    }
})();
(function () {
  'use strict';

  angular.module('administracionNotificaciones')
    .factory('EncuestasRealizadas', EncuestasRealizadas);

  function EncuestasRealizadas($resource, URL_SERVIDOR) {
    var EncuestasRealizadas = $resource(URL_SERVIDOR + 'encuestas2025/informes-encuestas', {
      id: '@id'
    }, {
      query: {
        url: URL_SERVIDOR + 'encuestas2025/listado',
        method: 'GET',
        isArray: false
      }
    });

    EncuestasRealizadas.config = {
      resource: {
        name: 'EncuestasRealizadas',
        methods: {
          delete: {
            params: true
          },
          remove: {
            params: true
          }
        }
      }
    };

    return EncuestasRealizadas;
  }
})(); 
(function () {
  'use strict';

  angular.module('administracionNotificaciones')
    .factory('EncuestasPendientes', EncuestasPendientes);

  function EncuestasPendientes($resource, URL_SERVIDOR) {
    var EncuestasPendientes = $resource(URL_SERVIDOR + 'encuestas2025/pendientes/:id', {
      id: '@id'
    }, {
      query: {
        url: URL_SERVIDOR + 'encuestas2025/pendientes',
        method: 'GET',
        params: {
          id: '@id'
        },
        isArray: true
      }
    });

    EncuestasPendientes.config = {
      resource: {
        name: 'EncuestasPendientes',
        methods: {
          delete: {
            params: true
          },
          remove: {
            params: true
          }
        }
      }
    };

    return EncuestasPendientes;
  }
})(); 
(function () {
  'use strict';

  angular.module('administracionNotificaciones').factory('EncuestasDocentes', EncuestasDocentes);

  function EncuestasDocentes($resource, URL_SERVIDOR) {

    var EncuestasDocentes = $resource(
      URL_SERVIDOR + 'encuesta/dashboard/',
      {
        codigo: '@id',
        especialidad: '@especialidad',
        comision: '@comision',
        materia: '@materia',
        plan: '@plan',
      },
      {
        obtenerLink: {
          url: URL_SERVIDOR + 'analitica/dashboard/encuestas-docentes/:codigo/solicitar-link',
          method: 'POST'
        },
        obtenerLinkAutoridades: {
          url: URL_SERVIDOR + 'analitica/dashboard/encuestas-docentes-autoridades/53/solicitar-link',
          method: 'POST'
        },
        obtenerLinkBasicas: {
          url: URL_SERVIDOR + 'analitica/dashboard/encuestas-docentes-basicas/54/solicitar-link',
          method: 'POST'
        },
      }
    );

    EncuestasDocentes.obtenerInformesDisponibles = function (tipo) {
      if (tipo === 'docentes') {
        return [{ id: 52, nombre: 'Estadísticas' }];
      }

      if (tipo === 'autoridades') {
        return [{ id: 53, nombre: 'Estadísticas' }];
      }

      if (tipo === 'basicas') {
        return [{ id: 54, nombre: 'Estadísticas' }];
      }

      return [];
    };

    return EncuestasDocentes;
  }

})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').factory('Encuesta', Encuesta);

  function Encuesta($resource, URL_SERVIDOR) {
    var resource = $resource(URL_SERVIDOR + 'encuestas/encuestas-disponibles',{}, {
      listarDisponibles: {
        url: URL_SERVIDOR + 'encuestas/encuestas-disponibles',
        method: 'GET',
        isArray: true
      },
      listarPreguntas: {
        url: URL_SERVIDOR + 'encuestas/preguntas',
        method: 'POST'
      },
      guardar: {
        url: URL_SERVIDOR + 'encuestas/',
        method: 'POST'
      }
    });
  

  /*resource.listarDisponibles = function (){
    return {$promise: [
      {
          "persona": {
              "id": 9124,
              "nombre": "RUBÉN",
              "apellido": "BACCIFAVA",
              "documento": 18573013,
              "telefono": "0353-155081888",
              "email": "rubenbaccifava@hotmail.com",
              "alumno": null,
              "docente": {
                  "id": 139,
                  "legajo": "25762"
              },
              "telefonoInternacional": "3535081888"
          },
          "cargoDocente": {
              "id": 294,
              "asignatura": {
                  "id": 13433,
                  "nombre": "Proyecto Final (Integración V)",
                  "codigo": 521,
                  "anio": 5,
                  "planAsignatura": {
                      "id": 33,
                      "nombre": "95"
                  },
                  "especialidad": {
                      "id": 337,
                      "nombre": "Ingeniería Química",
                      "codigo": "27",
                      "abreviatura": null,
                      "codigoDepartamento": "V"
                  }
              },
              "docente": {
                  "id": 139,
                  "legajo": "25762"
              },
              "tipoDictado": {
                  "id": 1,
                  "nombre": "Anual"
              },
              "tipoCargoDocente": {
                  "id": 2,
                  "nombre": "Auxiliar"
              }
          },
          "encuestaRealizada": false
      },
      {
          "persona": {
              "id": 9213,
              "nombre": "ROGER",
              "apellido": "ILLANES",
              "documento": 5088413,
              "telefono": "0353-154091416",
              "email": "rillanes@frvm.utn.edu.ar",
              "alumno": {
                  "legajo": "5323",
                  "especialidad": {
                      "id": 395,
                      "nombre": "Maestría en Tecnología de los Alimentos",
                      "codigoAcademico": "107"
                  }
              },
              "docente": {
                  "id": 228,
                  "legajo": "9356"
              },
              "telefonoInternacional": "3534091416"
          },
          "cargoDocente": {
              "id": 293,
              "asignatura": {
                  "id": 13433,
                  "nombre": "Proyecto Final (Integración V)",
                  "codigo": 521,
                  "anio": 5,
                  "planAsignatura": {
                      "id": 33,
                      "nombre": "95"
                  },
                  "especialidad": {
                      "id": 337,
                      "nombre": "Ingeniería Química",
                      "codigo": "27",
                      "abreviatura": null,
                      "codigoDepartamento": "V"
                  }
              },
              "docente": {
                  "id": 228,
                  "legajo": "9356"
              },
              "tipoDictado": {
                  "id": 1,
                  "nombre": "Anual"
              },
              "tipoCargoDocente": {
                  "id": 1,
                  "nombre": "Titular"
              }
          },
          "encuestaRealizada": false
      },
      {
          "persona": {
              "id": 13356,
              "nombre": "LUCIANO",
              "apellido": "CESARINI",
              "documento": null,
              "telefono": null,
              "email": null,
              "alumno": null,
              "docente": {
                  "id": 610,
                  "legajo": "123"
              },
              "telefonoInternacional": null
          },
          "cargoDocente": {
              "id": 1209,
              "asignatura": {
                  "id": 13433,
                  "nombre": "Proyecto Final (Integración V)",
                  "codigo": 521,
                  "anio": 5,
                  "planAsignatura": {
                      "id": 33,
                      "nombre": "95"
                  },
                  "especialidad": {
                      "id": 337,
                      "nombre": "Ingeniería Química",
                      "codigo": "27",
                      "abreviatura": null,
                      "codigoDepartamento": "V"
                  }
              },
              "docente": {
                  "id": 610,
                  "legajo": "123"
              },
              "tipoDictado": {
                  "id": 1,
                  "nombre": "Anual"
              },
              "tipoCargoDocente": {
                  "id": 1,
                  "nombre": "Titular"
              }
          },
          "encuestaRealizada": false
      },
      {
          "persona": {
              "id": 9293,
              "nombre": "JOSÉ",
              "apellido": "REYNOSO",
              "documento": 22999186,
              "telefono": "0353-154094986",
              "email": "ingjosereynoso@yahoo.com.ar",
              "alumno": null,
              "docente": {
                  "id": 308,
                  "legajo": "36277"
              },
              "telefonoInternacional": "3534094986"
          },
          "cargoDocente": {
              "id": 1011,
              "asignatura": {
                  "id": 13422,
                  "nombre": "Biotecnología",
                  "codigo": 432,
                  "anio": 4,
                  "planAsignatura": {
                      "id": 33,
                      "nombre": "95"
                  },
                  "especialidad": {
                      "id": 337,
                      "nombre": "Ingeniería Química",
                      "codigo": "27",
                      "abreviatura": null,
                      "codigoDepartamento": "V"
                  }
              },
              "docente": {
                  "id": 308,
                  "legajo": "36277"
              },
              "tipoDictado": {
                  "id": 2,
                  "nombre": "Primer Cuatrimestre"
              },
              "tipoCargoDocente": {
                  "id": 1,
                  "nombre": "Titular"
              }
          },
          "encuestaRealizada": false
      },
      {
          "persona": {
              "id": 9368,
              "nombre": "ALDANA",
              "apellido": "CHESTA",
              "documento": 27897013,
              "telefono": "0353-154137555",
              "email": "chaldana@gmail.com",
              "alumno": null,
              "docente": {
                  "id": 383,
                  "legajo": "55873"
              },
              "telefonoInternacional": "3534137555"
          },
          "cargoDocente": {
              "id": 1010,
              "asignatura": {
                  "id": 13422,
                  "nombre": "Biotecnología",
                  "codigo": 432,
                  "anio": 4,
                  "planAsignatura": {
                      "id": 33,
                      "nombre": "95"
                  },
                  "especialidad": {
                      "id": 337,
                      "nombre": "Ingeniería Química",
                      "codigo": "27",
                      "abreviatura": null,
                      "codigoDepartamento": "V"
                  }
              },
              "docente": {
                  "id": 383,
                  "legajo": "55873"
              },
              "tipoDictado": {
                  "id": 2,
                  "nombre": "Primer Cuatrimestre"
              },
              "tipoCargoDocente": {
                  "id": 2,
                  "nombre": "Auxiliar"
              }
          },
          "encuestaRealizada": false
      },
      {
          "persona": {
              "id": 9752,
              "nombre": "NOELIA",
              "apellido": "BERGERO",
              "documento": 27444411,
              "telefono": "0353-155109649",
              "email": "bergeronoe@gmail.com",
              "alumno": null,
              "docente": {
                  "id": 457,
                  "legajo": "75597"
              },
              "telefonoInternacional": "3535109649"
          },
          "cargoDocente": {
              "id": 1140,
              "asignatura": {
                  "id": 13385,
                  "nombre": "Economía",
                  "codigo": 308,
                  "anio": 3,
                  "planAsignatura": {
                      "id": 33,
                      "nombre": "95"
                  },
                  "especialidad": {
                      "id": 337,
                      "nombre": "Ingeniería Química",
                      "codigo": "27",
                      "abreviatura": null,
                      "codigoDepartamento": "V"
                  }
              },
              "docente": {
                  "id": 457,
                  "legajo": "75597"
              },
              "tipoDictado": {
                  "id": 2,
                  "nombre": "Primer Cuatrimestre"
              },
              "tipoCargoDocente": {
                  "id": 1,
                  "nombre": "Titular"
              }
          },
          "encuestaRealizada": false
      },
      {
          "persona": {
              "id": 9253,
              "nombre": "JULIO",
              "apellido": "NOBREGA",
              "documento": 10652195,
              "telefono": "0353-154013766",
              "email": "julionobrega@nobregalascano.com.ar",
              "alumno": null,
              "docente": {
                  "id": 268,
                  "legajo": "35515"
              },
              "telefonoInternacional": "3534013766"
          },
          "cargoDocente": {
              "id": 296,
              "asignatura": {
                  "id": 13386,
                  "nombre": "Legislación",
                  "codigo": 309,
                  "anio": 3,
                  "planAsignatura": {
                      "id": 33,
                      "nombre": "95"
                  },
                  "especialidad": {
                      "id": 337,
                      "nombre": "Ingeniería Química",
                      "codigo": "27",
                      "abreviatura": null,
                      "codigoDepartamento": "V"
                  }
              },
              "docente": {
                  "id": 268,
                  "legajo": "35515"
              },
              "tipoDictado": {
                  "id": 2,
                  "nombre": "Primer Cuatrimestre"
              },
              "tipoCargoDocente": {
                  "id": 1,
                  "nombre": "Titular"
              }
          },
          "encuestaRealizada": false
      },
      {
          "persona": {
              "id": 13308,
              "nombre": "DANIEL",
              "apellido": "GILLI",
              "documento": 28734187,
              "telefono": "0353-154124282",
              "email": "gillidaniel@gmail.com",
              "alumno": null,
              "docente": {
                  "id": 590,
                  "legajo": "86431"
              },
              "telefonoInternacional": "3534124282"
          },
          "cargoDocente": {
              "id": 1143,
              "asignatura": {
                  "id": 13445,
                  "nombre": "Control Automático de Procesos",
                  "codigo": 536,
                  "anio": 5,
                  "planAsignatura": {
                      "id": 33,
                      "nombre": "95"
                  },
                  "especialidad": {
                      "id": 337,
                      "nombre": "Ingeniería Química",
                      "codigo": "27",
                      "abreviatura": null,
                      "codigoDepartamento": "V"
                  }
              },
              "docente": {
                  "id": 590,
                  "legajo": "86431"
              },
              "tipoDictado": {
                  "id": 2,
                  "nombre": "Primer Cuatrimestre"
              },
              "tipoCargoDocente": {
                  "id": 1,
                  "nombre": "Titular"
              }
          },
          "encuestaRealizada": true
      }
  ]};
  };
  resource.listarPreguntas = function() {
    return {
      $promise: {
        "idEncuesta": null,
        "codigoDep": 24,
        "id": 1,
        "persona": {
            "id": 9124,
            "nombre": "RUBÉN",
            "apellido": "BACCIFAVA",
            "documento": 18573013,
            "telefono": "0353-155081888",
            "email": "rubenbaccifava@hotmail.com",
            "alumno": null,
            "docente": {
                "id": 139,
                "legajo": "25762"
            },
            "telefonoInternacional": "3535081888"
        },
        "docente": {
            "id": 139,
            "legajo": "25762"
        },
        "codigoDepartamento": "27",
        "asignatura": {
            "id": 13433,
            "nombre": "Proyecto Final (Integración V)",
            "codigo": 521,
            "anio": 5,
            "planAsignatura": {
                "id": 33,
                "nombre": "95"
            },
            "especialidad": {
                "id": 337,
                "nombre": "Ingeniería Química",
                "codigo": "27",
                "abreviatura": null,
                "codigoDepartamento": "V"
            }
        },
        "anio": 5,
        "comision": 1,
        "tipoCargoDocente": {
            "id": 2,
            "nombre": "Auxiliar"
        },
        "encuestaDto": null,
        "detalles": [
            {
                "id": null,
                "pregunta": {
                    "id": 12,
                    "pregunta": "Asiste regularmente a clase",
                    "tipoCargoDocente": {
                        "id": 2,
                        "nombre": "Auxiliar"
                    },
                    "tipoPregunta": {
                        "id": 3,
                        "nombre": "radius"
                    },
                    "ordenPregunta": 1,
                    "grupoPregunta": "A"
                },
                "respuesta": null,
                "opinion": null
            },
            {
                "id": null,
                "pregunta": {
                    "id": 13,
                    "pregunta": "Observa puntualidad al llegar y al irse",
                    "tipoCargoDocente": {
                        "id": 2,
                        "nombre": "Auxiliar"
                    },
                    "tipoPregunta": {
                        "id": 3,
                        "nombre": "radius"
                    },
                    "ordenPregunta": 2,
                    "grupoPregunta": "A"
                },
                "respuesta": null,
                "opinion": null
            },
            {
                "id": null,
                "pregunta": {
                    "id": 14,
                    "pregunta": "Trata correctamente a los estudiantes",
                    "tipoCargoDocente": {
                        "id": 2,
                        "nombre": "Auxiliar"
                    },
                    "tipoPregunta": {
                        "id": 3,
                        "nombre": "radius"
                    },
                    "ordenPregunta": 11,
                    "grupoPregunta": "B"
                },
                "respuesta": null,
                "opinion": null
            },
            {
                "id": null,
                "pregunta": {
                    "id": 15,
                    "pregunta": "Las explicaciones son claras y comprensibles",
                    "tipoCargoDocente": {
                        "id": 2,
                        "nombre": "Auxiliar"
                    },
                    "tipoPregunta": {
                        "id": 3,
                        "nombre": "radius"
                    },
                    "ordenPregunta": 13,
                    "grupoPregunta": "B"
                },
                "respuesta": null,
                "opinion": null
            },
            {
                "id": null,
                "pregunta": {
                    "id": 16,
                    "pregunta": "Acepta consultas y las satisface",
                    "tipoCargoDocente": {
                        "id": 2,
                        "nombre": "Auxiliar"
                    },
                    "tipoPregunta": {
                        "id": 3,
                        "nombre": "radius"
                    },
                    "ordenPregunta": 15,
                    "grupoPregunta": "B"
                },
                "respuesta": null,
                "opinion": null
            },
            {
                "id": null,
                "pregunta": {
                    "id": 17,
                    "pregunta": "Promueve el trabajo en equipo",
                    "tipoCargoDocente": {
                        "id": 2,
                        "nombre": "Auxiliar"
                    },
                    "tipoPregunta": {
                        "id": 3,
                        "nombre": "radius"
                    },
                    "ordenPregunta": 18,
                    "grupoPregunta": "C"
                },
                "respuesta": null,
                "opinion": null
            },
            {
                "id": null,
                "pregunta": {
                    "id": 18,
                    "pregunta": "Realice las observaciones que crea convenientes",
                    "tipoCargoDocente": {
                        "id": 2,
                        "nombre": "Auxiliar"
                    },
                    "tipoPregunta": {
                        "id": 1,
                        "nombre": "text"
                    },
                    "ordenPregunta": 25,
                    "grupoPregunta": "X"
                },
                "respuesta": null,
                "opinion": null
            },
            {
                "id": null,
                "pregunta": {
                    "id": 19,
                    "pregunta": "Corrige los trabajos prácticos en tiempo y forma",
                    "tipoCargoDocente": {
                        "id": 2,
                        "nombre": "Auxiliar"
                    },
                    "tipoPregunta": {
                        "id": 3,
                        "nombre": "radius"
                    },
                    "ordenPregunta": 3,
                    "grupoPregunta": "A"
                },
                "respuesta": null,
                "opinion": null
            },
            {
                "id": null,
                "pregunta": {
                    "id": 21,
                    "pregunta": "Presenta guía de problemas y/o material para TPs",
                    "tipoCargoDocente": {
                        "id": 2,
                        "nombre": "Auxiliar"
                    },
                    "tipoPregunta": {
                        "id": 3,
                        "nombre": "radius"
                    },
                    "ordenPregunta": 4,
                    "grupoPregunta": "A"
                },
                "respuesta": null,
                "opinion": null
            },
            {
                "id": null,
                "pregunta": {
                    "id": 24,
                    "pregunta": "Demuestra seguridad en la resolución de problemas y el tratamiento de los temas",
                    "tipoCargoDocente": {
                        "id": 2,
                        "nombre": "Auxiliar"
                    },
                    "tipoPregunta": {
                        "id": 3,
                        "nombre": "radius"
                    },
                    "ordenPregunta": 8,
                    "grupoPregunta": "B"
                },
                "respuesta": null,
                "opinion": null
            },
            {
                "id": null,
                "pregunta": {
                    "id": 29,
                    "pregunta": "Orienta sobre el uso de la bibliografía recomendada por el profesor",
                    "tipoCargoDocente": {
                        "id": 2,
                        "nombre": "Auxiliar"
                    },
                    "tipoPregunta": {
                        "id": 3,
                        "nombre": "radius"
                    },
                    "ordenPregunta": 16,
                    "grupoPregunta": "B"
                },
                "respuesta": null,
                "opinion": null
            },
            {
                "id": null,
                "pregunta": {
                    "id": 30,
                    "pregunta": "Utiliza correctamente lo recursos para enseñanza (pizarra, filminas, proyector, software, etc.)",
                    "tipoCargoDocente": {
                        "id": 2,
                        "nombre": "Auxiliar"
                    },
                    "tipoPregunta": {
                        "id": 3,
                        "nombre": "radius"
                    },
                    "ordenPregunta": 17,
                    "grupoPregunta": "B"
                },
                "respuesta": null,
                "opinion": null
            },
            {
                "id": null,
                "pregunta": {
                    "id": 34,
                    "pregunta": "Al enfrentar los prácticos tiene la preparación previa adecuada",
                    "tipoCargoDocente": {
                        "id": 2,
                        "nombre": "Auxiliar"
                    },
                    "tipoPregunta": {
                        "id": 3,
                        "nombre": "radius"
                    },
                    "ordenPregunta": 22,
                    "grupoPregunta": "D"
                },
                "respuesta": null,
                "opinion": null
            },
            {
                "id": null,
                "pregunta": {
                    "id": 36,
                    "pregunta": "Mencione las características del docente que ayudaron en su aprendizaje",
                    "tipoCargoDocente": {
                        "id": 2,
                        "nombre": "Auxiliar"
                    },
                    "tipoPregunta": {
                        "id": 1,
                        "nombre": "text"
                    },
                    "ordenPregunta": 23,
                    "grupoPregunta": "X"
                },
                "respuesta": null,
                "opinion": null
            },
            {
                "id": null,
                "pregunta": {
                    "id": 38,
                    "pregunta": "Mencione los aspectos del proceso de enseñanza que pueden mejorarse",
                    "tipoCargoDocente": {
                        "id": 2,
                        "nombre": "Auxiliar"
                    },
                    "tipoPregunta": {
                        "id": 1,
                        "nombre": "text"
                    },
                    "ordenPregunta": 24,
                    "grupoPregunta": "X"
                },
                "respuesta": null,
                "opinion": null
            },
            {
                "id": null,
                "pregunta": {
                    "id": 40,
                    "pregunta": "La corrección de los TPs es clara y contribuye  a la comprensión de la práctica realizada",
                    "tipoCargoDocente": {
                        "id": 2,
                        "nombre": "Auxiliar"
                    },
                    "tipoPregunta": {
                        "id": 3,
                        "nombre": "radius"
                    },
                    "ordenPregunta": 5,
                    "grupoPregunta": "B"
                },
                "respuesta": null,
                "opinion": null
            },
            {
                "id": null,
                "pregunta": {
                    "id": 41,
                    "pregunta": "Planifica el desarrollo de las prácticas",
                    "tipoCargoDocente": {
                        "id": 2,
                        "nombre": "Auxiliar"
                    },
                    "tipoPregunta": {
                        "id": 3,
                        "nombre": "radius"
                    },
                    "ordenPregunta": 6,
                    "grupoPregunta": "B"
                },
                "respuesta": null,
                "opinion": null
            },
            {
                "id": null,
                "pregunta": {
                    "id": 42,
                    "pregunta": "Explica con claridad los propósitos / objetivos de la práctica",
                    "tipoCargoDocente": {
                        "id": 2,
                        "nombre": "Auxiliar"
                    },
                    "tipoPregunta": {
                        "id": 3,
                        "nombre": "radius"
                    },
                    "ordenPregunta": 7,
                    "grupoPregunta": "B"
                },
                "respuesta": null,
                "opinion": null
            },
            {
                "id": null,
                "pregunta": {
                    "id": 43,
                    "pregunta": "Relaciona la práctica con situaciones de la vida profesional",
                    "tipoCargoDocente": {
                        "id": 2,
                        "nombre": "Auxiliar"
                    },
                    "tipoPregunta": {
                        "id": 3,
                        "nombre": "radius"
                    },
                    "ordenPregunta": 9,
                    "grupoPregunta": "B"
                },
                "respuesta": null,
                "opinion": null
            },
            {
                "id": null,
                "pregunta": {
                    "id": 44,
                    "pregunta": "Relaciona la práctica con los conceptos desarrollados en la teoría",
                    "tipoCargoDocente": {
                        "id": 2,
                        "nombre": "Auxiliar"
                    },
                    "tipoPregunta": {
                        "id": 3,
                        "nombre": "radius"
                    },
                    "ordenPregunta": 10,
                    "grupoPregunta": "B"
                },
                "respuesta": null,
                "opinion": null
            },
            {
                "id": null,
                "pregunta": {
                    "id": 45,
                    "pregunta": "Favorece la participación de los estudiantes",
                    "tipoCargoDocente": {
                        "id": 2,
                        "nombre": "Auxiliar"
                    },
                    "tipoPregunta": {
                        "id": 3,
                        "nombre": "radius"
                    },
                    "ordenPregunta": 12,
                    "grupoPregunta": "B"
                },
                "respuesta": null,
                "opinion": null
            },
            {
                "id": null,
                "pregunta": {
                    "id": 46,
                    "pregunta": "Cumple con la panificación de las prácticas aplicas y de laboratorio",
                    "tipoCargoDocente": {
                        "id": 2,
                        "nombre": "Auxiliar"
                    },
                    "tipoPregunta": {
                        "id": 3,
                        "nombre": "radius"
                    },
                    "ordenPregunta": 14,
                    "grupoPregunta": "B"
                },
                "respuesta": null,
                "opinion": null
            },
            {
                "id": null,
                "pregunta": {
                    "id": 48,
                    "pregunta": "Encuentra el laboratorio preparado para las prácticas",
                    "tipoCargoDocente": {
                        "id": 2,
                        "nombre": "Auxiliar"
                    },
                    "tipoPregunta": {
                        "id": 3,
                        "nombre": "radius"
                    },
                    "ordenPregunta": 19,
                    "grupoPregunta": "C"
                },
                "respuesta": null,
                "opinion": null
            },
            {
                "id": null,
                "pregunta": {
                    "id": 49,
                    "pregunta": "Utilizó o relaciono los conceptos teóricos en el desarrollo de los prácticos",
                    "tipoCargoDocente": {
                        "id": 2,
                        "nombre": "Auxiliar"
                    },
                    "tipoPregunta": {
                        "id": 3,
                        "nombre": "radius"
                    },
                    "ordenPregunta": 20,
                    "grupoPregunta": "D"
                },
                "respuesta": null,
                "opinion": null
            },
            {
                "id": null,
                "pregunta": {
                    "id": 50,
                    "pregunta": "La experimentación en el laboratorio y/o la resolución de los problemas permitío comprenderlas",
                    "tipoCargoDocente": {
                        "id": 2,
                        "nombre": "Auxiliar"
                    },
                    "tipoPregunta": {
                        "id": 3,
                        "nombre": "radius"
                    },
                    "ordenPregunta": 21,
                    "grupoPregunta": "D"
                },
                "respuesta": null,
                "opinion": null
            }
        ],
        "tipoRespuesta": null
    }
    }
  };*/
  return resource;
    }
})();


(function () {
  'use strict';

  angular.module('administracionNotificaciones')
    .factory('DocumentacionDocentes', DocumentacionDocentes);

  function DocumentacionDocentes($resource, $http, URL_SERVIDOR) {
    var DocumentacionDocentes = $resource(URL_SERVIDOR + 'documentacion-docente/:id', { id: '@id' }, {
      getDocumentacionMateria: {
        url: URL_SERVIDOR + 'documentacion-docente/:anoacademi/:especialid/:plan/:materia/:comision',
        method: 'GET',
        params: {
          anoacademi: '@anoacademi',
          especialid: '@especialid',
          plan: '@plan',
          materia: '@materia',
          comision: '@comision'
        }
      },
      listarPorEspecialidad: {
        url: URL_SERVIDOR + 'documentacion-docente/documentacion-especialidad/:anio',
        method: 'GET',
        isArray: true,
        params: {
          anio: '@anio'
        }
      },
      cambiarEstado: {
        url: URL_SERVIDOR + 'documentacion-docente/:idDocumentacion/cambiar-estado',
        method: 'PUT',
        params: {
          idDocumentacion: '@idDocumentacion'
        }
      }
    });
    DocumentacionDocentes.config = {
      female: false,
      icon: 'fa fa-file',
      name: 'Documentación',
      pluralName: 'Documentación',
      order: 8,
      resource: {
        name: 'DocumentacionDocentes',
        methods: {
          listarPorEspecialidad: {
            name: 'listarPorEspecialidad',
            params: true
          }
        }
      }
    };

    DocumentacionDocentes.descargarArchivo = function (id) {

      return $http.get(URL_SERVIDOR + '/documentacion-docente/' + id + '/archivo', {
        responseType: 'arraybuffer'
      }).then(function (response) {
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      });
    };

    DocumentacionDocentes.descargarTodosArchivo = function (filtros) {
      return $http.get(URL_SERVIDOR + 'documentacion-docente/descargar-documentacion-especialidad/' + filtros.anio, {
        responseType: 'blob',  // Cambiado a blob para manejar archivos binarios
        params: filtros
      }).then(function (response) {
        // Crear el Blob para el archivo ZIP
        var file = new Blob([response.data], {
          type: 'application/zip'
        });

        // Nombre del archivo descargado
        var fileName = 'documentacion_especialidad_' + filtros.anio + '.zip';

        // Guardar el archivo usando FileSaver.js
        if (window.saveAs) {
          window.saveAs(file, fileName);
        } else {
          // Fallback manual en caso de que no esté disponible FileSaver
          var fileURL = URL.createObjectURL(file);
          var a = document.createElement('a');
          a.href = fileURL;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }).catch(function (error) {
        console.error('Error al descargar el archivo:', error);
      });
    };


    return DocumentacionDocentes;
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').factory('DocenteHorarioCursado', DocenteHorarioCursado);

  function DocenteHorarioCursado($resource, URL_SERVIDOR) {
    return $resource(URL_SERVIDOR + 'academica/docentes/', {}, {
      docentes: {
        url: URL_SERVIDOR + 'persona/docentes',
        method: 'GET',
        isArray: true,
        params: {
          filtro: '@filtro'
        }
      },
      horariosDictado: {
        url: URL_SERVIDOR + 'academica/docentes/horarios-dictado',
        method: 'GET',
        isArray: true
      },
      horariosDictadoLegajo: {
        url: URL_SERVIDOR + 'academica/docentes/horarios-dictado-legajo',
        method: 'GET',
        isArray: true,
        params: {
          legajo: '@legajo'
        }
      }
    });
  }

})();

(function() {
    'use strict';
  
    angular.module('administracionNotificaciones').factory('DetalleCalendario', DetalleCalendario);
  
    function DetalleCalendario($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR + 'calendario/detalles', {}, {
        obtenerCalendario: {
            url: URL_SERVIDOR + 'calendario/detalles',
            method: 'GET',
            isArray: true
        }
      });
    }
  
  })();
(function () {
    'use strict';
  
    angular.module('administracionNotificaciones')
      .factory('Descargas', Descargas);
  
    function Descargas($resource, URL_SERVIDOR, $http) {
      var Descargas = $resource(URL_SERVIDOR + 'descarga/documentos', {
  
      }, {
        getDocumentoss: {
          url: URL_SERVIDOR + 'descarga/documentos',
          method: 'GET'
        }
      });
      Descargas.config = {
        female: true,
        name: 'Descargas',
        pluralName: 'Descargas',
        icon: 'fa fa-download',
        resource: {
          name: 'Descargas',
          methods: {
            getDocumentos: {
              name: 'getDocumentos',
              params: true
            }
          }
        },
        order: 80
      };
      Descargas.descargarArchivo = function (archivo) {
        //no me anda la url
        return $http.get(URL_SERVIDOR + 'descarga/documentos/' + archivo.id + '/descargar', {
          responseType: 'arraybuffer'
        }).then(function (response) {
          var file = new Blob([response.data], {
            type: 'application/pdf'
          });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        });
      };

      return Descargas;
    }

   

  })();
(function () {
  'use strict';

  angular.module('administracionNotificaciones').factory('Curso', Curso);

  function Curso($resource, $http, $timeout, URL_SERVIDOR) {
    var Curso = $resource(URL_SERVIDOR + 'cursos/:codigo/', {
      codigo: '@id'
    },
      {
        get: {
          url: URL_SERVIDOR + 'cursos/:id',
          method: 'GET',
          params: {
            id: '@id'
          }
        },
        listar: {
          url: URL_SERVIDOR + '/cursos',
          method: 'GET'
        },
        nuevo: {
          url: URL_SERVIDOR + '/cursos',
          method: 'POST'
        },
        listarConceptos: {
          url: URL_SERVIDOR + 'cursos/:id/conceptos',
          method: 'GET',
          params: { id: '@id' },
          isArray: true
        },
        getConceptData: {
          url: URL_SERVIDOR + 'cursos/:id_curso/conceptos/:id',
          method: 'GET',
          params: { id: '@id', id_curso: '@id_curso' }
        },
        editConceptData: {
          url: URL_SERVIDOR + 'cursos/:id_curso/conceptos/:id',
          method: 'PUT',
          params: { id: '@id', id_curso: '@id_curso' }
        },
        editarConcepto: {
          url: URL_SERVIDOR + 'cursos/:id/conceptos',
          method: 'GET',
          params: { id: '@id' },
          isArray: true
        }

      });
    
    Curso.config = {
      icon: 'fa fa-credit-card',
      order: 7,
      resource: {
        methods: {
          listar: {
            name: 'listar',
            params: true
          },
          nuevo: {
            name: 'nuevo',
            params: true
          },
          listarConceptos: {
            name: 'listarConceptos',
            params: true
          },
          editConceptData: {
            name: 'editConceptData',
            params: true
          },
          getConceptData: {
            name: 'getConceptData',
            params: true
          }
        }
      }
    };
    return Curso;
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones')
    .factory('ControlDiarioReloj', ControlDiarioReloj);

  function ControlDiarioReloj($resource, URL_LICENCIAS) {
    var ControlDiarioReloj = $resource(URL_LICENCIAS + 'reloj/eventos/dia/:fecha', { fecha: '@fecha' }, {
      query: {
        url: URL_LICENCIAS + 'reloj/eventos/dia/:fecha',
        method: 'GET',
        isArray: true
      },
      queryByPeriodo : {
        url: URL_LICENCIAS + 'reloj/eventos/periodo/:idPersonal',
        method: 'GET',
        isArray: true
      }
    });
    ControlDiarioReloj.config = {
      female: false,
      icon: 'fa fa-medkit',
      name: 'Control Diario',
      pluralName: 'Control Diario',
      order: 8,
      resource: {
        name: 'ControlDiarioReloj',
        methods: {
          queryByPeriodo: {
            name: 'queryByPeriodo',
            params: true
          }
        }
      }
    };
    return ControlDiarioReloj;
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones')
    .factory('ConfiguracionCierreComision', ConfiguracionCierreComision);

  function ConfiguracionCierreComision($resource, URL_SERVIDOR) {
    var ConfiguracionCierreComision = $resource(URL_SERVIDOR + 'ConfiguracionCierreComision/:id', { id: '@id' }, {
    });
    ConfiguracionCierreComision.config = {
      female: false,
      icon: 'fa fa-medkit',
      name: 'Configuración Cierre de Comisión',
      pluralName: 'Configuración cierre de Comisión',
      order: 8,
      resource: {
        name: 'ConfiguracionCierreComision'
      }
    };
    return ConfiguracionCierreComision;
  }
})();

(function() {
  'use strict';

  angular.module('administracionNotificaciones').factory('Certificado', Certificado);

  function Certificado($resource, URL_SERVIDOR) {
    return $resource(URL_SERVIDOR + 'certificados',{},{
      solicitar: {
        url: URL_SERVIDOR + 'certificados/solicitar',
        method: 'POST'
      }
    });
  }

})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones')
    .factory('Categoria', Categoria);

  function Categoria($resource, URL_SERVIDOR) {
    var Categoria = $resource(URL_SERVIDOR + 'categorias-notificacion/:id', {
      id: '@id'
    }, {
      obtenerCategoria: {
        url: URL_SERVIDOR + 'categorias-notificacion/:id',
        method: 'GET',
        params: {
          id: '@id'
        }
      },
      update: {
        url: URL_SERVIDOR + 'categorias-notificacion/:id',
        method: 'PUT'
      },
      nuevaCategoria: {
        url: URL_SERVIDOR + 'categorias-notificacion',
        method: 'POST'
      }
    });
    Categoria.config = {
      female: true,
      name: 'Categoría',
      icon: 'fa fa-tag',
      resource: {
        name: 'Categoria'
      },
      order: 2
    };
    return Categoria;
  }
})();

(function() {
  'use strict';
  
  angular.module('administracionNotificaciones').factory('CargoDocente', CargoDocente);
  
  function CargoDocente($resource, URL_SERVIDOR) {
    var CargoDocente = $resource(URL_SERVIDOR + 'docente/cargos', {}, {
      obtenerCargos: {
        url: URL_SERVIDOR + 'docente/cargos',
        method: 'GET'
      }
    });
    CargoDocente.config = {
      resource: {
        name: 'CargoDocente',
        methods: {
          obtenerCargos: {
            name: 'obtenerCargos'
          }
        }
      },
      order: 20
    };

    return CargoDocente;
  }
  
})();
(function () {
  angular
    .module('administracionNotificaciones')
    .factory('CargaLibroDeTemas', CargaLibroDeTemas);

  // function CargaLibroDeTemas($q) {
  function CargaLibroDeTemas($resource, URL_SERVIDOR) {
    var CargaLibroDeTemas = $resource(
      URL_SERVIDOR + 'libro-de-temas/:id',
      {
        id: '@id'
      },
      {
        get: {
          url:
            URL_SERVIDOR +
            'libro-de-temas/fechas-dictado/:especialid-:plan-:materia-:anoacademi-:comision/:fecha/:hora',
          method: 'GET',
          params: {
            anoacademi: '@anoacademi',
            especialid: '@especialid',
            plan: '@plan',
            materia: '@materia',
            comision: '@comision',
            fecha: '@fecha',
            hora: '@hora'
          }
        },
        update: {
          url: URL_SERVIDOR + 'libro-de-temas/cargar-clase/:id',
          method: 'PUT'
        },
        save: {
          url: URL_SERVIDOR + 'libro-de-temas/cargar-clase',
          method: 'POST'
        },
        getFechasDictado: {
          url:
            URL_SERVIDOR +
            'libro-de-temas/fechas-dictado/:especialidad-:plan-:materia-:anioAcademico-:comision',
          method: 'GET',
          params: {
            anioAcademico: '@anioAcademico',
            especialidad: '@especialidad',
            plan: '@plan',
            materia: '@materia',
            comision: '@comision'
          },
          isArray: true
        },
        getTipoClase: {
          url: URL_SERVIDOR + 'libro-de-temas/tipos-clase',
          method: 'GET',
          isArray: true
        },
        getCaracterClase: {
          url: URL_SERVIDOR + 'libro-de-temas/caracters-clase',
          method: 'GET',
          isArray: true
        },
        getCompetencia: {
          url: URL_SERVIDOR + 'libro-de-temas/competencias',
          method: 'GET',
          isArray: true
        },
        getModoImplementacionAulaVirtual: {
          url: URL_SERVIDOR + 'libro-de-temas/usos-aula',
          method: 'GET',
          isArray: true
        },
        getHerramientas: {
          url: URL_SERVIDOR + 'libro-de-temas/herramientas',
          method: 'GET',
          isArray: true
        },
        getActividades: {
          url: URL_SERVIDOR + 'libro-de-temas/actividades',
          method: 'GET',
          isArray: true
        },
        cargarClase: {
          url: URL_SERVIDOR + 'libro-de-temas/cargar-clase/:id',
          method: 'POST',
          params: {
            id: '@id'
          }
        },
        listarPorEspecialidad: {
          url: URL_SERVIDOR + 'libro-de-temas/materias-especialidad/:anio',
          method: 'GET',
          isArray: true,
          params: {
            anio: '@anio'
          }
        },
        getMateria: {
          url:
            URL_SERVIDOR +
            'libro-de-temas/:anoacademi/:especialid/:plan/:materia/:comision',
          method: 'GET',
          params: {
            anoacademi: '@anoacademi',
            especialid: '@especialid',
            plan: '@plan',
            materia: '@materia',
            comision: '@comision'
          }
        }
      }
    );

    CargaLibroDeTemas.config = {
      female: true,
      name: 'CargaLibroDeTema',
      displayName: 'carga de libro de tema',
      pluralName: 'Libro de Temas',
      icon: 'fa fa-tag',
      resource: {
        name: 'CargaLibroDeTemas',
        methods: {
          getFechasDictado: {
            name: 'getFechasDictado',
            params: true
          },
          cargarClase: {
            name: 'cargarClase',
            params: true
          },
          listarPorEspecialidad: {
            name: 'listarPorEspecialidad',
            params: true
          }
        }
      },
      order: 2
    };

    return CargaLibroDeTemas;
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').factory('AulaHorarioCursado', AulaHorarioCursado);

  function AulaHorarioCursado($resource, URL_SERVIDOR) {
    return $resource(URL_SERVIDOR + 'academica/aulas/', {}, {
      edificios: {
        url: URL_SERVIDOR + 'academica/aulas/edificios',
        method: 'GET',
        isArray: true
      },
      aulas: {
        url: URL_SERVIDOR + 'academica/aulas/edificios/:id/aulas',
        method: 'GET',
        isArray: true,
        params: {
          id: '@id'
        }
      },
      horariosDictado: {
        url: URL_SERVIDOR + 'academica/aulas/:edificio/:aula/horarios-dictado',
        method: 'GET',
        isArray: true,
        params: {
          edificio: '@edificio',
          aula: '@aula'
        }
      }
    });
  }

})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').factory('AnaliticaEncuesta', AnaliticaEncuesta);

  function AnaliticaEncuesta($resource, URL_SERVIDOR) {
    var AnaliticaEncuesta = $resource(URL_SERVIDOR + 'encuesta/dashboard/', {
      codigo: '@id',
      especialidad: '@especialidad',
      comision: '@comision',
      materia: '@materia',
      plan: '@plan',
    },
      {
        obtenerLink: {
          url: URL_SERVIDOR + 'analitica/dashboard/encuestas/:codigo/solicitar-link',
          method: 'POST'
        },
        obtenerLinkComparativa: {
            url: URL_SERVIDOR + 'analitica/dashboard/encuestas/comparativas/:codigo/especialidad/:especialidad/comision/:comision/plan/:plan/materia/:materia/solicitar-link-comparativa',
            method: 'POST'
        }

      });

    AnaliticaEncuesta.obtenerInformesDisponibles = function() {
        //devuelvo un array de enteros
      return [{id: 50, nombre: 'Estadísticas'} ,{id: 49, nombre: 'Encuestas Ponderadas'},{id: 48, nombre: 'Encuestas Comparativa'}];
    };
    return AnaliticaEncuesta;
  }

})();


(function () {
  'use strict';

  angular.module('administracionNotificaciones').factory('AnaliticaDocente', AnaliticaDocente);

  function AnaliticaDocente($resource, URL_SERVIDOR) {
    var AnaliticaDocente = $resource(URL_SERVIDOR + 'analitica/dashboard/', {
      codigo: '@id'
    },
      {
        obtenerLink: {
          url: URL_SERVIDOR + 'analitica/dashboard/:codigo/solicitar-link',
          method: 'POST'
        }

      });
    AnaliticaDocente.obtenerInformesDisponibles = function() {
        //devuelvo un array de enteros
      return [{id: 32, nombre: 'Informe de Regularidad'} ,{id: 33, nombre: 'Informe de Exámenes'},{id: 50, nombre: 'Resultados Generales de las Encuestas a Estudiantes'} ,{id: 49, nombre: 'Evaluación Docente con Escala Likert'}];
    };
    return AnaliticaDocente;
  }

})();


(function () {
    'use strict';
  
    angular.module('administracionNotificaciones')
      .factory('Alumnos', Alumnos);
  
    function Alumnos($resource, URL_SERVIDOR, $http) {
      var Alumnos = $resource(URL_SERVIDOR + '/alumnos/regulares', {
  
      }, {
        getRegulares: {
          url: URL_SERVIDOR + '/alumnos/regulares',
          method: 'GET',
        }
      });
      
      Alumnos.config = {
        female: true,
        name: 'Alumnos',
        pluralName: 'Alumnos Regulares',
        icon: 'ion ion-person',
        resource: {
          name: 'Alumnos',
          methods: {
            getRegulares: {
              name: 'getRegulares',
              params: true
            }
          }
        },
        order: 11
      };
      return Alumnos;
    }
  })();
(function () {
  'use strict';

  angular.module('administracionNotificaciones')
    .factory('AlumnoOficio', AlumnoOficio);

  function AlumnoOficio($resource, URL_SERVIDOR) {
    var AlumnoOficio = $resource(URL_SERVIDOR + 'cursos/alumnos/:codigo/', {
      codigo: '@id'
    },
      {
        get: {
          url: URL_SERVIDOR + 'cursos/alumnos/:id',
          method: 'GET',
          params: {
            id: '@id'
          }
        },
        listar: {
          url: URL_SERVIDOR + '/cursos/alumnos',
          method: 'GET'
        },
        nuevo: {
          url: URL_SERVIDOR + '/cursos/alumnos',
          method: 'POST'
        },
        inscribirse: {
          url: URL_SERVIDOR + 'cursos/alumnos/:id/inscribirse/:id_curso/:plan',
          method: 'POST',
          params: {
            id: '@id',
            id_curso: '@id_curso',
            plan: '@plan'
          }
        }
        
      });
    AlumnoOficio.config = {
      pluralName: 'Alumnos',
      icon: 'fa fa-key',
      order: 4,
      resource: {
        methods: {
          listar: {
            name: 'listar',
            params: true
          },
          delete: {
            params: true
          },
          remove: {
            params: true
          }
        }
      }
    };
    return AlumnoOficio;
  }
})();

(function () {
    'use strict';
  
    angular.module('administracionNotificaciones').factory('AlumnoHistorial', AlumnoHistorial);
  
    function AlumnoHistorial($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR + 'persona/alumnos/', {}, {
        alumnos: {
          url: URL_SERVIDOR + 'persona/alumnos/',
          method: 'GET',
          isArray: true,
          params: {
            filtro: '@filtro'
          }
        },
        materiasAsociadas: {
          url: URL_SERVIDOR + 'persona/alumnos/materias',
          method: 'GET',
          isArray: true,
          params: {
            legajo: '@legajo'
          }
        },
        historialesAlumno: {
          url: URL_SERVIDOR + 'persona/alumnos/historiales',
          method: 'GET',
          params: {
            legajo: '@legajo',
            materia: '@materia',
            materiaS: '@materiaS',
            carrera: '@carrera'
          }
        },
        materias: {
          url: URL_SERVIDOR + 'historial/materias',
          method: 'GET',
          isArray: true,
        }
      });
    }
  
  })();
  
(function () {
  'use strict';

  angular.module('administracionNotificaciones').factory('Usuario', Usuario);

  function Usuario($resource, $http, AlmacenUsuario, URL_SERVIDOR) {
    var Usuario = $resource(URL_SERVIDOR + 'usuarios/:codigo/', {
      codigo: '@id'
    }, 
      {
        getInfo: {
          url: URL_SERVIDOR + 'usuarios',
          method: 'GET'
        },
        logout: {
          url: URL_SERVIDOR + 'logout',
          method: 'GET'
        },
        cambiarPassword: {
          url: URL_SERVIDOR + 'usuarios/actual/cambiar-password',
          method: 'POST'
        },
        validarHash: {
          url: URL_SERVIDOR + 'validar-hash',
          method: 'GET'
        },
        getPermisos: {
          url: URL_SERVIDOR + 'Permisos',
          method: 'GET',
          isArray: true
        },
        pedirCambioDatos: {
          url: URL_SERVIDOR + '/persona/pedir-cambio-datos',
          method: 'POST'
        },
        listar: {
          url: URL_SERVIDOR + '/usuarios/lista',
          method: 'GET'
        },
        nuevoUsuarioDocente: {
          url: URL_SERVIDOR + '/usuarios/docentes',
          method: 'POST'
        },
        solicitarRecuperarPassword: {
          url: URL_SERVIDOR + '/usuarios/:nick/solicitar-recuperar-password',
          method: 'PUT',
          params: {
            nick: '@nick'
          }
        },
        recuperarPassword: {
          url: URL_SERVIDOR + '/usuarios/:nick/:codigo/recuperar-password/:hash/',
          method: 'PUT',
          params: {
            nick: '@nick',
            codigo: '@id',
            hash: '@hash'
          }
        },
        pedirCodigoVerificacion: {
          url: URL_SERVIDOR + '/usuarios/actual/codigo-verificacion',
          method: 'POST'
        }

      });
    Usuario.login = function(loginData) {
      return $http.get(URL_SERVIDOR + 'login', { headers: { nick: loginData.nick, password: loginData.password } });
    };
    Usuario.config = {
      icon: 'fa fa-user',
      order: 6,
      resource: {
        methods: {
          getInfo: {
            name: 'getInfo',
            params: false
          },
          pedirCambioDatos: {
            name: 'pedirCambioDatos',
            params: true
          },
          cambiarPassword: {
            name: 'cambiarPassword',
            params: true
          },
          listar: {
            name: 'listar',
            params: true
          },
          nuevoUsuarioDocente: {
            name: 'nuevoUsuarioDocente',
            params: true
          }
        }
      }
    };
    return Usuario;
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').service('ServicioSeccion', ServicioSeccion);

  function ServicioSeccion(Seccion) {
    var vm = this;
    var secciones = null;
    vm.habilitadas = habilitadas;
    vm.estaHabilitada = estaHabilitada;

    Seccion.query().$promise.then(function(respuesta) {
      secciones = {};
      respuesta.forEach(function (seccion) {
        secciones[seccion.nombreSeccion] = seccion.habilitada;
        if (seccion.nombreSeccion == 'consultaInscriptosExamen') {
          secciones[seccion.nombreSeccion] = false;
        }
      });
    });

    function habilitadas(secciones) {
      if (!secciones) {
        return true;
      } else if (Array.isArray(secciones)) {
        return secciones.filter(function(seccion) {
          return !estaHabilitada(seccion);
        }).length == 0;
      } else {
        return estaHabilitada(secciones);
      }
      
    }

    function estaHabilitada(seccion) {
      if (!seccion) return true;
      if (!secciones) return false;
      if (secciones[seccion] === undefined) {
        return true;
      } else {
        return secciones[seccion];
      }
    }
    
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').service('Autenticacion', Autenticacion);

  function Autenticacion($state, $rootScope, $q, $timeout, Dialogo, AlmacenUsuario, Usuario) {
    var vm = this;

    vm.iniciarSesion = iniciarSesion;
    vm.validarUsuarioLogueado = validarUsuarioLogueado;
    vm.cerrarSesion = cerrarSesion;
    vm.hayCredenciales = hayCredenciales;
    vm.intentarLoguear = intentarLoguear;
    vm.getPerfil = getPerfil;
    vm.getPermisos = getPermisos;
    vm.hasPermissions = hasPermissions;

    function iniciarSesion(login) {
      return Usuario.login(login).then(function (respuesta) {
        AlmacenUsuario.guardarUsuario(respuesta.data, login.recordar);
        return validarUsuarioLogueado();
      }, function (error) {
        AlmacenUsuario.borrarDatos();
        return $q.reject(error);
      }).then(function () {
        return Usuario.getPermisos().$promise;
      }).then(function (respuesta) {
        AlmacenUsuario.guardarPermisos(respuesta);
      });
    }

    function validarUsuarioLogueado() {
      return Usuario.validarHash().$promise.then(function (rta) {
        return rta;
      }, function (error) {
        AlmacenUsuario.borrarDatos();
        return $q.reject(error);
      }).then(function () {
        return Usuario.getPermisos().$promise;
      }).then(function (respuesta) {
        AlmacenUsuario.guardarPermisos(respuesta);
      });
    }

    function intentarLoguear() {
      return validarUsuarioLogueado().then(function (data) {
        return data;
      }, function (error) {
        // $state.go('login');
        return $q.reject(error);
      });
    }

    function hayCredenciales() {
      return Boolean(AlmacenUsuario.getCredenciales());
    }

    function getPerfil() {
      return Usuario.get().$promise;
    }

    function getPermisos() {
      return AlmacenUsuario.getPermisos();
    }

    function cerrarSesion() {
      AlmacenUsuario.borrarDatos();
      return $timeout(function () {
        return true;
      });
    }

    function hasPermissions(permissions) {
      if (!permissions || (angular.isArray(permissions) && permissions.length == 0)) {
        return true;
      } else {
        var requiredPermissions = angular.isArray(permissions) ? permissions : [permissions];
        var actualPermisssions = getPermisos().map(function (p) {
          return p.nombre;
        });
        var missingPermissions = requiredPermissions.filter(function (p) {
          return actualPermisssions.indexOf(p) === -1;
        });
        return missingPermissions.length === 0;
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').run(run);

  function run($http, AlmacenUsuario) {
    $http.defaults.headers.common.Authorization = AlmacenUsuario.getCredenciales;
  }
})();

(function () {
  'use strict';
  angular.module('administracionNotificaciones').service('AlmacenUsuario', AlmacenUsuario);

  function AlmacenUsuario($localStorage, $sessionStorage, $base64) {
    var vm = this;

    vm.getCredenciales = getCredenciales;
    vm.getUsuario = getUsuario;
    vm.guardarUsuario = guardarUsuario;
    vm.borrarDatos = borrarDatos;
    vm.guardarPermisos = guardarPermisos;
    vm.getPermisos = getPermisos;

    delete $sessionStorage.login;
    delete $localStorage.login;

    var permisos;

    function getUsuario() {
      if ($sessionStorage.usuario) {
        return $sessionStorage.usuario;
      } else if ($localStorage.usuario) {
        return $localStorage.usuario;
      }
      return {};
    }

    function getCredenciales() {
      return getUsuario().credenciales;
    }

    function guardarUsuario(usuario, recordar) {
      usuario.credenciales = 'Basic ' + $base64.encode(usuario.nick + ':' + usuario.hashActual);
      Raven.setUserContext({
        username: usuario.nick,
        id: usuario.id
      });
      if (recordar) {
        $localStorage.usuario = usuario;
      } else {
        $sessionStorage.usuario = usuario;
      }
    }

    function guardarPermisos(p) {
      permisos = p;
    }

    function getPermisos() {
      return permisos;
    }

    function borrarDatos() {
      delete $localStorage.usuario;
      delete $sessionStorage.usuario;
    }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').service('Dialogo', Dialogo);

  function Dialogo($uibModal, $http, $rootScope) {
    var vm = this;

    vm.mostrarBasico = mostrarBasico;
    vm.mostrarExito = mostrarExito;
    vm.mostrarError = mostrarError;
    vm.mostrarConfirmacion = mostrarConfirmacion;
    vm.mostrarCargando = mostrarCargando;
    vm.ocultarCargando = ocultarCargando;

    var templatesPromise = $http.get('app/components/dialogos/dialogo.templates.json');

    function mostrarCargando() {
      if (!vm.cargando) {
        vm.cargando = $uibModal.open({
          templateUrl: 'app/components/dialogos/dialogo-cargando.html',
          windowTemplateUrl: 'app/components/dialogos/dialogo-cargando.html',
          size: 'sm',
          backdrop: 'static',
          keyboard: false
        });
      }
    }

    function ocultarCargando() {
      if (vm.cargando) {
        vm.cargando.opened.then(
          function () {
            vm.cargando.close(true);
            vm.cargando = null;
          }
        );
      }
    }

    function mostrarBasico(config, scope) {
      return mostrarMensaje(config, scope);
    }

    function mostrarTemplate(nombre, config, scope) {
      return templatesPromise.then(function (data) {
        var newConf;
        var custom = data.data[nombre];
        if (custom) {
          newConf = angular.extend(angular.copy(custom), config);
        } else {
          newConf = angular.copy(config);
        }
        return mostrarMensaje(newConf, scope);
      });
    }

    function mostrarError(config, scope) {
      return mostrarTemplate('error', config, scope);
    }

    function mostrarExito(config, scope) {
      return mostrarTemplate('exito', config, scope);
    }

    function mostrarConfirmacion(config, scope) {
      return mostrarTemplate('confirmacion', config, scope);
    }

    function mostrarMensaje(config, scope) {
      var scopeHijo = crearScopeHijo(config, scope);
      var dialogo = $uibModal.open({
        templateUrl: config.plantilla,
        scope: scopeHijo,
        backdrop : config.backdrop,
        keyboard: config.keyboard
      });
      scopeHijo.dialogo = dialogo;
      if (!config.accionSi) {
        config.accionSi = function () {
          dialogo.close(true);
        };
      }
      if (!config.accionNo) {
        config.accionNo = function () {
          dialogo.dismiss(false);
        };
      }
      return dialogo;
    }

    function crearScopeHijo(config, scope) {
      var scopeHijo = scope ? scope.$new() : $rootScope;
      scopeHijo.config = config;
      return scopeHijo;
    }
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').run(run);

  function run($rootScope, Dialogo, $state) {
    $rootScope.$on('$stateChangeSuccess', function (event, toState, toStateParams, fromState) {
      // console.log( 'StateChangeSuccess: ' + fromState.name + ' -> ' + toState.name);
      if (!toState.data || !toState.data.mantenerCargando) {
        Dialogo.ocultarCargando();
      }
    });
    $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
      // console.log( 'StateChangeStart: ' + fromState.name + ' -> ' + toState.name);
      Dialogo.mostrarCargando();
      // console.log(new Date());
    });
    $rootScope.$on('OCULTAR_CARGANDO', function () {
      Dialogo.ocultarCargando();
    });
    $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
      // el mensaje del error es null
      // console.log(error);
      // console.log(toState);
      // console.log(fromState);
      // console.log( 'StateChangeError: ' + fromState.name + ' -> ' + toState.name);
      // console.log(JSON.stringify(error));
      Dialogo.ocultarCargando();
      // var config = {texto: error.data ? error.data.message : 'Para ingresar'};
      // Poner los if para para la accion desde donde va y donde viene.
      if ((fromState.name === '' || fromState.name === 'login') && toState.name === 'main' && error.data === null) {
        $state.go('login');
      } else {
        $state.go('main');
      }
      // if (fromState.name === 'main' && toState.name === 'login') {
      //   $state.go('main');
      // }
      //
      // if (fromState.name === '' && toState.name.substring(0, 5) === 'main.') {
      //   console.log('Aca toy');
      //   $state.go('main');
      // }
    });
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').run(run);

  function run($rootScope, $http) {
    $http.get('app/components/info/info.json').then(function (data) {
      $rootScope.info = data.data;
    });
  }
})();

(function () {
  'use-strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {
    $stateProvider.state('recupera-pass', {
      url: '/recuperar-pass/:nick/:id/:hash',
      templateUrl: 'app/app/recupera-pass/recupera-pass.html',
      controller: 'RecuperaPassCtrl as recuperaPass',
      resolve: {
        respuesta: function ($stateParams, Usuario) {
          return Usuario.recuperarPassword({ hash: $stateParams.hash, nick: $stateParams.nick, id: $stateParams.id },
            function (data) {
              return data;
            }, function () {
              // console.log(error);
            }
          ).$promise.then(function () {
            var respuesta = {exito : true};
            return respuesta;
          }, function (error) {
            var respuesta = {exito : false, error : error};
            return respuesta;
          });
        }
      }
    });
  }
})();

(function () {
  'use strict';

  angular
  .module('administracionNotificaciones')
  .controller('RecuperaPassCtrl', RecuperaPassCtrl);

  function RecuperaPassCtrl($state, Dialogo, respuesta) {
    var vm = this;
    vm.respuesta = respuesta;
    vm.aceptar = aceptar;

    function aceptar() {
      $state.go('login');
    }
    

    
  }
})();

(function () {
  'use-strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {
    $stateProvider.state('main', {
      url: '/',
      templateUrl: 'app/app/main/main.html',
      controller: 'MainCtrl as main',
      resolve: {
        logueado: function (Autenticacion, $q) {
          return Autenticacion.intentarLoguear().then(
            function (dato) {
              return dato;
            },
            function (dato) {
              return $q.reject(dato);
            }
          );
        }
      }
    });
  }
})();

(function () {
  'use strict';

  angular
  .module('administracionNotificaciones')
  .controller('MainCtrl', MainCtrl);

  function MainCtrl($rootScope, Usuario) {
    var vm = this;
    vm.usuario = Usuario.getInfo();
    vm.getTema = getTema;
    vm.getNombreRol = getNombreRol;

    $rootScope.$watch('sidebarOpen', function (newValue) {
      vm.sidebarOpen = newValue;
    });

    function getTema() {
      var grupo = vm.usuario.grupo ? vm.usuario.grupo.nombre : '';
      if (grupo === 'Alumno') {
        return 'celeste';
      } else if (grupo === 'RRHH') {
        return 'violeta';
      } else if (grupo === 'Notificador' || 
        grupo === 'Administrador' || 
        grupo === 'Directivo' || 
        grupo === 'SAE' || 
        grupo === 'Cooperadora' || 
        grupo === 'Bedel') {
        return 'negro';
      } else {
        return '';
      }
    }

    function getNombreRol() {
      var grupo = vm.usuario.grupo ? vm.usuario.grupo.nombre : '';
      return grupo;
    }
  }
})();

(function () {
  'use-strict';

  angular.module('administracionNotificaciones').config(config);

  function config($stateProvider) {
    $stateProvider.state('login', {
      url: '/login',
      templateUrl: 'app/app/login/login.html',
      controller: 'LoginCtrl as login',
      resolve: {
        logueado: function (Autenticacion, $q) {
          return Autenticacion.intentarLoguear().then(
            function (dato) {
              return $q.reject(dato);
            },
            function (dato) {
              return dato;
            }
          );
        },
        campos: function($http, Fields) {
          return $http.get('app/app/login/login.fields.json').then(function(response){
            return Fields.get({fields:response.data});
          });
        }
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('administracionNotificaciones')
    .controller('LoginCtrl', LoginCtrl);

  function LoginCtrl($q, $state, Autenticacion, Dialogo, Usuario, campos) {
    var vm = this;

    vm.iniciarSesion = iniciarSesion;
    vm.recuperarPass = recuperarPass;
    vm.campos = campos;

    var gruposHabilitados = ['Administrador','Notificador','Docente','RRHH','Bedel','Directivo', 'Alumno', 'Extension', 'Decanato', 'Autoridad','Basicas'];

    function iniciarSesion() {
      Dialogo.mostrarCargando();
      Autenticacion.iniciarSesion(vm.data).then(validarGrupo).then(redireccionar, error);
    }

    function validarGrupo() {
      return Usuario.getInfo().$promise.then(function(info) {
        if (!info.grupo || !gruposHabilitados.find(function(item) { return item == info.grupo.nombre;})) {
          Autenticacion.cerrarSesion();
          return $q.reject({data: {message: 'Este tipo de usuario no está habilitado para usar la autogestión web'}});
        } else {
          return info;
        }
      });
    }

    function redireccionar() {
      $state.go('main');
    }

    function error(error) {
      if (error.status === 401) {
        Dialogo.mostrarError({
          titulo: 'Error',
          texto: 'El nombre de usuario o la contraseña ingresada no es correcta.'
        });
        inicializarData();
      } else if (error.data === null) {
        Dialogo.mostrarError({
          titulo: 'Error',
          texto: 'Verifique su conexión'
        });
      } else {
        Dialogo.mostrarError({
          titulo: 'Error',
          texto: ' ' + error.data.message
        });
      }
      Dialogo.ocultarCargando();
    }

    function inicializarData() {
      vm.data = {
        nick: '',
        password: '',
        recordar: false
      };
    }

    inicializarData();

    function recuperarPass() {
      Dialogo.mostrarConfirmacion({
        data: {},
        titulo: 'Recuperar Contraseña',
        texto: 'Ingrese su nombre de usuario',
        plantilla: 'app/app/login/dialogo-recuperar-password.html',
        accionSi: function (dialogo, data) {
          Dialogo.mostrarCargando();
          dialogo.close();
          // console.log(data);
          // var params = {
          //   nick: data.nick
          // };
          Usuario.solicitarRecuperarPassword({
            nick: data.nick
          }, function () {
            Dialogo.mostrarExito({
              titulo: 'Éxito',
              texto: 'Le hemos enviado un correo electrónico con las instrucciones para confirmar la recuperación de su clave.',
              accionSi: function (dialogo) {
                dialogo.close();
                $state.go('login');
              }
            });
            Dialogo.ocultarCargando();
          }, function (error) {
            Dialogo.mostrarError({
              titulo: 'Error',
              texto: error.data.message
            });
            Dialogo.ocultarCargando();
          });
        },
        textoSi: 'Aceptar',
        textoNo: 'Cancelar',
        accionNo: function (dialogo) {
          dialogo.close();
          $state.go('login');
        }
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('administracionNotificaciones')
    .constant('VERSION', '0.0.1');

})();

var ACTIVE_PROFILE = 'produccion';
var VERSION = '0.0.1';

if (ACTIVE_PROFILE === 'produccion') {
  Raven
      .config('https://0c3b4d5e726e4ba3b67fdef4f185d215@webservice.frvm.utn.edu.ar/logs/4', {
        environment: ACTIVE_PROFILE,
        release: VERSION
      })
      .addPlugin(Raven.Plugins.Angular)
      .install();
}

(function() {
  'use strict';

  angular
    .module('administracionNotificaciones')
    .constant('ACTIVE_PROFILE', 'produccion');

})();

(function () {

  angular.module('administracionNotificaciones').run(run);

  function run(Menu) {

    Menu.addMenuItems({
      pluralName: 'Estado Académico',
      icon: 'ion ion-university',
      order: 6
    }, [{
      menuName: 'Consultar',
      icon: 'ion ion-search',
      permissions: ['estadoAcademico'],
      sections: ['estadoAcademico'],
      state: 'main.estado-academico'
    }, {
      menuName: 'Materias Electivas',
      icon: 'ion ion-checkmark-round',
      permissions: ['materiasElectivas'],
      sections: ['materiasElectivas'],
      state: 'main.materias-electivas'
    }]);

    Menu.addMenuItems({
      pluralName: 'Cursando',
      icon: 'ion ion-easel',
      order: 7
    }, [{
      menuName: 'Consultar',
      icon: 'ion ion-search',
      permissions: ['materiasCursando'],
      sections: ['materiasCursando'],
      state: 'main.materias-cursando.materias'
    }, {
      menuName: 'Horario',
      icon: 'ion ion-android-calendar',
      permissions: ['horarioCursado'],
      sections: ['horarioCursado'],
      state: 'main.horario-cursado'
    }, {
      menuName: 'Libro de Tema',
      icon: 'ion ion-ios-book',
      permissions: ['libroDeTemas_NO'],
      sections: ['libroDeTemas'],
      state: 'main.libro-de-temas.materias'
    }, {
      menuName: 'Inscripción',
      icon: 'ion ion-folder',
      permissions: ['inscripcionCursado_NO'],
      sections: ['inscripcionCursado'],
      state: 'main.inscripcion-cursado'
    }]);

    Menu.addMenuItems({
      pluralName: 'Exámenes',
      icon: 'ion ion-document-text',
      order: 8
    }, [{
      menuName: 'Consultar',
      icon: 'ion ion-search',
      permissions: ['examenes'],
      sections: ['examenes'],
      state: 'main.examen'
    }, {
      menuName: 'Inscripción',
      icon: 'ion ion-edit',
      permissions: ['inscripcionExamen_NO'],
      sections: ['inscripcionExamen'],
      state: 'main.inscripcion-examen'
    }]);

    Menu.addMenuItems({
      pluralName: 'Encuestas',
      icon: 'ion ion-clipboard',
      order: 9
    }, [{
      menuName: 'Realizar Encuestas',
      icon: 'ion ion-clipboard',
      permissions: ['encuestas_NO'],
      sections: ['encuestas'],
      state: 'main.encuestas'
    }]);

    Menu.addMenuItems({
      pluralName: 'Solicitudes',
      icon: 'ion ion-ribbon-b',
      order: 10
    }, [{
      menuName: 'Pedir Certificados',
      icon: 'ion ion-ribbon-b',
      permissions: ['pedirCertificados_NO'],
      sections: ['pedirCertificados'],
      state: 'main.pedir-certificados'
    }]);

    Menu.addMenuItems({
      pluralName: 'Datos Personales',
      icon: 'ion ion-person',
      order: 18
    }, [{
      menuName: 'Editar',
      icon: 'ion ion-edit',
      permissions: ['estadoAcademico'],
      sections: ['estadoAcademico'],
      state: 'main.usuarios.edit'
    }]);

    Menu.addMenuItems({
      pluralName: 'RRHH',
      icon: 'ion ion-ribbon-b',
      order: 10
    }, [{
      menuName: 'Asist. Docentes',
      icon: 'fa fa-print',
      permissions: ['gestionLicencias'],
      sections: ['gestionLicencias'],
      state: 'main.rr-hh'
    }]);

    Menu.addMenuItems({
      pluralName: 'Horario Cursado',
      icon: 'ion ion-android-calendar',
      order: 11
    }, [{
      menuName: 'Aula',
      icon: 'fa fa-university',
      permissions: ['administrarHorarios'],
      sections: ['horarios'],
      state: 'main.horario-cursado-aula'
    }, {
      menuName: 'Especialidad',
      icon: 'fa fa-graduation-cap',
      permissions: ['administrarHorarios'],
      sections: ['horarios'],
      state: 'main.horario-cursado-especialidad'
    }, {
      menuName: 'Docente',
      icon: 'fa fa-briefcase',
      permissions: ['administrarHorarios'],
      sections: ['horarios'],
      state: 'main.horario-cursado-docente-filtrar'
    }]);

    Menu.addMenuItems({
      pluralName: 'Analíticas',
      icon: 'fa fa-line-chart',
      order: 10
    }, [{
      menuName: 'Ver',
      icon: 'fa fa-bar-chart',
      permissions: ['informesInscripcion'],
      sections: ['estadoAcademico'],
      state: 'main.analitica-docente-home'
    }]);

    Menu.addMenuItems({
      pluralName: 'Encuestas Docentes',
      icon: 'fa fa-line-chart',
      order: 10
    }, [{
      menuName: 'Ver',
      icon: 'fa fa-bar-chart',
      permissions: ['encuestasDocentes'],
      sections: ['encuestasDocentes'],
      state: 'main.encuestas-docentes-home'
    }]);

   Menu.addMenuItems({
      pluralName: 'Encuestas Generales Docentes',
      icon: 'fa fa-line-chart',
      order: 51
    }, [{
      menuName: 'Ver',
      icon: 'fa fa-bar-chart',
      permissions: ['encuestaDocenteAutoridades'],
      state: 'main.encuestas-docentes-autoridades-home'
    }]);
 
    Menu.addMenuItems({
      pluralName: 'Encuestas Basicas',
      icon: 'fa fa-line-chart',
      order: 11
    }, [{
      menuName: 'Ver',
      icon: 'fa fa-bar-chart',
      permissions: ['encuestaBasicas'],
      sections: ['encuestasDocentes'],
      state: 'main.encuestas-docentes-basicas-home'
    }]);

    Menu.addMenuItems({
      pluralName: 'Mis Exámenes',
      icon: 'fa fa-graduation-cap',
      order: 10
    }, [{
      menuName: 'Consultar',
      icon: 'ion ion-search',
      permissions: ['informesInscripcion'],
      sections: ['estadoAcademico'],
      state: 'main.pre-inscripciones-examen-home'
    }]);

    Menu.addMenuItems({
      pluralName: 'Mis Alumnos',
      icon: 'ion ion-person',
      order: 11
    }, [{
      menuName: 'Consultar',
      icon: 'ion ion-search',
      permissions: ['informesInscripcion'],
      sections: ['estadoAcademico'],
      state: 'main.busqueda-alumnos-home'
    }]);

    Menu.addMenuItems({
      pluralName: 'Mi Calendario',
      icon: 'fa fa-calendar',
      order: 13
    }, [{
      menuName: 'Consultar',
      icon: 'ion ion-search',
      permissions: ['informesInscripcion'],
      sections: ['estadoAcademico'],
      state: 'main.detalle-calendario'
    }]);

    Menu.addMenuItems({
      pluralName: 'Notificaciones',
      icon: 'ion ion-paper-airplane',
      order: 21
    }, [{
      menuName: 'Nueva',
      icon: 'fa fa-plus',
      permissions: ['crearNotificaciones'],
      state: 'main.notificaciones.edit'
    },{
      menuName: 'Enviar',
      icon: 'ion ion-paper-airplane',
      permissions: ['crearNotificaciones'],
      state: 'main.notificacionEnviar'
    }, {
      menuName: 'Enviadas',
      icon: 'fa fa-history',
      permissions: ['crearNotificaciones'],
      state: 'main.notificaciones-enviadas'
    },{
      menuName: 'Listado',
      icon: 'fa fa-bars',
      permissions: ['crearNotificaciones'],
      state: 'main.notificaciones.list'
    }]);

  }

})();

if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function(predicate) {
     // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return undefined.
      return undefined;
    },
    configurable: true,
    writable: true
  });
}

(function () {
  'use strict';

  angular
    .module('administracionNotificaciones')
    .factory('URL_SERVIDOR', function (ACTIVE_PROFILE) {
      if (ACTIVE_PROFILE === 'produccion') {
        return 'https://webservice.frvm.utn.edu.ar/autogestion/';
      } else if (ACTIVE_PROFILE === 'test') {
        return 'http://192.168.130.5:8088/';
      } else if (ACTIVE_PROFILE === 'development') {
        return 'http://192.168.130.31:8088/';
      } else if (ACTIVE_PROFILE === 'developmentMati') {
        return 'http://localhost:8088/';
      }
    })
    .factory('URL_LICENCIAS', function (ACTIVE_PROFILE) {
      if (ACTIVE_PROFILE === 'produccion') {
        return 'https://webservice.frvm.utn.edu.ar/licencias/';
      } else if (ACTIVE_PROFILE === 'test') {
        return 'http://localhost:8089/';
        // return 'http://192.168.130.5:8080/licencias/';
      } else if (ACTIVE_PROFILE === 'development') {
        return 'http://localhost:8088/';
      } else if (ACTIVE_PROFILE === 'developmentMati') {
        return 'https://webservice.frvm.utn.edu.ar/licencias/';
      }
    })
    .factory('ENABLE_API_CHECK', function (ACTIVE_PROFILE) {
      if (ACTIVE_PROFILE === 'produccion') {
        return false;
        //return 'https://webservice.frvm.utn.edu.ar/licencias/';
      } else if (ACTIVE_PROFILE === 'test') {
        return false;
        // return 'http://192.168.130.5:8080/licencias/';
      } else if (ACTIVE_PROFILE === 'development') {
        return true;
      } else if (ACTIVE_PROFILE === 'developmentMati') {
        return true;
      }
    });
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').run(run);

  function run($location, DataState) {
    DataState.setInitialUrl($location.path());
  }
})();

(function () {
  'use strict';

  angular.module('administracionNotificaciones').config(config);

  function config($locationProvider, $urlRouterProvider, $localStorageProvider, $sessionStorageProvider, $resourceProvider) {
    moment.locale('es');
    $locationProvider.html5Mode(true);
    $urlRouterProvider.otherwise('/');

    $localStorageProvider.setKeyPrefix('autogestion.');
    $sessionStorageProvider.setKeyPrefix('autogestion.');

    $resourceProvider.defaults.cancellable = true;
    $resourceProvider.defaults.actions.update = {
      method: 'PUT'
    };
  }
})();

'use strict';
angular.module('ngLocale', [], ['$provide', function ($provide) {
  var PLURAL_CATEGORY = { ZERO: 'zero', ONE: 'one', TWO: 'two', FEW: 'few', MANY: 'many', OTHER: 'other' };
  $provide.value('$locale', {
    'DATETIME_FORMATS': {
      'AMPMS': [
        'a. m.',
        'p. m.'
      ],
      'DAY': [
        'domingo',
        'lunes',
        'martes',
        'mi\u00e9rcoles',
        'jueves',
        'viernes',
        's\u00e1bado'
      ],
      'ERANAMES': [
        'antes de Cristo',
        'despu\u00e9s de Cristo'
      ],
      'ERAS': [
        'a. C.',
        'd. C.'
      ],
      'FIRSTDAYOFWEEK': 6,
      'MONTH': [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre'
      ],
      'SHORTDAY': [
        'dom.',
        'lun.',
        'mar.',
        'mi\u00e9.',
        'jue.',
        'vie.',
        's\u00e1b.'
      ],
      'SHORTMONTH': [
        'ene.',
        'feb.',
        'mar.',
        'abr.',
        'may.',
        'jun.',
        'jul.',
        'ago.',
        'sep.',
        'oct.',
        'nov.',
        'dic.'
      ],
      'STANDALONEMONTH': [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre'
      ],
      'WEEKENDRANGE': [
        5,
        6
      ],
      'fullDate': 'EEEE, d \'de\' MMMM \'de\' y',
      'longDate': 'd \'de\' MMMM \'de\' y',
      'medium': 'd MMM y HH:mm:ss',
      'mediumDate': 'd MMM y',
      'mediumTime': 'HH:mm:ss',
      'short': 'd/M/yy HH:mm',
      'shortDate': 'd/M/yy',
      'shortTime': 'HH:mm'
    },
    'NUMBER_FORMATS': {
      'CURRENCY_SYM': '$',
      'DECIMAL_SEP': ',',
      'GROUP_SEP': '.',
      'PATTERNS': [
        {
          'gSize': 3,
          'lgSize': 3,
          'maxFrac': 3,
          'minFrac': 0,
          'minInt': 1,
          'negPre': '-',
          'negSuf': '',
          'posPre': '',
          'posSuf': ''
        },
        {
          'gSize': 3,
          'lgSize': 3,
          'maxFrac': 2,
          'minFrac': 2,
          'minInt': 1,
          'negPre': '-\u00a4\u00a0',
          'negSuf': '',
          'posPre': '\u00a4\u00a0',
          'posSuf': ''
        }
      ]
    },
    'id': 'es-ar',
    'localeID': 'es_AR',
    'pluralCat': function (n, opt_precision) { if (n == 1) { return PLURAL_CATEGORY.ONE; } return PLURAL_CATEGORY.OTHER; }
  });
}]);

angular.module("administracionNotificaciones").run(["$templateCache", function($templateCache) {$templateCache.put("app/app/login/dialogo-recuperar-password.html","<div class=\"modal-header\" ng-if=\"config.titulo\">\n    <h3 class=\"modal-title\" id=\"modal-title\">\n      <i class=\"fa-stack\">\n        <i class=\"fa fa-circle fa-stack-2x\"></i>\n        <i class=\"fa fa-stack-1x fa-inverse {{config.icono}}\"></i>\n      </i>\n      {{config.titulo}}\n    </h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <p>{{config.texto}}</p>\n    <input type=\"text\" ng-model=\"config.data.nick\" class=\"form-control\" required>\n    <p>Recibirá un mail con las instrucciones para confirmar este proceso.</p>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn {{config.tipoSi}}\" type=\"button\" ng-click=\"config.accionSi(dialogo,config.data)\" ng-if=\"config.si\">{{config.textoSi}}</button>\n    <button class=\"btn {{config.tipoNo}}\" type=\"button\" ng-click=\"config.accionNo(dialogo)\" ng-if=\"config.no\">{{config.textoNo}}</button>\n</div>");
$templateCache.put("app/app/login/login.html","<div class=\"login-page-div\">\n  <div class=\"divDelLogin animated fadeInUp smooth\">\n    <img src=\"./app/components/tema/utn2023.png\" class=\"img-responsive center-block\">\n    <h3 class=\"text-center\">Autogesti&oacute;n</h3>\n    <br>\n    <formly-form class=\"login-form\" fields=\"login.campos\" model=\"login.data\" form=\"form\" ng-keyup=\"$event.keyCode == 13 && form.$valid && login.iniciarSesion()\">\n      <button ng-click=\"login.iniciarSesion()\" ng-disabled=\"form.$invalid\" class=\"center-block\">Ingresar</button>\n    </formly-form>\n    <br>\n    <br>\n    <a class=\"center-block text-center pointer\" ng-click=\"login.recuperarPass()\">\n      Olvidé mi contraseña\n    </a>\n\n  </div>\n</div>\n");
$templateCache.put("app/app/recupera-pass/recupera-pass.html","<div class=\"login-page-div\">\n  <div class=\"divDelLogin animated fadeInUp smooth\">\n    <img src=\"./app/components/tema/favicon-32x32.png\" height=\"72\" width=\"72\" class=\"img-responsive center-block\">\n    <h3 class=\"text-center\">Autogesti&oacute;n <br> UTN-FRVM</h3>\n    <br>\n    <div ng-if=\"recuperaPass.respuesta.exito\" class=\"text-center\">\n      <span class=\"fa fa-check-circle-o fa-5x\" style=\"color:#5cb85c\"></span>\n      <br>\n      Su clave fue recuperada!\n    </div>\n    <div ng-if=\"!recuperaPass.respuesta.exito\" class=\"text-center\">\n      <span class=\"fa fa-ban fa-5x\" style=\"color:#d43f3a\"></span>\n      <br>\n      {{recuperaPass.respuesta.error.data.message}}\n    </div>\n    <br>\n    <br>\n    <button class=\"center-block\" ng-click=\"recuperaPass.aceptar()\">\n      Aceptar\n    </button>\n    \n  </div>\n</div>\n");
$templateCache.put("app/app/main/main.html","<div id=\"page-wrapper\" ng-class=\"{\'open\': main.sidebarOpen}\" class=\"{{main.getTema()}}\">\n\n  <sidebar></sidebar>\n\n  <content-wrapper></content-wrapper>\n  \n</div>\n");
$templateCache.put("app/components/dialogos/dialogo-basico.html","<div class=\"modal-header\" ng-if=\"config.titulo\">\n    <h3 class=\"modal-title\" id=\"modal-title\">\n      <i class=\"fa-stack\">\n        <i class=\"fa fa-circle fa-stack-2x\"></i>\n        <i class=\"fa fa-stack-1x fa-inverse {{config.icono}}\"></i>\n      </i>\n      {{config.titulo}}\n    </h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    {{config.texto}}\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn {{config.tipoSi}}\" type=\"button\" ng-click=\"config.accionSi(dialogo)\" ng-if=\"config.si\">{{config.textoSi}}</button>\n    <button class=\"btn {{config.tipoNo}}\" type=\"button\" ng-click=\"config.accionNo(dialogo)\" ng-if=\"config.no\">{{config.textoNo}}</button>\n</div>\n");
$templateCache.put("app/components/dialogos/dialogo-cargando.html","<div class=\"loading\">\n  <div class=\"double-bounce1\"></div>\n  <div class=\"double-bounce2\"></div>\n</div>\n");
$templateCache.put("app/components/tema/content-wrapper.html","<div id=\"content-wrapper\">\n  <div class=\"page-content\">\n    <page-header></page-header>\n    <ui-view></ui-view>\n  </div>\n</div>\n");
$templateCache.put("app/app/main/Inscripcion-examen/dialogo-confirmacion-visualizacion-turnos.html","<div class=\"modal-header\" ng-if=\"config.titulo\">\n    <h3 class=\"modal-title\" id=\"modal-title\">\n      <i class=\"fa-stack\">\n        <i class=\"fa fa-circle fa-stack-2x\"></i>\n        <i class=\"fa fa-stack-1x fa-inverse {{config.icono}}\"></i>\n      </i>\n      {{config.titulo}}\n    </h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <li ng-repeat=\"parrafo in config.parrafos\"> {{parrafo}}</li>\n    {{config.texto}}\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn {{config.tipoSi}}\" type=\"button\" ng-click=\"config.accionSi(dialogo)\" ng-if=\"config.si\">{{config.textoSi}}</button>\n    <button class=\"btn {{config.tipoNo}}\" type=\"button\" ng-click=\"config.accionNo(dialogo)\" ng-if=\"config.no\">{{config.textoNo}}</button>\n</div>");
$templateCache.put("app/app/main/Inscripcion-examen/dialogo-error-turnos.html","<div class=\"modal-header\" ng-if=\"config.titulo\">\n    <h3 class=\"modal-title\" id=\"modal-title\">\n      <i class=\"fa-stack\">\n        <i class=\"fa fa-circle fa-stack-2x\"></i>\n        <i class=\"fa fa-stack-1x fa-inverse {{config.icono}}\"></i>\n      </i>\n      {{config.titulo}}\n    </h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <li ng-repeat=\"parrafo in config.parrafos\"> {{parrafo}}</li>\n    {{config.texto}}\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn {{config.tipoSi}}\" type=\"button\" ng-click=\"config.accionSi(dialogo)\" ng-if=\"config.si\">{{config.textoSi}}</button>\n    <button class=\"btn {{config.tipoNo}}\" type=\"button\" ng-click=\"config.accionNo(dialogo)\" ng-if=\"config.no\">{{config.textoNo}}</button>\n</div>");
$templateCache.put("app/app/main/Inscripcion-examen/inscripcion-examen.html","<div class=\"row\">\n    <div class=\"col-md-12\">\n      <div class=\"widget\">\n        <div class=\"widget-header\">\n          <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n          <span>Inscripción a Exámen</span>\n          <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n        </div>\n        <div class=\"widget-body big no-padding\">\n			<table class=\"table table-striped table-hover table-condensed table-responsive {{className}}\">\n				<tbody>\n					<tr>\n						<th class=\"text-center\">Asignatura</th>\n						<th class=\"text-center\">Estado</th>\n						<th class=\"text-center\">Fecha Exámen</th>\n						<th class=\"text-center\">Acciones</th>\n					</tr>\n					<tr ng-repeat=\"examen in vm.examenesInscriptos\">\n						<td class=\"col-md-6 col text-center\">{{examen.nombreMateria}}</td>\n						<td class=\"col-md-3 col text-center\">\n							<span class=\"label label-success\"> \n							  Inscripto\n							</span>\n						</td>\n						<td class=\"col-md-2 col text-center\">{{examen.fecha | date : \'dd/MM/yyyy\'}}</td>\n						<td class=\"col-md-1 col text-center\">\n							<div class=\"btn-group btn-group\">\n								<button type=\"button\" title=\"Anular Inscripción\" class=\"btn btn-danger\" ng-click=\"vm.anularInscripcion(examen.info)\">\n									  <i class=\"fa fa-trash fa-3x\"></i>  \n							  	</button>\n							  	<button type=\"button\" title=\"Información\" class=\"btn btn-primary\" ng-click=\"vm.getInformacionExamen(examen.info)\">\n									  <i class=\"fa fa-info-circle fa-3x\"></i>  \n							  	</button>\n							</div>\n						</td>\n					</tr>\n					<tr ng-repeat=\"materia in vm.materiasDisponibles | orderBy:[\'-estado\' ,\'nombreMateriaLargo\']\">\n						<td class=\"col-md-6 col text-center\">{{materia.nombreMateriaLargo}}</td>\n						<td class=\"col-md-3 col text-center\">\n							<span class=\"label {{vm.getEstado(materia)}}\"> \n							  {{vm.getNombreEstado(materia)}}\n							</span>\n						</td>\n						<td class=\"col-md-2 col text-center\"> - </td>\n						<td class=\"col-md-1 col text-center\">\n							<div class=\"btn-group btn-group\" ng-if=\"materia.estado===\'rendible\'\">\n								<button type=\"button\" title=\"Inscribirse\" class=\"btn btn-success active\" ng-click=\"vm.verificarTurnos(materia)\">\n									  <i class=\"fa fa-sign-in fa-3x\"></i>  \n							  	</button>\n							</div>\n							<div class=\"btn-group btn-group\" ng-if=\"materia.estado!==\'rendible\'\">\n								<button type=\"button\" title=\"Información\" class=\"btn btn-primary\" ng-click=\"vm.verificarTurnos(materia)\">\n									  <i class=\"fa fa-info-circle fa-3x\"></i>  \n							  	</button>\n							</div>\n						</td>\n					</tr>\n				</tbody>\n			</table>\n		</div>\n	</div>\n</div>\n</div>");
$templateCache.put("app/app/main/analitica-docente/analitica-docente-detail.html","<div class=\"row\">\n  <iframe ng-src=\"{{ vm.link1 }}\" class=\"col-md-12\" ng-style=\"vm.innerComponentStyle\"></iframe>\n</div>");
$templateCache.put("app/app/main/analitica-docente/analitica-docente-home.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n        <span>Analítica del Docente</span>\n        <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n      </div>\n      <div class=\"widget-body big no-padding\">\n\n        <table class=\"table table-striped table-hover table-condensed table-responsive {{className}}\">\n          <thead>\n            <tr>\n              <th class=\"text-center\">Informe</th>\n              <th class=\"text-center\">Acciones</th>\n            </tr>\n          </thead>          \n          <tbody>\n            <tr ng-repeat=\"informe in vm.informes\">\n              <td class=\"col-md-10 text-left\">{{ informe.nombre }}</td>\n              <td class=\"col-md-2 text-center\">\n                <div class=\"btn-group btn-group\">\n                  <button type=\"button\" title=\"Ver Información\" class=\"btn btn-info\" ng-click=\"vm.verInformes(informe)\">\n                      <i class=\"fa fa-info-circle fa-3x\"></i>\n                  </button>\n                </div>               \n              </td>\n            </tr>\n        </tbody></table></div>\n    </div>      \n  </div>    \n</div>     \n");
$templateCache.put("app/app/main/calendario/detalle-calendario.html","<div class=\"row\">\n    <div class=\"col-md-12\">\n      <div class=\"widget\">\n        <div class=\"widget-header\">\n          <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n          <span>Calendario</span>\n          \n        </div>\n        <div class=\"widget-body big no-padding\">\n  \n          <table class=\"table table-striped table-hover table-condensed table-responsive {{className}}\">\n            <thead>\n              <tr>\n                <!-- <th class=\"text-center\">Especialidad</th> -->\n                <th class=\"text-center\">Fecha</th>\n                <th class=\"text-center\">Día</th>\n                <th class=\"text-center\">Detalle</th>\n                \n              </tr>\n            </thead>\n            <tbody>\n              <tr ng-repeat=\"detalle in vm.detalles\">\n                <td class=\"col-md-1 text-center\">{{ detalle.fecha | date : \'dd/MM/yyyy\'}}</td>\n                <td class=\"col-md-3 text-left\">{{ detalle.dia }}</td>\n                <td class=\"col-md-3 text-left\">{{ detalle.detalle }}</td>\n                \n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n    </div>\n  </div>\n  \n\n  ");
$templateCache.put("app/app/main/alumno/busqueda-alumnos-home.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-search\" ng-class=\"icon\"></i>\n        <span>Búsqueda de Mis Alumnos</span>\n      </div>\n\n      <div class=\"widget-body big no-padding\">\n        <div class=\"panel\">\n          <div class=\"panel-heading\">\n            <form ng-submit=\"vm.onSubmit()\" name=\"vm.form\" novalidate>\n              <formly-form model=\"vm.model\" fields=\"vm.fields\" options=\"vm.options\">\n              </formly-form>\n            </form>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div ng-repeat=\"materia in vm.historialMateria | orderBy:[\'materiaId\']\">\n        <desempenio-alumno carrera=\"materia.carrera\" materia=\"materia.nombreMateria\" nombre=\"vm.nombreAlumno\" historial-materia=\"materia.cursados\" historial-examen=\"materia.examenes\">\n        </desempenio-alumno>\n</div>");
$templateCache.put("app/app/main/alumno/desempenio-alumno-modal.html","<div class=\"col-md-12\" style=\"margin-top:2em\">\n    <div class=\"widget\">\n        <div class=\"widget-header\" ng-style=\"{\'background-color\': $odd ? \'#CCCCCC\' : \'#CCCCCC\'}\">\n            <span class=\"\" style=\"font-size: large; font-weight: bold\">{{ $ctrl.materia }}  {{ $ctrl.titulo }}<br> {{ $ctrl.titulo2\n                }}</span>\n                {{ $ctrl.carrera }}    \n        </div>\n        <div class=\"widget-body big no-padding\">\n\n            <div>\n                <div ng-if=\"$ctrl.historialMateria\">\n                    <div class=\"row\" ng-if=\"$ctrl.historialMateria\">\n                        <div class=\"col-md-12 mt-1\">\n                            <div class=\"widget\">\n                                <div class=\"widget-header\">\n                                    <i class=\"fa fa-info-circle\" ng-class=\"icon\"></i>\n                                    <span style=\"font-weight: bold\">Cursado</span>\n                                </div>\n\n                                <div class=\"widget-body big no-padding\" ng-if=\"$ctrl.historialMateria.length\">\n                                    <table class=\"table table-striped table-hover table-condensed table-responsive\">\n                                        <thead>\n                                            <tr>\n                                                <th class=\"text-center\">Año</th>\n                                                <th class=\"text-center\">Cursado</th>\n                                                <th class=\"text-center\">Notas</th>\n                                                <th class=\"text-center\">Nota Final</th>\n                                                <th class=\"text-center\">Estado Académico</th>\n\n                                            </tr>\n                                        </thead>\n                                        <tbody>\n                                            <tr ng-repeat=\"hmateria in $ctrl.historialMateria\">\n                                                <td class=\"col-md-2 text-center\">{{ hmateria.anioAcademic }}</td>\n                                                <td class=\"col-md-2 text-center\">\n                                                    <span ng-if=\"hmateria.tipo ===\'A\'\">\n                                                        Anual</span>\n                                                    <span ng-if=\"hmateria.tipo ===\'1\'\"> 1er\n                                                        Cuatrimestre </span>\n                                                    <span ng-if=\"hmateria.tipo ===\'2\'\"> 2do\n                                                        Cuatrimestre </span>\n                                                </td>\n                                                <td class=\"col-md-2 text-center\">{{ hmateria.notasAsociadas }}</td>\n                                                <td class=\"col-md-2 text-center\"><span ng-if=\"hmateria.notaFinal > 0\">\n                                                        {{\n                                                        hmateria.notaFinal | number:0 }} </span></td>\n                                                <td class=\"col-md-2 text-center\">\n                                                    <span ng-if=\"hmateria.condicion === \'Inscripto\'\" class=\"label label-primary\">Inscripto</span>\n                                                    <span ng-if=\"hmateria.condicion === \'Regular\'\" class=\"label label-info\">Regular</span>\n                                                    <span ng-if=\"hmateria.condicion === \'Libre\'\" class=\"label label-danger\">Libre</span>\n                                                    <span ng-if=\"hmateria.condicion === \'Abandonó\'\" class=\"label label-warning\">Abandonó</span>\n                                                    <span ng-if=\"hmateria.condicion === \'Promocion TP\'\" class=\"label label-success\">Promoción TP</span>\n                                                    <span ng-if=\"hmateria.condicion === \'Ap. Directa\'\" class=\"label label-success\">Ap. Directa</span>\n                                                  </td>                                                  \n\n                                            </tr>\n                                        </tbody>\n                                    </table>\n                                </div>\n                                <div class=\"row\" ng-if=\"!$ctrl.historialMateria.length\">\n                                    <div class=\"col-md-12 text-center\">\n                                        <p>No hay registros de cursado.</p>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n                </div>\n                <div class=\"row\" ng-if=\"($ctrl.historialMateria.condicion !== \'Libre\' && $ctrl.historialMateria.condicion !== \'\') && $ctrl.historialExamen\">\n                    <div class=\"col-md-12\">\n                        <div class=\"widget\">\n                            <div class=\"widget-header\">\n                                <i class=\"fa fa-graduation-cap\" ng-class=\"icon\"></i>\n                                <span style=\"font-weight: bold\">Exámenes</span>\n                            </div>\n\n                            <div class=\"widget-body big no-padding\" ng-if=\"$ctrl.historialExamen.length\">\n                                <table class=\"table table-striped table-hover table-condensed table-responsive\">\n                                    <thead>\n                                        <tr>\n                                            <th class=\"text-center\">Fecha</th>\n                                            <th class=\"text-center\">Nota</th>\n                                        </tr>\n                                    </thead>\n                                    <tbody>\n                                        <tr ng-repeat=\"hexamen in $ctrl.historialExamen\">\n                                            <td class=\"col-md-2 text-center\">{{ hexamen.fecha | date:\'dd/MM/yyyy\' }}\n                                            </td>\n                                            <td class=\"col-md-2 text-center\">{{ hexamen.notaS }}</td>\n                                        </tr>\n                                    </tbody>\n                                </table>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>");
$templateCache.put("app/app/main/cargos-docentes/cargos-docentes.html","<div class=\"row\">\n    <div class=\"col-md-12\">\n      <div class=\"widget\">\n        <div class=\"widget-header\">\n          <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n          <span>Cargos Docentes</span>\n          \n        </div>\n        <div class=\"widget-body big no-padding\">\n  \n          <table class=\"table table-striped table-hover table-condensed table-responsive {{className}}\">\n            <thead>\n              <tr>\n                <!-- <th class=\"text-center\">Especialidad</th> -->\n                <th class=\"text-center\">Cargo</th>\n                <th class=\"text-center\">Nombre</th>\n                <th class=\"text-center\">Depto</th>\n                <th class=\"text-center\">Desde</th>\n                <th class=\"text-center\">Hasta</th>\n                <th class=\"text-center\">Resol</th>\n                <th class=\"text-center\">Vigente</th>\n                <th class=\"text-center\"></th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr ng-repeat=\"cargo in vm.cargos\">\n                <td class=\"col-md-1 text-center\">{{ cargo.cargo }}</td>\n                <td class=\"col-md-3 text-left\">{{ cargo.nomcargo }}</td>\n                <td class=\"col-md-3 text-left\">{{ cargo.nomdpto }}</td>\n                <td class=\"col-md-1 text-center\">{{ cargo.desde }}</td>\n                <td class=\"col-md-1 text-center\">{{ cargo.hasta }}</td>\n                <td class=\"col-md-1 text-center\">{{ cargo.resol }}</td>\n                <td class=\"col-md-1 text-center\">\n                    <span ng-if=\"cargo.activa\" class=\"text-success\"><i class=\"fa fa-check\"></i></span>\n                    <span ng-if=\"!cargo.activa\" class=\"text-danger\"><i class=\"fa fa-times\"></i></span>\n                </td>\n                <td class=\"col-md-1 text-center\">\n                    <button type=\"button\" title=\"Ver Información\" class=\"btn btn-primary\" ng-click=\"vm.mostrarCargo(cargo)\">\n                        <i class=\"fa fa-search\"></i>\n                    </button>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n    </div>\n  </div>\n  \n<div id=\"modalCargo\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\" role=\"document\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h5 class=\"modal-title\" style=\"font-size: large; font-weight: bold\">Detalle del Cargo</h5>\n            </div>\n            <div class=\"modal-body\">\n                <p ng-if=\"vm.cargoSeleccionado.cargo\"><strong>Cargo:</strong> {{ vm.cargoSeleccionado.cargo }}</p>\n                <p ng-if=\"vm.cargoSeleccionado.nomcargo\"><strong>Nombre Cargo:</strong> {{ vm.cargoSeleccionado.nomcargo }}</p>\n                <p ng-if=\"vm.cargoSeleccionado.nomdpto\"><strong>Departamento:</strong> {{ vm.cargoSeleccionado.nomdpto }}</p>\n                <p ng-if=\"vm.cargoSeleccionado.dedica\"><strong>Dedicación:</strong> {{ vm.cargoSeleccionado.dedica }} hs</p>\n                <p ng-if=\"vm.cargoSeleccionado.desde\"><strong>Desde:</strong> {{ vm.cargoSeleccionado.desde }} - <strong>Hasta:</strong> {{ vm.cargoSeleccionado.hasta }}</p>\n                <p ng-if=\"vm.cargoSeleccionado.resol\"><strong>Resolución:</strong> {{ vm.cargoSeleccionado.resol }}</p>\n                <p ng-if=\"vm.cargoSeleccionado.materia\"><strong>Materia:</strong> {{ vm.cargoSeleccionado.materia }}</p>\n                <p ng-if=\"vm.cargoSeleccionado.comision\"><strong>Comisión:</strong> {{ vm.cargoSeleccionado.comision }}</p>\n                <p ng-if=\"vm.cargoSeleccionado.cantcur\"><strong>Cantidad de Cursos:</strong> {{ vm.cargoSeleccionado.cantcur }}</p>\n                <p ng-if=\"vm.cargoSeleccionado.investiga\"><strong>Investigación:</strong> {{ vm.cargoSeleccionado.investiga }}</p>\n                <p ng-if=\"vm.cargoSeleccionado.extension\"><strong>Extensión:</strong> {{ vm.cargoSeleccionado.extension }}</p>\n                <p ng-if=\"vm.cargoSeleccionado.gestion\"><strong>Gestión:</strong> {{ vm.cargoSeleccionado.gestion }}</p>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\">Cerrar</button>\n            </div>\n        </div>\n    </div>\n</div>\n  ");
$templateCache.put("app/app/main/cargos-docentes/detalle-cargo-docente.html","<div class=\"modal-header\">\n    <h5 class=\"modal-title\" style=\"font-size: large; font-weight: bold\">Detalle del Cargo</h5>\n</div>\n<div class=\"modal-body\">\n    <p ng-if=\"vm.cargoSeleccionado.cargo\"><strong>Cargo:</strong> {{ vm.cargoSeleccionado.cargo }}</p>\n    <p ng-if=\"vm.cargoSeleccionado.nomcargo\"><strong>Nombre Cargo:</strong> {{ vm.cargoSeleccionado.nomcargo }}</p>\n    <p ng-if=\"vm.cargoSeleccionado.nomdpto\"><strong>Departamento:</strong> {{ vm.cargoSeleccionado.nomdpto }}</p>\n    <p ng-if=\"vm.cargoSeleccionado.dedica\"><strong>Dedicación:</strong> {{ vm.cargoSeleccionado.dedica }} hs</p>\n    <p ng-if=\"vm.cargoSeleccionado.desde\"><strong>Desde:</strong> {{ vm.cargoSeleccionado.desde }} -\n        <strong>Hasta:</strong> {{ vm.cargoSeleccionado.hasta }}</p>\n    <p ng-if=\"vm.cargoSeleccionado.resol\"><strong>Resolución:</strong> {{ vm.cargoSeleccionado.resol }}</p>\n    <p ng-if=\"vm.cargoSeleccionado.materia\"><strong>Materia:</strong> {{ vm.cargoSeleccionado.materia }}</p>\n    <p ng-if=\"vm.cargoSeleccionado.comision\"><strong>Comisión:</strong> {{ vm.cargoSeleccionado.comision }}</p>\n    <p ng-if=\"vm.cargoSeleccionado.cantcur\"><strong>Cantidad de Cursos:</strong> {{ vm.cargoSeleccionado.cantcur }}</p>\n    <p ng-if=\"vm.cargoSeleccionado.investiga\"><strong>Investigación:</strong> {{ vm.cargoSeleccionado.investiga }}</p>\n    <p ng-if=\"vm.cargoSeleccionado.extension\"><strong>Extensión:</strong> {{ vm.cargoSeleccionado.extension }}</p>\n    <p ng-if=\"vm.cargoSeleccionado.gestion\"><strong>Gestión:</strong> {{ vm.cargoSeleccionado.gestion }}</p>\n</div>\n<div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" ng-click=\"vm.cerrar()\">Cerrar</button>\n</div>\n");
$templateCache.put("app/app/main/documentacion-docentes/dialogo-cambiar-estado-documentacion.html","<div class=\"modal-header\" ng-if=\"config.titulo\">\n    <h3 class=\"modal-title\" id=\"modal-title\">\n      <i class=\"fa-stack\">\n        <i class=\"fa fa-circle fa-stack-2x\"></i>\n        <i class=\"fa fa-stack-1x fa-inverse {{config.icono}}\"></i>\n      </i>\n      {{config.titulo}}\n    </h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <p>{{config.texto}}</p>\n    <formly-form model=\"config.data\" fields=\"config.fields\" form=\"form\">\n    </formly-form>\n    <p>&nbsp;</p>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn {{config.tipoSi}}\" type=\"button\" ng-disabled=\"form.$invalid\" ng-click=\"config.accionSi(dialogo,config.data)\" ng-if=\"config.si\">{{config.textoSi}}</button>\n    <button class=\"btn {{config.tipoNo}}\" type=\"button\" ng-click=\"config.accionNo(dialogo)\" ng-if=\"config.no\">{{config.textoNo}}</button>\n</div>");
$templateCache.put("app/app/main/encuestas/encuestas.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n        <span>Encuestas</span>\n        <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n      </div>\n      <div class=\"widget-body big no-padding\">\n\n        <table class=\"table table-striped table-hover table-condensed table-responsive {{className}}\">\n          <thead>\n            <tr>\n              <th class=\"text-center\">Asignatura</th>\n              <th class=\"text-center\">Docente</th>\n              <th class=\"text-center\">Cargo</th>\n              <th class=\"text-center\">Estado</th>\n              <th class=\"text-center\">Acciones</th>\n            </tr>\n          </thead>          \n          <tbody>\n            <tr ng-repeat=\"encuesta in vm.encuestas | orderBy:[\'cargoDocente.asignatura.nombre\', \'cargoDocente.tipoCargoDocente.nombre\']\">\n              <td class=\"col-md-4 col text-center\">{{encuesta.cargoDocente.asignatura.nombre}}</td>\n              <td class=\"col-md-3 col text-center\">{{encuesta.persona.apellido}}, {{encuesta.persona.nombre}}</td>\n              <td class=\"col-md-2 col text-center\">{{ encuesta.cargoDocente.tipoCargoDocente.nombre }}</td>\n              <td class=\"col-md-2 col text-center\">\n                <span class=\"label {{vm.getColorEstado(encuesta)}}\">\n                  {{ vm.getNombreEstado(encuesta) }}\n                </span>\n              </td>\n              <td class=\"col-md-1 col\">\n                <div class=\"button text-center\">\n                  <button type=\"button\" title=\"Realizar encuesta\" class=\"btn btn-info\" ng-click=\"vm.realizarEncuesta(encuesta)\" ng-disabled=\"encuesta.encuestaRealizada\">\n                      <i class=\"fa fa-pencil-square-o fa-3x\"></i>  \n                  </button>\n                </div>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </div>    \n    </div>\n  </div> \n</div>\n ");
$templateCache.put("app/app/main/encuestas-docentes/encuestas-docentes-autoridades-home.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n        <span>Encuestas Docentes</span>\n        <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n      </div>\n      <div class=\"widget-body big no-padding\">\n\n         <table class=\"table table-striped table-hover table-condensed table-responsive {{className}}\">\n          <thead>\n            <tr>\n              <th class=\"text-center\">Informe</th>\n              <th class=\"text-center\">Acciones</th>\n            </tr>\n          </thead>          \n          <tbody>\n            <tr ng-repeat=\"informe in vm.informes\">\n              <td class=\"col-md-10 text-left\">{{ informe.nombre }}</td>\n              <td class=\"col-md-2 text-center\">\n                <div class=\"btn-group btn-group\">\n                  <button type=\"button\" title=\"Ver Información\" class=\"btn btn-info\" ng-click=\"vm.verInformes(informe)\">\n                      <i class=\"fa fa-info-circle fa-3x\"></i>\n                  </button>\n                </div>               \n              </td>\n            </tr> \n        </tbody></table></div>\n    </div>      \n  </div>    \n</div>     \n");
$templateCache.put("app/app/main/encuestas-docentes/encuestas-docentes-detail.html","<div class=\"row\">\n  <iframe ng-src=\"{{ vm.link1 }}\" class=\"col-md-12\" ng-style=\"vm.innerComponentStyle\"></iframe>\n</div>");
$templateCache.put("app/app/main/encuestas-docentes/encuestas-docentes-home.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n        <span>Encuestas Docentes</span>\n        <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n      </div>\n      <div class=\"widget-body big no-padding\">\n\n         <table class=\"table table-striped table-hover table-condensed table-responsive {{className}}\">\n          <thead>\n            <tr>\n              <th class=\"text-center\">Informe</th>\n              <th class=\"text-center\">Acciones</th>\n            </tr>\n          </thead>          \n          <tbody>\n            <tr ng-repeat=\"informe in vm.informes\">\n              <td class=\"col-md-10 text-left\">{{ informe.nombre }}</td>\n              <td class=\"col-md-2 text-center\">\n                <div class=\"btn-group btn-group\">\n                  <button type=\"button\" title=\"Ver Información\" class=\"btn btn-info\" ng-click=\"vm.verInformes(informe)\">\n                      <i class=\"fa fa-info-circle fa-3x\"></i>\n                  </button>\n                </div>               \n              </td>\n            </tr> \n        </tbody></table></div>\n    </div>      \n  </div>    \n</div>     \n");
$templateCache.put("app/app/main/estado-academico/estado-academico.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n        <span>Estado Académico</span>\n        <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n      </div>\n      <div class=\"widget-body big no-padding\">\n\n        <table class=\"table table-striped table-hover table-condensed table-responsive {{className}}\">\n          <thead>\n            <tr>\n              <th class=\"text-center\">Asignatura</th>\n              <th class=\"text-center\">Estado</th>\n              <th class=\"text-center\">Falta Para Cursar</th>\n              <th class=\"text-center\">Falta Para Aprobar</th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-click=\"vm.toggleDetalle(detalle)\" ng-repeat=\"detalle in vm.estadoAcademico.detalles | orderBy :\'nivel\'\">\n              <td class=\"col-md-4 col text-center\">{{ detalle.materia.nombre }}</td>\n              <td class=\"col-md-2 col text-center\">\n                <span class=\"label {{vm.getEstado(detalle)}}\"> \n                  {{ vm.getNombreEstado(detalle) }}</span>\n                  </td>       \n              <td class=\"col-md-3 col text-center\">\n                <div ng-if=\"detalle.abierto && detalle.faltaAprobar\" ng-repeat=\"faltaParaCursar in vm.getFaltaParaCursar(detalle)\">\n                  {{ faltaParaCursar }}\n                </div>\n                  <span ng-if=\"!detalle.abierto && detalle.faltaReg\" class=\"label label-default\">...</span>\n                <span ng-if=\"!detalle.faltaReg\">\n                  -\n                </span>\n              </td>\n              <td class=\"col-md-3 col text-center\">\n                <div ng-if=\"detalle.abierto && detalle.faltaAprobar\" ng-repeat=\"faltaParaAprobar in vm.getFaltaParaAprobar(detalle)\">\n                  {{ faltaParaAprobar }}\n                </div>\n                  <span ng-if=\"!detalle.abierto && detalle.faltaAprobar\" class=\"label label-default\">...</span>\n                <span ng-if=\"!detalle.faltaAprobar\">\n                  -\n                </span>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </div>    \n    </div>\n  </div> \n</div>");
$templateCache.put("app/app/main/examen/examen.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n        <span>Exámenes</span>\n        <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n      </div>\n      <div class=\"widget-body big no-padding\">\n\n        <table class=\"table table-striped table-hover table-condensed table-responsive {{className}}\">\n          <thead>\n            <tr>\n              <th class=\"text-center\">Asignatura</th>\n              <th class=\"text-center\">Nota</th>\n              <th class=\"text-center\">Fecha</th>\n            </tr>\n          </thead>          \n          <tbody>\n            <tr ng-repeat=\"detalle in vm.examen.detalles | orderBy:\'fecha\'\">\n              <td class=\"col-md-4 col text-center\">{{ detalle.materia.nombre }}</td>\n              <td class=\"col-md-4 col text-center\">\n                <span class=\"label {{vm.getEstado(detalle)}}\">\n                  {{ vm.getNombreNota(detalle) }}\n                </span>\n              </td>\n              <td class=\"col-md-4 col text-center\">{{ detalle.fecha | date : \'dd/MM/yyyy\' }}</td>\n            </tr>\n          </tbody>\n        </table>\n      </div>    \n    </div>\n  </div> \n</div>\n \n<estadistica-examen examenes=\"vm.examen\"><estadistica-examen>\n\n\n</estadistica-examen></estadistica-examen>");
$templateCache.put("app/app/main/examen-docente/pre-inscripciones-examen-home.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n        <span>Inscripciones a Exámenes</span>\n        <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n\n        <div class=\"alert alert-info mt-1\" role=\"alert\">\n          <p>\n            La siguiente información corresponde a una <strong>preinscripción</strong>.\n            Los alumnos podrán modificar su inscripción hasta el cierre del acta,\n            incluyendo la posibilidad de <strong>cancelarla</strong>.\n          </p>\n        </div>\n\n\n      </div>\n      <div class=\"widget-body big no-padding\">\n\n        <table class=\"table table-striped table-hover table-condensed table-responsive {{className}}\">\n          <thead>\n            <tr>\n              <!-- <th class=\"text-center\">Especialidad</th> -->\n              <th class=\"text-center\">Plan</th>\n              <th class=\"text-center\">Materia</th>\n              <th class=\"text-center\">Inscriptos</th>\n              <th class=\"text-center\"></th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"inscripcion in vm.inscripciones\">\n              <!-- <td class=\"col-md-2  text-center\">{{ inscripcion.materiaDocente.especialidad }}-{{ inscripcion.materiaDocente.abreviaturaEspecialidad }}</td> -->\n              <td class=\"col-md-2 text-center\">{{ inscripcion.materiaDocente.plan }}</td>\n\n              <td class=\"col-md-6 text-left\">{{ inscripcion.materiaDocente.nombreMateria }}</td>\n              <td class=\"col-md-2 text-center\">{{ inscripcion.inscriptos.length }}</td>\n              <td class=\"col-md-2 text-center\">\n                <button type=\"button\" title=\"Ver Información\" class=\"btn btn-primary\" ng-click=\"vm.mostrarInscriptos(inscripcion)\">\n                  <i class=\"fa fa-search\"></i>\n                </button>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n  </div>\n</div>\n<br>\n<div class=\"row\" ng-if=\"vm.selectedInscripcion\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n        <span>Inscriptos para {{ vm.selectedInscripcion.materiaDocente.nombreMateria }}</span>\n        <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n      </div>\n\n      <div class=\"widget-body big no-padding\" ng-if=\"vm.selectedInscripcion.inscriptos.length\">\n        <table class=\"table table-striped table-hover table-condensed table-responsive {{className}}\">\n          <thead>\n            <tr>\n              <th class=\"text-center\">Turno</th>\n              <th class=\"text-center\">Legajo</th>\n              <th class=\"text-center\">Apellido y Nombre</th>\n              <th class=\"text-center\"></th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"inscripto in vm.selectedInscripcion.inscriptos track by (inscripto.legajo + \'-\' + inscripto.turno)\">\n                        <td class=\"col-md-2 text-center\">{{ inscripto.fecha | date:\'dd/MM/yyyy\'}}</td>\n              <td class=\"col-md-2 text-center\">{{ inscripto.legajo }}</td>\n              <td class=\"col-md-2 text-center\">{{ inscripto.nombre }}</td>\n              <td class=\"col-md-2 text-center\">\n                <button type=\"button\" title=\"Ver Información\" class=\"btn btn-primary\" ng-click=\"vm.abrirModalDesempenio(inscripto)\">\n                  <i class=\"fa fa-search fa-3x\"></i>\n                </button>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n\n      <div class=\"widget-body big no-padding text-center\" ng-if=\"!vm.selectedInscripcion.inscriptos.length\">\n        <p class=\"text-muted\">No hay inscriptos en esta materia.</p>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade\" id=\"modalDesempenio\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalLabel\" aria-hidden=\"true\">\n  <div class=\"modal-dialog\" role=\"document\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h5 class=\"modal-title\" id=\"modalLabel\">{{ vm.selectedInscripcion.materiaDocente.nombreMateria }} </h5>\n        <span aria-hidden=\"true\">{{ vm.inscripto.nombre }}</span>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Cerrar\">\n          <span aria-hidden=\"true\">&times;</span>\n        </button>\n      </div>\n      <div class=\"modal-body\">\n        <desempenio-alumno nombre=\"vm.inscripto.nombre\" historial-materia=\"vm.historialMateria\" historial-examen=\"vm.historialExamen\">\n        </desempenio-alumno>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\">Cerrar</button>\n      </div>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/app/main/horario-cursado/horario-cursado.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n        <span>Horario de Cursado</span>\n        <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n      </div>\n      <div class=\"widget-body big no-padding\">\n\n        <div ui-calendar=\"vm.uiConfig.calendar\"></div>\n\n      </div>    \n    </div>\n  </div> \n</div>\n\n\n\n");
$templateCache.put("app/app/main/horario-cursado-aula/horario-cursado-aula.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n        <span>Horario de Aula</span>\n        <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n      </div>\n      <div class=\"widget-body big no-padding\">\n        <div class=\"panel\">\n          <div class=\"panel-heading\">\n            <form name=\"vm.form\" novalidate>\n              <formly-form model=\"vm.model\" fields=\"vm.formFields\" form=\"vm.form\">\n                <br>\n                <button type=\"button\" ng-click=\"vm.cargarClases()\" class=\"btn btn-primary submit-button text-center\" ng-disabled=\"!(vm.model.edificio && vm.model.aula)\">Buscar</button>\n              </formly-form>\n            </form>\n          </div>\n\n          <div class=\"panel-body\">\n            <div ui-calendar=\"vm.uiConfig.calendar\" ng-if=\"vm.eventos && vm.eventos.length > 0\" ng-model=\"vm.eventsSources\" calendar=\"myCalendar\"></div>\n          </div>\n        </div>\n      </div>    \n    </div>\n  </div> \n</div>\n\n\n\n");
$templateCache.put("app/app/main/horario-cursado-docente/horario-cursado-docente.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n        <span>Horario de Dictado</span>\n        <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n      </div>\n      <div class=\"widget-body big no-padding\">\n\n        <div ui-calendar=\"vm.uiConfig.calendar\"></div>\n\n      </div>    \n    </div>\n  </div> \n</div>\n\n\n\n");
$templateCache.put("app/app/main/horario-cursado-docente-filtrar/horario-cursado-docente.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n        <span>Horario de Docente</span>\n        <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n      </div>\n      <div class=\"widget-body big no-padding\">\n        <div class=\"panel\">\n          <div class=\"panel-heading\">\n            <form ng-submit=\"vm.onSubmit()\" name=\"vm.form\" novalidate>\n              <formly-form model=\"vm.model\" fields=\"vm.fields\" options=\"vm.options\">\n              </formly-form>\n            </form>\n          </div>\n          <div class=\"panel-body\">\n            <div ui-calendar=\"vm.uiConfig.calendar\" ng-if=\"vm.eventos && vm.eventos.length > 0\" ng-model=\"vm.eventsSources\" calendar=\"myCalendar\"></div>\n            <div ng-if=\"!(vm.eventos && vm.eventos.length > 0) && vm.model.docente.docente.legajo != null \n              && vm.flag\">\n              No hay comisiones cargadas\n            </div>\n          </div>\n        </div>\n      </div>    \n    </div>\n  </div> \n</div>\n\n\n");
$templateCache.put("app/app/main/horario-cursado-especialidad/horario-cursado-especialidad.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n        <span>Horario de Especialidad</span>\n        <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n      </div>\n      <div class=\"widget-body big no-padding\">\n        <div class=\"panel\">\n          <div class=\"panel-heading\">\n            <div class=\"row\">\n              <div class=\"form-group col-sm-5\">\n                <label>Especialidad: </label>\n                <select class=\"form-control\" ng-model=\"vm.model.especialidad\" ng-options=\"especialidad.nombre for especialidad in vm.especialidades | orderBy:\'nombre\' track by especialidad.especialid \"></select>\n              </div>\n              <div class=\"form-group col-sm-5\">\n                <label>Nivel: </label>\n                <input type=\"number\" min=\"1\" max=\"6\" class=\"form-control\" ng-model=\"vm.model.nivel\">\n              </div>\n              <div class=\"form-group col-sm-2\">\n                 <br>\n                 <button type=\"button\" ng-click=\"vm.cargarClases()\" class=\"btn btn-primary submit-button text-center\" ng-disabled=\"!(vm.model.especialidad && vm.model.nivel)\">Buscar</button>\n              </div>\n            </div>\n                \n          </div>\n\n          <div class=\"panel-body\">\n            <div ui-calendar=\"vm.uiConfig.calendar\" ng-if=\"vm.eventos && vm.eventos.length > 0\" ng-model=\"vm.eventsSources\" calendar=\"myCalendar\"></div>\n          </div>\n        </div>\n      </div>    \n    </div>\n  </div> \n</div>\n\n\n\n");
$templateCache.put("app/app/main/inscripcion-cursado/dialogo-confirmacion-visualizacion-comisiones.html","<div class=\"modal-header\" ng-if=\"config.titulo\">\n    <h3 class=\"modal-title\" id=\"modal-title\">\n      <i class=\"fa-stack\">\n        <i class=\"fa fa-circle fa-stack-2x\"></i>\n        <i class=\"fa fa-stack-1x fa-inverse {{config.icono}}\"></i>\n      </i>\n      {{config.titulo}}\n    </h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <li ng-repeat=\"parrafo in config.parrafos\"> {{parrafo}}</li>\n    {{config.texto}}\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn {{config.tipoSi}}\" type=\"button\" ng-click=\"config.accionSi(dialogo)\" ng-if=\"config.si\">{{config.textoSi}}</button>\n    <button class=\"btn {{config.tipoNo}}\" type=\"button\" ng-click=\"config.accionNo(dialogo)\" ng-if=\"config.no\">{{config.textoNo}}</button>\n</div>\n");
$templateCache.put("app/app/main/inscripcion-cursado/dialogo-error-inscripcion-cursado.html","<div class=\"modal-header\" ng-if=\"config.titulo\">\n    <h3 class=\"modal-title\" id=\"modal-title\">\n      <i class=\"fa-stack\">\n        <i class=\"fa fa-circle fa-stack-2x\"></i>\n        <i class=\"fa fa-stack-1x fa-inverse {{config.icono}}\"></i>\n      </i>\n      {{config.titulo}}\n    </h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <li ng-repeat=\"parrafo in config.parrafos\"> {{parrafo}}</li>\n    {{config.texto}}\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn {{config.tipoSi}}\" type=\"button\" ng-click=\"config.accionSi(dialogo)\" ng-if=\"config.si\">{{config.textoSi}}</button>\n    <button class=\"btn {{config.tipoNo}}\" type=\"button\" ng-click=\"config.accionNo(dialogo)\" ng-if=\"config.no\">{{config.textoNo}}</button>\n</div>\n");
$templateCache.put("app/app/main/inscripcion-cursado/inscripcion-cursado.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n        <span>Inscripción a Cursado</span>\n        <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n      </div>\n      <div class=\"widget-body big no-padding\">\n\n        <table class=\"table table-striped table-hover table-condensed table-responsive {{className}}\">\n          <thead>\n            <tr>\n        			<th class=\"text-center\">Asignatura</th>\n              <th class=\"text-center\">Estado</th>\n              <th class=\"text-center\">Acciones</th>\n        		</tr>\n          </thead>\n          <tbody>\n        		<tr ng-repeat=\"materia in vm.materias | orderBy:[\'estado\',\'nombreLargo\']\">\n        			<td class=\"col-md-6 col text-center\">{{ materia.nombreLargo }}</td>   \n              <td class=\"col-md-4 col text-center\">\n                <span class=\"label {{vm.getEstado(materia)}}\"> \n                  {{vm.getNombreEstado(materia)}}\n                </span>\n              </td>\n              <td class=\"col-md-2 col text-center\">\n                <div class=\"btn-group btn-group\">\n                  <button type=\"button\" title=\"Ver Comisiones\" class=\"btn btn-primary\" ng-if=\"!materia.checksum && materia.estado === \'cursable\'\" ng-click=\"vm.verificarCursado(materia)\">\n                      <i class=\"fa fa-search fa-3x\"></i>  \n                  </button>\n                  <button type=\"button\" title=\"Anular\" class=\"btn btn-danger\" ng-if=\"materia.checksum && materia.estado === \'cursando\'\" ng-click=\"vm.confirmarAnulacion(materia)\">\n                      <i class=\"fa fa-trash fa-3x\"></i>\n                  </button>\n                  <button type=\"button\" title=\"Ver Información\" class=\"btn btn-info\" ng-if=\"materia.checksum && materia.estado === \'cursando\'\" ng-click=\"vm.verificarCursado(materia)\">\n                      <i class=\"fa fa-info-circle fa-3x\"></i>\n                  </button>\n                </div>               \n              </td>                \n        		</tr>\n        	</tbody>\n        </table>\n\n      </div>    \n    </div>\n  </div> \n</div>\n\n");
$templateCache.put("app/app/main/libro-de-temas/libro-de-temas.html","<ui-view>\n	\n	\n</ui-view>\n");
$templateCache.put("app/app/main/materia-cursando/materia-cursando.html","<ui-view>\n  \n  \n</ui-view>");
$templateCache.put("app/app/main/materia-docente/dialogo-confirmar-cierre-comision.html","<div class=\"modal-header\" ng-if=\"config.titulo\">\n    <h3 class=\"modal-title\" id=\"modal-title\">\n      <i class=\"fa-stack\">\n        <i class=\"fa fa-circle fa-stack-2x\"></i>\n        <i class=\"fa fa-stack-1x fa-inverse {{config.icono}}\"></i>\n      </i>\n      {{config.titulo}}\n    </h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <p>{{config.texto}}</p>\n    <formly-form model=\"config.data\" fields=\"config.fields\" form=\"form\">\n    </formly-form>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn {{config.tipoSi}}\" type=\"button\" ng-disabled=\"form.$invalid\" ng-click=\"config.accionSi(dialogo,config.data)\" ng-if=\"config.si\">{{config.textoSi}}</button>\n    <button class=\"btn {{config.tipoNo}}\" type=\"button\" ng-click=\"config.accionNo(dialogo)\" ng-if=\"config.no\">{{config.textoNo}}</button>\n</div>\n");
$templateCache.put("app/app/main/materia-docente/dialogo-confirmar-notas-inmediato.html","<div class=\"modal-header\" ng-if=\"config.titulo\">\n    <h3 class=\"modal-title\" id=\"modal-title\">\n      <i class=\"fa-stack\">\n        <i class=\"fa fa-circle fa-stack-2x\"></i>\n        <i class=\"fa fa-stack-1x fa-inverse {{config.icono}}\"></i>\n      </i>\n      {{config.titulo}}\n    </h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <p>{{config.texto}}</p>\n    <formly-form model=\"config.data\" fields=\"config.fields\" form=\"form\">\n    </formly-form>\n    <p>Si no confirma las notas ahora, puede hacerlo luego desde la opción \"Confirmar notas\" en la lista de cátedras.</p>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn {{config.tipoSi}}\" type=\"button\" ng-disabled=\"form.$invalid\" ng-click=\"config.accionSi(dialogo,config.data)\" ng-if=\"config.si\">{{config.textoSi}}</button>\n    <button class=\"btn {{config.tipoNo}}\" type=\"button\" ng-click=\"config.accionNo(dialogo)\" ng-if=\"config.no\">{{config.textoNo}}</button>\n</div>");
$templateCache.put("app/app/main/materia-docente/dialogo-confirmar-notas.html","<div class=\"modal-header\" ng-if=\"config.titulo\">\n    <h3 class=\"modal-title\" id=\"modal-title\">\n      <i class=\"fa-stack\">\n        <i class=\"fa fa-circle fa-stack-2x\"></i>\n        <i class=\"fa fa-stack-1x fa-inverse {{config.icono}}\"></i>\n      </i>\n      {{config.titulo}}\n    </h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <formly-form model=\"config.data\" fields=\"config.fields\" form=\"form\">\n    </formly-form>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn {{config.tipoSi}}\" type=\"button\" ng-disabled=\"form.$invalid\" ng-click=\"config.accionSi(dialogo,config.data)\" ng-if=\"config.si\">{{config.textoSi}}</button>\n    <button class=\"btn {{config.tipoNo}}\" type=\"button\" ng-click=\"config.accionNo(dialogo)\" ng-if=\"config.no\">{{config.textoNo}}</button>\n</div>\n");
$templateCache.put("app/app/main/materia-electiva/materia-electiva.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n        <span>Materias Electivas</span>\n        <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n      </div>\n      <div class=\"widget-body big no-padding\">\n        <table class=\"table table-striped table-hover table-condensed table-responsive {{className}}\">\n            <thead>\n                <tr>\n        			<th class=\"text-center\">Asignatura</th>\n        			<th class=\"text-center\">Horas</th>\n        			<th class=\"text-center\">Dictado</th>\n        			<th class=\"text-center\">Año</th>\n        			<th class=\"text-center\">Carrera</th>\n                    <th class=\"text-center\">Estado</th>\n                    <th class=\"text-center\">Exámen</th>\n        		</tr>\n            </thead>          \n            <tbody>\n        		<tr ng-repeat=\"electiva in vm.materiasElectivas | orderBy :\'anoacademi\'\">\n        			<td class=\"col-md-2 col text-center\">{{ electiva.materia }}</td>\n        			<td class=\"col-md-1 col text-center\">{{ electiva.horas }}</td>\n        			<td class=\"col-md-2 col text-center\">\n        				<span ng-if=\"electiva.dictado ===\'A\'\"> Anual </span>\n        				<span ng-if=\"electiva.dictado ===\'1\'\"> 1er Cuatrimestre </span>\n        				<span ng-if=\"electiva.dictado ===\'2\'\"> 2do Cuatrimestre </span>\n        			</td>\n        			<td class=\"col-md-1 col text-center\">{{electiva.anoacademi}}</td>\n        			<td class=\"col-md-2 col text-center\">{{electiva.carrera}}</td>\n                    <td class=\"col-md-2 col text-center\">\n                        <span class=\"label {{vm.getEstado(electiva)}}\"> \n                            {{vm.getNombreEstado(electiva)}}\n                        </span>\n                    </td>\n                    <td class=\"col-md-2 col text-center\" ng-if=\"electiva.examen\">\n                        Fecha: {{electiva.fechaExamen | date:\'dd/MM/yyyy\'}}\n                        <br>Nota: {{electiva.notaExamen}}<br>\n                    </td>\n                    <td class=\"col-md-2 col text-center\" ng-if=\"!electiva.examen\">\n                        <span>-</span>\n                    </td>                  \n        		</tr>\n        	</tbody>\n        </table>\n      </div>    \n    </div>\n  </div> \n</div>\n\n\n<div class=\"row\">\n    <div class=\"col-md-4\">\n        <div class=\"widget\">\n            <div class=\"widget-body\">\n                <div class=\"widget-content\">\n                   <div class=\"widget-icon green pull-left\">\n                      <i class=\"fa fa-clock-o\"></i>\n                    </div>\n                    <div class=\"title\">\n                      {{vm.totales.aprobadas | number:1}}\n                    </div> \n                    <div class=\"comment\">\n                      Horas aprobadas\n                    </div> \n                </div>\n            </div>\n        </div>\n    </div>	\n\n    <div class=\"col-md-4\">\n        <div class=\"widget\">\n            <div class=\"widget-body\">\n                <div class=\"widget-content\">\n                    <div class=\"widget-icon blue pull-left\">\n                        <i class=\"fa fa-clock-o\"></i>\n                    </div>\n                    <div class=\"title\">\n                        {{vm.totales.regulares | number:1}}\n                    </div> \n                    <div class=\"comment\">\n                        Horas regularizadas\n                    </div> \n                </div>\n            </div>\n        </div>\n    </div>   \n\n    <div class=\"col-md-4\">\n        <div class=\"widget\">\n            <div class=\"widget-body\">\n                <div class=\"widget-content\">\n                    <div class=\"widget-icon orange pull-left\">\n                        <i class=\"fa fa-clock-o\"></i>\n                    </div>\n                    <div class=\"title\">\n                        {{vm.totales.cursando | number:1}}\n                    </div> \n                    <div class=\"comment\">\n                        Horas cursando\n                    </div> \n                </div>\n            </div>\n        </div>\n    </div>    \n</div>");
$templateCache.put("app/app/main/notificacion/bandeja-notificacion.html","<div class=\"row\">\n    <div class=\"col-md-12\">\n        <div class=\"widget\">\n            <div class=\"widget-header\">\n                <i class=\"fa fa-bell\" ng-class=\"icon\"></i>\n                <span>Bandeja de Notificaciones</span>\n            </div>\n\n            <div class=\"widget-body big no-padding\">\n                <div class=\"panel\">\n                    <div class=\"panel-heading\">\n                        <form ng-submit=\"vm.onSubmit()\" name=\"vm.form\" novalidate>\n                            <formly-form model=\"vm.model\" fields=\"vm.fields\" options=\"vm.options\">\n\n                                <!-- FILTROS -->\n                                <div class=\"row\" style=\"margin-bottom:15px\">\n\n                                    <div class=\"col-md-3\">\n                                        <input type=\"text\" class=\"form-control\" placeholder=\"Buscar por título o mensaje...\" ng-model=\"vm.filtro.texto\">\n                                    </div>\n\n                                    <div class=\"col-md-1\">\n                                        <select class=\"form-control\" ng-model=\"vm.filtro.anio\" ng-options=\"a for a in vm.aniosDisponibles\">\n                                            <option value=\"\">Todos</option>\n                                        </select>\n                                    </div> \n\n                                    <div class=\"col-md-2\">\n                                        <input type=\"date\" class=\"form-control\" ng-model=\"vm.filtro.desde\">\n                                    </div>\n\n                                    <div class=\"col-md-2\">\n                                        <input type=\"date\" class=\"form-control\" ng-model=\"vm.filtro.hasta\">\n                                    </div>\n\n                                    <div class=\"col-md-2\">\n                                        <select class=\"form-control\" ng-model=\"vm.filtro.estado\">\n                                            <option value=\"\">Todas</option>\n                                            <option value=\"leidas\">Leídas</option>\n                                            <option value=\"noLeidas\">No leídas</option>\n                                        </select>\n                                    </div>\n\n                                    <div class=\"col-md-2\">\n                                        <button class=\"btn btn-default btn-block\" ng-click=\"vm.limpiarFiltros()\">\n                                            Resetar filtros\n                                        </button>\n                                    </div>\n\n                                </div>\n\n                                <!-- SIN NOTIFICACIONES \n                                <div ng-if=\"vm.notificaciones.length === 0\" class=\"alert alert-info\">\n                                    No tenés notificaciones.\n                                </div>-->\n\n                                <!-- LISTADO -->\n                                <!-- <div ng-repeat=\"n in vm.notificaciones \n                    | filter:vm.filtroTexto \n                    | filter:vm.filtroEstado \n                    | filter:vm.filtroFecha\n                    | orderBy:\'-fecha\'\n                    | limitTo:vm.tamanioPagina:(vm.paginaActual-1)*vm.tamanioPagina\"\n        class=\"panel notificacion-panel\"\n        ng-class=\"{\n            \'panel-primary\': !n.leida,\n            \'panel-default notificacion-leida\': n.leida\n        }\"\n        style=\"cursor:pointer;\"\n        ng-click=\"vm.verNotificacion(n)\">\n\n        <div class=\"panel-heading\">\n\n            <strong>{{ n.titulo }}</strong>\n\n            <span style=\"float:right;\">\n                {{ n.fecha | date:\'dd/MM/yyyy HH:mm\' }}\n            </span>\n\n        </div>\n\n        <div class=\"panel-body\">\n            {{ n.mensaje }}\n\n            <button ng-if=\"!n.leida\" class=\"btn btn-xs btn-success\" style=\"float:right;\"\n                ng-click=\"vm.marcarComoLeida(n, $event)\">\n                Notificado\n            </button>\n\n            \n        </div>\n\n\n\n    </div> -->\n                                <!-- TABLA NOTIFICACIONES -->\n                                <div class=\"table-responsive\" ng-if=\"vm.notificacionesFiltradas().length > 0\">\n\n                                    <table class=\"table table-hover table-striped\">\n\n                                        <thead>\n                                            <tr>\n                                                <th style=\"width:40px\"></th>\n                                                <th style=\"width:40px\"></th>\n                                                <th>Título</th>\n                                                <th style=\"width:160px\">Categoría</th>\n                                                <th style=\"width:150px\">Recepción</th>\n                                                <th style=\"width:150px\">Lectura</th>\n                                                <th style=\"width:150px\">Remitente</th>\n                                            </tr>\n                                        </thead>\n\n                                        <tbody>\n\n                                            <tr ng-repeat=\"n in vm.notificacionesFiltradas()\n                        | orderBy:\'-fechaRecepcion\'\n                        | limitTo:vm.tamanioPagina:(vm.paginaActual-1)*vm.tamanioPagina\" ng-class=\"{\'info\': !vm.estaLeida(n)}\" style=\"cursor:pointer\" ng-click=\"vm.seleccionarNotificacion(n)\">\n\n                                                <td class=\"text-center\">\n                                                    <i class=\"fa\" ng-class=\"{\n                     \'fa-envelope\': !vm.estaLeida(n),\n                     \'fa-envelope-open-o\': vm.estaLeida(n)\n                   }\">\n                                                    </i>\n                                                </td>\n\n                                                <td class=\"text-center\">\n                                                    <a ng-if=\"n.tieneAdjunto\" ng-click=\"vm.descargarAdjunto(n)\" style=\"cursor:pointer\" title=\"{{n.nombreAdjunto}}\">\n                                                        <i class=\"fa fa-paperclip\"></i>\n                                                    </a>\n                                                </td>\n\n                                                <td>\n                                                    <strong ng-if=\"!vm.estaLeida(n)\">{{n.titulo}}</strong>\n                                                    <span ng-if=\"vm.estaLeida(n)\">{{n.titulo}}</span>\n                                                </td>\n\n                                                <td>\n\n                                                    <span class=\"label label-primary\" ng-if=\"n.categoria\">\n                                                        {{n.categoria}}\n                                                    </span>\n\n                                                    <span class=\"label label-primary\" ng-if=\"!n.categoria\">\n                                                        Notificaciones\n                                                    </span>\n\n                                                </td>\n                                                <td>\n                                                    {{ (n.fechaRecepcion || n.fecha) | date:\'dd/MM/yyyy HH:mm\' }}\n                                                </td>\n\n                                                <td>\n\n                                                    <span ng-if=\"vm.calcularFechaLectura(n)\">\n                                                        {{ vm.calcularFechaLectura(n) | date:\'dd/MM/yyyy HH:mm\' }}\n                                                    </span>\n\n                                                    <span ng-if=\"!vm.calcularFechaLectura(n)\">\n                                                        —\n                                                    </span>\n\n                                                </td>\n\n                                                <td>\n                                                    <span ng-if=\"n.remitente\">{{n.remitente}}</span>\n                                                    <span ng-if=\"!n.remitente\" class=\"text-muted\">—</span>\n                                                </td>\n\n\n                                            </tr>\n\n                                        </tbody>\n\n                                    </table>\n\n                                </div>\n\n                    </formly-form></form></div>\n\n                    <div class=\"text-center\" style=\"margin-top:20px\" ng-if=\"vm.totalPaginas() > 1\">\n\n                        <button class=\"btn btn-default\" ng-disabled=\"vm.paginaActual === 1\" ng-click=\"vm.cambiarPagina(vm.paginaActual - 1)\">\n                            &laquo;\n                        </button>\n\n                        <span style=\"margin:0 10px\">\n                            Página {{vm.paginaActual}} de {{vm.totalPaginas()}}\n                        </span>\n\n                        <button class=\"btn btn-default\" ng-disabled=\"vm.paginaActual === vm.totalPaginas()\" ng-click=\"vm.cambiarPagina(vm.paginaActual + 1)\">\n                            &raquo;\n                        </button>\n\n                    </div>\n\n                    \n                    \n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<script type=\"text/ng-template\" id=\"ver-notificacion-modal.html\">\n\n<div class=\"modal-header\">\n    <h4 class=\"modal-title\">\n        {{n.titulo}}\n    </h4>\n</div>\n\n<div class=\"modal-body\">\n\n    <div style=\"margin-bottom:10px;color:#777;\">\n        <strong>Categoría:</strong> {{n.categoria || \'Notificaciones\'}}\n        <br>\n        <strong>Recibido:</strong>\n        {{ (n.fechaRecepcion || n.fecha) | date:\'dd/MM/yyyy HH:mm\' }}\n    </div>\n\n    <div ng-if=\"n.tieneAdjunto\" style=\"margin-bottom:12px;\">\n        <a ng-click=\"descargar()\" style=\"cursor:pointer; color:#2980b9;\">\n            <i class=\"fa fa-download\"></i> Descargar archivo adjunto\n            <span ng-if=\"n.nombreAdjunto\" style=\"color:#777; font-size:12px;\"> — {{n.nombreAdjunto}}</span>\n        </a>\n    </div>\n\n    <hr>\n\n    <div style=\"white-space:pre-line;\">\n        {{n.mensaje}}\n    </div>\n\n</div>\n\n<div class=\"modal-footer\">\n\n    <button class=\"btn btn-primary\" ng-click=\"cerrar()\">\n        Cerrar\n    </button>\n\n</div>\n\n</script>\n\n<div class=\"panel panel-default\" ng-if=\"vm.notificacionSeleccionada\">\n\n    <div class=\"panel-heading\">\n\n        <strong>\n            {{vm.notificacionSeleccionada.titulo}}\n        </strong>\n\n        <span style=\"float:right\">\n            {{ (vm.notificacionSeleccionada.fechaRecepcion || vm.notificacionSeleccionada.fecha) | date:\'dd/MM/yyyy\n            HH:mm\' }}\n        </span>\n\n    </div>\n\n    <div class=\"panel-body\">\n\n        <div ng-if=\"vm.notificacionSeleccionada.tieneAdjunto\" style=\"margin-bottom:10px\">\n            <a ng-click=\"vm.descargarAdjunto(vm.notificacionSeleccionada)\" style=\"cursor:pointer; color:#2980b9\">\n                <i class=\"fa fa-download\"></i> Descargar archivo adjunto\n                <span ng-if=\"vm.notificacionSeleccionada.nombreAdjunto\" style=\"color:#777; font-size:12px\">\n                    — {{vm.notificacionSeleccionada.nombreAdjunto}}\n                </span>\n            </a>\n        </div>\n\n        <hr>\n        <div style=\"white-space:pre-line\">\n            {{vm.notificacionSeleccionada.mensaje}}\n        </div>\n\n    </div>\n\n</div>\n");
$templateCache.put("app/app/main/notificacion/enviar-notificacion.html","<div class=\"widget\">\n  <div class=\"widget-header\">\n    <i class=\"ion ion-paper-airplane\"></i>\n    <span>Enviar Notificación</span>\n  </div>\n\n  <div class=\"widget-body\">\n\n    <div class=\"form-group\">\n      <label>1. Seleccionar categoría</label>\n      <select class=\"form-control\" ng-model=\"vm.categoriaSeleccionada\" ng-options=\"c as c.nombre for c in vm.categorias\" ng-change=\"vm.onCategoriaChange()\">\n        <option value=\"\">-- Seleccione una categoría --</option>\n      </select>\n    </div>\n\n    <div class=\"form-group\" ng-if=\"vm.categoriaSeleccionada\">\n      <label>2. Seleccionar notificación</label>\n      <div class=\"row\" style=\"margin-bottom:8px\">\n        <div class=\"col-md-3\">\n          <select class=\"form-control\" ng-model=\"vm.filtroAnio\" ng-change=\"vm.notificacionSeleccionada = null\">\n            <option value=\"\">Todos los años</option>\n            <option ng-repeat=\"a in vm.aniosDisponibles\" value=\"{{a}}\">{{a}}</option>\n          </select>\n        </div>\n      </div>\n      <div ng-if=\"vm.notificacionesFiltradas().length === 0\" class=\"alert alert-info\">\n        No hay notificaciones disponibles para esta categoría y año.\n      </div>\n      <select class=\"form-control\" ng-if=\"vm.notificacionesFiltradas().length > 0\" ng-model=\"vm.notificacionSeleccionada\" ng-options=\"n as n.titulo for n in vm.notificacionesFiltradas()\" ng-change=\"vm.onNotificacionChange()\">\n        <option value=\"\">-- Seleccione una notificación --</option>\n      </select>\n    </div>\n\n    <!-- Edito el mensaje -->\n    <div ng-if=\"vm.notificacionSeleccionada\" style=\"margin-bottom:15px\">\n      <div class=\"form-group\">\n        <label>Título <small class=\"text-muted\">(podés modificarlo)</small></label>\n        <input type=\"text\" class=\"form-control\" ng-model=\"vm.tituloEditable\">\n      </div>\n      <div class=\"form-group\">\n        <label>Mensaje <small class=\"text-muted\">(podés modificarlo)</small></label>\n        <textarea class=\"form-control\" rows=\"4\" ng-model=\"vm.mensajeEditable\"></textarea>\n      </div>\n    </div>\n\n    <div ng-if=\"vm.notificacionSeleccionada\">\n\n      <!-- Buscador de destinatarios (grupos y personas) -->\n      <div class=\"form-group\">\n        <label>3. Agregar destinatarios (grupos o personas)</label>\n        <div class=\"input-group\">\n          <input type=\"text\" class=\"form-control\" placeholder=\"Nombre de grupo, persona, apellido o legajo...\" ng-model=\"vm.textoBusqueda\" ng-change=\"vm.buscarDestinatarios()\">\n          <span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span>\n        </div>\n\n        <!-- Resultados de búsqueda -->\n        <div ng-if=\"vm.resultadosBusqueda.length > 0\" style=\"margin-top:8px\">\n          <select class=\"form-control\" ng-model=\"vm.destinatarioTemporal\" ng-options=\"r as vm.getNombreDestinatario(r) for r in vm.resultadosBusqueda\">\n            <option value=\"\">-- Seleccione para agregar --</option>\n          </select>\n          <button class=\"btn btn-default btn-sm\" style=\"margin-top:5px\" ng-click=\"vm.agregarDestinatario(vm.destinatarioTemporal); vm.destinatarioTemporal = null;\" ng-disabled=\"!vm.destinatarioTemporal\">\n            <i class=\"fa fa-plus\"></i> Agregar\n          </button>\n        </div>\n\n        <div ng-if=\"vm.textoBusqueda.length >= 2 && vm.resultadosBusqueda.length === 0 && !vm.buscando\" class=\"alert alert-info\" style=\"margin-top:8px\">\n          No se encontraron resultados.\n        </div>\n\n        <!-- Lista de destinatarios seleccionados -->\n        <div ng-if=\"vm.destinatarios.length > 0\" style=\"margin-top:10px\">\n          <label>Destinatarios seleccionados:</label>\n          <ul class=\"list-group\">\n            <li class=\"list-group-item\" ng-repeat=\"d in vm.destinatarios\" style=\"padding:6px 12px; display:flex; justify-content:space-between; align-items:center\">\n              <span>\n                <span class=\"label label-default\" style=\"margin-right:6px\">\n                  {{ d.apellido ? \'Persona\' : \'Grupo\' }}\n                </span>\n                {{ vm.getNombreDestinatario(d) }}\n              </span>\n              <a ng-click=\"vm.quitarDestinatario($index)\" style=\"cursor:pointer; color:#e74c3c\">\n                <i class=\"fa fa-times\"></i>\n              </a>\n            </li>\n          </ul>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label>Adjunto PDF (opcional)</label>\n        <input type=\"file\" accept=\".pdf\" onchange=\"angular.element(this).scope().vm.onArchivoSeleccionado(this)\">\n        <span ng-if=\"vm.adjunto\" style=\"margin-left:8px; color:#27ae60\">\n          <i class=\"fa fa-paperclip\"></i> {{ vm.adjunto.nombre }}\n          <a ng-click=\"vm.quitarAdjunto()\" style=\"cursor:pointer; color:#e74c3c; margin-left:5px\">\n            <i class=\"fa fa-times\"></i>\n          </a>\n        </span>\n      </div>\n\n      <button class=\"btn btn-primary\" ng-click=\"vm.enviar()\" ng-disabled=\"vm.destinatarios.length === 0 || vm.enviando\">\n        <i class=\"fa fa-paper-plane\" ng-if=\"!vm.enviando\"></i>\n        <i class=\"fa fa-spinner fa-spin\" ng-if=\"vm.enviando\"></i>\n        {{ vm.enviando ? \'Enviando...\' : \'Enviar\' }}\n      </button>\n\n    </div>\n\n  </div>\n</div>\n");
$templateCache.put("app/app/main/notificacion/notificaciones-enviadas.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"ion ion-paper-airplane\"></i>\n        <span>Notificaciones Enviadas</span>\n      </div>\n\n      <div class=\"widget-body big no-padding\">\n        <div class=\"panel\">\n          <div class=\"panel-heading\">\n\n            <!-- FILTROS -->\n            <div class=\"row\" style=\"margin-bottom:15px\">\n\n              <div class=\"col-md-3\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"Buscar por título o destinatario...\" ng-model=\"vm.filtro.texto\">\n              </div>\n\n              <div class=\"col-md-1\">\n                <select class=\"form-control\" ng-model=\"vm.filtro.anio\" ng-options=\"a for a in vm.aniosDisponibles\">\n                  <option value=\"\">Todos</option>\n                </select>\n              </div>\n \n              <div class=\"col-md-2\">\n                <input type=\"date\" class=\"form-control\" placeholder=\"Desde\" ng-model=\"vm.filtro.desde\">\n              </div>\n\n              <div class=\"col-md-2\">\n                <input type=\"date\" class=\"form-control\" placeholder=\"Hasta\" ng-model=\"vm.filtro.hasta\">\n              </div>\n\n              <div class=\"col-md-2\">\n                <select class=\"form-control\" ng-model=\"vm.filtro.estado\">\n                  <option value=\"\">Todos</option>\n                  <option value=\"leida\">Leídas</option>\n                  <option value=\"enviada\">No leídas</option>\n                </select>\n              </div>\n\n              <div class=\"col-md-2\">\n                <button class=\"btn btn-default btn-block\" ng-click=\"vm.limpiarFiltros()\">\n                  Limpiar filtros\n                </button>\n              </div>\n\n            </div>\n\n            <!-- CARGANDO -->\n            <div ng-if=\"vm.cargando\" class=\"text-center\" style=\"padding:20px\">\n              <i class=\"fa fa-spinner fa-spin fa-2x\"></i>\n            </div>\n\n            <!-- SIN RESULTADOS -->\n            <div ng-if=\"!vm.cargando && vm.notificacionesFiltradas().length === 0\" class=\"alert alert-info\">\n              No hay notificaciones enviadas que coincidan con los filtros.\n            </div>\n\n            <!-- TABLA -->\n            <div class=\"table-responsive\" ng-if=\"!vm.cargando && vm.notificacionesFiltradas().length > 0\">\n              <table class=\"table table-hover table-striped\">\n                <thead>\n                  <tr>\n                    <th>Título</th>\n                    <th style=\"width:200px\">Destinatario</th>\n                    <th style=\"width:120px\">Estado</th>\n                    <th style=\"width:150px\">Enviada</th>\n                    <th style=\"width:150px\">Leída</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <tr ng-repeat=\"n in vm.notificacionesFiltradas()\n                      | orderBy:\'-fechaRecepcion\'\n                      | limitTo:vm.tamanioPagina:(vm.paginaActual-1)*vm.tamanioPagina\">\n                    <td>{{n.titulo}}</td>\n                    <td>{{n.destinatario || \'—\'}}</td>\n                    <td>\n                      <span class=\"label label-success\" ng-if=\"n.estadoCodigo === \'leida\'\">Leída</span>\n                      <span class=\"label label-warning\" ng-if=\"n.estadoCodigo !== \'leida\'\">No leída</span>\n                    </td>\n                    <td>{{ (n.fechaRecepcion || n.fechaEnvio) | date:\'dd/MM/yyyy HH:mm\' }}</td>\n                    <td>\n                      <span ng-if=\"n.fechaLectura\">{{ n.fechaLectura | date:\'dd/MM/yyyy HH:mm\' }}</span>\n                      <span ng-if=\"!n.fechaLectura\" class=\"text-muted\">—</span>\n                    </td>\n                  </tr>\n                </tbody>\n              </table>\n            </div>\n\n            <!-- PAGINACIÓN -->\n            <div class=\"text-center\" style=\"margin-top:20px\" ng-if=\"vm.totalPaginas() > 1\">\n              <button class=\"btn btn-default\" ng-disabled=\"vm.paginaActual === 1\" ng-click=\"vm.cambiarPagina(vm.paginaActual - 1)\">\n                Anterior\n              </button>\n              <span style=\"margin:0 10px\">\n                Página {{vm.paginaActual}} de {{vm.totalPaginas()}}\n              </span>\n              <button class=\"btn btn-default\" ng-disabled=\"vm.paginaActual === vm.totalPaginas()\" ng-click=\"vm.cambiarPagina(vm.paginaActual + 1)\">\n                Siguiente\n              </button>\n            </div>\n\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/app/main/pedir-certificados/pedir-certificados.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n        <span>Certificados</span>\n        <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n      </div>\n\n      <div class=\"widget-body big no-padding\">\n\n        <div class=\"row\">\n    			<span type=\"button\" class=\"btn btn-default btn-block text-center\" ng-click=\"vm.pedirCertificado(certificado)\" ng-repeat=\"certificado in vm.certificados\">\n    		        {{certificado.nombre}}\n    			</span>\n    		</div>\n\n      </div>\n    </div>\n  </div> \n</div>\n\n\n\n\n");
$templateCache.put("app/app/main/rr-hh/rr-hh.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n        <abm-title key=\"vm.key\" scope=\"vm.list\"></abm-title>\n        <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n      </div>\n      <div class=\"widget-header\" ng-if=\"vm.list.filterFields.length\">\n        <div class=\"row\">\n          <formly-form model=\"vm.list.filterValues\" fields=\"vm.list.filterFields\" form=\"vm.list.filterForm\">\n          </formly-form>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n\n\n");
$templateCache.put("app/components/abm/form/form.html","<formly-form model=\"formData\" fields=\"form.fields\" form=\"form.htmlForm\">\n</formly-form>\n");
$templateCache.put("app/components/abm/list/list.html","<ng-form name=\"listForm\">\n  <table ng-table-dynamic=\"list.params with list.cols\" class=\"table table-striped table-hover table-condensed table-responsive\">\n    <tbody>\n      <tr search-row ng-if=\"list.searchRow\" conf=\"list.searchRow\" length=\"$columns.length\" actions=\"list.actions\"></tr>\n      <tr ng-if=\"!list.ready\" class=\"cargando-lista\">\n        <td colspan=\"{{$columns.length}}\" class=\"text-center\">\n            <div class=\"loading\">\n              <div class=\"double-bounce1\"></div>\n              <div class=\"double-bounce2\"></div>\n            </div>\n        </td>\n      </tr>\n      <tr ng-if=\"list.ready\" ng-repeat=\"(rowIndex, row) in $data | filter:list.searchRow.text\" on-finish-render=\"onFinishRender()\">\n        <td ng-repeat=\"(colIndex, col) in $columns\" data-orden=\"{{col.sortable(this)}}\" ng-init=\"colCopy = col.copy(col)\" class=\"{{col.clase}}\" bind-html-compile=\"col.expression\"></td>\n      </tr>\n      <tr ng-if=\"$data.length == 0 && list.noDataMessage\">\n        <td colspan=\"{{$columns.length}}\" class=\"text-center\">{{list.noDataMessage}}</td>\n      </tr>\n      <tr add-item-row ng-if=\"list.addItemRow\" conf=\"list.addItemRow\" add=\"list.datasource.addElement\" length=\"$columns.length\" actions=\"list.actions\"></tr>\n    </tbody>\n    <tfoot>\n      <tr ng-repeat=\"summary in list.summaryRows\">\n        <td colspan=\"{{col.colspan}}\" class=\"{{col.clase}}\" ng-repeat=\"col in summary\" bind-html-compile=\"col.expression\"></td>\n      </tr>\n    </tfoot>\n  </table>\n</ng-form>\n");
$templateCache.put("app/components/tema/page-header/page-header.html","<div class=\"row header\">\n  <div class=\"col-xs-12\">\n    <div class=\"user pull-right\" style=\"min-width: auto\">\n      <div class=\"item dropdown\" uib-dropdown>\n        <a class=\"dropdown-toggle\" uib-dropdown-toggle>\n          <img src=\"app/components/tema/utn.png\">\n          <!-- <i class=\"fa fa-user\" ng-class=\"icon\" style=\"color : black\"></i> -->\n        </a>\n      </div>\n    </div>\n    <user-info></user-info>\n    <profile></profile>\n    <page-title></page-title>\n  </div>\n</div>\n");
$templateCache.put("app/components/tema/sidebar/sidebar.html","<div id=\"sidebar-wrapper\">\n  <ul class=\"sidebar\">\n    <li class=\"sidebar-main\">\n      <a ng-click=\"sidebar.toggle()\">\n        {{sidebar.info.tituloApp}}\n        <span class=\"menu-icon fa fa-arrows-h\"></span>\n      </a>\n    </li>\n    <li class=\"sidebar-title\">\n      <span>Menú</span>\n    </li>\n    <menu-item ng-repeat=\"item in sidebar.menu.items\" item=\"item\"></menu-item>\n  </ul>\n  <div class=\"sidebar-footer\">\n    <div class=\"col-xs-12\">\n      <a ng-click=\"vm.cerrarSesion()\" target=\"_blank\" style=\"cursor: pointer\">Cerrar sesión</a>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/app/main/Inscripcion-examen/turno-examen/dialogo-inscripcion-exitosa.html","<div class=\"modal-header\" ng-if=\"config.titulo\">\n    <h3 class=\"modal-title\" id=\"modal-title\">\n      <i class=\"fa-stack\">\n        <i class=\"fa fa-circle fa-stack-2x\"></i>\n        <i class=\"fa fa-stack-1x fa-inverse {{config.icono}}\"></i>\n      </i>\n      {{config.titulo}}<!--\'Usted ya esta inscripto en un turno para esta materia\'-->\n    </h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <li ng-repeat=\"parrafo in config.parrafos\"> {{parrafo}}</li>\n    {{config.texto}}\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn {{config.tipoSi}}\" type=\"button\" ng-click=\"config.accionSi(dialogo)\" ng-if=\"config.si\">{{config.textoSi}}</button>\n    <button class=\"btn {{config.tipoNo}}\" type=\"button\" ng-click=\"config.accionNo(dialogo)\" ng-if=\"config.no\">{{config.textoNo}}</button>\n</div>");
$templateCache.put("app/app/main/Inscripcion-examen/turno-examen/turno-examen.html","<div class=\"row\">\n    <div class=\"col-md-12\">\n      <div class=\"widget\">\n        <div class=\"widget-header\">\n          <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n          <span>Inscripción a Exámen</span>\n          <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n          <span type=\"button\" class=\"btn btn-default pull-right\" ng-click=\"vm.volver()\">Volver</span>\n        </div>\n        <div class=\"widget-body big no-padding\">\n      <table class=\"table table-striped table-hover table-condensed table-responsive {{className}}\">\n        <div ng-if=\"vm.turnosInscripcion.detalles.length===0\">\n            No hay turnos de inscripción disponibles.\n        </div>\n        <tbody ng-if=\"vm.turnosInscripcion.detalles.length!==0\">\n          <tr>\n            <th class=\"text-center\">Asignatura</th>\n            <th class=\"text-center\">Fecha Exámen</th>\n            <th class=\"text-center\">Turnos</th>\n            <th class=\"text-center\">Acciones</th>\n          </tr>\n          <tr ng-repeat=\"turno in vm.turnosInscripcion.detalles\">\n            <td class=\"col-md-6 col text-center\">{{vm.turnosInscripcion.materia.nombreMateria}}</td>\n            <td class=\"col-md-2 col text-center\">{{turno.fechaExamen | date : \'dd/MM/yyyy\'}}</td>\n            <td class=\"col-md-3 col text-center\">{{turno.horariosDisponibles[0]}}</td>\n            <td class=\"col-md-1 col text-center\">\n              <div class=\"btn-group btn-group\">\n                <button type=\"button\" title=\"Inscribirse\" class=\"btn btn-success active\" ng-click=\"vm.confirmarInscripcion(turno)\">\n                    <i class=\"fa fa-sign-in fa-3x\"></i>  \n                </button>\n              </div>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div></div>");
$templateCache.put("app/app/main/encuestas/analitica/analitica-encuesta-detail.html","<div class=\"row\">\n  <iframe ng-src=\"{{ vm.link1 }}\" class=\"col-md-12\" ng-style=\"vm.innerComponentStyle\"></iframe>\n</div>");
$templateCache.put("app/app/main/encuestas/analitica/analitica-encuesta-home.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n        <span>Analítica de las Encuestas</span>\n        <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n      </div>\n      <div class=\"widget-body big no-padding\">\n\n         <table class=\"table table-striped table-hover table-condensed table-responsive {{className}}\">\n          <thead>\n            <tr>\n              <th class=\"text-center\">Informe</th>\n              <th class=\"text-center\">Acciones</th>\n            </tr>\n          </thead>          \n          <tbody>\n            <tr ng-repeat=\"informe in vm.informes\">\n              <td class=\"col-md-10 text-left\">{{ informe.nombre }}</td>\n              <td class=\"col-md-2 text-center\">\n                <div class=\"btn-group btn-group\">\n                  <button type=\"button\" title=\"Ver Información\" class=\"btn btn-info\" ng-click=\"vm.verInformes(informe)\">\n                      <i class=\"fa fa-info-circle fa-3x\"></i>\n                  </button>\n                </div>               \n              </td>\n            </tr> \n        </tbody></table></div>\n    </div>      \n  </div>    \n</div>     \n");
$templateCache.put("app/app/main/encuestas/realizar-encuesta/realizar-encuesta.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n        <span>Encuesta de {{vm.encuesta.persona.apellido}}, {{vm.encuesta.persona.nombre}} - {{vm.encuesta.asignatura.nombre}}\n        </span>\n        <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n        <span type=\"button\" class=\"btn btn-default pull-right\" ng-click=\"vm.volver()\">Volver</span>\n      </div>\n      <div class=\"widget-body big\">\n        <div class=\"row\">\n          <div class=\"panel col-md-10 col-sm-offset-1\" ng-class=\"{\'panel-success\':(detalle.opinion || detalle.respuesta!==null) ,\'panel-warning\':(!detalle.opinion && detalle.respuesta===null)}\" ng-repeat=\"detalle in vm.encuesta.detalles\">\n            <div class=\"panel-heading\">\n              {{detalle.pregunta.ordenPregunta}}. {{detalle.pregunta.pregunta}}\n            </div>\n            <div class=\"panel-body\" ng-if=\"detalle.pregunta.tipoPregunta.nombre == \'radius\'\">\n              <div class=\"col-md-4\"></div>\n              <div class=\"col-md-3\">\n                <star-rating-comp num-of-stars=\"5\" size=\"\'large\'\" star-type=\"\'icon\'\" rating=\"vm.getRating(detalle)\" on-click=\"vm.cambiarRating(detalle, $event.rating)\"></star-rating-comp>\n              </div>\n              <div class=\"col-md-2 text-center\">\n                <label><input type=\"checkbox\" ng-model=\"detalle.deshabilitado\" ng-change=\"vm.toogleCheckbox(detalle,detalle.deshabilitado)\"> No sé</label>\n              </div>\n            </div>\n            \n            <div class=\"panel-body\" ng-if=\"detalle.pregunta.tipoPregunta.nombre == \'text\'\">\n              <textarea class=\"form-control\" rows=\"3\" maxlength=\"248\" placeholder=\"Respuesta\" ng-model=\"detalle.opinion\"></textarea>\n            </div>\n          </div>\n        </div>\n        <div class=\"row text-center\"> \n          <button type=\"submit\" class=\"btn btn-success\" ng-click=\"vm.finalizar()\">\n            Enviar Encuesta\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/app/main/examen/estadistica-examen/estadistica-examen.html","      \n        \n<div class=\"row\">\n  <!-- <p>\n        Promedio sin aplazos:\n        <span class=\"item-note\">\n          {{vm.estadistica.promedioSinAplazo | number:2}}\n        </span>\n      </p>\n      <p>\n        Promedio con aplazos:\n        <span class=\"item-note\">\n          {{vm.estadistica.promedioConAplazo | number:2}}\n        </span>\n      </p> -->\n  <div class=\"col-md-3\">\n    <div class=\"widget\">\n      <div class=\"widget-body\">\n        <div class=\"widget-content\">\n          <div class=\"widget-icon blue pull-left\">\n            <i class=\"fa fa-book\"></i>\n          </div>\n          <div class=\"title\">\n            {{vm.estadistica.cantidadExamenesAnotados}}\n          </div> \n          <div class=\"comment\">\n            Inscripciones\n          </div> \n        </div>\n      </div>\n    </div>    \n  </div>\n\n  <div class=\"col-md-3\">\n    <div class=\"widget\">\n      <div class=\"widget-body\">\n        <div class=\"widget-content\">\n          <div class=\"widget-icon green pull-left\">\n            <i class=\"fa fa-check-circle\"></i>\n          </div>\n          <div class=\"title\">\n            {{vm.estadistica.cantidadMateriasAprobadas}}\n          </div> \n          <div class=\"comment\">\n            Aprobadas\n          </div> \n        </div>\n      </div>\n    </div>    \n  </div>\n\n  <div class=\"col-md-3\">\n    <div class=\"widget\">\n      <div class=\"widget-body\">\n        <div class=\"widget-content\">\n          <div class=\"widget-icon red pull-left\">\n            <i class=\"fa fa-close\"></i>\n          </div>\n          <div class=\"title\">\n            {{vm.estadistica.cantidadMateriasDesaprobadas}}\n          </div> \n          <div class=\"comment\">\n            Desaprobadas\n          </div> \n        </div>\n      </div>\n    </div>    \n  </div>\n\n  <div class=\"col-md-3\">\n    <div class=\"widget\">\n      <div class=\"widget-body\">\n        <div class=\"widget-content\">\n          <div class=\"widget-icon orange pull-left\">\n            <i class=\"fa fa-sign-out\"></i>\n          </div>\n          <div class=\"title\">\n            {{vm.estadistica.cantidadAusencias}}\n          </div> \n          <div class=\"comment\">\n            Ausentes\n          </div> \n        </div>\n      </div>\n    </div>    \n  </div>\n</div>\n");
$templateCache.put("app/app/main/inscripcion-cursado/comisiones-para-cursado/comisiones-para-cursado.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n        <span>Inscripción a Cursado</span>\n        <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n        <span type=\"button\" class=\"btn btn-default pull-right\" ng-click=\"vm.volver()\">Volver</span>\n      </div>\n      <div class=\"widget-body big no-padding\">\n        <!-- <div ng-if=\"vm.comisionesCursado.comisiones.length === 0\">\n          No hay comisiones disponibles.\n        </div> -->\n        <table class=\"table table-striped table-hover table-condensed table-responsive {{className}}\">\n          <thead>\n            <tr>\n              <th class=\"text-center\">Comisión</th>\n              <th class=\"text-center\">Horario </th>\n              <th class=\"text-center\">Curso</th>\n              <th class=\"text-center\">Edificio</th>\n              <th class=\"text-center\">Acciones</th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"comision in vm.comisionesCursado.comisiones | orderBy:[\'numero\',\'especialidad\']\">\n              <td class=\"col-md-1 col text-center\">\n                {{comision.comision}}\n              </td>\n              <td class=\"col-md-5 col text-center\">\n                {{comision.horario}}\n              </td>\n              <td class=\"col-md-2 col text-center\">\n                {{comision.curso}}\n              </td>\n              <td class=\"col-md-3 col text-center\">\n                {{comision.edificio}}\n              </td>\n              <td class=\"col-md-1 col text-center\">\n                <div class=\"btn-group btn-group\">\n                  <button type=\"button\" title=\"Inscribirse\" class=\"btn btn-primary\" ng-click=\"vm.confirmarInscripcion(comision)\">\n                        <i class=\"fa fa-sign-in fa-3x\"></i>  \n                    </button>\n                </div>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/app/main/inscripcion-cursado/comisiones-para-cursado/dialogo-confirmacion-visualizacion-comisiones.html","<div class=\"modal-header\" ng-if=\"config.titulo\">\n  <h3 class=\"modal-title\" id=\"modal-title\">\n    <i class=\"fa-stack\">\n      <i class=\"fa fa-circle fa-stack-2x\"></i>\n      <i class=\"fa fa-stack-1x fa-inverse {{config.icono}}\"></i>\n    </i>\n    {{config.titulo}}\n  </h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n  <li ng-repeat=\"parrafo in config.parrafos\"> {{parrafo}}</li>\n  {{config.texto}}\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn {{config.tipoSi}}\" type=\"button\" ng-click=\"config.accionSi(dialogo)\" ng-if=\"config.si\">{{config.textoSi}}</button>\n  <button class=\"btn {{config.tipoNo}}\" type=\"button\" ng-click=\"config.accionNo(dialogo)\" ng-if=\"config.no\">{{config.textoNo}}</button>\n</div>");
$templateCache.put("app/app/main/libro-de-temas/libro-de-temas/libro-de-temas.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n        <span>Libro de Temas</span>\n        <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n        <span type=\"button\" class=\"btn btn-default pull-right\" ng-click=\"vm.volver()\">Volver</span>\n      </div>\n\n      <div class=\"widget-body big no-padding\">\n\n        <div ng-if=\"vm.clases.length > 0\">\n          \n          <table class=\"table table-striped table-hover table-condensed table-responsive {{className}}\">\n            <thead>\n                <tr>\n                  <th class=\"text-center\">Clase</th>\n                  <th class=\"text-center\">Fecha</th>\n                  <th class=\"text-center\">Observaciones</th>\n                </tr>\n            </thead>\n            <tbody>\n              <tr ng-repeat=\"clase in vm.clases  | orderBy:\'fecha\'\" ng-click=\"clase.abierto = !clase.abierto\">\n                <td class=\"col-md-4 col text-center\">{{vm.getTitulo(clase)}}</td>\n                <td class=\"col-md-4 col text-center\">{{clase.fecha | date : \'dd-MM-yyyy\'}}</td>\n\n                <td class=\"col-md-4 col text-center\">\n                  <span ng-if=\"!clase.abierto && clase.claseDictada\" class=\"label label-default\">...</span>\n\n                  <span ng-if=\"!clase.claseDictada\">-</span>\n\n                  <span ng-if=\"clase.abierto && clase.claseDictada\">\n                    <ul ng-if=\"clase.claseDictada.arrayObservaciones.length > 1\">\n                      <li ng-repeat=\"observ in clase.claseDictada.arrayObservaciones track by $index\" ng-if=\"observ!==\'\'\">\n                        <div>{{observ}}</div>\n                      </li>\n                    </ul>\n                    <span ng-if=\"clase.claseDictada.arrayObservaciones.length === 1\">\n                      <span ng-repeat=\"observ in clase.claseDictada.arrayObservaciones track by $index\" ng-if=\"observ!==\'\'\">\n                        <div>{{observ}}</div>\n                      </span>\n                    </span>\n                  </span>\n                </td>\n\n              </tr>\n            </tbody>\n          </table>\n        </div>\n        <div ng-if=\"vm.clases.length === 0\">\n          No hay clases dictadas\n        </div>\n\n      </div>    \n    </div>\n  </div> \n</div>\n\n\n\n\n\n");
$templateCache.put("app/app/main/libro-de-temas/materias-libro-de-temas/materias-libro-de-temas.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n        <span>Libro de Temas</span>\n        <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n      </div>\n\n      <div class=\"widget-body big no-padding\">\n\n        <table class=\"table table-striped table-hover table-condensed table-responsive {{className}}\">\n          <thead>\n              <tr>\n                <th class=\"text-center\">Asignatura</th>\n                <th class=\"text-center\">Nivel</th>\n                <th class=\"text-center\">Estado</th>\n                <th class=\"text-center\">Acciones</th>\n              </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"materia in vm.materias | orderBy: [\'estadoMateria\',\'nombreMateria\']\">\n              <td class=\"col-md-6 col text-center\">{{ materia.nombreMateria }}</td>\n              <td class=\"col-md-1 col text-center\">{{ materia.nivel }}</td>\n              <td class=\"col-md-4 col text-center\">{{ vm.getEstado(materia) }}</td>\n              <td class=\"col-md-1 col\">\n                <div class=\"button text-center\">\n                  <button type=\"button\" title=\"Ver Información\" class=\"btn btn-info\" ng-click=\"vm.verLibroDeTemas(materia)\">\n                      <i class=\"fa fa-info-circle fa-3x\"></i>\n                  </button>\n                </div>               \n              </td>\n            </tr>\n          </tbody>\n        </table>\n        \n      </div>\n    </div>\n  </div> \n</div>\n\n\n\n\n\n\n\n");
$templateCache.put("app/app/main/materia-cursando/materia/materia.html","<div class=\"row\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <div class=\"widget\">\n        <div class=\"widget-header\">\n          <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n          <span>Parciales</span>\n          <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n          <span type=\"button\" class=\"btn btn-default pull-right\" ng-click=\"vm.volver()\">Volver</span>\n        </div>\n        \n        <div class=\"widget-body big no-padding\" ng-if=\"vm.materia.notas.length!== 0\">\n          <table class=\"table table-striped table-hover table-condensed table-responsive {{className}}\">\n            <thead> \n              <tr>\n                <th class=\"text-center\">Nombre</th>\n                <th class=\"text-center\">Nota</th>\n                <th class=\"text-center\">Estado</th>\n              </tr>\n            </thead>\n            <tbody>            \n              <tr ng-repeat=\"parcial in vm.materia.notas\">\n                <td class=\"col-md-4 col text-center\">{{parcial.nombre}}</td>\n                <td class=\"col-md-4 col text-center\">{{parcial.notaNumero}}</td>\n                <td class=\"col-md-4 col text-center\">\n                  <span class=\"label {{vm.getEstado(parcial)}}\"> \n                    {{ vm.getNombreEstado(parcial) }}\n                  </span>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </div>    \n        <div ng-if=\"vm.materia.notas.length=== 0\">\n          <span> No hay parciales cargados </span>\n        </div>\n      </div>\n    </div> \n  </div>\n  \n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <div class=\"widget\">\n        <div class=\"widget-header\">\n          <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n          <span>Faltas</span>\n          <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n        </div>\n  \n        <div class=\"widget-body big no-padding\">\n  \n            <table class=\"table table-striped table-hover table-condensed table-responsive {{className}}\">\n              <tbody>\n                <tr>\n                  <th class=\"text-center\">Faltas Justificadas</th>\n                  <th class=\"text-center\">Faltas Injustificadas</th>\n                </tr>      \n                <tr>\n                  <td class=\"col-md-6 col text-center\">\n                    <span class=\"item-note\" ng-if=\"vm.materia.faltasJustificadas.length === 0\">\n                      0\n                    </span>\n  \n                    <span ng-if=\"vm.materia.faltasJustificadas.length!==0\" class=\"item-note\">\n                      Total: {{vm.materia.faltasJustificadas.length}}\n                    </span>\n  \n                    <span class=\"lista-faltas\" ng-if=\"vm.materia.faltasJustificadas.length!==0\">\n                      <div ng-repeat=\"falta in vm.materia.faltasJustificadas\">\n                        {{falta | date:\'dd/MM/yyyy\'}}\n                      </div>\n                    </span>\n                  </td>\n                  <td class=\"col-md-6 col text-center\"> \n                    <span class=\"item-note\" ng-if=\"vm.materia.faltasInjustificadas.length === 0\">\n                      0\n                    </span>\n  \n                    <span ng-if=\"vm.materia.faltasInjustificadas.length!==0\">\n                      Total: {{vm.materia.faltasInjustificadas.length}}\n                    </span>\n                    \n                    <span class=\"lista-faltas\" ng-if=\"vm.materia.faltasInjustificadas.length!==0\">\n                      <div ng-repeat=\"falta in vm.materia.faltasInjustificadas\">\n                        {{falta | date:\'dd/MM/yyyy\'}}\n                      </div>\n                    </span>\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n            \n        </div>    \n      </div>\n    </div> \n  </div>\n</div>\n\n\n\n\n\n\n\n\n\n\n\n");
$templateCache.put("app/app/main/materia-cursando/materias-cursando/materias-cursando.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n        <span>Materias Cursando</span>\n        <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n      </div>\n      <div class=\"widget-body big no-padding\">\n        <table class=\"table table-striped table-hover table-condensed table-responsive {{className}}\">\n          <thead>\n              <tr>\n                <th class=\"text-center\">Asignatura</th>\n                <th class=\"text-center\">Nivel</th>\n                <th class=\"text-center\">Plan</th>\n                <th class=\"text-center\">Acciones</th>\n              </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"detalle in vm.materiaCursando.detalles | orderBy:\'materia.nombre\'\">\n              <td class=\"col-md-6 col text-center\">{{ detalle.materia.nombre }}</td>\n              <td class=\"col-md-3 col text-center\">{{ detalle.nivel }}</td>\n              <td class=\"col-md-2 col text-center\">{{ detalle.plan }}</td>\n              <td class=\"col-md-1 col\">\n                <div class=\"button text-center\">\n                  <button type=\"button\" title=\"Ver Información\" class=\"btn btn-info\" ng-click=\"vm.verMateria(detalle)\">\n                      <i class=\"fa fa-info-circle fa-3x\"></i>\n                  </button>\n                </div>               \n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </div>    \n    </div>\n  </div> \n</div>\n\n\n\n\n");
$templateCache.put("app/app/main/pago-tic/inscripcion/inscribirse.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n        <span>Inscripción de Alumno en Curso</span>\n        <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n      </div>\n      <div class=\"widget-body\">\n        <h1>Inscribirse</h1>\n        <p> {{ vm.model.alumno.nombreCompleto }} - DNI: {{ vm.model.alumno.dni }}</p>\n        <p> {{ vm.model.alumno.telefonoInternacional }} - <a href=\"{{ vm.model.alumno.linkWhatsapp }}\" target=\"_blank\">WhatsApp</a></p>\n\n\n        <formly-form model=\"vm.model\" fields=\"vm.fields\" ng-if=\"vm.conceptosAgrupados\">\n          <h2>Conceptos</h2>\n          <div ng-repeat=\"(plan, conceptos) in vm.conceptosAgrupados\">\n            <h3>Plan: {{ plan }}</h3>\n            <table class=\"table table-striped\">\n              <thead>\n                <tr>\n                  <th class=\"text-center\">Orden</th>\n                  <th class=\"text-center\">Código</th>\n                  <th class=\"text-center\">Nombre</th>\n                  <th class=\"text-center\">Descripción</th>\n                  <th class=\"text-center\">Precio</th>\n                  <th class=\"text-center\">Fecha de Vto.</th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr ng-repeat=\"concepto in conceptos\">\n                  <td class=\"text-center\">{{ concepto.orden }}</td>\n                  <td class=\"text-center\">{{ concepto.codigo }}</td>\n                  <td>{{ concepto.nombre }}</td>\n                  <td>{{ concepto.descripcion }}</td>\n                  <td class=\"text-right\">{{ concepto.precio | currency}}</td>\n                  <td class=\"text-center\">{{ concepto.fechaVto | date:\'dd/MM/yyyy\' }}</td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n          <div class=\"widget-footer row\">\n            <div class=\"btn-group pull-right\">\n              <button type=\"submit\" class=\"btn btn-success\" ng-click=\"vm.submit()\" ng-disabled=\"vm.form.$invalid\">Inscribirse</button>\n              <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.volver()\">Cancelar</button>\n            </div>\n          </div>\n          \n\n        </formly-form>\n\n\n      </div>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/app/main/reloj/control-diario/lista-eventos-control-diario.html","<div class=\"panel panel-default\">\n  <div class=\"panel-heading\">\n    <h3 class=\"panel-title\">Eventos del día {{ fecha | date:\'dd/MM/yyyy\' }}</h3>\n  </div>\n  <div class=\"panel-body\">\n    <table class=\"table table-striped\">\n			<tr>\n				<th>Hora</th>\n				<th>Válido</th>\n			</tr>\n    	<tr ng-repeat=\"evento in vm.eventos\">\n    		<td>\n    			{{evento.hora}}\n    		</td>\n    		<td>\n					<span class=\"label label-success\" ng-if=\"evento.valida == \'V\'\">Sí</span>\n					<span class=\"label label-danger\" ng-if=\"evento.valida == \'N\'\">No</span>\n    		</td>\n    	</tr>\n  </table></div>\n</div>\n");
$templateCache.put("app/app/main/reloj/control-diario/lista-licencias-control-diario.html","<div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n      <h3 class=\"panel-title\">Licencias del día {{ fecha | date:\'dd/MM/yyyy\' }}</h3>\n    </div>\n    <div class=\"panel-body\">\n      <table class=\"table table-striped\">\n              <tr>\n                  <th>Nro</th>\n                  <th>Tipo</th>\n                  <th>Fecha inicio</th>\n                  <th>Fecha fin</th>\n                  <th>Estado</th>\n              </tr>\n          <tr ng-repeat=\"licencia in vm.licencias\">\n              <td>{{licencia.id}}/{{licencia.fecha | date:\'yyyy\'}}</td>\n              <td>{{licencia.tipoLicencia.nombre}}</td>\n              <td>{{licencia.fechaDesde | date:\'dd/MM/yyyy\'}}</td>\n              <td>{{licencia.fechaHasta | date:\'dd/MM/yyyy\'}}</td>\n              <td>\n                      <span class=\"label label-success\" ng-if=\"licencia.estado.nombre == \'Concedida\'\">Concedida</span>\n                      <span class=\"label label-warning\" ng-if=\"licencia.estado.nombre == \'Pendiente\'\">Pendiente</span>\n                      <span class=\"label label-danger\" ng-if=\"licencia.estado.nombre == \'Denegado\'\">Denegado</span>\n              </td>\n          </tr>\n    </table></div>\n  </div>\n");
$templateCache.put("app/components/abm/form/state/default-edit.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-tag\" ng-class=\"icon\"></i>\n        <abm-title key=\"vm.form.name ? vm.form.name + \'.title\' : \'edit.title\'\" scope=\"vm.form\"></abm-title>\n      </div>\n      <div class=\"widget-body\">\n        <div class=\"widget-content row\">\n          <abm-form form=\"vm.form\"></abm-form>\n        </div>\n      </div>\n      <div class=\"widget-footer row\">\n        <div class=\"btn-group pull-right\">\n          <button type=\"submit\" class=\"btn btn-success\" ng-click=\"vm.form.actions.saveElement(vm.form.formData)\" ng-disabled=\"vm.form.htmlForm.$invalid || vm.form.htmlForm.$pristine\">Guardar</button>\n          <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.form.actions.cancelElement()\">Cancelar</button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/abm/form/types/typeahead.html","<div class=\"input-group\">\n	<input type=\"text\" ng-model=\"model[options.key]\" typeahead-editable=\"to.permitirNuevo\" typeahead-wait-ms=\"to.espera\" typeahead-loading=\"to.cargando\" typeahead-on-select=\"to.buscar\" class=\"form-control\">\n	 <span class=\"input-group-addon\">\n	 	<span ng-if=\"to.cargando\"><span class=\"fa fa-refresh fa-spin\"></span></span>\n	 	<span ng-if=\"!to.cargando\" ng-click=\"to.buscar()\" class=\"fa fa-search fa-fw\"></span>\n	 </span>\n </div>");
$templateCache.put("app/components/abm/form/types/upload-file.html","<div class=\"input-group\">\n	<input type=\"file\" subir-archivo=\"model[options.key]\" accept=\"{{to.accept}}\"> \n</div>");
$templateCache.put("app/components/abm/list/filter/checkbox-list-filter.html","<formly-form model=\"$column.checkboxModel\" fields=\"$column.checkboxFields\"></formly-form>\n");
$templateCache.put("app/components/abm/list/filter/checkbox-list.html","<checkbox-list-filter></checkbox-list-filter>\n");
$templateCache.put("app/components/abm/list/state/default-list.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"widget\">\n      <div class=\"widget-header\">\n        <i class=\"fa fa-tasks\" ng-class=\"icon\"></i>\n        <abm-title key=\"vm.list.name ? vm.list.name+\'.title\': \'list.title\'\" scope=\"vm.list\"></abm-title>\n        <action-bar class=\"pull-right\" actions=\"vm.list.generalActions\" scope=\"vm.list\"></action-bar>\n      </div>\n      <div class=\"widget-header\" ng-if=\"vm.list.filterFields.length\">\n        <div class=\"row\">\n          <formly-form model=\"vm.list.filterValues\" fields=\"vm.list.filterFields\" form=\"vm.list.filterForm\">\n          </formly-form>\n        </div>\n      </div>\n      <div class=\"widget-body big no-padding\">\n        <abm-list list=\"vm.list\"></abm-list>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/tema/page-header/page-title/page-title.html","<div class=\"meta\">\n  <div class=\"page\"><abm-title key=\"\" scope=\"title.state.data.state\"></abm-title></div>\n  <div class=\"breadcrumb-links\" ng-bind=\"title.ruta.join(\' / \')\"></div>\n</div>\n");
$templateCache.put("app/components/tema/page-header/profile/profile.html","<div class=\"user pull-right\" style=\"min-width: auto\">\n        <div class=\"item dropdown\" uib-dropdown style=\"width: auto\">\n          <a class=\"dropdown-toggle\" uib-dropdown-toggle style=\"background-color: red; color: white\">\n            <i class=\"fa fa-warning\" ng-if=\"!profile.esProduccion()\"></i>{{profile.esProduccion() ? \'\' : profile.profile | uppercase}}\n          </a>\n        </div>\n      </div>");
$templateCache.put("app/components/tema/page-header/user-info/user-info.html","\n<div class=\"user pull-right\">\n\n  <!-- Menú de usuario -->\n  <div class=\"item dropdown\" uib-dropdown style=\"width: auto\">\n    <a class=\"dropdown-toggle\" uib-dropdown-toggle style=\"cursor: pointer; text-decoration: none\">\n      <i class=\"fa fa-user\"></i> <span class=\"hidden-xs\">{{vm.getFullName()}}</span> <i class=\"fa fa-sort-down hidden-xs\"></i>\n    </a>\n    <ul class=\"dropdown-menu dropdown-menu-right animated fadeIn\">\n      <li class=\"dropdown-header user-role\">\n        Rol: {{vm.usuario.grupo.nombre}}\n      </li>\n      <li class=\"divider\"></li>\n      <li class=\"link\">\n        <a ng-click=\"vm.mostrarInformacionPersonal()\" style=\"cursor: pointer\">Información personal</a>\n      </li>\n      <li class=\"link\">\n        <a ng-click=\"vm.cambiarPassword()\" style=\"cursor: pointer\">Cambiar contraseña</a>\n      </li>\n      <li class=\"divider\"></li>\n      <li class=\"link\">\n        <a ng-click=\"vm.cerrarSesion()\" style=\"cursor: pointer\">Cerrar sesión</a>\n      </li>\n    </ul>\n  </div>\n\n  <!-- Campanita de notificaciones -->\n  <div class=\"item\" style=\"margin-right: 15px; position: relative; display: inline-block\">\n    <a style=\"cursor: pointer; text-decoration: none; position: relative\" ng-click=\"vm.irABandeja()\" ng-mouseenter=\"vm.cargarPreview()\" ng-mouseleave=\"vm.ocultarPreview()\">\n\n      <i class=\"fa fa-bell\" style=\"font-size: 18px\"></i>\n\n      <!-- Badge con cantidad de no leídas -->\n      <span style=\"position: absolute; top: 8px; right: -10px;\n                   background: #e74c3c; color: white; border-radius: 50%;\n                   font-size: 10px; font-weight: bold;\n                   min-width: 16px; height: 16px; line-height: 16px;\n                   text-align: center; padding: 0 3px\" ng-if=\"vm.cantidadNotificaciones > 0\">\n        {{vm.cantidadNotificaciones}}\n      </span>\n\n    </a>\n  </div>\n\n</div>\n");
$templateCache.put("app/components/tema/sidebar/navigation-menu/menu-item.html","<div ng-show=\"menuItem.isVisible(menuItem.item)\">\n  <li class=\"sidebar-list animated flipInX\" ng-class=\"{\'actual\':menuItem.item.present,\'deshabilitado\':!menuItem.isEnabled(menuItem.item)} \" style=\"cursor: pointer\">\n    <a uib-tooltip=\"{{menuItem.getTooltip()}}\" tooltip-trigger=\"\'mouseenter\'\" tooltip-append-to-body=\"true\" ng-style=\"{\'padding-left\':menuItem.padding + \'px\'}\" ng-click=\"menuItem.select()\">\n      <span>{{menuItem.getName()}}</span>\n      <span class=\"menu-icon {{menuItem.item.icon}}\"></span>\n    </a>\n  </li>\n  <menu-item ng-show=\"menuItem.item.opened\" ng-repeat=\"child in menuItem.item.children\" item=\"child\" padding=\"menuItem.padding+10\"></menu-item>\n</div>\n");}]);